(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea1dc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea1dc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lKySX", function(module, exports) {

$parcel$export(module.exports, "animator", function () { return animator; });
$parcel$export(module.exports, "Animation", function () { return Animation; });
$parcel$export(module.exports, "Animations", function () { return Animations; });
$parcel$export(module.exports, "DatasetController", function () { return DatasetController; });
$parcel$export(module.exports, "BarController", function () { return BarController; });
$parcel$export(module.exports, "BubbleController", function () { return BubbleController; });
$parcel$export(module.exports, "DoughnutController", function () { return DoughnutController; });
$parcel$export(module.exports, "LineController", function () { return LineController; });
$parcel$export(module.exports, "PolarAreaController", function () { return PolarAreaController; });
$parcel$export(module.exports, "PieController", function () { return PieController; });
$parcel$export(module.exports, "RadarController", function () { return RadarController; });
$parcel$export(module.exports, "ScatterController", function () { return ScatterController; });
$parcel$export(module.exports, "controllers", function () { return controllers; });
$parcel$export(module.exports, "_adapters", function () { return adapters; });
$parcel$export(module.exports, "Interaction", function () { return Interaction; });
$parcel$export(module.exports, "layouts", function () { return layouts; });
$parcel$export(module.exports, "BasePlatform", function () { return BasePlatform; });
$parcel$export(module.exports, "BasicPlatform", function () { return BasicPlatform; });
$parcel$export(module.exports, "DomPlatform", function () { return DomPlatform; });
$parcel$export(module.exports, "_detectPlatform", function () { return _detectPlatform; });
$parcel$export(module.exports, "Element", function () { return Element; });
$parcel$export(module.exports, "Scale", function () { return Scale; });
$parcel$export(module.exports, "registry", function () { return registry; });
$parcel$export(module.exports, "Chart", function () { return Chart; });
$parcel$export(module.exports, "ArcElement", function () { return ArcElement; });
$parcel$export(module.exports, "LineElement", function () { return LineElement; });
$parcel$export(module.exports, "PointElement", function () { return PointElement; });
$parcel$export(module.exports, "BarElement", function () { return BarElement; });
$parcel$export(module.exports, "elements", function () { return elements; });
$parcel$export(module.exports, "Colors", function () { return plugin_colors; });
$parcel$export(module.exports, "Decimation", function () { return plugin_decimation; });
$parcel$export(module.exports, "Filler", function () { return index; });
$parcel$export(module.exports, "Legend", function () { return plugin_legend; });
$parcel$export(module.exports, "Title", function () { return plugin_title; });
$parcel$export(module.exports, "SubTitle", function () { return plugin_subtitle; });
$parcel$export(module.exports, "Tooltip", function () { return plugin_tooltip; });
$parcel$export(module.exports, "plugins", function () { return plugins; });
$parcel$export(module.exports, "CategoryScale", function () { return CategoryScale; });
$parcel$export(module.exports, "LinearScale", function () { return LinearScale; });
$parcel$export(module.exports, "LogarithmicScale", function () { return LogarithmicScale; });
$parcel$export(module.exports, "RadialLinearScale", function () { return RadialLinearScale; });
$parcel$export(module.exports, "TimeScale", function () { return TimeScale; });
$parcel$export(module.exports, "TimeSeriesScale", function () { return TimeSeriesScale; });
$parcel$export(module.exports, "scales", function () { return scales; });
$parcel$export(module.exports, "registerables", function () { return registerables; });
$parcel$export(module.exports, "Ticks", function () { return (parcelRequire("8AEPV")).aM; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("8AEPV")).d; });
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $lXwto = parcelRequire("lXwto");

var $bzgVo = parcelRequire("bzgVo");

var $gHG1J = parcelRequire("gHG1J");

var $k9HNQ = parcelRequire("k9HNQ");

var $8wpvj = parcelRequire("8wpvj");

var $grPlv = parcelRequire("grPlv");

var $fwyhh = parcelRequire("fwyhh");

var $7idZr = parcelRequire("7idZr");

var $fth2V = parcelRequire("fth2V");

var $8Hr86 = parcelRequire("8Hr86");

var $2l5av = parcelRequire("2l5av");

var $aqUTs = parcelRequire("aqUTs");

var $ggYC0 = parcelRequire("ggYC0");

var $8AEPV = parcelRequire("8AEPV");

var Animator = /*#__PURE__*/ function() {
    "use strict";
    function Animator() {
        (0, $bzgVo._)(this, Animator);
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    (0, $gHG1J._)(Animator, [
        {
            key: "_notify",
            value: function _notify(chart, anims, date, type) {
                var callbacks = anims.listeners[type];
                var numSteps = anims.duration;
                callbacks.forEach(function(fn) {
                    return fn({
                        chart: chart,
                        initial: anims.initial,
                        numSteps: numSteps,
                        currentStep: Math.min(date - anims.start, numSteps)
                    });
                });
            }
        },
        {
            key: "_refresh",
            value: function _refresh() {
                var _this = this;
                if (this._request) return;
                this._running = true;
                this._request = (0, $8AEPV.r).call(window, function() {
                    _this._update();
                    _this._request = null;
                    if (_this._running) _this._refresh();
                });
            }
        },
        {
            key: "_update",
            value: function _update() {
                var _this = this;
                var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                var remaining = 0;
                this._charts.forEach(function(anims, chart) {
                    if (!anims.running || !anims.items.length) return;
                    var items = anims.items;
                    var i = items.length - 1;
                    var draw = false;
                    var item;
                    for(; i >= 0; --i){
                        item = items[i];
                        if (item._active) {
                            if (item._total > anims.duration) anims.duration = item._total;
                            item.tick(date);
                            draw = true;
                        } else {
                            items[i] = items[items.length - 1];
                            items.pop();
                        }
                    }
                    if (draw) {
                        chart.draw();
                        _this._notify(chart, anims, date, 'progress');
                    }
                    if (!items.length) {
                        anims.running = false;
                        _this._notify(chart, anims, date, 'complete');
                        anims.initial = false;
                    }
                    remaining += items.length;
                });
                this._lastDate = date;
                if (remaining === 0) this._running = false;
            }
        },
        {
            key: "_getAnims",
            value: function _getAnims(chart) {
                var charts = this._charts;
                var anims = charts.get(chart);
                if (!anims) {
                    anims = {
                        running: false,
                        initial: true,
                        items: [],
                        listeners: {
                            complete: [],
                            progress: []
                        }
                    };
                    charts.set(chart, anims);
                }
                return anims;
            }
        },
        {
            key: "listen",
            value: function listen(chart, event, cb) {
                this._getAnims(chart).listeners[event].push(cb);
            }
        },
        {
            key: "add",
            value: function add(chart, items) {
                var _this__getAnims_items;
                if (!items || !items.length) return;
                (_this__getAnims_items = this._getAnims(chart).items).push.apply(_this__getAnims_items, (0, $2l5av._)(items));
            }
        },
        {
            key: "has",
            value: function has(chart) {
                return this._getAnims(chart).items.length > 0;
            }
        },
        {
            key: "start",
            value: function start(chart) {
                var anims = this._charts.get(chart);
                if (!anims) return;
                anims.running = true;
                anims.start = Date.now();
                anims.duration = anims.items.reduce(function(acc, cur) {
                    return Math.max(acc, cur._duration);
                }, 0);
                this._refresh();
            }
        },
        {
            key: "running",
            value: function running(chart) {
                if (!this._running) return false;
                var anims = this._charts.get(chart);
                if (!anims || !anims.running || !anims.items.length) return false;
                return true;
            }
        },
        {
            key: "stop",
            value: function stop(chart) {
                var anims = this._charts.get(chart);
                if (!anims || !anims.items.length) return;
                var items = anims.items;
                var i = items.length - 1;
                for(; i >= 0; --i)items[i].cancel();
                anims.items = [];
                this._notify(chart, anims, Date.now(), 'complete');
            }
        },
        {
            key: "remove",
            value: function remove(chart) {
                return this._charts.delete(chart);
            }
        }
    ]);
    return Animator;
}();
var animator = /* #__PURE__ */ new Animator();
var transparent = 'transparent';
var interpolators = {
    boolean: function(from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color: function(from, to, factor) {
        var c0 = (0, $8AEPV.c)(from || transparent);
        var c1 = c0.valid && (0, $8AEPV.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number: function(from, to, factor) {
        return from + (to - from) * factor;
    }
};
var Animation = /*#__PURE__*/ function() {
    "use strict";
    function Animation(cfg, target, prop, to) {
        (0, $bzgVo._)(this, Animation);
        var currentValue = target[prop];
        to = (0, $8AEPV.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        var from = (0, $8AEPV.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || (typeof from === "undefined" ? "undefined" : (0, $aqUTs._)(from))];
        this._easing = (0, $8AEPV.e)[cfg.easing] || (0, $8AEPV.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    (0, $gHG1J._)(Animation, [
        {
            key: "active",
            value: function active() {
                return this._active;
            }
        },
        {
            key: "update",
            value: function update(cfg, to, date) {
                if (this._active) {
                    this._notify(false);
                    var currentValue = this._target[this._prop];
                    var elapsed = date - this._start;
                    var remain = this._duration - elapsed;
                    this._start = date;
                    this._duration = Math.floor(Math.max(remain, cfg.duration));
                    this._total += elapsed;
                    this._loop = !!cfg.loop;
                    this._to = (0, $8AEPV.a)([
                        cfg.to,
                        to,
                        currentValue,
                        cfg.from
                    ]);
                    this._from = (0, $8AEPV.a)([
                        cfg.from,
                        currentValue,
                        to
                    ]);
                }
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this._active) {
                    this.tick(Date.now());
                    this._active = false;
                    this._notify(false);
                }
            }
        },
        {
            key: "tick",
            value: function tick(date) {
                var elapsed = date - this._start;
                var duration = this._duration;
                var prop = this._prop;
                var from = this._from;
                var loop = this._loop;
                var to = this._to;
                var factor;
                this._active = from !== to && (loop || elapsed < duration);
                if (!this._active) {
                    this._target[prop] = to;
                    this._notify(true);
                    return;
                }
                if (elapsed < 0) {
                    this._target[prop] = from;
                    return;
                }
                factor = elapsed / duration % 2;
                factor = loop && factor > 1 ? 2 - factor : factor;
                factor = this._easing(Math.min(1, Math.max(0, factor)));
                this._target[prop] = this._fn(from, to, factor);
            }
        },
        {
            key: "wait",
            value: function wait() {
                var promises = this._promises || (this._promises = []);
                return new Promise(function(res, rej) {
                    promises.push({
                        res: res,
                        rej: rej
                    });
                });
            }
        },
        {
            key: "_notify",
            value: function _notify(resolved) {
                var method = resolved ? 'res' : 'rej';
                var promises = this._promises || [];
                for(var i = 0; i < promises.length; i++)promises[i][method]();
            }
        }
    ]);
    return Animation;
}();
var Animations = /*#__PURE__*/ function() {
    "use strict";
    function Animations(chart, config) {
        (0, $bzgVo._)(this, Animations);
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    (0, $gHG1J._)(Animations, [
        {
            key: "configure",
            value: function configure(config) {
                if (!(0, $8AEPV.i)(config)) return;
                var animationOptions = Object.keys((0, $8AEPV.d).animation);
                var animatedProps = this._properties;
                Object.getOwnPropertyNames(config).forEach(function(key) {
                    var cfg = config[key];
                    if (!(0, $8AEPV.i)(cfg)) return;
                    var resolved = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = animationOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var option = _step.value;
                            resolved[option] = cfg[option];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    ((0, $8AEPV.b)(cfg.properties) && cfg.properties || [
                        key
                    ]).forEach(function(prop) {
                        if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
                    });
                });
            }
        },
        {
            key: "_animateOptions",
            value: function _animateOptions(target, values) {
                var newOptions = values.options;
                var options = resolveTargetOptions(target, newOptions);
                if (!options) return [];
                var animations = this._createAnimations(options, newOptions);
                if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(function() {
                    target.options = newOptions;
                }, function() {});
                return animations;
            }
        },
        {
            key: "_createAnimations",
            value: function _createAnimations(target, values) {
                var animatedProps = this._properties;
                var animations = [];
                var running = target.$animations || (target.$animations = {});
                var props = Object.keys(values);
                var date = Date.now();
                var i;
                for(i = props.length - 1; i >= 0; --i){
                    var prop = props[i];
                    if (prop.charAt(0) === '$') continue;
                    if (prop === 'options') {
                        var _animations;
                        (_animations = animations).push.apply(_animations, (0, $2l5av._)(this._animateOptions(target, values)));
                        continue;
                    }
                    var value = values[prop];
                    var animation = running[prop];
                    var cfg = animatedProps.get(prop);
                    if (animation) {
                        if (cfg && animation.active()) {
                            animation.update(cfg, value, date);
                            continue;
                        } else animation.cancel();
                    }
                    if (!cfg || !cfg.duration) {
                        target[prop] = value;
                        continue;
                    }
                    running[prop] = animation = new Animation(cfg, target, prop, value);
                    animations.push(animation);
                }
                return animations;
            }
        },
        {
            key: "update",
            value: function update(target, values) {
                if (this._properties.size === 0) {
                    Object.assign(target, values);
                    return;
                }
                var animations = this._createAnimations(target, values);
                if (animations.length) {
                    animator.add(this._chart, animations);
                    return true;
                }
            }
        }
    ]);
    return Animations;
}();
function awaitAll(animations, properties) {
    var running = [];
    var keys = Object.keys(properties);
    for(var i = 0; i < keys.length; i++){
        var anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    var options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    var opts = scale && scale.options || {};
    var reverse = opts.reverse;
    var min = opts.min === undefined ? allowedOverflow : 0;
    var max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    var x = scaleClip(xScale, allowedOverflow);
    var y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    var t, r, b, l;
    if ((0, $8AEPV.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    var keys = [];
    var metasets = chart._getSortedDatasetMetas(filterVisible);
    var i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var keys = stack.keys;
    var singleMode = options.mode === 'single';
    var i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    var found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $8AEPV.g)(otherValue) && (singleMode || value === 0 || (0, $8AEPV.s)(value) === (0, $8AEPV.s)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function convertObjectDataToArray(data, meta) {
    var iScale = meta.iScale, vScale = meta.vScale;
    var iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    var vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    var keys = Object.keys(data);
    var adata = new Array(keys.length);
    var i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        var _obj;
        adata[i] = (_obj = {}, (0, $k9HNQ._)(_obj, iAxisKey, key), (0, $k9HNQ._)(_obj, vAxisKey, data[key]), _obj);
    }
    return adata;
}
function isStacked(scale, meta) {
    var stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return "".concat(indexScale.id, ".").concat(valueScale.id, ".").concat(meta.stack || meta.type);
}
function getUserBounds(scale) {
    var _scale_getUserBounds = scale.getUserBounds(), min = _scale_getUserBounds.min, max = _scale_getUserBounds.max, minDefined = _scale_getUserBounds.minDefined, maxDefined = _scale_getUserBounds.maxDefined;
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    var subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = vScale.getMatchingVisibleMetas(type).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var meta = _step.value;
            var value = stack[meta.index];
            if (positive && value > 0 || !positive && value < 0) return meta.index;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function updateStacks(controller, parsed) {
    var chart = controller.chart, meta = controller._cachedMeta;
    var stacks = chart._stacks || (chart._stacks = {});
    var iScale = meta.iScale, vScale = meta.vScale, datasetIndex = meta.index;
    var iAxis = iScale.axis;
    var vAxis = vScale.axis;
    var key = getStackKey(iScale, vScale, meta);
    var ilen = parsed.length;
    var stack;
    for(var i = 0; i < ilen; ++i){
        var item = parsed[i];
        var index = item[iAxis], value = item[vAxis];
        var itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        var visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    var scales = chart.scales;
    return Object.keys(scales).filter(function(key) {
        return scales[key].axis === axis;
    }).shift();
}
function createDatasetContext(parent, index) {
    return (0, $8AEPV.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return (0, $8AEPV.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    var datasetIndex = meta.controller.index;
    var axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var parsed = _step.value;
            var stacks = parsed._stacks;
            if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
            delete stacks[axis][datasetIndex];
            if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var isDirectUpdateMode = function(mode) {
    return mode === 'reset' || mode === 'none';
};
var cloneIfNotShared = function(cached, shared) {
    return shared ? cached : Object.assign({}, cached);
};
var createStack = function(canStack, meta, chart) {
    return canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
};
var DatasetController = /*#__PURE__*/ function _target() {
    "use strict";
    function DatasetController(chart, datasetIndex) {
        (0, $bzgVo._)(this, DatasetController);
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = (this instanceof DatasetController ? this.constructor : void 0).datasetElementType;
        this.dataElementType = (this instanceof DatasetController ? this.constructor : void 0).dataElementType;
        this.initialize();
    }
    (0, $gHG1J._)(DatasetController, [
        {
            key: "initialize",
            value: function initialize() {
                var meta = this._cachedMeta;
                this.configure();
                this.linkScales();
                meta._stacked = isStacked(meta.vScale, meta);
                this.addElements();
                if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
            }
        },
        {
            key: "updateIndex",
            value: function updateIndex(datasetIndex) {
                if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
                this.index = datasetIndex;
            }
        },
        {
            key: "linkScales",
            value: function linkScales() {
                var chart = this.chart;
                var meta = this._cachedMeta;
                var dataset = this.getDataset();
                var chooseId = function(axis, x, y, r) {
                    return axis === 'x' ? x : axis === 'r' ? r : y;
                };
                var xid = meta.xAxisID = (0, $8AEPV.v)(dataset.xAxisID, getFirstScaleId(chart, 'x'));
                var yid = meta.yAxisID = (0, $8AEPV.v)(dataset.yAxisID, getFirstScaleId(chart, 'y'));
                var rid = meta.rAxisID = (0, $8AEPV.v)(dataset.rAxisID, getFirstScaleId(chart, 'r'));
                var indexAxis = meta.indexAxis;
                var iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
                var vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
                meta.xScale = this.getScaleForId(xid);
                meta.yScale = this.getScaleForId(yid);
                meta.rScale = this.getScaleForId(rid);
                meta.iScale = this.getScaleForId(iid);
                meta.vScale = this.getScaleForId(vid);
            }
        },
        {
            key: "getDataset",
            value: function getDataset() {
                return this.chart.data.datasets[this.index];
            }
        },
        {
            key: "getMeta",
            value: function getMeta() {
                return this.chart.getDatasetMeta(this.index);
            }
        },
        {
            key: "getScaleForId",
            value: function getScaleForId(scaleID) {
                return this.chart.scales[scaleID];
            }
        },
        {
            key: "_getOtherScale",
            value: function _getOtherScale(scale) {
                var meta = this._cachedMeta;
                return scale === meta.iScale ? meta.vScale : meta.iScale;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._update('reset');
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                var meta = this._cachedMeta;
                if (this._data) (0, $8AEPV.u)(this._data, this);
                if (meta._stacked) clearStacks(meta);
            }
        },
        {
            key: "_dataCheck",
            value: function _dataCheck() {
                var dataset = this.getDataset();
                var data = dataset.data || (dataset.data = []);
                var _data = this._data;
                if ((0, $8AEPV.i)(data)) {
                    var meta = this._cachedMeta;
                    this._data = convertObjectDataToArray(data, meta);
                } else if (_data !== data) {
                    if (_data) {
                        (0, $8AEPV.u)(_data, this);
                        var meta1 = this._cachedMeta;
                        clearStacks(meta1);
                        meta1._parsed = [];
                    }
                    if (data && Object.isExtensible(data)) (0, $8AEPV.l)(data, this);
                    this._syncList = [];
                    this._data = data;
                }
            }
        },
        {
            key: "addElements",
            value: function addElements() {
                var meta = this._cachedMeta;
                this._dataCheck();
                if (this.datasetElementType) meta.dataset = new this.datasetElementType();
            }
        },
        {
            key: "buildOrUpdateElements",
            value: function buildOrUpdateElements(resetNewElements) {
                var meta = this._cachedMeta;
                var dataset = this.getDataset();
                var stackChanged = false;
                this._dataCheck();
                var oldStacked = meta._stacked;
                meta._stacked = isStacked(meta.vScale, meta);
                if (meta.stack !== dataset.stack) {
                    stackChanged = true;
                    clearStacks(meta);
                    meta.stack = dataset.stack;
                }
                this._resyncElements(resetNewElements);
                if (stackChanged || oldStacked !== meta._stacked) {
                    updateStacks(this, meta._parsed);
                    meta._stacked = isStacked(meta.vScale, meta);
                }
            }
        },
        {
            key: "configure",
            value: function configure() {
                var config = this.chart.config;
                var scopeKeys = config.datasetScopeKeys(this._type);
                var scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
                this.options = config.createResolver(scopes, this.getContext());
                this._parsing = this.options.parsing;
                this._cachedDataOpts = {};
            }
        },
        {
            key: "parse",
            value: function parse(start, count) {
                var _this = this, meta = _this._cachedMeta, data = _this._data;
                var iScale = meta.iScale, _stacked = meta._stacked;
                var iAxis = iScale.axis;
                var sorted = start === 0 && count === data.length ? true : meta._sorted;
                var prev = start > 0 && meta._parsed[start - 1];
                var i, cur, parsed;
                if (this._parsing === false) {
                    meta._parsed = data;
                    meta._sorted = true;
                    parsed = data;
                } else {
                    if ((0, $8AEPV.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
                    else if ((0, $8AEPV.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
                    else parsed = this.parsePrimitiveData(meta, data, start, count);
                    var isNotInOrderComparedToPrev = function() {
                        return cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
                    };
                    for(i = 0; i < count; ++i){
                        meta._parsed[i + start] = cur = parsed[i];
                        if (sorted) {
                            if (isNotInOrderComparedToPrev()) sorted = false;
                            prev = cur;
                        }
                    }
                    meta._sorted = sorted;
                }
                if (_stacked) updateStacks(this, parsed);
            }
        },
        {
            key: "parsePrimitiveData",
            value: function parsePrimitiveData(meta, data, start, count) {
                var iScale = meta.iScale, vScale = meta.vScale;
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                var labels = iScale.getLabels();
                var singleScale = iScale === vScale;
                var parsed = new Array(count);
                var i, ilen, index;
                for(i = 0, ilen = count; i < ilen; ++i){
                    index = i + start;
                    var _obj;
                    parsed[i] = (_obj = {}, (0, $k9HNQ._)(_obj, iAxis, singleScale || iScale.parse(labels[index], index)), (0, $k9HNQ._)(_obj, vAxis, vScale.parse(data[index], index)), _obj);
                }
                return parsed;
            }
        },
        {
            key: "parseArrayData",
            value: function parseArrayData(meta, data, start, count) {
                var xScale = meta.xScale, yScale = meta.yScale;
                var parsed = new Array(count);
                var i, ilen, index, item;
                for(i = 0, ilen = count; i < ilen; ++i){
                    index = i + start;
                    item = data[index];
                    parsed[i] = {
                        x: xScale.parse(item[0], index),
                        y: yScale.parse(item[1], index)
                    };
                }
                return parsed;
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                var xScale = meta.xScale, yScale = meta.yScale;
                var _this__parsing = this._parsing, _this__parsing_xAxisKey = _this__parsing.xAxisKey, xAxisKey = _this__parsing_xAxisKey === void 0 ? 'x' : _this__parsing_xAxisKey, _this__parsing_yAxisKey = _this__parsing.yAxisKey, yAxisKey = _this__parsing_yAxisKey === void 0 ? 'y' : _this__parsing_yAxisKey;
                var parsed = new Array(count);
                var i, ilen, index, item;
                for(i = 0, ilen = count; i < ilen; ++i){
                    index = i + start;
                    item = data[index];
                    parsed[i] = {
                        x: xScale.parse((0, $8AEPV.f)(item, xAxisKey), index),
                        y: yScale.parse((0, $8AEPV.f)(item, yAxisKey), index)
                    };
                }
                return parsed;
            }
        },
        {
            key: "getParsed",
            value: function getParsed(index) {
                return this._cachedMeta._parsed[index];
            }
        },
        {
            key: "getDataElement",
            value: function getDataElement(index) {
                return this._cachedMeta.data[index];
            }
        },
        {
            key: "applyStack",
            value: function applyStack1(scale, parsed, mode) {
                var chart = this.chart;
                var meta = this._cachedMeta;
                var value = parsed[scale.axis];
                var stack = {
                    keys: getSortedDatasetIndices(chart, true),
                    values: parsed._stacks[scale.axis]._visualValues
                };
                return applyStack(stack, value, meta.index, {
                    mode: mode
                });
            }
        },
        {
            key: "updateRangeFromParsed",
            value: function updateRangeFromParsed(range, scale, parsed, stack) {
                var parsedValue = parsed[scale.axis];
                var value = parsedValue === null ? NaN : parsedValue;
                var values = stack && parsed._stacks[scale.axis];
                if (stack && values) {
                    stack.values = values;
                    value = applyStack(stack, parsedValue, this._cachedMeta.index);
                }
                range.min = Math.min(range.min, value);
                range.max = Math.max(range.max, value);
            }
        },
        {
            key: "getMinMax",
            value: function getMinMax(scale, canStack) {
                var meta = this._cachedMeta;
                var _parsed = meta._parsed;
                var sorted = meta._sorted && scale === meta.iScale;
                var ilen = _parsed.length;
                var otherScale = this._getOtherScale(scale);
                var stack = createStack(canStack, meta, this.chart);
                var range = {
                    min: Number.POSITIVE_INFINITY,
                    max: Number.NEGATIVE_INFINITY
                };
                var _getUserBounds = getUserBounds(otherScale), otherMin = _getUserBounds.min, otherMax = _getUserBounds.max;
                var i, parsed;
                function _skip() {
                    parsed = _parsed[i];
                    var otherValue = parsed[otherScale.axis];
                    return !(0, $8AEPV.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
                }
                for(i = 0; i < ilen; ++i){
                    if (_skip()) continue;
                    this.updateRangeFromParsed(range, scale, parsed, stack);
                    if (sorted) break;
                }
                if (sorted) for(i = ilen - 1; i >= 0; --i){
                    if (_skip()) continue;
                    this.updateRangeFromParsed(range, scale, parsed, stack);
                    break;
                }
                return range;
            }
        },
        {
            key: "getAllParsedValues",
            value: function getAllParsedValues(scale) {
                var parsed = this._cachedMeta._parsed;
                var values = [];
                var i, ilen, value;
                for(i = 0, ilen = parsed.length; i < ilen; ++i){
                    value = parsed[i][scale.axis];
                    if ((0, $8AEPV.g)(value)) values.push(value);
                }
                return values;
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                return false;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var iScale = meta.iScale;
                var vScale = meta.vScale;
                var parsed = this.getParsed(index);
                return {
                    label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
                    value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
                };
            }
        },
        {
            key: "_update",
            value: function _update(mode) {
                var meta = this._cachedMeta;
                this.update(mode || 'default');
                meta._clip = toClip((0, $8AEPV.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
            }
        },
        {
            key: "update",
            value: function update(mode) {}
        },
        {
            key: "draw",
            value: function draw() {
                var ctx = this._ctx;
                var chart = this.chart;
                var meta = this._cachedMeta;
                var elements = meta.data || [];
                var area = chart.chartArea;
                var active = [];
                var start = this._drawStart || 0;
                var count = this._drawCount || elements.length - start;
                var drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
                var i;
                if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
                for(i = start; i < start + count; ++i){
                    var element = elements[i];
                    if (element.hidden) continue;
                    if (element.active && drawActiveElementsOnTop) active.push(element);
                    else element.draw(ctx, area);
                }
                for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
            }
        },
        {
            key: "getStyle",
            value: function getStyle(index, active) {
                var mode = active ? 'active' : 'default';
                return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
            }
        },
        {
            key: "getContext",
            value: function getContext(index, active, mode) {
                var dataset = this.getDataset();
                var context;
                if (index >= 0 && index < this._cachedMeta.data.length) {
                    var element = this._cachedMeta.data[index];
                    context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
                    context.parsed = this.getParsed(index);
                    context.raw = dataset.data[index];
                    context.index = context.dataIndex = index;
                } else {
                    context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
                    context.dataset = dataset;
                    context.index = context.datasetIndex = this.index;
                }
                context.active = !!active;
                context.mode = mode;
                return context;
            }
        },
        {
            key: "resolveDatasetElementOptions",
            value: function resolveDatasetElementOptions(mode) {
                return this._resolveElementOptions(this.datasetElementType.id, mode);
            }
        },
        {
            key: "resolveDataElementOptions",
            value: function resolveDataElementOptions(index, mode) {
                return this._resolveElementOptions(this.dataElementType.id, mode, index);
            }
        },
        {
            key: "_resolveElementOptions",
            value: function _resolveElementOptions(elementType) {
                var _this = this;
                var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'default', index = arguments.length > 2 ? arguments[2] : void 0;
                var active = mode === 'active';
                var cache = this._cachedDataOpts;
                var cacheKey = elementType + '-' + mode;
                var cached = cache[cacheKey];
                var sharing = this.enableOptionSharing && (0, $8AEPV.h)(index);
                if (cached) return cloneIfNotShared(cached, sharing);
                var config = this.chart.config;
                var scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
                var prefixes = active ? [
                    "".concat(elementType, "Hover"),
                    'hover',
                    elementType,
                    ''
                ] : [
                    elementType,
                    ''
                ];
                var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
                var names = Object.keys((0, $8AEPV.d).elements[elementType]);
                var context = function() {
                    return _this.getContext(index, active, mode);
                };
                var values = config.resolveNamedOptions(scopes, names, context, prefixes);
                if (values.$shared) {
                    values.$shared = sharing;
                    cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
                }
                return values;
            }
        },
        {
            key: "_resolveAnimations",
            value: function _resolveAnimations(index, transition, active) {
                var chart = this.chart;
                var cache = this._cachedDataOpts;
                var cacheKey = "animation-".concat(transition);
                var cached = cache[cacheKey];
                if (cached) return cached;
                var options;
                if (chart.options.animation !== false) {
                    var config = this.chart.config;
                    var scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
                    var scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
                    options = config.createResolver(scopes, this.getContext(index, active, transition));
                }
                var animations = new Animations(chart, options && options.animations);
                if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
                return animations;
            }
        },
        {
            key: "getSharedOptions",
            value: function getSharedOptions(options) {
                if (!options.$shared) return;
                return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
            }
        },
        {
            key: "includeOptions",
            value: function includeOptions(mode, sharedOptions) {
                return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
            }
        },
        {
            key: "_getSharedOptions",
            value: function _getSharedOptions(start, mode) {
                var firstOpts = this.resolveDataElementOptions(start, mode);
                var previouslySharedOptions = this._sharedOptions;
                var sharedOptions = this.getSharedOptions(firstOpts);
                var includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
                this.updateSharedOptions(sharedOptions, mode, firstOpts);
                return {
                    sharedOptions: sharedOptions,
                    includeOptions: includeOptions
                };
            }
        },
        {
            key: "updateElement",
            value: function updateElement(element, index, properties, mode) {
                if (isDirectUpdateMode(mode)) Object.assign(element, properties);
                else this._resolveAnimations(index, mode).update(element, properties);
            }
        },
        {
            key: "updateSharedOptions",
            value: function updateSharedOptions(sharedOptions, mode, newOptions) {
                if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
            }
        },
        {
            key: "_setStyle",
            value: function _setStyle(element, index, mode, active) {
                element.active = active;
                var options = this.getStyle(index, active);
                this._resolveAnimations(index, mode, active).update(element, {
                    options: !active && this.getSharedOptions(options) || options
                });
            }
        },
        {
            key: "removeHoverStyle",
            value: function removeHoverStyle(element, datasetIndex, index) {
                this._setStyle(element, index, 'active', false);
            }
        },
        {
            key: "setHoverStyle",
            value: function setHoverStyle(element, datasetIndex, index) {
                this._setStyle(element, index, 'active', true);
            }
        },
        {
            key: "_removeDatasetHoverStyle",
            value: function _removeDatasetHoverStyle() {
                var element = this._cachedMeta.dataset;
                if (element) this._setStyle(element, undefined, 'active', false);
            }
        },
        {
            key: "_setDatasetHoverStyle",
            value: function _setDatasetHoverStyle() {
                var element = this._cachedMeta.dataset;
                if (element) this._setStyle(element, undefined, 'active', true);
            }
        },
        {
            key: "_resyncElements",
            value: function _resyncElements(resetNewElements) {
                var data = this._data;
                var elements = this._cachedMeta.data;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._syncList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8Hr86._)(_step.value, 3), method = _step_value[0], arg1 = _step_value[1], arg2 = _step_value[2];
                        this[method](arg1, arg2);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._syncList = [];
                var numMeta = elements.length;
                var numData = data.length;
                var count = Math.min(numData, numMeta);
                if (count) this.parse(0, count);
                if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
                else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
            }
        },
        {
            key: "_insertElements",
            value: function _insertElements(start, count) {
                var resetNewElements = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var meta = this._cachedMeta;
                var data = meta.data;
                var end = start + count;
                var i;
                var move = function(arr) {
                    arr.length += count;
                    for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
                };
                move(data);
                for(i = start; i < end; ++i)data[i] = new this.dataElementType();
                if (this._parsing) move(meta._parsed);
                this.parse(start, count);
                if (resetNewElements) this.updateElements(data, start, count, 'reset');
            }
        },
        {
            key: "updateElements",
            value: function updateElements(element, start, count, mode) {}
        },
        {
            key: "_removeElements",
            value: function _removeElements(start, count) {
                var meta = this._cachedMeta;
                if (this._parsing) {
                    var removed = meta._parsed.splice(start, count);
                    if (meta._stacked) clearStacks(meta, removed);
                }
                meta.data.splice(start, count);
            }
        },
        {
            key: "_sync",
            value: function _sync(args) {
                if (this._parsing) this._syncList.push(args);
                else {
                    var _args = (0, $8Hr86._)(args, 3), method = _args[0], arg1 = _args[1], arg2 = _args[2];
                    this[method](arg1, arg2);
                }
                this.chart._dataChanges.push([
                    this.index
                ].concat((0, $2l5av._)(args)));
            }
        },
        {
            key: "_onDataPush",
            value: function _onDataPush() {
                var count = arguments.length;
                this._sync([
                    '_insertElements',
                    this.getDataset().data.length - count,
                    count
                ]);
            }
        },
        {
            key: "_onDataPop",
            value: function _onDataPop() {
                this._sync([
                    '_removeElements',
                    this._cachedMeta.data.length - 1,
                    1
                ]);
            }
        },
        {
            key: "_onDataShift",
            value: function _onDataShift() {
                this._sync([
                    '_removeElements',
                    0,
                    1
                ]);
            }
        },
        {
            key: "_onDataSplice",
            value: function _onDataSplice(start, count) {
                if (count) this._sync([
                    '_removeElements',
                    start,
                    count
                ]);
                var newCount = arguments.length - 2;
                if (newCount) this._sync([
                    '_insertElements',
                    start,
                    newCount
                ]);
            }
        },
        {
            key: "_onDataUnshift",
            value: function _onDataUnshift() {
                this._sync([
                    '_insertElements',
                    0,
                    arguments.length
                ]);
            }
        }
    ]);
    return DatasetController;
}();
(0, $k9HNQ._)(DatasetController, "defaults", {});
(0, $k9HNQ._)(DatasetController, "datasetElementType", null);
(0, $k9HNQ._)(DatasetController, "dataElementType", null);
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        var visibleMetas = scale.getMatchingVisibleMetas(type);
        var values = [];
        for(var i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $8AEPV._)(values.sort(function(a, b) {
            return a - b;
        }));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    var scale = meta.iScale;
    var values = getAllScaleValues(scale, meta.type);
    var min = scale._length;
    var i, ilen, curr, prev;
    var updateMinAndPrev = function() {
        if (curr === 32767 || curr === -32768) return;
        if ((0, $8AEPV.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    var thickness = options.barThickness;
    var size, ratio;
    if ((0, $8AEPV.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    var pixels = ruler.pixels;
    var curr = pixels[index];
    var prev = index > 0 ? pixels[index - 1] : null;
    var next = index < pixels.length - 1 ? pixels[index + 1] : null;
    var percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    var start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    var size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    var startValue = vScale.parse(entry[0], i);
    var endValue = vScale.parse(entry[1], i);
    var min = Math.min(startValue, endValue);
    var max = Math.max(startValue, endValue);
    var barStart = min;
    var barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, $8AEPV.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    var iScale = meta.iScale;
    var vScale = meta.vScale;
    var labels = iScale.getLabels();
    var singleScale = iScale === vScale;
    var parsed = [];
    var i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $8AEPV.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    var reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    var edge = options.borderSkipped;
    var res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    var _borderProps = borderProps(properties), start = _borderProps.start, end = _borderProps.end, reverse = _borderProps.reverse, top = _borderProps.top, bottom = _borderProps.bottom;
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, param, ratio) {
    var inflateAmount = param.inflateAmount;
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
var BarController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $fwyhh._)(BarController, DatasetController);
    function BarController() {
        (0, $bzgVo._)(this, BarController);
        return (0, $lXwto._)(this, BarController, arguments);
    }
    (0, $gHG1J._)(BarController, [
        {
            key: "parsePrimitiveData",
            value: function parsePrimitiveData(meta, data, start, count) {
                return parseArrayOrPrimitive(meta, data, start, count);
            }
        },
        {
            key: "parseArrayData",
            value: function parseArrayData(meta, data, start, count) {
                return parseArrayOrPrimitive(meta, data, start, count);
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                var iScale = meta.iScale, vScale = meta.vScale;
                var _this__parsing = this._parsing, _this__parsing_xAxisKey = _this__parsing.xAxisKey, xAxisKey = _this__parsing_xAxisKey === void 0 ? 'x' : _this__parsing_xAxisKey, _this__parsing_yAxisKey = _this__parsing.yAxisKey, yAxisKey = _this__parsing_yAxisKey === void 0 ? 'y' : _this__parsing_yAxisKey;
                var iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
                var vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
                var parsed = [];
                var i, ilen, item, obj;
                for(i = start, ilen = start + count; i < ilen; ++i){
                    obj = data[i];
                    item = {};
                    item[iScale.axis] = iScale.parse((0, $8AEPV.f)(obj, iAxisKey), i);
                    parsed.push(parseValue((0, $8AEPV.f)(obj, vAxisKey), item, vScale, i));
                }
                return parsed;
            }
        },
        {
            key: "updateRangeFromParsed",
            value: function updateRangeFromParsed(range, scale, parsed, stack) {
                (0, $8wpvj._)((0, $grPlv._)(BarController.prototype), "updateRangeFromParsed", this).call(this, range, scale, parsed, stack);
                var custom = parsed._custom;
                if (custom && scale === this._cachedMeta.vScale) {
                    range.min = Math.min(range.min, custom.min);
                    range.max = Math.max(range.max, custom.max);
                }
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                return 0;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var iScale = meta.iScale, vScale = meta.vScale;
                var parsed = this.getParsed(index);
                var custom = parsed._custom;
                var value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
                return {
                    label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
                    value: value
                };
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                this.enableOptionSharing = true;
                (0, $8wpvj._)((0, $grPlv._)(BarController.prototype), "initialize", this).call(this);
                var meta = this._cachedMeta;
                meta.stack = this.getDataset().stack;
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                this.updateElements(meta.data, 0, meta.data.length, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(bars, start, count, mode) {
                var reset = mode === 'reset';
                var _this = this, index = _this.index, vScale = _this._cachedMeta.vScale;
                var base = vScale.getBasePixel();
                var horizontal = vScale.isHorizontal();
                var ruler = this._getRuler();
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                for(var i = start; i < start + count; i++){
                    var parsed = this.getParsed(i);
                    var vpixels = reset || (0, $8AEPV.k)(parsed[vScale.axis]) ? {
                        base: base,
                        head: base
                    } : this._calculateBarValuePixels(i);
                    var ipixels = this._calculateBarIndexPixels(i, ruler);
                    var stack = (parsed._stacks || {})[vScale.axis];
                    var properties = {
                        horizontal: horizontal,
                        base: vpixels.base,
                        enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                        x: horizontal ? vpixels.head : ipixels.center,
                        y: horizontal ? ipixels.center : vpixels.head,
                        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
                    };
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
                    var options = properties.options || bars[i].options;
                    setBorderSkipped(properties, options, stack, index);
                    setInflateAmount(properties, options, ruler.ratio);
                    this.updateElement(bars[i], i, properties, mode);
                }
            }
        },
        {
            key: "_getStacks",
            value: function _getStacks(last, dataIndex) {
                var iScale = this._cachedMeta.iScale;
                var metasets = iScale.getMatchingVisibleMetas(this._type).filter(function(meta) {
                    return meta.controller.options.grouped;
                });
                var stacked = iScale.options.stacked;
                var stacks = [];
                var currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
                var iScaleValue = currentParsed && currentParsed[iScale.axis];
                var skipNull = function(meta) {
                    var parsed = meta._parsed.find(function(item) {
                        return item[iScale.axis] === iScaleValue;
                    });
                    var val = parsed && parsed[meta.vScale.axis];
                    if ((0, $8AEPV.k)(val) || isNaN(val)) return true;
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = metasets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var meta = _step.value;
                        if (dataIndex !== undefined && skipNull(meta)) continue;
                        if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                        if (meta.index === last) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (!stacks.length) stacks.push(undefined);
                return stacks;
            }
        },
        {
            key: "_getStackCount",
            value: function _getStackCount(index) {
                return this._getStacks(undefined, index).length;
            }
        },
        {
            key: "_getAxisCount",
            value: function _getAxisCount() {
                return this._getAxis().length;
            }
        },
        {
            key: "getFirstScaleIdForIndexAxis",
            value: function getFirstScaleIdForIndexAxis() {
                var scales = this.chart.scales;
                var indexScaleId = this.chart.options.indexAxis;
                return Object.keys(scales).filter(function(key) {
                    return scales[key].axis === indexScaleId;
                }).shift();
            }
        },
        {
            key: "_getAxis",
            value: function _getAxis() {
                var axis = {};
                var firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.chart.data.datasets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataset = _step.value;
                        axis[(0, $8AEPV.v)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Object.keys(axis);
            }
        },
        {
            key: "_getStackIndex",
            value: function _getStackIndex(datasetIndex, name, dataIndex) {
                var stacks = this._getStacks(datasetIndex, dataIndex);
                var index = name !== undefined ? stacks.indexOf(name) : -1;
                return index === -1 ? stacks.length - 1 : index;
            }
        },
        {
            key: "_getRuler",
            value: function _getRuler() {
                var opts = this.options;
                var meta = this._cachedMeta;
                var iScale = meta.iScale;
                var pixels = [];
                var i, ilen;
                for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
                var barThickness = opts.barThickness;
                var min = barThickness || computeMinSampleSize(meta);
                return {
                    min: min,
                    pixels: pixels,
                    start: iScale._startPixel,
                    end: iScale._endPixel,
                    stackCount: this._getStackCount(),
                    scale: iScale,
                    grouped: opts.grouped,
                    ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
                };
            }
        },
        {
            key: "_calculateBarValuePixels",
            value: function _calculateBarValuePixels(index) {
                var _this = this, _this__cachedMeta = _this._cachedMeta, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, datasetIndex = _this__cachedMeta.index, _this_options = _this.options, baseValue = _this_options.base, minBarLength = _this_options.minBarLength;
                var actualBase = baseValue || 0;
                var parsed = this.getParsed(index);
                var custom = parsed._custom;
                var floating = isFloatBar(custom);
                var value = parsed[vScale.axis];
                var start = 0;
                var length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
                var head, size;
                if (length !== value) {
                    start = length - value;
                    length = value;
                }
                if (floating) {
                    value = custom.barStart;
                    length = custom.barEnd - custom.barStart;
                    if (value !== 0 && (0, $8AEPV.s)(value) !== (0, $8AEPV.s)(custom.barEnd)) start = 0;
                    start += value;
                }
                var startValue = !(0, $8AEPV.k)(baseValue) && !floating ? baseValue : start;
                var base = vScale.getPixelForValue(startValue);
                if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
                else head = base;
                size = head - base;
                if (Math.abs(size) < minBarLength) {
                    size = barSign(size, vScale, actualBase) * minBarLength;
                    if (value === actualBase) base -= size / 2;
                    var startPixel = vScale.getPixelForDecimal(0);
                    var endPixel = vScale.getPixelForDecimal(1);
                    var min = Math.min(startPixel, endPixel);
                    var max = Math.max(startPixel, endPixel);
                    base = Math.max(Math.min(base, max), min);
                    head = base + size;
                    if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
                }
                if (base === vScale.getPixelForValue(actualBase)) {
                    var halfGrid = (0, $8AEPV.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
                    base += halfGrid;
                    size -= halfGrid;
                }
                return {
                    size: size,
                    base: base,
                    head: head,
                    center: head + size / 2
                };
            }
        },
        {
            key: "_calculateBarIndexPixels",
            value: function _calculateBarIndexPixels(index, ruler) {
                var scale = ruler.scale;
                var options = this.options;
                var skipNull = options.skipNull;
                var maxBarThickness = (0, $8AEPV.v)(options.maxBarThickness, Infinity);
                var center, size;
                var axisCount = this._getAxisCount();
                if (ruler.grouped) {
                    var stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
                    var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
                    var axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
                    var axisNumber = this._getAxis().indexOf((0, $8AEPV.v)(axisID, this.getFirstScaleIdForIndexAxis()));
                    var stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
                    center = range.start + range.chunk * stackIndex + range.chunk / 2;
                    size = Math.min(maxBarThickness, range.chunk * range.ratio);
                } else {
                    center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
                    size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
                }
                return {
                    base: center - size / 2,
                    head: center + size / 2,
                    center: center,
                    size: size
                };
            }
        },
        {
            key: "draw",
            value: function draw() {
                var meta = this._cachedMeta;
                var vScale = meta.vScale;
                var rects = meta.data;
                var ilen = rects.length;
                var i = 0;
                for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
            }
        }
    ]);
    return BarController;
}(DatasetController);
(0, $k9HNQ._)(BarController, "id", 'bar');
(0, $k9HNQ._)(BarController, "defaults", {
    datasetElementType: false,
    dataElementType: 'bar',
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'base',
                'width',
                'height'
            ]
        }
    }
});
(0, $k9HNQ._)(BarController, "overrides", {
    scales: {
        _index_: {
            type: 'category',
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: 'linear',
            beginAtZero: true
        }
    }
});
var BubbleController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $fwyhh._)(BubbleController, DatasetController);
    function BubbleController() {
        (0, $bzgVo._)(this, BubbleController);
        return (0, $lXwto._)(this, BubbleController, arguments);
    }
    (0, $gHG1J._)(BubbleController, [
        {
            key: "initialize",
            value: function initialize() {
                this.enableOptionSharing = true;
                (0, $8wpvj._)((0, $grPlv._)(BubbleController.prototype), "initialize", this).call(this);
            }
        },
        {
            key: "parsePrimitiveData",
            value: function parsePrimitiveData(meta, data, start, count) {
                var parsed = (0, $8wpvj._)((0, $grPlv._)(BubbleController.prototype), "parsePrimitiveData", this).call(this, meta, data, start, count);
                for(var i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
                return parsed;
            }
        },
        {
            key: "parseArrayData",
            value: function parseArrayData(meta, data, start, count) {
                var parsed = (0, $8wpvj._)((0, $grPlv._)(BubbleController.prototype), "parseArrayData", this).call(this, meta, data, start, count);
                for(var i = 0; i < parsed.length; i++){
                    var item = data[start + i];
                    parsed[i]._custom = (0, $8AEPV.v)(item[2], this.resolveDataElementOptions(i + start).radius);
                }
                return parsed;
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                var parsed = (0, $8wpvj._)((0, $grPlv._)(BubbleController.prototype), "parseObjectData", this).call(this, meta, data, start, count);
                for(var i = 0; i < parsed.length; i++){
                    var item = data[start + i];
                    parsed[i]._custom = (0, $8AEPV.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
                }
                return parsed;
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                var data = this._cachedMeta.data;
                var max = 0;
                for(var i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
                return max > 0 && max;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var labels = this.chart.data.labels || [];
                var xScale = meta.xScale, yScale = meta.yScale;
                var parsed = this.getParsed(index);
                var x = xScale.getLabelForValue(parsed.x);
                var y = yScale.getLabelForValue(parsed.y);
                var r = parsed._custom;
                return {
                    label: labels[index] || '',
                    value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
                };
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var points = this._cachedMeta.data;
                this.updateElements(points, 0, points.length, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var reset = mode === 'reset';
                var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale;
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                for(var i = start; i < start + count; i++){
                    var point = points[i];
                    var parsed = !reset && this.getParsed(i);
                    var properties = {};
                    var iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
                    var vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
                    properties.skip = isNaN(iPixel) || isNaN(vPixel);
                    if (includeOptions) {
                        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                        if (reset) properties.options.radius = 0;
                    }
                    this.updateElement(point, i, properties, mode);
                }
            }
        },
        {
            key: "resolveDataElementOptions",
            value: function resolveDataElementOptions(index, mode) {
                var parsed = this.getParsed(index);
                var values = (0, $8wpvj._)((0, $grPlv._)(BubbleController.prototype), "resolveDataElementOptions", this).call(this, index, mode);
                if (values.$shared) values = Object.assign({}, values, {
                    $shared: false
                });
                var radius = values.radius;
                if (mode !== 'active') values.radius = 0;
                values.radius += (0, $8AEPV.v)(parsed && parsed._custom, radius);
                return values;
            }
        }
    ]);
    return BubbleController;
}(DatasetController);
(0, $k9HNQ._)(BubbleController, "id", 'bubble');
(0, $k9HNQ._)(BubbleController, "defaults", {
    datasetElementType: false,
    dataElementType: 'point',
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'borderWidth',
                'radius'
            ]
        }
    }
});
(0, $k9HNQ._)(BubbleController, "overrides", {
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
});
function getRatioAndOffset(rotation, circumference, cutout) {
    var ratioX = 1;
    var ratioY = 1;
    var offsetX = 0;
    var offsetY = 0;
    if (circumference < (0, $8AEPV.T)) {
        var startAngle = rotation;
        var endAngle = startAngle + circumference;
        var startX = Math.cos(startAngle);
        var startY = Math.sin(startAngle);
        var endX = Math.cos(endAngle);
        var endY = Math.sin(endAngle);
        var calcMax = function(angle, a, b) {
            return (0, $8AEPV.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        };
        var calcMin = function(angle, a, b) {
            return (0, $8AEPV.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        };
        var maxX = calcMax(0, startX, endX);
        var maxY = calcMax((0, $8AEPV.H), startY, endY);
        var minX = calcMin((0, $8AEPV.P), startX, endX);
        var minY = calcMin((0, $8AEPV.P) + (0, $8AEPV.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
var DoughnutController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $fwyhh._)(DoughnutController, DatasetController);
    function DoughnutController(chart, datasetIndex) {
        (0, $bzgVo._)(this, DoughnutController);
        var _this;
        _this = (0, $lXwto._)(this, DoughnutController, [
            chart,
            datasetIndex
        ]);
        _this.enableOptionSharing = true;
        _this.innerRadius = undefined;
        _this.outerRadius = undefined;
        _this.offsetX = undefined;
        _this.offsetY = undefined;
        return _this;
    }
    (0, $gHG1J._)(DoughnutController, [
        {
            key: "linkScales",
            value: function linkScales() {}
        },
        {
            key: "parse",
            value: function parse(start, count) {
                var data = this.getDataset().data;
                var meta = this._cachedMeta;
                if (this._parsing === false) meta._parsed = data;
                else {
                    var getter = function(i) {
                        return +data[i];
                    };
                    if ((0, $8AEPV.i)(data[start])) {
                        var _this__parsing = this._parsing, _this__parsing_key = _this__parsing.key, key = _this__parsing_key === void 0 ? 'value' : _this__parsing_key;
                        getter = function(i) {
                            return +(0, $8AEPV.f)(data[i], key);
                        };
                    }
                    var i, ilen;
                    for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
                }
            }
        },
        {
            key: "_getRotation",
            value: function _getRotation() {
                return (0, $8AEPV.t)(this.options.rotation - 90);
            }
        },
        {
            key: "_getCircumference",
            value: function _getCircumference() {
                return (0, $8AEPV.t)(this.options.circumference);
            }
        },
        {
            key: "_getRotationExtents",
            value: function _getRotationExtents() {
                var min = (0, $8AEPV.T);
                var max = -(0, $8AEPV.T);
                for(var i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
                    var controller = this.chart.getDatasetMeta(i).controller;
                    var rotation = controller._getRotation();
                    var circumference = controller._getCircumference();
                    min = Math.min(min, rotation);
                    max = Math.max(max, rotation + circumference);
                }
                return {
                    rotation: min,
                    circumference: max - min
                };
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var chart = this.chart;
                var chartArea = chart.chartArea;
                var meta = this._cachedMeta;
                var arcs = meta.data;
                var spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
                var maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
                var cutout = Math.min((0, $8AEPV.m)(this.options.cutout, maxSize), 1);
                var chartWeight = this._getRingWeight(this.index);
                var _this__getRotationExtents = this._getRotationExtents(), circumference = _this__getRotationExtents.circumference, rotation = _this__getRotationExtents.rotation;
                var _getRatioAndOffset = getRatioAndOffset(rotation, circumference, cutout), ratioX = _getRatioAndOffset.ratioX, ratioY = _getRatioAndOffset.ratioY, offsetX = _getRatioAndOffset.offsetX, offsetY = _getRatioAndOffset.offsetY;
                var maxWidth = (chartArea.width - spacing) / ratioX;
                var maxHeight = (chartArea.height - spacing) / ratioY;
                var maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
                var outerRadius = (0, $8AEPV.n)(this.options.radius, maxRadius);
                var innerRadius = Math.max(outerRadius * cutout, 0);
                var radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
                this.offsetX = offsetX * outerRadius;
                this.offsetY = offsetY * outerRadius;
                meta.total = this.calculateTotal();
                this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
                this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
                this.updateElements(arcs, 0, arcs.length, mode);
            }
        },
        {
            key: "_circumference",
            value: function _circumference(i, reset) {
                var opts = this.options;
                var meta = this._cachedMeta;
                var circumference = this._getCircumference();
                if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
                return this.calculateCircumference(meta._parsed[i] * circumference / (0, $8AEPV.T));
            }
        },
        {
            key: "updateElements",
            value: function updateElements(arcs, start, count, mode) {
                var reset = mode === 'reset';
                var chart = this.chart;
                var chartArea = chart.chartArea;
                var opts = chart.options;
                var animationOpts = opts.animation;
                var centerX = (chartArea.left + chartArea.right) / 2;
                var centerY = (chartArea.top + chartArea.bottom) / 2;
                var animateScale = reset && animationOpts.animateScale;
                var innerRadius = animateScale ? 0 : this.innerRadius;
                var outerRadius = animateScale ? 0 : this.outerRadius;
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                var startAngle = this._getRotation();
                var i;
                for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
                for(i = start; i < start + count; ++i){
                    var circumference = this._circumference(i, reset);
                    var arc = arcs[i];
                    var properties = {
                        x: centerX + this.offsetX,
                        y: centerY + this.offsetY,
                        startAngle: startAngle,
                        endAngle: startAngle + circumference,
                        circumference: circumference,
                        outerRadius: outerRadius,
                        innerRadius: innerRadius
                    };
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
                    startAngle += circumference;
                    this.updateElement(arc, i, properties, mode);
                }
            }
        },
        {
            key: "calculateTotal",
            value: function calculateTotal() {
                var meta = this._cachedMeta;
                var metaData = meta.data;
                var total = 0;
                var i;
                for(i = 0; i < metaData.length; i++){
                    var value = meta._parsed[i];
                    if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
                }
                return total;
            }
        },
        {
            key: "calculateCircumference",
            value: function calculateCircumference(value) {
                var total = this._cachedMeta.total;
                if (total > 0 && !isNaN(value)) return (0, $8AEPV.T) * (Math.abs(value) / total);
                return 0;
            }
        },
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var chart = this.chart;
                var labels = chart.data.labels || [];
                var value = (0, $8AEPV.o)(meta._parsed[index], chart.options.locale);
                return {
                    label: labels[index] || '',
                    value: value
                };
            }
        },
        {
            key: "getMaxBorderWidth",
            value: function getMaxBorderWidth(arcs) {
                var max = 0;
                var chart = this.chart;
                var i, ilen, meta, controller, options;
                if (!arcs) {
                    for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                        meta = chart.getDatasetMeta(i);
                        arcs = meta.data;
                        controller = meta.controller;
                        break;
                    }
                }
                if (!arcs) return 0;
                for(i = 0, ilen = arcs.length; i < ilen; ++i){
                    options = controller.resolveDataElementOptions(i);
                    if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
                }
                return max;
            }
        },
        {
            key: "getMaxOffset",
            value: function getMaxOffset(arcs) {
                var max = 0;
                for(var i = 0, ilen = arcs.length; i < ilen; ++i){
                    var options = this.resolveDataElementOptions(i);
                    max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
                }
                return max;
            }
        },
        {
            key: "_getRingWeightOffset",
            value: function _getRingWeightOffset(datasetIndex) {
                var ringWeightOffset = 0;
                for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
                return ringWeightOffset;
            }
        },
        {
            key: "_getRingWeight",
            value: function _getRingWeight(datasetIndex) {
                return Math.max((0, $8AEPV.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
            }
        },
        {
            key: "_getVisibleDatasetWeightTotal",
            value: function _getVisibleDatasetWeightTotal() {
                return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
            }
        }
    ]);
    return DoughnutController;
}(DatasetController);
(0, $k9HNQ._)(DoughnutController, "id", 'doughnut');
(0, $k9HNQ._)(DoughnutController, "defaults", {
    datasetElementType: false,
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'circumference',
                'endAngle',
                'innerRadius',
                'outerRadius',
                'startAngle',
                'x',
                'y',
                'offset',
                'borderWidth',
                'spacing'
            ]
        }
    },
    cutout: '50%',
    rotation: 0,
    circumference: 360,
    radius: '100%',
    spacing: 0,
    indexAxis: 'r'
});
(0, $k9HNQ._)(DoughnutController, "descriptors", {
    _scriptable: function(name) {
        return name !== 'spacing';
    },
    _indexable: function(name) {
        return name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash');
    }
});
(0, $k9HNQ._)(DoughnutController, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, pointStyle = _chart_legend_options_labels.pointStyle, textAlign = _chart_legend_options_labels.textAlign, color = _chart_legend_options_labels.color, useBorderRadius = _chart_legend_options_labels.useBorderRadius, borderRadius = _chart_legend_options_labels.borderRadius;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            fontColor: color,
                            hidden: !chart.getDataVisibility(i),
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            textAlign: textAlign,
                            pointStyle: pointStyle,
                            borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    }
});
var LineController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $fwyhh._)(LineController, DatasetController);
    function LineController() {
        (0, $bzgVo._)(this, LineController);
        return (0, $lXwto._)(this, LineController, arguments);
    }
    (0, $gHG1J._)(LineController, [
        {
            key: "initialize",
            value: function initialize() {
                this.enableOptionSharing = true;
                this.supportsDecimation = true;
                (0, $8wpvj._)((0, $grPlv._)(LineController.prototype), "initialize", this).call(this);
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                var line = meta.dataset, tmp = meta.data, points = tmp === void 0 ? [] : tmp, _dataset = meta._dataset;
                var animationsDisabled = this.chart._animationsDisabled;
                var _$_getStartAndCountOfVisiblePoints = (0, $8AEPV.q)(meta, points, animationsDisabled), start = _$_getStartAndCountOfVisiblePoints.start, count = _$_getStartAndCountOfVisiblePoints.count;
                this._drawStart = start;
                this._drawCount = count;
                if ((0, $8AEPV.w)(meta)) {
                    start = 0;
                    count = points.length;
                }
                line._chart = this.chart;
                line._datasetIndex = this.index;
                line._decimated = !!_dataset._decimated;
                line.points = points;
                var options = this.resolveDatasetElementOptions(mode);
                if (!this.options.showLine) options.borderWidth = 0;
                options.segment = this.options.segment;
                this.updateElement(line, undefined, {
                    animated: !animationsDisabled,
                    options: options
                }, mode);
                this.updateElements(points, start, count, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var reset = mode === 'reset';
                var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, _dataset = _this__cachedMeta._dataset;
                var _this__getSharedOptions = this._getSharedOptions(start, mode), sharedOptions = _this__getSharedOptions.sharedOptions, includeOptions = _this__getSharedOptions.includeOptions;
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                var _this_options = this.options, spanGaps = _this_options.spanGaps, segment = _this_options.segment;
                var maxGapLength = (0, $8AEPV.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
                var directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
                var end = start + count;
                var pointsCount = points.length;
                var prevParsed = start > 0 && this.getParsed(start - 1);
                for(var i = 0; i < pointsCount; ++i){
                    var point = points[i];
                    var properties = directUpdate ? point : {};
                    if (i < start || i >= end) {
                        properties.skip = true;
                        continue;
                    }
                    var parsed = this.getParsed(i);
                    var nullData = (0, $8AEPV.k)(parsed[vAxis]);
                    var iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
                    var vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
                    properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
                    properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
                    if (segment) {
                        properties.parsed = parsed;
                        properties.raw = _dataset.data[i];
                    }
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                    if (!directUpdate) this.updateElement(point, i, properties, mode);
                    prevParsed = parsed;
                }
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                var meta = this._cachedMeta;
                var dataset = meta.dataset;
                var border = dataset.options && dataset.options.borderWidth || 0;
                var data = meta.data || [];
                if (!data.length) return border;
                var firstPoint = data[0].size(this.resolveDataElementOptions(0));
                var lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
                return Math.max(border, firstPoint, lastPoint) / 2;
            }
        },
        {
            key: "draw",
            value: function draw() {
                var meta = this._cachedMeta;
                meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
                (0, $8wpvj._)((0, $grPlv._)(LineController.prototype), "draw", this).call(this);
            }
        }
    ]);
    return LineController;
}(DatasetController);
(0, $k9HNQ._)(LineController, "id", 'line');
(0, $k9HNQ._)(LineController, "defaults", {
    datasetElementType: 'line',
    dataElementType: 'point',
    showLine: true,
    spanGaps: false
});
(0, $k9HNQ._)(LineController, "overrides", {
    scales: {
        _index_: {
            type: 'category'
        },
        _value_: {
            type: 'linear'
        }
    }
});
var PolarAreaController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $fwyhh._)(PolarAreaController, DatasetController);
    function PolarAreaController(chart, datasetIndex) {
        (0, $bzgVo._)(this, PolarAreaController);
        var _this;
        _this = (0, $lXwto._)(this, PolarAreaController, [
            chart,
            datasetIndex
        ]);
        _this.innerRadius = undefined;
        _this.outerRadius = undefined;
        return _this;
    }
    (0, $gHG1J._)(PolarAreaController, [
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var chart = this.chart;
                var labels = chart.data.labels || [];
                var value = (0, $8AEPV.o)(meta._parsed[index].r, chart.options.locale);
                return {
                    label: labels[index] || '',
                    value: value
                };
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                return (0, $8AEPV.y).bind(this)(meta, data, start, count);
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var arcs = this._cachedMeta.data;
                this._updateRadius();
                this.updateElements(arcs, 0, arcs.length, mode);
            }
        },
        {
            key: "getMinMax",
            value: function getMinMax() {
                var _this = this;
                var meta = this._cachedMeta;
                var range = {
                    min: Number.POSITIVE_INFINITY,
                    max: Number.NEGATIVE_INFINITY
                };
                meta.data.forEach(function(element, index) {
                    var parsed = _this.getParsed(index).r;
                    if (!isNaN(parsed) && _this.chart.getDataVisibility(index)) {
                        if (parsed < range.min) range.min = parsed;
                        if (parsed > range.max) range.max = parsed;
                    }
                });
                return range;
            }
        },
        {
            key: "_updateRadius",
            value: function _updateRadius() {
                var chart = this.chart;
                var chartArea = chart.chartArea;
                var opts = chart.options;
                var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                var outerRadius = Math.max(minSize / 2, 0);
                var innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
                var radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
                this.outerRadius = outerRadius - radiusLength * this.index;
                this.innerRadius = this.outerRadius - radiusLength;
            }
        },
        {
            key: "updateElements",
            value: function updateElements(arcs, start, count, mode) {
                var reset = mode === 'reset';
                var chart = this.chart;
                var opts = chart.options;
                var animationOpts = opts.animation;
                var scale = this._cachedMeta.rScale;
                var centerX = scale.xCenter;
                var centerY = scale.yCenter;
                var datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $8AEPV.P);
                var angle = datasetStartAngle;
                var i;
                var defaultAngle = 360 / this.countVisibleElements();
                for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
                for(i = start; i < start + count; i++){
                    var arc = arcs[i];
                    var startAngle = angle;
                    var endAngle = angle + this._computeAngle(i, mode, defaultAngle);
                    var outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
                    angle = endAngle;
                    if (reset) {
                        if (animationOpts.animateScale) outerRadius = 0;
                        if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
                    }
                    var properties = {
                        x: centerX,
                        y: centerY,
                        innerRadius: 0,
                        outerRadius: outerRadius,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
                    };
                    this.updateElement(arc, i, properties, mode);
                }
            }
        },
        {
            key: "countVisibleElements",
            value: function countVisibleElements() {
                var _this = this;
                var meta = this._cachedMeta;
                var count = 0;
                meta.data.forEach(function(element, index) {
                    if (!isNaN(_this.getParsed(index).r) && _this.chart.getDataVisibility(index)) count++;
                });
                return count;
            }
        },
        {
            key: "_computeAngle",
            value: function _computeAngle(index, mode, defaultAngle) {
                return this.chart.getDataVisibility(index) ? (0, $8AEPV.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
            }
        }
    ]);
    return PolarAreaController;
}(DatasetController);
(0, $k9HNQ._)(PolarAreaController, "id", 'polarArea');
(0, $k9HNQ._)(PolarAreaController, "defaults", {
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'startAngle',
                'endAngle',
                'innerRadius',
                'outerRadius'
            ]
        }
    },
    indexAxis: 'r',
    startAngle: 0
});
(0, $k9HNQ._)(PolarAreaController, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, pointStyle = _chart_legend_options_labels.pointStyle, color = _chart_legend_options_labels.color;
                        return data.labels.map(function(label, i) {
                            var meta = chart.getDatasetMeta(0);
                            var style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                fontColor: color,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick: function(e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    },
    scales: {
        r: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
});
var PieController = /*#__PURE__*/ function(DoughnutController) {
    "use strict";
    (0, $fwyhh._)(PieController, DoughnutController);
    function PieController() {
        (0, $bzgVo._)(this, PieController);
        return (0, $lXwto._)(this, PieController, arguments);
    }
    return PieController;
}(DoughnutController);
(0, $k9HNQ._)(PieController, "id", 'pie');
(0, $k9HNQ._)(PieController, "defaults", {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: '100%'
});
var RadarController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $fwyhh._)(RadarController, DatasetController);
    function RadarController() {
        (0, $bzgVo._)(this, RadarController);
        return (0, $lXwto._)(this, RadarController, arguments);
    }
    (0, $gHG1J._)(RadarController, [
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var vScale = this._cachedMeta.vScale;
                var parsed = this.getParsed(index);
                return {
                    label: vScale.getLabels()[index],
                    value: '' + vScale.getLabelForValue(parsed[vScale.axis])
                };
            }
        },
        {
            key: "parseObjectData",
            value: function parseObjectData(meta, data, start, count) {
                return (0, $8AEPV.y).bind(this)(meta, data, start, count);
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                var line = meta.dataset;
                var points = meta.data || [];
                var labels = meta.iScale.getLabels();
                line.points = points;
                if (mode !== 'resize') {
                    var options = this.resolveDatasetElementOptions(mode);
                    if (!this.options.showLine) options.borderWidth = 0;
                    var properties = {
                        _loop: true,
                        _fullLoop: labels.length === points.length,
                        options: options
                    };
                    this.updateElement(line, undefined, properties, mode);
                }
                this.updateElements(points, 0, points.length, mode);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var scale = this._cachedMeta.rScale;
                var reset = mode === 'reset';
                for(var i = start; i < start + count; i++){
                    var point = points[i];
                    var options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                    var pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
                    var x = reset ? scale.xCenter : pointPosition.x;
                    var y = reset ? scale.yCenter : pointPosition.y;
                    var properties = {
                        x: x,
                        y: y,
                        angle: pointPosition.angle,
                        skip: isNaN(x) || isNaN(y),
                        options: options
                    };
                    this.updateElement(point, i, properties, mode);
                }
            }
        }
    ]);
    return RadarController;
}(DatasetController);
(0, $k9HNQ._)(RadarController, "id", 'radar');
(0, $k9HNQ._)(RadarController, "defaults", {
    datasetElementType: 'line',
    dataElementType: 'point',
    indexAxis: 'r',
    showLine: true,
    elements: {
        line: {
            fill: 'start'
        }
    }
});
(0, $k9HNQ._)(RadarController, "overrides", {
    aspectRatio: 1,
    scales: {
        r: {
            type: 'radialLinear'
        }
    }
});
var ScatterController = /*#__PURE__*/ function(DatasetController) {
    "use strict";
    (0, $fwyhh._)(ScatterController, DatasetController);
    function ScatterController() {
        (0, $bzgVo._)(this, ScatterController);
        return (0, $lXwto._)(this, ScatterController, arguments);
    }
    (0, $gHG1J._)(ScatterController, [
        {
            key: "getLabelAndValue",
            value: function getLabelAndValue(index) {
                var meta = this._cachedMeta;
                var labels = this.chart.data.labels || [];
                var xScale = meta.xScale, yScale = meta.yScale;
                var parsed = this.getParsed(index);
                var x = xScale.getLabelForValue(parsed.x);
                var y = yScale.getLabelForValue(parsed.y);
                return {
                    label: labels[index] || '',
                    value: '(' + x + ', ' + y + ')'
                };
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var meta = this._cachedMeta;
                var tmp = meta.data, points = tmp === void 0 ? [] : tmp;
                var animationsDisabled = this.chart._animationsDisabled;
                var _$_getStartAndCountOfVisiblePoints = (0, $8AEPV.q)(meta, points, animationsDisabled), start = _$_getStartAndCountOfVisiblePoints.start, count = _$_getStartAndCountOfVisiblePoints.count;
                this._drawStart = start;
                this._drawCount = count;
                if ((0, $8AEPV.w)(meta)) {
                    start = 0;
                    count = points.length;
                }
                if (this.options.showLine) {
                    if (!this.datasetElementType) this.addElements();
                    var line = meta.dataset, _dataset = meta._dataset;
                    line._chart = this.chart;
                    line._datasetIndex = this.index;
                    line._decimated = !!_dataset._decimated;
                    line.points = points;
                    var options = this.resolveDatasetElementOptions(mode);
                    options.segment = this.options.segment;
                    this.updateElement(line, undefined, {
                        animated: !animationsDisabled,
                        options: options
                    }, mode);
                } else if (this.datasetElementType) {
                    delete meta.dataset;
                    this.datasetElementType = false;
                }
                this.updateElements(points, start, count, mode);
            }
        },
        {
            key: "addElements",
            value: function addElements() {
                var showLine = this.options.showLine;
                if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
                (0, $8wpvj._)((0, $grPlv._)(ScatterController.prototype), "addElements", this).call(this);
            }
        },
        {
            key: "updateElements",
            value: function updateElements(points, start, count, mode) {
                var reset = mode === 'reset';
                var _this__cachedMeta = this._cachedMeta, iScale = _this__cachedMeta.iScale, vScale = _this__cachedMeta.vScale, _stacked = _this__cachedMeta._stacked, _dataset = _this__cachedMeta._dataset;
                var firstOpts = this.resolveDataElementOptions(start, mode);
                var sharedOptions = this.getSharedOptions(firstOpts);
                var includeOptions = this.includeOptions(mode, sharedOptions);
                var iAxis = iScale.axis;
                var vAxis = vScale.axis;
                var _this_options = this.options, spanGaps = _this_options.spanGaps, segment = _this_options.segment;
                var maxGapLength = (0, $8AEPV.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
                var directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
                var prevParsed = start > 0 && this.getParsed(start - 1);
                for(var i = start; i < start + count; ++i){
                    var point = points[i];
                    var parsed = this.getParsed(i);
                    var properties = directUpdate ? point : {};
                    var nullData = (0, $8AEPV.k)(parsed[vAxis]);
                    var iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
                    var vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
                    properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
                    properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
                    if (segment) {
                        properties.parsed = parsed;
                        properties.raw = _dataset.data[i];
                    }
                    if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                    if (!directUpdate) this.updateElement(point, i, properties, mode);
                    prevParsed = parsed;
                }
                this.updateSharedOptions(sharedOptions, mode, firstOpts);
            }
        },
        {
            key: "getMaxOverflow",
            value: function getMaxOverflow() {
                var meta = this._cachedMeta;
                var data = meta.data || [];
                if (!this.options.showLine) {
                    var max = 0;
                    for(var i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
                    return max > 0 && max;
                }
                var dataset = meta.dataset;
                var border = dataset.options && dataset.options.borderWidth || 0;
                if (!data.length) return border;
                var firstPoint = data[0].size(this.resolveDataElementOptions(0));
                var lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
                return Math.max(border, firstPoint, lastPoint) / 2;
            }
        }
    ]);
    return ScatterController;
}(DatasetController);
(0, $k9HNQ._)(ScatterController, "id", 'scatter');
(0, $k9HNQ._)(ScatterController, "defaults", {
    datasetElementType: false,
    dataElementType: 'point',
    showLine: false,
    fill: false
});
(0, $k9HNQ._)(ScatterController, "overrides", {
    interaction: {
        mode: 'point'
    },
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
});
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ var DateAdapterBase = /*#__PURE__*/ function() {
    "use strict";
    function DateAdapterBase(options) {
        (0, $bzgVo._)(this, DateAdapterBase);
        (0, $k9HNQ._)(this, "options", void 0);
        this.options = options || {};
    }
    (0, $gHG1J._)(DateAdapterBase, [
        {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            key: "init",
            value: function init() {}
        },
        {
            key: "formats",
            value: function formats() {
                return abstract();
            }
        },
        {
            key: "parse",
            value: function parse() {
                return abstract();
            }
        },
        {
            key: "format",
            value: function format() {
                return abstract();
            }
        },
        {
            key: "add",
            value: function add() {
                return abstract();
            }
        },
        {
            key: "diff",
            value: function diff() {
                return abstract();
            }
        },
        {
            key: "startOf",
            value: function startOf() {
                return abstract();
            }
        },
        {
            key: "endOf",
            value: function endOf() {
                return abstract();
            }
        }
    ], [
        {
            key: "override",
            value: /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ function override(members) {
                Object.assign(DateAdapterBase.prototype, members);
            }
        }
    ]);
    return DateAdapterBase;
}();
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    var controller = metaset.controller, data = metaset.data, _sorted = metaset._sorted;
    var iScale = controller._cachedMeta.iScale;
    var spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        var lookupMethod = iScale._reversePixels ? (0, $8AEPV.A) : (0, $8AEPV.B);
        if (!intersect) {
            var result = lookupMethod(data, axis, value);
            if (spanGaps) {
                var vScale = controller._cachedMeta.vScale;
                var _parsed = metaset._parsed;
                var distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex(function(point) {
                    return !(0, $8AEPV.k)(point[vScale.axis]);
                });
                result.lo -= Math.max(0, distanceToDefinedLo);
                var distanceToDefinedHi = _parsed.slice(result.hi).findIndex(function(point) {
                    return !(0, $8AEPV.k)(point[vScale.axis]);
                });
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            var el = data[0];
            var range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                var start = lookupMethod(data, axis, value - range);
                var end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    var metasets = chart.getSortedVisibleDatasetMetas();
    var value = position[axis];
    for(var i = 0, ilen = metasets.length; i < ilen; ++i){
        var _metasets_i = metasets[i], index = _metasets_i.index, data = _metasets_i.data;
        var _binarySearch = binarySearch(metasets[i], axis, value, intersect), lo = _binarySearch.lo, hi = _binarySearch.hi;
        for(var j = lo; j <= hi; ++j){
            var element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    var useX = axis.indexOf('x') !== -1;
    var useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    var items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    var evaluationFunc = function evaluationFunc(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $8AEPV.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    var items = [];
    function evaluationFunc(element, datasetIndex, index) {
        var _element_getProps = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition), startAngle = _element_getProps.startAngle, endAngle = _element_getProps.endAngle;
        var angle = (0, $8AEPV.D)(element, {
            x: position.x,
            y: position.y
        }).angle;
        if ((0, $8AEPV.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    var items = [];
    var distanceMetric = getDistanceMetricForAxis(axis);
    var minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        var inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        var center = element.getCenterPoint(useFinalPosition);
        var pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    var items = [];
    var rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    var intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, function(element, datasetIndex, index) {
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems: evaluateInteractionItems,
    modes: {
        index: function(chart, e, options, useFinalPosition) {
            var position = (0, $8AEPV.z)(e, chart);
            var axis = options.axis || 'x';
            var includeInvisible = options.includeInvisible || false;
            var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            var elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach(function(meta) {
                var index = items[0].index;
                var element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset: function(chart, e, options, useFinalPosition) {
            var position = (0, $8AEPV.z)(e, chart);
            var axis = options.axis || 'xy';
            var includeInvisible = options.includeInvisible || false;
            var items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                var datasetIndex = items[0].datasetIndex;
                var data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(var i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point: function(chart, e, options, useFinalPosition) {
            var position = (0, $8AEPV.z)(e, chart);
            var axis = options.axis || 'xy';
            var includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest: function(chart, e, options, useFinalPosition) {
            var position = (0, $8AEPV.z)(e, chart);
            var axis = options.axis || 'xy';
            var includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x: function(chart, e, options, useFinalPosition) {
            var position = (0, $8AEPV.z)(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y: function(chart, e, options, useFinalPosition) {
            var position = (0, $8AEPV.z)(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
var STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter(function(v) {
        return v.pos === position;
    });
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter(function(v) {
        return STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis;
    });
}
function sortByWeight(array, reverse) {
    return array.sort(function(a, b) {
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    var layoutBoxes = [];
    var i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        var ref, ref1, ref2;
        ref = box, pos = ref.position, ref1 = ref.options, stack = ref1.stack, ref2 = ref1.stackWeight, stackWeight = ref2 === void 0 ? 1 : ref2, ref1, ref;
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    var stacks = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = layouts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var wrap = _step.value;
            var stack = wrap.stack, pos = wrap.pos, stackWeight = wrap.stackWeight;
            if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
            var _stack = stacks[stack] || (stacks[stack] = {
                count: 0,
                placed: 0,
                weight: 0,
                size: 0
            });
            _stack.count++;
            _stack.weight += stackWeight;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    var stacks = buildStacks(layouts);
    var vBoxMaxWidth = params.vBoxMaxWidth, hBoxMaxHeight = params.hBoxMaxHeight;
    var i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        var fullSize = layout.box.fullSize;
        var stack = stacks[layout.stack];
        var factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    var layoutBoxes = wrapBoxes(boxes);
    var fullSize = sortByWeight(layoutBoxes.filter(function(wrap) {
        return wrap.box.fullSize;
    }), true);
    var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    var centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    var centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    var pos = layout.pos, box = layout.box;
    var maxPadding = chartArea.maxPadding;
    if (!(0, $8AEPV.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        var stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    var newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    var newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    var widthChanged = newWidth !== chartArea.w;
    var heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    var maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    var maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        var margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach(function(pos) {
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    var refitBoxes = [];
    var i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        var _updateDims = updateDims(chartArea, params, layout, stacks), same = _updateDims.same, other = _updateDims.other;
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    var userPadding = params.padding;
    var x = chartArea.x, y = chartArea.y;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = boxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var layout = _step.value;
            var box = layout.box;
            var stack = stacks[layout.stack] || {
                count: 1,
                placed: 0,
                weight: 1
            };
            var weight = layout.stackWeight / stack.weight || 1;
            if (layout.horizontal) {
                var width = chartArea.w * weight;
                var height = stack.size || box.height;
                if ((0, $8AEPV.h)(stack.start)) y = stack.start;
                if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
                else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
                stack.start = y;
                stack.placed += width;
                y = box.bottom;
            } else {
                var height1 = chartArea.h * weight;
                var width1 = stack.size || box.width;
                if ((0, $8AEPV.h)(stack.start)) x = stack.start;
                if (box.fullSize) setBoxDims(box, x, userPadding.top, width1, params.outerHeight - userPadding.bottom - userPadding.top);
                else setBoxDims(box, x, chartArea.top + stack.placed, width1, height1);
                stack.start = x;
                stack.placed += height1;
                x = box.right;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox: function(chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw: function(chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox: function(chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure: function(chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update: function(chart, width, height, minPadding) {
        if (!chart) return;
        var padding = (0, $8AEPV.E)(chart.options.layout.padding);
        var availableWidth = Math.max(width - padding.width, 0);
        var availableHeight = Math.max(height - padding.height, 0);
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        (0, $8AEPV.F)(chart.boxes, function(box) {
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        var visibleVerticalBoxCount = verticalBoxes.reduce(function(total, wrap) {
            return wrap.box.options && wrap.box.options.display === false ? total : total + 1;
        }, 0) || 1;
        var params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        var maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, $8AEPV.E)(minPadding));
        var chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        var stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $8AEPV.F)(boxes.chartArea, function(layout) {
            var box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
var BasePlatform = /*#__PURE__*/ function() {
    "use strict";
    function BasePlatform() {
        (0, $bzgVo._)(this, BasePlatform);
    }
    (0, $gHG1J._)(BasePlatform, [
        {
            key: "acquireContext",
            value: function acquireContext(canvas, aspectRatio) {}
        },
        {
            key: "releaseContext",
            value: function releaseContext(context) {
                return false;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(chart, type, listener) {}
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(chart, type, listener) {}
        },
        {
            key: "getDevicePixelRatio",
            value: function getDevicePixelRatio() {
                return 1;
            }
        },
        {
            key: "getMaximumSize",
            value: function getMaximumSize(element, width, height, aspectRatio) {
                width = Math.max(0, width || element.width);
                height = height || element.height;
                return {
                    width: width,
                    height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
                };
            }
        },
        {
            key: "isAttached",
            value: function isAttached(canvas) {
                return true;
            }
        },
        {
            key: "updateConfig",
            value: function updateConfig(config) {}
        }
    ]);
    return BasePlatform;
}();
var BasicPlatform = /*#__PURE__*/ function(BasePlatform) {
    "use strict";
    (0, $fwyhh._)(BasicPlatform, BasePlatform);
    function BasicPlatform() {
        (0, $bzgVo._)(this, BasicPlatform);
        return (0, $lXwto._)(this, BasicPlatform, arguments);
    }
    (0, $gHG1J._)(BasicPlatform, [
        {
            key: "acquireContext",
            value: function acquireContext(item) {
                return item && item.getContext && item.getContext('2d') || null;
            }
        },
        {
            key: "updateConfig",
            value: function updateConfig(config) {
                config.options.animation = false;
            }
        }
    ]);
    return BasicPlatform;
}(BasePlatform);
var EXPANDO_KEY = '$chartjs';
var EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
var isNullOrEmpty = function(value) {
    return value === null || value === '';
};
function initCanvas(canvas, aspectRatio) {
    var style = canvas.style;
    var renderHeight = canvas.getAttribute('height');
    var renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        var displayWidth = (0, $8AEPV.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            var displayHeight = (0, $8AEPV.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
var eventListenerOptions = (0, $8AEPV.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    var type = EVENT_TYPES[event.type] || event.type;
    var _getRelativePosition = (0, $8AEPV.z)(event, chart), x = _getRelativePosition.x, y = _getRelativePosition.y;
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nodeList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (node === canvas || node.contains(canvas)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function createAttachObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var observer = new MutationObserver(function(entries) {
        var trigger = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                trigger = trigger || nodeListContains(entry.addedNodes, canvas);
                trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var observer = new MutationObserver(function(entries) {
        var trigger = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                trigger = trigger || nodeListContains(entry.removedNodes, canvas);
                trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
var drpListeningCharts = new Map();
var oldDevicePixelRatio = 0;
function onWindowResize() {
    var dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach(function(resize, chart) {
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener('resize', onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener('resize', onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    var canvas = chart.canvas;
    var container = canvas && (0, $8AEPV.I)(canvas);
    if (!container) return;
    var resize = (0, $8AEPV.L)(function(width, height) {
        var w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    var observer = new ResizeObserver(function(entries) {
        var entry = entries[0];
        var width = entry.contentRect.width;
        var height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    var canvas = chart.canvas;
    var proxy = (0, $8AEPV.L)(function(event) {
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
var DomPlatform = /*#__PURE__*/ function(BasePlatform) {
    "use strict";
    (0, $fwyhh._)(DomPlatform, BasePlatform);
    function DomPlatform() {
        (0, $bzgVo._)(this, DomPlatform);
        return (0, $lXwto._)(this, DomPlatform, arguments);
    }
    (0, $gHG1J._)(DomPlatform, [
        {
            key: "acquireContext",
            value: function acquireContext(canvas, aspectRatio) {
                var context = canvas && canvas.getContext && canvas.getContext('2d');
                if (context && context.canvas === canvas) {
                    initCanvas(canvas, aspectRatio);
                    return context;
                }
                return null;
            }
        },
        {
            key: "releaseContext",
            value: function releaseContext(context) {
                var canvas = context.canvas;
                if (!canvas[EXPANDO_KEY]) return false;
                var initial = canvas[EXPANDO_KEY].initial;
                [
                    'height',
                    'width'
                ].forEach(function(prop) {
                    var value = initial[prop];
                    if ((0, $8AEPV.k)(value)) canvas.removeAttribute(prop);
                    else canvas.setAttribute(prop, value);
                });
                var style = initial.style || {};
                Object.keys(style).forEach(function(key) {
                    canvas.style[key] = style[key];
                });
                canvas.width = canvas.width;
                delete canvas[EXPANDO_KEY];
                return true;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(chart, type, listener) {
                this.removeEventListener(chart, type);
                var proxies = chart.$proxies || (chart.$proxies = {});
                var handlers = {
                    attach: createAttachObserver,
                    detach: createDetachObserver,
                    resize: createResizeObserver
                };
                var handler = handlers[type] || createProxyAndListen;
                proxies[type] = handler(chart, type, listener);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(chart, type) {
                var proxies = chart.$proxies || (chart.$proxies = {});
                var proxy = proxies[type];
                if (!proxy) return;
                var handlers = {
                    attach: releaseObserver,
                    detach: releaseObserver,
                    resize: releaseObserver
                };
                var handler = handlers[type] || removeListener;
                handler(chart, type, proxy);
                proxies[type] = undefined;
            }
        },
        {
            key: "getDevicePixelRatio",
            value: function getDevicePixelRatio() {
                return window.devicePixelRatio;
            }
        },
        {
            key: "getMaximumSize",
            value: function getMaximumSize1(canvas, width, height, aspectRatio) {
                return (0, $8AEPV.G)(canvas, width, height, aspectRatio);
            }
        },
        {
            key: "isAttached",
            value: function isAttached(canvas) {
                var container = canvas && (0, $8AEPV.I)(canvas);
                return !!(container && container.isConnected);
            }
        }
    ]);
    return DomPlatform;
}(BasePlatform);
function _detectPlatform(canvas) {
    if (!(0, $8AEPV.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
var Element = /*#__PURE__*/ function() {
    "use strict";
    function Element() {
        (0, $bzgVo._)(this, Element);
        (0, $k9HNQ._)(this, "x", void 0);
        (0, $k9HNQ._)(this, "y", void 0);
        (0, $k9HNQ._)(this, "active", false);
        (0, $k9HNQ._)(this, "options", void 0);
        (0, $k9HNQ._)(this, "$animations", void 0);
    }
    (0, $gHG1J._)(Element, [
        {
            key: "tooltipPosition",
            value: function tooltipPosition(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
                return {
                    x: x,
                    y: y
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                return (0, $8AEPV.x)(this.x) && (0, $8AEPV.x)(this.y);
            }
        },
        {
            key: "getProps",
            value: function getProps(props, final) {
                var _this = this;
                var anims = this.$animations;
                if (!final || !anims) // let's not create an object, if not needed
                return this;
                var ret = {};
                props.forEach(function(prop) {
                    ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : _this[prop];
                });
                return ret;
            }
        }
    ]);
    return Element;
}();
(0, $k9HNQ._)(Element, "defaults", {});
(0, $k9HNQ._)(Element, "defaultRoutes", undefined);
function autoSkip(scale, ticks) {
    var tickOpts = scale.options.ticks;
    var determinedMaxTicks = determineMaxTicks(scale);
    var ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    var numMajorIndices = majorIndices.length;
    var first = majorIndices[0];
    var last = majorIndices[numMajorIndices - 1];
    var newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    var spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        var i, ilen;
        var avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, $8AEPV.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, $8AEPV.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    var offset = scale.options.offset;
    var tickLength = scale._tickSize();
    var maxScale = scale._length / tickLength + (offset ? 0 : 1);
    var maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    var evenMajorSpacing = getEvenSpacing(majorIndices);
    var spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    var factors = (0, $8AEPV.N)(evenMajorSpacing);
    for(var i = 0, ilen = factors.length - 1; i < ilen; i++){
        var factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    var result = [];
    var i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    var count = 0;
    var next = majorIndices[0];
    var i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    var start = (0, $8AEPV.v)(majorStart, 0);
    var end = Math.min((0, $8AEPV.v)(majorEnd, ticks.length), ticks.length);
    var count = 0;
    var length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    var len = arr.length;
    var i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
var reverseAlign = function(align) {
    return align === 'left' ? 'right' : align === 'right' ? 'left' : align;
};
var offsetFromEdge = function(scale, edge, offset) {
    return edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
};
var getTicksLimit = function(ticksLength, maxTicksLimit) {
    return Math.min(maxTicksLimit || ticksLength, ticksLength);
};
function sample(arr, numItems) {
    var result = [];
    var increment = arr.length / numItems;
    var len = arr.length;
    var i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    var length = scale.ticks.length;
    var validIndex = Math.min(index, length - 1);
    var start = scale._startPixel;
    var end = scale._endPixel;
    var epsilon = 1e-6;
    var lineValue = scale.getPixelForTick(validIndex);
    var offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, $8AEPV.F)(caches, function(cache) {
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    var font = (0, $8AEPV.a0)(options.font, fallback);
    var padding = (0, $8AEPV.E)(options.padding);
    var lines = (0, $8AEPV.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, $8AEPV.j)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return (0, $8AEPV.j)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
    var ret = (0, $8AEPV.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    var top = scale.top, left = scale.left, bottom = scale.bottom, right = scale.right, chart = scale.chart;
    var chartArea = chart.chartArea, scales = chart.scales;
    var rotation = 0;
    var maxWidth, titleX, titleY;
    var height = bottom - top;
    var width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $8AEPV.a2)(align, left, right);
        if ((0, $8AEPV.i)(position)) {
            var positionAxisID = Object.keys(position)[0];
            var value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $8AEPV.i)(position)) {
            var positionAxisID1 = Object.keys(position)[0];
            var value1 = position[positionAxisID1];
            titleX = scales[positionAxisID1].getPixelForValue(value1) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, $8AEPV.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, $8AEPV.H) : (0, $8AEPV.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
var Scale = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(Scale, Element);
    function Scale(cfg) {
        (0, $bzgVo._)(this, Scale);
        var _this;
        _this = (0, $lXwto._)(this, Scale);
        _this.id = cfg.id;
        _this.type = cfg.type;
        _this.options = undefined;
        _this.ctx = cfg.ctx;
        _this.chart = cfg.chart;
        _this.top = undefined;
        _this.bottom = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.width = undefined;
        _this.height = undefined;
        _this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        _this.maxWidth = undefined;
        _this.maxHeight = undefined;
        _this.paddingTop = undefined;
        _this.paddingBottom = undefined;
        _this.paddingLeft = undefined;
        _this.paddingRight = undefined;
        _this.axis = undefined;
        _this.labelRotation = undefined;
        _this.min = undefined;
        _this.max = undefined;
        _this._range = undefined;
        _this.ticks = [];
        _this._gridLineItems = null;
        _this._labelItems = null;
        _this._labelSizes = null;
        _this._length = 0;
        _this._maxLength = 0;
        _this._longestTextCache = {};
        _this._startPixel = undefined;
        _this._endPixel = undefined;
        _this._reversePixels = false;
        _this._userMax = undefined;
        _this._userMin = undefined;
        _this._suggestedMax = undefined;
        _this._suggestedMin = undefined;
        _this._ticksLength = 0;
        _this._borderValue = 0;
        _this._cache = {};
        _this._dataLimitsCached = false;
        _this.$context = undefined;
        return _this;
    }
    (0, $gHG1J._)(Scale, [
        {
            key: "init",
            value: function init(options) {
                this.options = options.setContext(this.getContext());
                this.axis = options.axis;
                this._userMin = this.parse(options.min);
                this._userMax = this.parse(options.max);
                this._suggestedMin = this.parse(options.suggestedMin);
                this._suggestedMax = this.parse(options.suggestedMax);
            }
        },
        {
            key: "parse",
            value: function parse(raw, index) {
                return raw;
            }
        },
        {
            key: "getUserBounds",
            value: function getUserBounds() {
                var _this = this, _userMin = _this._userMin, _userMax = _this._userMax, _suggestedMin = _this._suggestedMin, _suggestedMax = _this._suggestedMax;
                _userMin = (0, $8AEPV.O)(_userMin, Number.POSITIVE_INFINITY);
                _userMax = (0, $8AEPV.O)(_userMax, Number.NEGATIVE_INFINITY);
                _suggestedMin = (0, $8AEPV.O)(_suggestedMin, Number.POSITIVE_INFINITY);
                _suggestedMax = (0, $8AEPV.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
                return {
                    min: (0, $8AEPV.O)(_userMin, _suggestedMin),
                    max: (0, $8AEPV.O)(_userMax, _suggestedMax),
                    minDefined: (0, $8AEPV.g)(_userMin),
                    maxDefined: (0, $8AEPV.g)(_userMax)
                };
            }
        },
        {
            key: "getMinMax",
            value: function getMinMax(canStack) {
                var _this_getUserBounds = this.getUserBounds(), min = _this_getUserBounds.min, max = _this_getUserBounds.max, minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var range;
                if (minDefined && maxDefined) return {
                    min: min,
                    max: max
                };
                var metas = this.getMatchingVisibleMetas();
                for(var i = 0, ilen = metas.length; i < ilen; ++i){
                    range = metas[i].controller.getMinMax(this, canStack);
                    if (!minDefined) min = Math.min(min, range.min);
                    if (!maxDefined) max = Math.max(max, range.max);
                }
                min = maxDefined && min > max ? max : min;
                max = minDefined && min > max ? min : max;
                return {
                    min: (0, $8AEPV.O)(min, (0, $8AEPV.O)(max, min)),
                    max: (0, $8AEPV.O)(max, (0, $8AEPV.O)(min, max))
                };
            }
        },
        {
            key: "getPadding",
            value: function getPadding() {
                return {
                    left: this.paddingLeft || 0,
                    top: this.paddingTop || 0,
                    right: this.paddingRight || 0,
                    bottom: this.paddingBottom || 0
                };
            }
        },
        {
            key: "getTicks",
            value: function getTicks() {
                return this.ticks;
            }
        },
        {
            key: "getLabels",
            value: function getLabels() {
                var data = this.chart.data;
                return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
            }
        },
        {
            key: "getLabelItems",
            value: function getLabelItems() {
                var chartArea = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.chart.chartArea;
                var items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
                return items;
            }
        },
        {
            key: "beforeLayout",
            value: function beforeLayout() {
                this._cache = {};
                this._dataLimitsCached = false;
            }
        },
        {
            key: "beforeUpdate",
            value: function beforeUpdate() {
                (0, $8AEPV.Q)(this.options.beforeUpdate, [
                    this
                ]);
            }
        },
        {
            key: "update",
            value: function update(maxWidth, maxHeight, margins) {
                var _this_options = this.options, beginAtZero = _this_options.beginAtZero, grace = _this_options.grace, tickOpts = _this_options.ticks;
                var sampleSize = tickOpts.sampleSize;
                this.beforeUpdate();
                this.maxWidth = maxWidth;
                this.maxHeight = maxHeight;
                this._margins = margins = Object.assign({
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }, margins);
                this.ticks = null;
                this._labelSizes = null;
                this._gridLineItems = null;
                this._labelItems = null;
                this.beforeSetDimensions();
                this.setDimensions();
                this.afterSetDimensions();
                this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
                if (!this._dataLimitsCached) {
                    this.beforeDataLimits();
                    this.determineDataLimits();
                    this.afterDataLimits();
                    this._range = (0, $8AEPV.R)(this, grace, beginAtZero);
                    this._dataLimitsCached = true;
                }
                this.beforeBuildTicks();
                this.ticks = this.buildTicks() || [];
                this.afterBuildTicks();
                var samplingEnabled = sampleSize < this.ticks.length;
                this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
                this.configure();
                this.beforeCalculateLabelRotation();
                this.calculateLabelRotation();
                this.afterCalculateLabelRotation();
                if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
                    this.ticks = autoSkip(this, this.ticks);
                    this._labelSizes = null;
                    this.afterAutoSkip();
                }
                if (samplingEnabled) this._convertTicksToLabels(this.ticks);
                this.beforeFit();
                this.fit();
                this.afterFit();
                this.afterUpdate();
            }
        },
        {
            key: "configure",
            value: function configure() {
                var reversePixels = this.options.reverse;
                var startPixel, endPixel;
                if (this.isHorizontal()) {
                    startPixel = this.left;
                    endPixel = this.right;
                } else {
                    startPixel = this.top;
                    endPixel = this.bottom;
                    reversePixels = !reversePixels;
                }
                this._startPixel = startPixel;
                this._endPixel = endPixel;
                this._reversePixels = reversePixels;
                this._length = endPixel - startPixel;
                this._alignToPixels = this.options.alignToPixels;
            }
        },
        {
            key: "afterUpdate",
            value: function afterUpdate() {
                (0, $8AEPV.Q)(this.options.afterUpdate, [
                    this
                ]);
            }
        },
        {
            key: "beforeSetDimensions",
            value: function beforeSetDimensions() {
                (0, $8AEPV.Q)(this.options.beforeSetDimensions, [
                    this
                ]);
            }
        },
        {
            key: "setDimensions",
            value: function setDimensions() {
                if (this.isHorizontal()) {
                    this.width = this.maxWidth;
                    this.left = 0;
                    this.right = this.width;
                } else {
                    this.height = this.maxHeight;
                    this.top = 0;
                    this.bottom = this.height;
                }
                this.paddingLeft = 0;
                this.paddingTop = 0;
                this.paddingRight = 0;
                this.paddingBottom = 0;
            }
        },
        {
            key: "afterSetDimensions",
            value: function afterSetDimensions() {
                (0, $8AEPV.Q)(this.options.afterSetDimensions, [
                    this
                ]);
            }
        },
        {
            key: "_callHooks",
            value: function _callHooks(name) {
                this.chart.notifyPlugins(name, this.getContext());
                (0, $8AEPV.Q)(this.options[name], [
                    this
                ]);
            }
        },
        {
            key: "beforeDataLimits",
            value: function beforeDataLimits() {
                this._callHooks('beforeDataLimits');
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {}
        },
        {
            key: "afterDataLimits",
            value: function afterDataLimits() {
                this._callHooks('afterDataLimits');
            }
        },
        {
            key: "beforeBuildTicks",
            value: function beforeBuildTicks() {
                this._callHooks('beforeBuildTicks');
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                return [];
            }
        },
        {
            key: "afterBuildTicks",
            value: function afterBuildTicks() {
                this._callHooks('afterBuildTicks');
            }
        },
        {
            key: "beforeTickToLabelConversion",
            value: function beforeTickToLabelConversion() {
                (0, $8AEPV.Q)(this.options.beforeTickToLabelConversion, [
                    this
                ]);
            }
        },
        {
            key: "generateTickLabels",
            value: function generateTickLabels(ticks) {
                var tickOpts = this.options.ticks;
                var i, ilen, tick;
                for(i = 0, ilen = ticks.length; i < ilen; i++){
                    tick = ticks[i];
                    tick.label = (0, $8AEPV.Q)(tickOpts.callback, [
                        tick.value,
                        i,
                        ticks
                    ], this);
                }
            }
        },
        {
            key: "afterTickToLabelConversion",
            value: function afterTickToLabelConversion() {
                (0, $8AEPV.Q)(this.options.afterTickToLabelConversion, [
                    this
                ]);
            }
        },
        {
            key: "beforeCalculateLabelRotation",
            value: function beforeCalculateLabelRotation() {
                (0, $8AEPV.Q)(this.options.beforeCalculateLabelRotation, [
                    this
                ]);
            }
        },
        {
            key: "calculateLabelRotation",
            value: function calculateLabelRotation() {
                var options = this.options;
                var tickOpts = options.ticks;
                var numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
                var minRotation = tickOpts.minRotation || 0;
                var maxRotation = tickOpts.maxRotation;
                var labelRotation = minRotation;
                var tickWidth, maxHeight, maxLabelDiagonal;
                if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
                    this.labelRotation = minRotation;
                    return;
                }
                var labelSizes = this._getLabelSizes();
                var maxLabelWidth = labelSizes.widest.width;
                var maxLabelHeight = labelSizes.highest.height;
                var maxWidth = (0, $8AEPV.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
                tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
                if (maxLabelWidth + 6 > tickWidth) {
                    tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                    maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
                    maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                    labelRotation = (0, $8AEPV.U)(Math.min(Math.asin((0, $8AEPV.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $8AEPV.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $8AEPV.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
                    labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
                }
                this.labelRotation = labelRotation;
            }
        },
        {
            key: "afterCalculateLabelRotation",
            value: function afterCalculateLabelRotation() {
                (0, $8AEPV.Q)(this.options.afterCalculateLabelRotation, [
                    this
                ]);
            }
        },
        {
            key: "afterAutoSkip",
            value: function afterAutoSkip() {}
        },
        {
            key: "beforeFit",
            value: function beforeFit() {
                (0, $8AEPV.Q)(this.options.beforeFit, [
                    this
                ]);
            }
        },
        {
            key: "fit",
            value: function fit() {
                var minSize = {
                    width: 0,
                    height: 0
                };
                var _this = this, chart = _this.chart, _this_options = _this.options, tickOpts = _this_options.ticks, titleOpts = _this_options.title, gridOpts = _this_options.grid;
                var display = this._isVisible();
                var isHorizontal = this.isHorizontal();
                if (display) {
                    var titleHeight = getTitleHeight(titleOpts, chart.options.font);
                    if (isHorizontal) {
                        minSize.width = this.maxWidth;
                        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
                    } else {
                        minSize.height = this.maxHeight;
                        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
                    }
                    if (tickOpts.display && this.ticks.length) {
                        var _this__getLabelSizes = this._getLabelSizes(), first = _this__getLabelSizes.first, last = _this__getLabelSizes.last, widest = _this__getLabelSizes.widest, highest = _this__getLabelSizes.highest;
                        var tickPadding = tickOpts.padding * 2;
                        var angleRadians = (0, $8AEPV.t)(this.labelRotation);
                        var cos = Math.cos(angleRadians);
                        var sin = Math.sin(angleRadians);
                        if (isHorizontal) {
                            var labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                            minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                        } else {
                            var labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                            minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                        }
                        this._calculatePadding(first, last, sin, cos);
                    }
                }
                this._handleMargins();
                if (isHorizontal) {
                    this.width = this._length = chart.width - this._margins.left - this._margins.right;
                    this.height = minSize.height;
                } else {
                    this.width = minSize.width;
                    this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
                }
            }
        },
        {
            key: "_calculatePadding",
            value: function _calculatePadding(first, last, sin, cos) {
                var _this_options = this.options, _this_options_ticks = _this_options.ticks, align = _this_options_ticks.align, padding = _this_options_ticks.padding, position = _this_options.position;
                var isRotated = this.labelRotation !== 0;
                var labelsBelowTicks = position !== 'top' && this.axis === 'x';
                if (this.isHorizontal()) {
                    var offsetLeft = this.getPixelForTick(0) - this.left;
                    var offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
                    var paddingLeft = 0;
                    var paddingRight = 0;
                    if (isRotated) {
                        if (labelsBelowTicks) {
                            paddingLeft = cos * first.width;
                            paddingRight = sin * last.height;
                        } else {
                            paddingLeft = sin * first.height;
                            paddingRight = cos * last.width;
                        }
                    } else if (align === 'start') paddingRight = last.width;
                    else if (align === 'end') paddingLeft = first.width;
                    else if (align !== 'inner') {
                        paddingLeft = first.width / 2;
                        paddingRight = last.width / 2;
                    }
                    this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
                    this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
                } else {
                    var paddingTop = last.height / 2;
                    var paddingBottom = first.height / 2;
                    if (align === 'start') {
                        paddingTop = 0;
                        paddingBottom = first.height;
                    } else if (align === 'end') {
                        paddingTop = last.height;
                        paddingBottom = 0;
                    }
                    this.paddingTop = paddingTop + padding;
                    this.paddingBottom = paddingBottom + padding;
                }
            }
        },
        {
            key: "_handleMargins",
            value: function _handleMargins() {
                if (this._margins) {
                    this._margins.left = Math.max(this.paddingLeft, this._margins.left);
                    this._margins.top = Math.max(this.paddingTop, this._margins.top);
                    this._margins.right = Math.max(this.paddingRight, this._margins.right);
                    this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
                }
            }
        },
        {
            key: "afterFit",
            value: function afterFit() {
                (0, $8AEPV.Q)(this.options.afterFit, [
                    this
                ]);
            }
        },
        {
            key: "isHorizontal",
            value: function isHorizontal() {
                var _this_options = this.options, axis = _this_options.axis, position = _this_options.position;
                return position === 'top' || position === 'bottom' || axis === 'x';
            }
        },
        {
            key: "isFullSize",
            value: function isFullSize() {
                return this.options.fullSize;
            }
        },
        {
            key: "_convertTicksToLabels",
            value: function _convertTicksToLabels(ticks) {
                this.beforeTickToLabelConversion();
                this.generateTickLabels(ticks);
                var i, ilen;
                for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $8AEPV.k)(ticks[i].label)) {
                    ticks.splice(i, 1);
                    ilen--;
                    i--;
                }
                this.afterTickToLabelConversion();
            }
        },
        {
            key: "_getLabelSizes",
            value: function _getLabelSizes() {
                var labelSizes = this._labelSizes;
                if (!labelSizes) {
                    var sampleSize = this.options.ticks.sampleSize;
                    var ticks = this.ticks;
                    if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
                    this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
                }
                return labelSizes;
            }
        },
        {
            key: "_computeLabelSizes",
            value: function _computeLabelSizes(ticks, length, maxTicksLimit) {
                var _this = this, ctx = _this.ctx, caches = _this._longestTextCache;
                var widths = [];
                var heights = [];
                var increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
                var widestLabelSize = 0;
                var highestLabelSize = 0;
                var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
                for(i = 0; i < length; i += increment){
                    label = ticks[i].label;
                    tickFont = this._resolveTickFontOptions(i);
                    ctx.font = fontString = tickFont.string;
                    cache = caches[fontString] = caches[fontString] || {
                        data: {},
                        gc: []
                    };
                    lineHeight = tickFont.lineHeight;
                    width = height = 0;
                    if (!(0, $8AEPV.k)(label) && !(0, $8AEPV.b)(label)) {
                        width = (0, $8AEPV.V)(ctx, cache.data, cache.gc, width, label);
                        height = lineHeight;
                    } else if ((0, $8AEPV.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                        nestedLabel = label[j];
                        if (!(0, $8AEPV.k)(nestedLabel) && !(0, $8AEPV.b)(nestedLabel)) {
                            width = (0, $8AEPV.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                            height += lineHeight;
                        }
                    }
                    widths.push(width);
                    heights.push(height);
                    widestLabelSize = Math.max(width, widestLabelSize);
                    highestLabelSize = Math.max(height, highestLabelSize);
                }
                garbageCollect(caches, length);
                var widest = widths.indexOf(widestLabelSize);
                var highest = heights.indexOf(highestLabelSize);
                var valueAt = function(idx) {
                    return {
                        width: widths[idx] || 0,
                        height: heights[idx] || 0
                    };
                };
                return {
                    first: valueAt(0),
                    last: valueAt(length - 1),
                    widest: valueAt(widest),
                    highest: valueAt(highest),
                    widths: widths,
                    heights: heights
                };
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return value;
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value, index) {
                return NaN;
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {}
        },
        {
            key: "getPixelForTick",
            value: function getPixelForTick(index) {
                var ticks = this.ticks;
                if (index < 0 || index > ticks.length - 1) return null;
                return this.getPixelForValue(ticks[index].value);
            }
        },
        {
            key: "getPixelForDecimal",
            value: function getPixelForDecimal(decimal) {
                if (this._reversePixels) decimal = 1 - decimal;
                var pixel = this._startPixel + decimal * this._length;
                return (0, $8AEPV.W)(this._alignToPixels ? (0, $8AEPV.X)(this.chart, pixel, 0) : pixel);
            }
        },
        {
            key: "getDecimalForPixel",
            value: function getDecimalForPixel(pixel) {
                var decimal = (pixel - this._startPixel) / this._length;
                return this._reversePixels ? 1 - decimal : decimal;
            }
        },
        {
            key: "getBasePixel",
            value: function getBasePixel() {
                return this.getPixelForValue(this.getBaseValue());
            }
        },
        {
            key: "getBaseValue",
            value: function getBaseValue() {
                var _this = this, min = _this.min, max = _this.max;
                return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
            }
        },
        {
            key: "getContext",
            value: function getContext(index) {
                var ticks = this.ticks || [];
                if (index >= 0 && index < ticks.length) {
                    var tick = ticks[index];
                    return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
                }
                return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
            }
        },
        {
            key: "_tickSize",
            value: function _tickSize() {
                var optionTicks = this.options.ticks;
                var rot = (0, $8AEPV.t)(this.labelRotation);
                var cos = Math.abs(Math.cos(rot));
                var sin = Math.abs(Math.sin(rot));
                var labelSizes = this._getLabelSizes();
                var padding = optionTicks.autoSkipPadding || 0;
                var w = labelSizes ? labelSizes.widest.width + padding : 0;
                var h = labelSizes ? labelSizes.highest.height + padding : 0;
                return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
            }
        },
        {
            key: "_isVisible",
            value: function _isVisible() {
                var display = this.options.display;
                if (display !== 'auto') return !!display;
                return this.getMatchingVisibleMetas().length > 0;
            }
        },
        {
            key: "_computeGridLineItems",
            value: function _computeGridLineItems(chartArea) {
                var axis = this.axis;
                var chart = this.chart;
                var options = this.options;
                var grid = options.grid, position = options.position, border = options.border;
                var offset = grid.offset;
                var isHorizontal = this.isHorizontal();
                var ticks = this.ticks;
                var ticksLength = ticks.length + (offset ? 1 : 0);
                var tl = getTickMarkLength(grid);
                var items = [];
                var borderOpts = border.setContext(this.getContext());
                var axisWidth = borderOpts.display ? borderOpts.width : 0;
                var axisHalfWidth = axisWidth / 2;
                var alignBorderValue = function alignBorderValue(pixel) {
                    return (0, $8AEPV.X)(chart, pixel, axisWidth);
                };
                var borderValue, i, lineValue, alignedLineValue;
                var tx1, ty1, tx2, ty2, x1, y1, x2, y2;
                if (position === 'top') {
                    borderValue = alignBorderValue(this.bottom);
                    ty1 = this.bottom - tl;
                    ty2 = borderValue - axisHalfWidth;
                    y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                    y2 = chartArea.bottom;
                } else if (position === 'bottom') {
                    borderValue = alignBorderValue(this.top);
                    y1 = chartArea.top;
                    y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                    ty1 = borderValue + axisHalfWidth;
                    ty2 = this.top + tl;
                } else if (position === 'left') {
                    borderValue = alignBorderValue(this.right);
                    tx1 = this.right - tl;
                    tx2 = borderValue - axisHalfWidth;
                    x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                    x2 = chartArea.right;
                } else if (position === 'right') {
                    borderValue = alignBorderValue(this.left);
                    x1 = chartArea.left;
                    x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                    tx1 = borderValue + axisHalfWidth;
                    tx2 = this.left + tl;
                } else if (axis === 'x') {
                    if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
                    else if ((0, $8AEPV.i)(position)) {
                        var positionAxisID = Object.keys(position)[0];
                        var value = position[positionAxisID];
                        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
                    }
                    y1 = chartArea.top;
                    y2 = chartArea.bottom;
                    ty1 = borderValue + axisHalfWidth;
                    ty2 = ty1 + tl;
                } else if (axis === 'y') {
                    if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
                    else if ((0, $8AEPV.i)(position)) {
                        var positionAxisID1 = Object.keys(position)[0];
                        var value1 = position[positionAxisID1];
                        borderValue = alignBorderValue(this.chart.scales[positionAxisID1].getPixelForValue(value1));
                    }
                    tx1 = borderValue - axisHalfWidth;
                    tx2 = tx1 - tl;
                    x1 = chartArea.left;
                    x2 = chartArea.right;
                }
                var limit = (0, $8AEPV.v)(options.ticks.maxTicksLimit, ticksLength);
                var step = Math.max(1, Math.ceil(ticksLength / limit));
                for(i = 0; i < ticksLength; i += step){
                    var context = this.getContext(i);
                    var optsAtIndex = grid.setContext(context);
                    var optsAtIndexBorder = border.setContext(context);
                    var lineWidth = optsAtIndex.lineWidth;
                    var lineColor = optsAtIndex.color;
                    var borderDash = optsAtIndexBorder.dash || [];
                    var borderDashOffset = optsAtIndexBorder.dashOffset;
                    var tickWidth = optsAtIndex.tickWidth;
                    var tickColor = optsAtIndex.tickColor;
                    var tickBorderDash = optsAtIndex.tickBorderDash || [];
                    var tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
                    lineValue = getPixelForGridLine(this, i, offset);
                    if (lineValue === undefined) continue;
                    alignedLineValue = (0, $8AEPV.X)(chart, lineValue, lineWidth);
                    if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                    else ty1 = ty2 = y1 = y2 = alignedLineValue;
                    items.push({
                        tx1: tx1,
                        ty1: ty1,
                        tx2: tx2,
                        ty2: ty2,
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        width: lineWidth,
                        color: lineColor,
                        borderDash: borderDash,
                        borderDashOffset: borderDashOffset,
                        tickWidth: tickWidth,
                        tickColor: tickColor,
                        tickBorderDash: tickBorderDash,
                        tickBorderDashOffset: tickBorderDashOffset
                    });
                }
                this._ticksLength = ticksLength;
                this._borderValue = borderValue;
                return items;
            }
        },
        {
            key: "_computeLabelItems",
            value: function _computeLabelItems(chartArea) {
                var axis = this.axis;
                var options = this.options;
                var position = options.position, optionTicks = options.ticks;
                var isHorizontal = this.isHorizontal();
                var ticks = this.ticks;
                var align = optionTicks.align, crossAlign = optionTicks.crossAlign, padding = optionTicks.padding, mirror = optionTicks.mirror;
                var tl = getTickMarkLength(options.grid);
                var tickAndPadding = tl + padding;
                var hTickAndPadding = mirror ? -padding : tickAndPadding;
                var rotation = -(0, $8AEPV.t)(this.labelRotation);
                var items = [];
                var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
                var textBaseline = 'middle';
                if (position === 'top') {
                    y = this.bottom - hTickAndPadding;
                    textAlign = this._getXAxisLabelAlignment();
                } else if (position === 'bottom') {
                    y = this.top + hTickAndPadding;
                    textAlign = this._getXAxisLabelAlignment();
                } else if (position === 'left') {
                    var ret = this._getYAxisLabelAlignment(tl);
                    textAlign = ret.textAlign;
                    x = ret.x;
                } else if (position === 'right') {
                    var ret1 = this._getYAxisLabelAlignment(tl);
                    textAlign = ret1.textAlign;
                    x = ret1.x;
                } else if (axis === 'x') {
                    if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
                    else if ((0, $8AEPV.i)(position)) {
                        var positionAxisID = Object.keys(position)[0];
                        var value = position[positionAxisID];
                        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
                    }
                    textAlign = this._getXAxisLabelAlignment();
                } else if (axis === 'y') {
                    if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
                    else if ((0, $8AEPV.i)(position)) {
                        var positionAxisID1 = Object.keys(position)[0];
                        var value1 = position[positionAxisID1];
                        x = this.chart.scales[positionAxisID1].getPixelForValue(value1);
                    }
                    textAlign = this._getYAxisLabelAlignment(tl).textAlign;
                }
                if (axis === 'y') {
                    if (align === 'start') textBaseline = 'top';
                    else if (align === 'end') textBaseline = 'bottom';
                }
                var labelSizes = this._getLabelSizes();
                for(i = 0, ilen = ticks.length; i < ilen; ++i){
                    tick = ticks[i];
                    label = tick.label;
                    var optsAtIndex = optionTicks.setContext(this.getContext(i));
                    pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
                    font = this._resolveTickFontOptions(i);
                    lineHeight = font.lineHeight;
                    lineCount = (0, $8AEPV.b)(label) ? label.length : 1;
                    var halfCount = lineCount / 2;
                    var color = optsAtIndex.color;
                    var strokeColor = optsAtIndex.textStrokeColor;
                    var strokeWidth = optsAtIndex.textStrokeWidth;
                    var tickTextAlign = textAlign;
                    if (isHorizontal) {
                        x = pixel;
                        if (textAlign === 'inner') {
                            if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                            else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                            else tickTextAlign = 'center';
                        }
                        if (position === 'top') {
                            if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                            else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                            else textOffset = -labelSizes.highest.height + lineHeight / 2;
                        } else {
                            if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                            else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                            else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                        }
                        if (mirror) textOffset *= -1;
                        if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
                    } else {
                        y = pixel;
                        textOffset = (1 - lineCount) * lineHeight / 2;
                    }
                    var backdrop = void 0;
                    if (optsAtIndex.showLabelBackdrop) {
                        var labelPadding = (0, $8AEPV.E)(optsAtIndex.backdropPadding);
                        var height = labelSizes.heights[i];
                        var width = labelSizes.widths[i];
                        var top = textOffset - labelPadding.top;
                        var left = 0 - labelPadding.left;
                        switch(textBaseline){
                            case 'middle':
                                top -= height / 2;
                                break;
                            case 'bottom':
                                top -= height;
                                break;
                        }
                        switch(textAlign){
                            case 'center':
                                left -= width / 2;
                                break;
                            case 'right':
                                left -= width;
                                break;
                            case 'inner':
                                if (i === ilen - 1) left -= width;
                                else if (i > 0) left -= width / 2;
                                break;
                        }
                        backdrop = {
                            left: left,
                            top: top,
                            width: width + labelPadding.width,
                            height: height + labelPadding.height,
                            color: optsAtIndex.backdropColor
                        };
                    }
                    items.push({
                        label: label,
                        font: font,
                        textOffset: textOffset,
                        options: {
                            rotation: rotation,
                            color: color,
                            strokeColor: strokeColor,
                            strokeWidth: strokeWidth,
                            textAlign: tickTextAlign,
                            textBaseline: textBaseline,
                            translation: [
                                x,
                                y
                            ],
                            backdrop: backdrop
                        }
                    });
                }
                return items;
            }
        },
        {
            key: "_getXAxisLabelAlignment",
            value: function _getXAxisLabelAlignment() {
                var _this_options = this.options, position = _this_options.position, ticks = _this_options.ticks;
                var rotation = -(0, $8AEPV.t)(this.labelRotation);
                if (rotation) return position === 'top' ? 'left' : 'right';
                var align = 'center';
                if (ticks.align === 'start') align = 'left';
                else if (ticks.align === 'end') align = 'right';
                else if (ticks.align === 'inner') align = 'inner';
                return align;
            }
        },
        {
            key: "_getYAxisLabelAlignment",
            value: function _getYAxisLabelAlignment(tl) {
                var _this_options = this.options, position = _this_options.position, _this_options_ticks = _this_options.ticks, crossAlign = _this_options_ticks.crossAlign, mirror = _this_options_ticks.mirror, padding = _this_options_ticks.padding;
                var labelSizes = this._getLabelSizes();
                var tickAndPadding = tl + padding;
                var widest = labelSizes.widest.width;
                var textAlign;
                var x;
                if (position === 'left') {
                    if (mirror) {
                        x = this.right + padding;
                        if (crossAlign === 'near') textAlign = 'left';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x += widest / 2;
                        } else {
                            textAlign = 'right';
                            x += widest;
                        }
                    } else {
                        x = this.right - tickAndPadding;
                        if (crossAlign === 'near') textAlign = 'right';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x -= widest / 2;
                        } else {
                            textAlign = 'left';
                            x = this.left;
                        }
                    }
                } else if (position === 'right') {
                    if (mirror) {
                        x = this.left + padding;
                        if (crossAlign === 'near') textAlign = 'right';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x -= widest / 2;
                        } else {
                            textAlign = 'left';
                            x -= widest;
                        }
                    } else {
                        x = this.left + tickAndPadding;
                        if (crossAlign === 'near') textAlign = 'left';
                        else if (crossAlign === 'center') {
                            textAlign = 'center';
                            x += widest / 2;
                        } else {
                            textAlign = 'right';
                            x = this.right;
                        }
                    }
                } else textAlign = 'right';
                return {
                    textAlign: textAlign,
                    x: x
                };
            }
        },
        {
            key: "_computeLabelArea",
            value: function _computeLabelArea() {
                if (this.options.ticks.mirror) return;
                var chart = this.chart;
                var position = this.options.position;
                if (position === 'left' || position === 'right') return {
                    top: 0,
                    left: this.left,
                    bottom: chart.height,
                    right: this.right
                };
                if (position === 'top' || position === 'bottom') return {
                    top: this.top,
                    left: 0,
                    bottom: this.bottom,
                    right: chart.width
                };
            }
        },
        {
            key: "drawBackground",
            value: function drawBackground() {
                var _this = this, ctx = _this.ctx, backgroundColor = _this.options.backgroundColor, left = _this.left, top = _this.top, width = _this.width, height = _this.height;
                if (backgroundColor) {
                    ctx.save();
                    ctx.fillStyle = backgroundColor;
                    ctx.fillRect(left, top, width, height);
                    ctx.restore();
                }
            }
        },
        {
            key: "getLineWidthForValue",
            value: function getLineWidthForValue(value) {
                var grid = this.options.grid;
                if (!this._isVisible() || !grid.display) return 0;
                var ticks = this.ticks;
                var index = ticks.findIndex(function(t) {
                    return t.value === value;
                });
                if (index >= 0) {
                    var opts = grid.setContext(this.getContext(index));
                    return opts.lineWidth;
                }
                return 0;
            }
        },
        {
            key: "drawGrid",
            value: function drawGrid(chartArea) {
                var grid = this.options.grid;
                var ctx = this.ctx;
                var items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
                var i, ilen;
                var drawLine = function(p1, p2, style) {
                    if (!style.width || !style.color) return;
                    ctx.save();
                    ctx.lineWidth = style.width;
                    ctx.strokeStyle = style.color;
                    ctx.setLineDash(style.borderDash || []);
                    ctx.lineDashOffset = style.borderDashOffset;
                    ctx.beginPath();
                    ctx.moveTo(p1.x, p1.y);
                    ctx.lineTo(p2.x, p2.y);
                    ctx.stroke();
                    ctx.restore();
                };
                if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
                    var item = items[i];
                    if (grid.drawOnChartArea) drawLine({
                        x: item.x1,
                        y: item.y1
                    }, {
                        x: item.x2,
                        y: item.y2
                    }, item);
                    if (grid.drawTicks) drawLine({
                        x: item.tx1,
                        y: item.ty1
                    }, {
                        x: item.tx2,
                        y: item.ty2
                    }, {
                        color: item.tickColor,
                        width: item.tickWidth,
                        borderDash: item.tickBorderDash,
                        borderDashOffset: item.tickBorderDashOffset
                    });
                }
            }
        },
        {
            key: "drawBorder",
            value: function drawBorder() {
                var _this = this, chart = _this.chart, ctx = _this.ctx, _this_options = _this.options, border = _this_options.border, grid = _this_options.grid;
                var borderOpts = border.setContext(this.getContext());
                var axisWidth = border.display ? borderOpts.width : 0;
                if (!axisWidth) return;
                var lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
                var borderValue = this._borderValue;
                var x1, x2, y1, y2;
                if (this.isHorizontal()) {
                    x1 = (0, $8AEPV.X)(chart, this.left, axisWidth) - axisWidth / 2;
                    x2 = (0, $8AEPV.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = (0, $8AEPV.X)(chart, this.top, axisWidth) - axisWidth / 2;
                    y2 = (0, $8AEPV.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.save();
                ctx.lineWidth = borderOpts.width;
                ctx.strokeStyle = borderOpts.color;
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
                ctx.restore();
            }
        },
        {
            key: "drawLabels",
            value: function drawLabels(chartArea) {
                var optionTicks = this.options.ticks;
                if (!optionTicks.display) return;
                var ctx = this.ctx;
                var area = this._computeLabelArea();
                if (area) (0, $8AEPV.Y)(ctx, area);
                var items = this.getLabelItems(chartArea);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        var renderTextOptions = item.options;
                        var tickFont = item.font;
                        var label = item.label;
                        var y = item.textOffset;
                        (0, $8AEPV.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (area) (0, $8AEPV.$)(ctx);
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle() {
                var _this = this, ctx = _this.ctx, _this_options = _this.options, position = _this_options.position, title = _this_options.title, reverse = _this_options.reverse;
                if (!title.display) return;
                var font = (0, $8AEPV.a0)(title.font);
                var padding = (0, $8AEPV.E)(title.padding);
                var align = title.align;
                var offset = font.lineHeight / 2;
                if (position === 'bottom' || position === 'center' || (0, $8AEPV.i)(position)) {
                    offset += padding.bottom;
                    if ((0, $8AEPV.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
                } else offset += padding.top;
                var _titleArgs = titleArgs(this, offset, position, align), titleX = _titleArgs.titleX, titleY = _titleArgs.titleY, maxWidth = _titleArgs.maxWidth, rotation = _titleArgs.rotation;
                (0, $8AEPV.Z)(ctx, title.text, 0, 0, font, {
                    color: title.color,
                    maxWidth: maxWidth,
                    rotation: rotation,
                    textAlign: titleAlign(align, position, reverse),
                    textBaseline: 'middle',
                    translation: [
                        titleX,
                        titleY
                    ]
                });
            }
        },
        {
            key: "draw",
            value: function draw(chartArea) {
                if (!this._isVisible()) return;
                this.drawBackground();
                this.drawGrid(chartArea);
                this.drawBorder();
                this.drawTitle();
                this.drawLabels(chartArea);
            }
        },
        {
            key: "_layers",
            value: function _layers() {
                var _this = this;
                var opts = this.options;
                var tz = opts.ticks && opts.ticks.z || 0;
                var gz = (0, $8AEPV.v)(opts.grid && opts.grid.z, -1);
                var bz = (0, $8AEPV.v)(opts.border && opts.border.z, 0);
                if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
                    {
                        z: tz,
                        draw: function(chartArea) {
                            _this.draw(chartArea);
                        }
                    }
                ];
                return [
                    {
                        z: gz,
                        draw: function(chartArea) {
                            _this.drawBackground();
                            _this.drawGrid(chartArea);
                            _this.drawTitle();
                        }
                    },
                    {
                        z: bz,
                        draw: function() {
                            _this.drawBorder();
                        }
                    },
                    {
                        z: tz,
                        draw: function(chartArea) {
                            _this.drawLabels(chartArea);
                        }
                    }
                ];
            }
        },
        {
            key: "getMatchingVisibleMetas",
            value: function getMatchingVisibleMetas(type) {
                var metas = this.chart.getSortedVisibleDatasetMetas();
                var axisID = this.axis + 'AxisID';
                var result = [];
                var i, ilen;
                for(i = 0, ilen = metas.length; i < ilen; ++i){
                    var meta = metas[i];
                    if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
                }
                return result;
            }
        },
        {
            key: "_resolveTickFontOptions",
            value: function _resolveTickFontOptions(index) {
                var opts = this.options.ticks.setContext(this.getContext(index));
                return (0, $8AEPV.a0)(opts.font);
            }
        },
        {
            key: "_maxDigits",
            value: function _maxDigits() {
                var fontSize = this._resolveTickFontOptions(0).lineHeight;
                return (this.isHorizontal() ? this.width : this.height) / fontSize;
            }
        }
    ]);
    return Scale;
}((0, $ggYC0._)(Element));
var TypedRegistry = /*#__PURE__*/ function() {
    "use strict";
    function TypedRegistry(type, scope, override) {
        (0, $bzgVo._)(this, TypedRegistry);
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    (0, $gHG1J._)(TypedRegistry, [
        {
            key: "isForType",
            value: function isForType(type) {
                return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
            }
        },
        {
            key: "register",
            value: function register(item) {
                var proto = Object.getPrototypeOf(item);
                var parentScope;
                if (isIChartComponent(proto)) parentScope = this.register(proto);
                var items = this.items;
                var id = item.id;
                var scope = this.scope + '.' + id;
                if (!id) throw new Error('class does not have id: ' + item);
                if (id in items) return scope;
                items[id] = item;
                registerDefaults(item, scope, parentScope);
                if (this.override) (0, $8AEPV.d).override(item.id, item.overrides);
                return scope;
            }
        },
        {
            key: "get",
            value: function get(id) {
                return this.items[id];
            }
        },
        {
            key: "unregister",
            value: function unregister(item) {
                var items = this.items;
                var id = item.id;
                var scope = this.scope;
                if (id in items) delete items[id];
                if (scope && id in (0, $8AEPV.d)[scope]) {
                    delete (0, $8AEPV.d)[scope][id];
                    if (this.override) delete (0, $8AEPV.a3)[id];
                }
            }
        }
    ]);
    return TypedRegistry;
}();
function registerDefaults(item, scope, parentScope) {
    var itemDefaults = (0, $8AEPV.a4)(Object.create(null), [
        parentScope ? (0, $8AEPV.d).get(parentScope) : {},
        (0, $8AEPV.d).get(scope),
        item.defaults
    ]);
    (0, $8AEPV.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $8AEPV.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach(function(property) {
        var propertyParts = property.split('.');
        var sourceName = propertyParts.pop();
        var sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        var parts = routes[property].split('.');
        var targetName = parts.pop();
        var targetScope = parts.join('.');
        (0, $8AEPV.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
var Registry = /*#__PURE__*/ function() {
    "use strict";
    function Registry() {
        (0, $bzgVo._)(this, Registry);
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    (0, $gHG1J._)(Registry, [
        {
            key: "add",
            value: function add() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args);
            }
        },
        {
            key: "remove",
            value: function remove() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args);
            }
        },
        {
            key: "addControllers",
            value: function addControllers() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.controllers);
            }
        },
        {
            key: "addElements",
            value: function addElements() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.elements);
            }
        },
        {
            key: "addPlugins",
            value: function addPlugins() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.plugins);
            }
        },
        {
            key: "addScales",
            value: function addScales() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('register', args, this.scales);
            }
        },
        {
            key: "getController",
            value: function getController(id) {
                return this._get(id, this.controllers, 'controller');
            }
        },
        {
            key: "getElement",
            value: function getElement(id) {
                return this._get(id, this.elements, 'element');
            }
        },
        {
            key: "getPlugin",
            value: function getPlugin(id) {
                return this._get(id, this.plugins, 'plugin');
            }
        },
        {
            key: "getScale",
            value: function getScale(id) {
                return this._get(id, this.scales, 'scale');
            }
        },
        {
            key: "removeControllers",
            value: function removeControllers() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.controllers);
            }
        },
        {
            key: "removeElements",
            value: function removeElements() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.elements);
            }
        },
        {
            key: "removePlugins",
            value: function removePlugins() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.plugins);
            }
        },
        {
            key: "removeScales",
            value: function removeScales() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._each('unregister', args, this.scales);
            }
        },
        {
            key: "_each",
            value: function _each(method, args, typedRegistry) {
                var _this = this;
                (0, $2l5av._)(args).forEach(function(arg) {
                    var reg = typedRegistry || _this._getRegistryForType(arg);
                    if (typedRegistry || reg.isForType(arg) || reg === _this.plugins && arg.id) _this._exec(method, reg, arg);
                    else (0, $8AEPV.F)(arg, function(item) {
                        var itemReg = typedRegistry || _this._getRegistryForType(item);
                        _this._exec(method, itemReg, item);
                    });
                });
            }
        },
        {
            key: "_exec",
            value: function _exec(method, registry, component) {
                var camelMethod = (0, $8AEPV.a5)(method);
                (0, $8AEPV.Q)(component['before' + camelMethod], [], component);
                registry[method](component);
                (0, $8AEPV.Q)(component['after' + camelMethod], [], component);
            }
        },
        {
            key: "_getRegistryForType",
            value: function _getRegistryForType(type) {
                for(var i = 0; i < this._typedRegistries.length; i++){
                    var reg = this._typedRegistries[i];
                    if (reg.isForType(type)) return reg;
                }
                return this.plugins;
            }
        },
        {
            key: "_get",
            value: function _get(id, typedRegistry, type) {
                var item = typedRegistry.get(id);
                if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
                return item;
            }
        }
    ]);
    return Registry;
}();
var registry = /* #__PURE__ */ new Registry();
var PluginService = /*#__PURE__*/ function() {
    "use strict";
    function PluginService() {
        (0, $bzgVo._)(this, PluginService);
        this._init = undefined;
    }
    (0, $gHG1J._)(PluginService, [
        {
            key: "notify",
            value: function notify(chart, hook, args, filter) {
                if (hook === 'beforeInit') {
                    this._init = this._createDescriptors(chart, true);
                    this._notify(this._init, chart, 'install');
                }
                if (this._init === undefined) return;
                var descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
                var result = this._notify(descriptors, chart, hook, args);
                if (hook === 'afterDestroy') {
                    this._notify(descriptors, chart, 'stop');
                    this._notify(this._init, chart, 'uninstall');
                    this._init = undefined;
                }
                return result;
            }
        },
        {
            key: "_notify",
            value: function _notify(descriptors, chart, hook, args) {
                args = args || {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = descriptors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var descriptor = _step.value;
                        var plugin = descriptor.plugin;
                        var method = plugin[hook];
                        var params = [
                            chart,
                            args,
                            descriptor.options
                        ];
                        if ((0, $8AEPV.Q)(method, params, plugin) === false && args.cancelable) return false;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            }
        },
        {
            key: "invalidate",
            value: function invalidate() {
                if (!(0, $8AEPV.k)(this._cache)) {
                    this._oldCache = this._cache;
                    this._cache = undefined;
                }
            }
        },
        {
            key: "_descriptors",
            value: function _descriptors(chart) {
                if (this._cache) return this._cache;
                var descriptors = this._cache = this._createDescriptors(chart);
                this._notifyStateChanges(chart);
                return descriptors;
            }
        },
        {
            key: "_createDescriptors",
            value: function _createDescriptors(chart, all) {
                var config = chart && chart.config;
                var options = (0, $8AEPV.v)(config.options && config.options.plugins, {});
                var plugins = allPlugins(config);
                return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
            }
        },
        {
            key: "_notifyStateChanges",
            value: function _notifyStateChanges(chart) {
                var previousDescriptors = this._oldCache || [];
                var descriptors = this._cache;
                var diff = function(a, b) {
                    return a.filter(function(x) {
                        return !b.some(function(y) {
                            return x.plugin.id === y.plugin.id;
                        });
                    });
                };
                this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
                this._notify(diff(descriptors, previousDescriptors), chart, 'start');
            }
        }
    ]);
    return PluginService;
}();
function allPlugins(config) {
    var localIds = {};
    var plugins = [];
    var keys = Object.keys(registry.plugins.items);
    for(var i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    var local = config.plugins || [];
    for(var i1 = 0; i1 < local.length; i1++){
        var plugin = local[i1];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, param, options, all) {
    var plugins = param.plugins, localIds = param.localIds;
    var result = [];
    var context = chart.getContext();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            var id = plugin.id;
            var opts = getOpts(options[id], all);
            if (opts === null) continue;
            result.push({
                plugin: plugin,
                options: pluginOpts(chart.config, {
                    plugin: plugin,
                    local: localIds[id]
                }, opts, context)
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function pluginOpts(config, param, opts, context) {
    var plugin = param.plugin, local = param.local;
    var keys = config.pluginScopeKeys(plugin);
    var scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    var datasetDefaults = (0, $8AEPV.d).datasets[type] || {};
    var datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    var axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function determineAxis(id) {
    for(var _len = arguments.length, scaleOptions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        scaleOptions[_key - 1] = arguments[_key];
    }
    if (idMatchesAxis(id)) return id;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scaleOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var opts = _step.value;
            var axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
            if (axis) return axis;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    throw new Error("Cannot determine type of '".concat(id, "' axis. Please provide 'axis' or 'position' option."));
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        var boundDs = config.data.datasets.filter(function(d) {
            return d.xAxisID === id || d.yAxisID === id;
        });
        if (boundDs.length) return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    var chartDefaults = (0, $8AEPV.a3)[config.type] || {
        scales: {}
    };
    var configScales = options.scales || {};
    var chartIndexAxis = getIndexAxis(config.type, options);
    var scales = Object.create(null);
    Object.keys(configScales).forEach(function(id) {
        var scaleConf = configScales[id];
        if (!(0, $8AEPV.i)(scaleConf)) return console.error("Invalid scale configuration for scale: ".concat(id));
        if (scaleConf._proxy) return console.warn("Ignoring resolver passed as options for scale: ".concat(id));
        var axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, $8AEPV.d).scales[scaleConf.type]);
        var defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        var defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $8AEPV.ab)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach(function(dataset) {
        var type = dataset.type || config.type;
        var indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        var datasetDefaults = (0, $8AEPV.a3)[type] || {};
        var defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach(function(defaultID) {
            var axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            var id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $8AEPV.ab)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach(function(key) {
        var scale = scales[key];
        (0, $8AEPV.ab)(scale, [
            (0, $8AEPV.d).scales[scale.type],
            (0, $8AEPV.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    var options = config.options || (config.options = {});
    options.plugins = (0, $8AEPV.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
var keyCache = new Map();
var keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    var keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
var addIfFound = function(set, obj, key) {
    var opts = (0, $8AEPV.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
var Config = /*#__PURE__*/ function() {
    "use strict";
    function Config(config) {
        (0, $bzgVo._)(this, Config);
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    (0, $gHG1J._)(Config, [
        {
            key: "platform",
            get: function get() {
                return this._config.platform;
            }
        },
        {
            key: "type",
            get: function get() {
                return this._config.type;
            },
            set: function set(type) {
                this._config.type = type;
            }
        },
        {
            key: "data",
            get: function get() {
                return this._config.data;
            },
            set: function set(data) {
                this._config.data = initData(data);
            }
        },
        {
            key: "options",
            get: function get() {
                return this._config.options;
            },
            set: function set(options) {
                this._config.options = options;
            }
        },
        {
            key: "plugins",
            get: function get() {
                return this._config.plugins;
            }
        },
        {
            key: "update",
            value: function update() {
                var config = this._config;
                this.clearCache();
                initOptions(config);
            }
        },
        {
            key: "clearCache",
            value: function clearCache() {
                this._scopeCache.clear();
                this._resolverCache.clear();
            }
        },
        {
            key: "datasetScopeKeys",
            value: function datasetScopeKeys(datasetType) {
                return cachedKeys(datasetType, function() {
                    return [
                        [
                            "datasets.".concat(datasetType),
                            ''
                        ]
                    ];
                });
            }
        },
        {
            key: "datasetAnimationScopeKeys",
            value: function datasetAnimationScopeKeys(datasetType, transition) {
                return cachedKeys("".concat(datasetType, ".transition.").concat(transition), function() {
                    return [
                        [
                            "datasets.".concat(datasetType, ".transitions.").concat(transition),
                            "transitions.".concat(transition)
                        ],
                        [
                            "datasets.".concat(datasetType),
                            ''
                        ]
                    ];
                });
            }
        },
        {
            key: "datasetElementScopeKeys",
            value: function datasetElementScopeKeys(datasetType, elementType) {
                return cachedKeys("".concat(datasetType, "-").concat(elementType), function() {
                    return [
                        [
                            "datasets.".concat(datasetType, ".elements.").concat(elementType),
                            "datasets.".concat(datasetType),
                            "elements.".concat(elementType),
                            ''
                        ]
                    ];
                });
            }
        },
        {
            key: "pluginScopeKeys",
            value: function pluginScopeKeys(plugin) {
                var id = plugin.id;
                var type = this.type;
                return cachedKeys("".concat(type, "-plugin-").concat(id), function() {
                    return [
                        [
                            "plugins.".concat(id)
                        ].concat((0, $2l5av._)(plugin.additionalOptionScopes || []))
                    ];
                });
            }
        },
        {
            key: "_cachedScopes",
            value: function _cachedScopes(mainScope, resetCache) {
                var _scopeCache = this._scopeCache;
                var cache = _scopeCache.get(mainScope);
                if (!cache || resetCache) {
                    cache = new Map();
                    _scopeCache.set(mainScope, cache);
                }
                return cache;
            }
        },
        {
            key: "getOptionScopes",
            value: function getOptionScopes(mainScope, keyLists, resetCache) {
                var _this = this, options = _this.options, type = _this.type;
                var cache = this._cachedScopes(mainScope, resetCache);
                var cached = cache.get(keyLists);
                if (cached) return cached;
                var scopes = new Set();
                keyLists.forEach(function(keys) {
                    if (mainScope) {
                        scopes.add(mainScope);
                        keys.forEach(function(key) {
                            return addIfFound(scopes, mainScope, key);
                        });
                    }
                    keys.forEach(function(key) {
                        return addIfFound(scopes, options, key);
                    });
                    keys.forEach(function(key) {
                        return addIfFound(scopes, (0, $8AEPV.a3)[type] || {}, key);
                    });
                    keys.forEach(function(key) {
                        return addIfFound(scopes, (0, $8AEPV.d), key);
                    });
                    keys.forEach(function(key) {
                        return addIfFound(scopes, (0, $8AEPV.a6), key);
                    });
                });
                var array = Array.from(scopes);
                if (array.length === 0) array.push(Object.create(null));
                if (keysCached.has(keyLists)) cache.set(keyLists, array);
                return array;
            }
        },
        {
            key: "chartOptionScopes",
            value: function chartOptionScopes() {
                var _this = this, options = _this.options, type = _this.type;
                return [
                    options,
                    (0, $8AEPV.a3)[type] || {},
                    (0, $8AEPV.d).datasets[type] || {},
                    {
                        type: type
                    },
                    (0, $8AEPV.d),
                    (0, $8AEPV.a6)
                ];
            }
        },
        {
            key: "resolveNamedOptions",
            value: function resolveNamedOptions(scopes, names, context) {
                var prefixes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
                    ''
                ];
                var result = {
                    $shared: true
                };
                var _getResolver = getResolver(this._resolverCache, scopes, prefixes), resolver = _getResolver.resolver, subPrefixes = _getResolver.subPrefixes;
                var options = resolver;
                if (needContext(resolver, names)) {
                    result.$shared = false;
                    context = (0, $8AEPV.a7)(context) ? context() : context;
                    var subResolver = this.createResolver(scopes, context, subPrefixes);
                    options = (0, $8AEPV.a8)(resolver, context, subResolver);
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var prop = _step.value;
                        result[prop] = options[prop];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "createResolver",
            value: function createResolver(scopes, context) {
                var prefixes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
                    ''
                ], descriptorDefaults = arguments.length > 3 ? arguments[3] : void 0;
                var resolver = getResolver(this._resolverCache, scopes, prefixes).resolver;
                return (0, $8AEPV.i)(context) ? (0, $8AEPV.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
            }
        }
    ]);
    return Config;
}();
function getResolver(resolverCache, scopes, prefixes) {
    var cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    var cacheKey = prefixes.join();
    var cached = cache.get(cacheKey);
    if (!cached) {
        var resolver = (0, $8AEPV.a9)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter(function(p) {
                return !p.toLowerCase().includes('hover');
            })
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
var hasFunction = function(value) {
    return (0, $8AEPV.i)(value) && Object.getOwnPropertyNames(value).some(function(key) {
        return (0, $8AEPV.a7)(value[key]);
    });
};
function needContext(proxy, names) {
    var _$_descriptors = (0, $8AEPV.aa)(proxy), isScriptable = _$_descriptors.isScriptable, isIndexable = _$_descriptors.isIndexable;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            var scriptable = isScriptable(prop);
            var indexable = isIndexable(prop);
            var value = (indexable || scriptable) && proxy[prop];
            if (scriptable && ((0, $8AEPV.a7)(value) || hasFunction(value)) || indexable && (0, $8AEPV.b)(value)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
var version = "4.5.1";
var KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    var chart = context.chart;
    var animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $8AEPV.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    var chart = context.chart;
    var animationOptions = chart.options.animation;
    (0, $8AEPV.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, $8AEPV.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
var instances = {};
var getChart = function(key) {
    var canvas = getCanvas(key);
    return Object.values(instances).filter(function(c) {
        return c.canvas === canvas;
    }).pop();
};
function moveNumericKeys(obj, start, move) {
    var keys = Object.keys(obj);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var intKey = +key;
            if (intKey >= start) {
                var value = obj[key];
                delete obj[key];
                if (move > 0 || intKey > start) obj[intKey + move] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
var Chart = /*#__PURE__*/ function() {
    "use strict";
    function Chart(item, userConfig) {
        var _this = this;
        (0, $bzgVo._)(this, Chart);
        var config = this.config = new Config(userConfig);
        var initialCanvas = getCanvas(item);
        var existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        var options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        var context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        this.id = (0, $8AEPV.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $8AEPV.ad)(function(mode) {
            return _this.update(mode);
        }, options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    (0, $gHG1J._)(Chart, [
        {
            key: "aspectRatio",
            get: function get() {
                var _this = this, _this_options = _this.options, aspectRatio = _this_options.aspectRatio, maintainAspectRatio = _this_options.maintainAspectRatio, width = _this.width, height = _this.height, _aspectRatio = _this._aspectRatio;
                if (!(0, $8AEPV.k)(aspectRatio)) return aspectRatio;
                if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
                return height ? width / height : null;
            }
        },
        {
            key: "data",
            get: function get() {
                return this.config.data;
            },
            set: function set(data) {
                this.config.data = data;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._options;
            },
            set: function set(options) {
                this.config.options = options;
            }
        },
        {
            key: "registry",
            get: function get() {
                return registry;
            }
        },
        {
            key: "_initialize",
            value: function _initialize() {
                this.notifyPlugins('beforeInit');
                if (this.options.responsive) this.resize();
                else (0, $8AEPV.ae)(this, this.options.devicePixelRatio);
                this.bindEvents();
                this.notifyPlugins('afterInit');
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                (0, $8AEPV.af)(this.canvas, this.ctx);
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                animator.stop(this);
                return this;
            }
        },
        {
            key: "resize",
            value: function resize(width, height) {
                if (!animator.running(this)) this._resize(width, height);
                else this._resizeBeforeDraw = {
                    width: width,
                    height: height
                };
            }
        },
        {
            key: "_resize",
            value: function _resize(width, height) {
                var options = this.options;
                var canvas = this.canvas;
                var aspectRatio = options.maintainAspectRatio && this.aspectRatio;
                var newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
                var newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
                var mode = this.width ? 'resize' : 'attach';
                this.width = newSize.width;
                this.height = newSize.height;
                this._aspectRatio = this.aspectRatio;
                if (!(0, $8AEPV.ae)(this, newRatio, true)) return;
                this.notifyPlugins('resize', {
                    size: newSize
                });
                (0, $8AEPV.Q)(options.onResize, [
                    this,
                    newSize
                ], this);
                if (this.attached) {
                    if (this._doResize(mode)) this.render();
                }
            }
        },
        {
            key: "ensureScalesHaveIDs",
            value: function ensureScalesHaveIDs() {
                var options = this.options;
                var scalesOptions = options.scales || {};
                (0, $8AEPV.F)(scalesOptions, function(axisOptions, axisID) {
                    axisOptions.id = axisID;
                });
            }
        },
        {
            key: "buildOrUpdateScales",
            value: function buildOrUpdateScales() {
                var _this = this;
                var options = this.options;
                var scaleOpts = options.scales;
                var scales = this.scales;
                var updated = Object.keys(scales).reduce(function(obj, id) {
                    obj[id] = false;
                    return obj;
                }, {});
                var items = [];
                if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map(function(id) {
                    var scaleOptions = scaleOpts[id];
                    var axis = determineAxis(id, scaleOptions);
                    var isRadial = axis === 'r';
                    var isHorizontal = axis === 'x';
                    return {
                        options: scaleOptions,
                        dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                        dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
                    };
                }));
                (0, $8AEPV.F)(items, function(item) {
                    var scaleOptions = item.options;
                    var id = scaleOptions.id;
                    var axis = determineAxis(id, scaleOptions);
                    var scaleType = (0, $8AEPV.v)(scaleOptions.type, item.dtype);
                    if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                    updated[id] = true;
                    var scale = null;
                    if (id in scales && scales[id].type === scaleType) scale = scales[id];
                    else {
                        var scaleClass = registry.getScale(scaleType);
                        scale = new scaleClass({
                            id: id,
                            type: scaleType,
                            ctx: _this.ctx,
                            chart: _this
                        });
                        scales[scale.id] = scale;
                    }
                    scale.init(scaleOptions, options);
                });
                (0, $8AEPV.F)(updated, function(hasUpdated, id) {
                    if (!hasUpdated) delete scales[id];
                });
                (0, $8AEPV.F)(scales, function(scale) {
                    layouts.configure(_this, scale, scale.options);
                    layouts.addBox(_this, scale);
                });
            }
        },
        {
            key: "_updateMetasets",
            value: function _updateMetasets() {
                var metasets = this._metasets;
                var numData = this.data.datasets.length;
                var numMeta = metasets.length;
                metasets.sort(function(a, b) {
                    return a.index - b.index;
                });
                if (numMeta > numData) {
                    for(var i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
                    metasets.splice(numData, numMeta - numData);
                }
                this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
            }
        },
        {
            key: "_removeUnreferencedMetasets",
            value: function _removeUnreferencedMetasets() {
                var _this = this;
                var _this1 = this, metasets = _this1._metasets, datasets = _this1.data.datasets;
                if (metasets.length > datasets.length) delete this._stacks;
                metasets.forEach(function(meta, index) {
                    if (datasets.filter(function(x) {
                        return x === meta._dataset;
                    }).length === 0) _this._destroyDatasetMeta(index);
                });
            }
        },
        {
            key: "buildOrUpdateControllers",
            value: function buildOrUpdateControllers() {
                var newControllers = [];
                var datasets = this.data.datasets;
                var i, ilen;
                this._removeUnreferencedMetasets();
                for(i = 0, ilen = datasets.length; i < ilen; i++){
                    var dataset = datasets[i];
                    var meta = this.getDatasetMeta(i);
                    var type = dataset.type || this.config.type;
                    if (meta.type && meta.type !== type) {
                        this._destroyDatasetMeta(i);
                        meta = this.getDatasetMeta(i);
                    }
                    meta.type = type;
                    meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
                    meta.order = dataset.order || 0;
                    meta.index = i;
                    meta.label = '' + dataset.label;
                    meta.visible = this.isDatasetVisible(i);
                    if (meta.controller) {
                        meta.controller.updateIndex(i);
                        meta.controller.linkScales();
                    } else {
                        var ControllerClass = registry.getController(type);
                        var _defaults_datasets_type = (0, $8AEPV.d).datasets[type], datasetElementType = _defaults_datasets_type.datasetElementType, dataElementType = _defaults_datasets_type.dataElementType;
                        Object.assign(ControllerClass, {
                            dataElementType: registry.getElement(dataElementType),
                            datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                        });
                        meta.controller = new ControllerClass(this, i);
                        newControllers.push(meta.controller);
                    }
                }
                this._updateMetasets();
                return newControllers;
            }
        },
        {
            key: "_resetElements",
            value: function _resetElements() {
                var _this = this;
                (0, $8AEPV.F)(this.data.datasets, function(dataset, datasetIndex) {
                    _this.getDatasetMeta(datasetIndex).controller.reset();
                }, this);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElements();
                this.notifyPlugins('reset');
            }
        },
        {
            key: "update",
            value: function update(mode) {
                var config = this.config;
                config.update();
                var options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
                var animsDisabled = this._animationsDisabled = !options.animation;
                this._updateScales();
                this._checkEventBindings();
                this._updateHiddenIndices();
                this._plugins.invalidate();
                if (this.notifyPlugins('beforeUpdate', {
                    mode: mode,
                    cancelable: true
                }) === false) return;
                var newControllers = this.buildOrUpdateControllers();
                this.notifyPlugins('beforeElementsUpdate');
                var minPadding = 0;
                for(var i = 0, ilen = this.data.datasets.length; i < ilen; i++){
                    var controller = this.getDatasetMeta(i).controller;
                    var reset = !animsDisabled && newControllers.indexOf(controller) === -1;
                    controller.buildOrUpdateElements(reset);
                    minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
                }
                minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
                this._updateLayout(minPadding);
                if (!animsDisabled) (0, $8AEPV.F)(newControllers, function(controller) {
                    controller.reset();
                });
                this._updateDatasets(mode);
                this.notifyPlugins('afterUpdate', {
                    mode: mode
                });
                this._layers.sort(compare2Level('z', '_idx'));
                var _this = this, _active = _this._active, _lastEvent = _this._lastEvent;
                if (_lastEvent) this._eventHandler(_lastEvent, true);
                else if (_active.length) this._updateHoverStyles(_active, _active, true);
                this.render();
            }
        },
        {
            key: "_updateScales",
            value: function _updateScales() {
                var _this = this;
                (0, $8AEPV.F)(this.scales, function(scale) {
                    layouts.removeBox(_this, scale);
                });
                this.ensureScalesHaveIDs();
                this.buildOrUpdateScales();
            }
        },
        {
            key: "_checkEventBindings",
            value: function _checkEventBindings() {
                var options = this.options;
                var existingEvents = new Set(Object.keys(this._listeners));
                var newEvents = new Set(options.events);
                if (!(0, $8AEPV.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
                    this.unbindEvents();
                    this.bindEvents();
                }
            }
        },
        {
            key: "_updateHiddenIndices",
            value: function _updateHiddenIndices() {
                var _hiddenIndices = this._hiddenIndices;
                var changes = this._getUniformDataChanges() || [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, method = _step_value.method, start = _step_value.start, count = _step_value.count;
                        var move = method === '_removeElements' ? -count : count;
                        moveNumericKeys(_hiddenIndices, start, move);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getUniformDataChanges",
            value: function _getUniformDataChanges() {
                var _dataChanges = this._dataChanges;
                if (!_dataChanges || !_dataChanges.length) return;
                this._dataChanges = [];
                var datasetCount = this.data.datasets.length;
                var makeSet = function(idx) {
                    return new Set(_dataChanges.filter(function(c) {
                        return c[0] === idx;
                    }).map(function(c, i) {
                        return i + ',' + c.splice(1).join(',');
                    }));
                };
                var changeSet = makeSet(0);
                for(var i = 1; i < datasetCount; i++){
                    if (!(0, $8AEPV.ag)(changeSet, makeSet(i))) return;
                }
                return Array.from(changeSet).map(function(c) {
                    return c.split(',');
                }).map(function(a) {
                    return {
                        method: a[1],
                        start: +a[2],
                        count: +a[3]
                    };
                });
            }
        },
        {
            key: "_updateLayout",
            value: function _updateLayout(minPadding) {
                var _this = this;
                if (this.notifyPlugins('beforeLayout', {
                    cancelable: true
                }) === false) return;
                layouts.update(this, this.width, this.height, minPadding);
                var area = this.chartArea;
                var noArea = area.width <= 0 || area.height <= 0;
                this._layers = [];
                (0, $8AEPV.F)(this.boxes, function(box) {
                    var _this__layers;
                    if (noArea && box.position === 'chartArea') return;
                    if (box.configure) box.configure();
                    (_this__layers = _this._layers).push.apply(_this__layers, (0, $2l5av._)(box._layers()));
                }, this);
                this._layers.forEach(function(item, index) {
                    item._idx = index;
                });
                this.notifyPlugins('afterLayout');
            }
        },
        {
            key: "_updateDatasets",
            value: function _updateDatasets(mode) {
                if (this.notifyPlugins('beforeDatasetsUpdate', {
                    mode: mode,
                    cancelable: true
                }) === false) return;
                for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
                for(var i1 = 0, ilen1 = this.data.datasets.length; i1 < ilen1; ++i1)this._updateDataset(i1, (0, $8AEPV.a7)(mode) ? mode({
                    datasetIndex: i1
                }) : mode);
                this.notifyPlugins('afterDatasetsUpdate', {
                    mode: mode
                });
            }
        },
        {
            key: "_updateDataset",
            value: function _updateDataset(index, mode) {
                var meta = this.getDatasetMeta(index);
                var args = {
                    meta: meta,
                    index: index,
                    mode: mode,
                    cancelable: true
                };
                if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
                meta.controller._update(mode);
                args.cancelable = false;
                this.notifyPlugins('afterDatasetUpdate', args);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.notifyPlugins('beforeRender', {
                    cancelable: true
                }) === false) return;
                if (animator.has(this)) {
                    if (this.attached && !animator.running(this)) animator.start(this);
                } else {
                    this.draw();
                    onAnimationsComplete({
                        chart: this
                    });
                }
            }
        },
        {
            key: "draw",
            value: function draw() {
                var i;
                if (this._resizeBeforeDraw) {
                    var _this__resizeBeforeDraw = this._resizeBeforeDraw, width = _this__resizeBeforeDraw.width, height = _this__resizeBeforeDraw.height;
                    this._resizeBeforeDraw = null;
                    this._resize(width, height);
                }
                this.clear();
                if (this.width <= 0 || this.height <= 0) return;
                if (this.notifyPlugins('beforeDraw', {
                    cancelable: true
                }) === false) return;
                var layers = this._layers;
                for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
                this._drawDatasets();
                for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
                this.notifyPlugins('afterDraw');
            }
        },
        {
            key: "_getSortedDatasetMetas",
            value: function _getSortedDatasetMetas(filterVisible) {
                var metasets = this._sortedMetasets;
                var result = [];
                var i, ilen;
                for(i = 0, ilen = metasets.length; i < ilen; ++i){
                    var meta = metasets[i];
                    if (!filterVisible || meta.visible) result.push(meta);
                }
                return result;
            }
        },
        {
            key: "getSortedVisibleDatasetMetas",
            value: function getSortedVisibleDatasetMetas() {
                return this._getSortedDatasetMetas(true);
            }
        },
        {
            key: "_drawDatasets",
            value: function _drawDatasets() {
                if (this.notifyPlugins('beforeDatasetsDraw', {
                    cancelable: true
                }) === false) return;
                var metasets = this.getSortedVisibleDatasetMetas();
                for(var i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
                this.notifyPlugins('afterDatasetsDraw');
            }
        },
        {
            key: "_drawDataset",
            value: function _drawDataset(meta) {
                var ctx = this.ctx;
                var args = {
                    meta: meta,
                    index: meta.index,
                    cancelable: true
                };
                var clip = (0, $8AEPV.ah)(this, meta);
                if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
                if (clip) (0, $8AEPV.Y)(ctx, clip);
                meta.controller.draw();
                if (clip) (0, $8AEPV.$)(ctx);
                args.cancelable = false;
                this.notifyPlugins('afterDatasetDraw', args);
            }
        },
        {
            key: "isPointInArea",
            value: function isPointInArea(point) {
                return (0, $8AEPV.C)(point, this.chartArea, this._minPadding);
            }
        },
        {
            key: "getElementsAtEventForMode",
            value: function getElementsAtEventForMode(e, mode, options, useFinalPosition) {
                var method = Interaction.modes[mode];
                if (typeof method === 'function') return method(this, e, options, useFinalPosition);
                return [];
            }
        },
        {
            key: "getDatasetMeta",
            value: function getDatasetMeta(datasetIndex) {
                var dataset = this.data.datasets[datasetIndex];
                var metasets = this._metasets;
                var meta = metasets.filter(function(x) {
                    return x && x._dataset === dataset;
                }).pop();
                if (!meta) {
                    meta = {
                        type: null,
                        data: [],
                        dataset: null,
                        controller: null,
                        hidden: null,
                        xAxisID: null,
                        yAxisID: null,
                        order: dataset && dataset.order || 0,
                        index: datasetIndex,
                        _dataset: dataset,
                        _parsed: [],
                        _sorted: false
                    };
                    metasets.push(meta);
                }
                return meta;
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.$context || (this.$context = (0, $8AEPV.j)(null, {
                    chart: this,
                    type: 'chart'
                }));
            }
        },
        {
            key: "getVisibleDatasetCount",
            value: function getVisibleDatasetCount() {
                return this.getSortedVisibleDatasetMetas().length;
            }
        },
        {
            key: "isDatasetVisible",
            value: function isDatasetVisible(datasetIndex) {
                var dataset = this.data.datasets[datasetIndex];
                if (!dataset) return false;
                var meta = this.getDatasetMeta(datasetIndex);
                return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
            }
        },
        {
            key: "setDatasetVisibility",
            value: function setDatasetVisibility(datasetIndex, visible) {
                var meta = this.getDatasetMeta(datasetIndex);
                meta.hidden = !visible;
            }
        },
        {
            key: "toggleDataVisibility",
            value: function toggleDataVisibility(index) {
                this._hiddenIndices[index] = !this._hiddenIndices[index];
            }
        },
        {
            key: "getDataVisibility",
            value: function getDataVisibility(index) {
                return !this._hiddenIndices[index];
            }
        },
        {
            key: "_updateVisibility",
            value: function _updateVisibility(datasetIndex, dataIndex, visible) {
                var mode = visible ? 'show' : 'hide';
                var meta = this.getDatasetMeta(datasetIndex);
                var anims = meta.controller._resolveAnimations(undefined, mode);
                if ((0, $8AEPV.h)(dataIndex)) {
                    meta.data[dataIndex].hidden = !visible;
                    this.update();
                } else {
                    this.setDatasetVisibility(datasetIndex, visible);
                    anims.update(meta, {
                        visible: visible
                    });
                    this.update(function(ctx) {
                        return ctx.datasetIndex === datasetIndex ? mode : undefined;
                    });
                }
            }
        },
        {
            key: "hide",
            value: function hide(datasetIndex, dataIndex) {
                this._updateVisibility(datasetIndex, dataIndex, false);
            }
        },
        {
            key: "show",
            value: function show(datasetIndex, dataIndex) {
                this._updateVisibility(datasetIndex, dataIndex, true);
            }
        },
        {
            key: "_destroyDatasetMeta",
            value: function _destroyDatasetMeta(datasetIndex) {
                var meta = this._metasets[datasetIndex];
                if (meta && meta.controller) meta.controller._destroy();
                delete this._metasets[datasetIndex];
            }
        },
        {
            key: "_stop",
            value: function _stop() {
                var i, ilen;
                this.stop();
                animator.remove(this);
                for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.notifyPlugins('beforeDestroy');
                var _this = this, canvas = _this.canvas, ctx = _this.ctx;
                this._stop();
                this.config.clearCache();
                if (canvas) {
                    this.unbindEvents();
                    (0, $8AEPV.af)(canvas, ctx);
                    this.platform.releaseContext(ctx);
                    this.canvas = null;
                    this.ctx = null;
                }
                delete instances[this.id];
                this.notifyPlugins('afterDestroy');
            }
        },
        {
            key: "toBase64Image",
            value: function toBase64Image() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_canvas;
                return (_this_canvas = this.canvas).toDataURL.apply(_this_canvas, (0, $2l5av._)(args));
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                this.bindUserEvents();
                if (this.options.responsive) this.bindResponsiveEvents();
                else this.attached = true;
            }
        },
        {
            key: "bindUserEvents",
            value: function bindUserEvents() {
                var _this = this;
                var listeners = this._listeners;
                var platform = this.platform;
                var _add = function(type, listener) {
                    platform.addEventListener(_this, type, listener);
                    listeners[type] = listener;
                };
                var listener = function(e, x, y) {
                    e.offsetX = x;
                    e.offsetY = y;
                    _this._eventHandler(e);
                };
                (0, $8AEPV.F)(this.options.events, function(type) {
                    return _add(type, listener);
                });
            }
        },
        {
            key: "bindResponsiveEvents",
            value: function bindResponsiveEvents() {
                var _this = this;
                if (!this._responsiveListeners) this._responsiveListeners = {};
                var listeners = this._responsiveListeners;
                var platform = this.platform;
                var _add = function(type, listener) {
                    platform.addEventListener(_this, type, listener);
                    listeners[type] = listener;
                };
                var _remove = function(type, listener) {
                    if (listeners[type]) {
                        platform.removeEventListener(_this, type, listener);
                        delete listeners[type];
                    }
                };
                var listener = function(width, height) {
                    if (_this.canvas) _this.resize(width, height);
                };
                var detached;
                var attached = function() {
                    _remove('attach', attached);
                    _this.attached = true;
                    _this.resize();
                    _add('resize', listener);
                    _add('detach', detached);
                };
                detached = function() {
                    _this.attached = false;
                    _remove('resize', listener);
                    _this._stop();
                    _this._resize(0, 0);
                    _add('attach', attached);
                };
                if (platform.isAttached(this.canvas)) attached();
                else detached();
            }
        },
        {
            key: "unbindEvents",
            value: function unbindEvents() {
                var _this = this;
                (0, $8AEPV.F)(this._listeners, function(listener, type) {
                    _this.platform.removeEventListener(_this, type, listener);
                });
                this._listeners = {};
                (0, $8AEPV.F)(this._responsiveListeners, function(listener, type) {
                    _this.platform.removeEventListener(_this, type, listener);
                });
                this._responsiveListeners = undefined;
            }
        },
        {
            key: "updateHoverStyle",
            value: function updateHoverStyle(items, mode, enabled) {
                var prefix = enabled ? 'set' : 'remove';
                var meta, item, i, ilen;
                if (mode === 'dataset') {
                    meta = this.getDatasetMeta(items[0].datasetIndex);
                    meta.controller['_' + prefix + 'DatasetHoverStyle']();
                }
                for(i = 0, ilen = items.length; i < ilen; ++i){
                    item = items[i];
                    var controller = item && this.getDatasetMeta(item.datasetIndex).controller;
                    if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
                }
            }
        },
        {
            key: "getActiveElements",
            value: function getActiveElements() {
                return this._active || [];
            }
        },
        {
            key: "setActiveElements",
            value: function setActiveElements(activeElements) {
                var _this = this;
                var lastActive = this._active || [];
                var active = activeElements.map(function(param) {
                    var datasetIndex = param.datasetIndex, index = param.index;
                    var meta = _this.getDatasetMeta(datasetIndex);
                    if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
                    return {
                        datasetIndex: datasetIndex,
                        element: meta.data[index],
                        index: index
                    };
                });
                var changed = !(0, $8AEPV.ai)(active, lastActive);
                if (changed) {
                    this._active = active;
                    this._lastEvent = null;
                    this._updateHoverStyles(active, lastActive);
                }
            }
        },
        {
            key: "notifyPlugins",
            value: function notifyPlugins(hook, args, filter) {
                return this._plugins.notify(this, hook, args, filter);
            }
        },
        {
            key: "isPluginEnabled",
            value: function isPluginEnabled(pluginId) {
                return this._plugins._cache.filter(function(p) {
                    return p.plugin.id === pluginId;
                }).length === 1;
            }
        },
        {
            key: "_updateHoverStyles",
            value: function _updateHoverStyles(active, lastActive, replay) {
                var hoverOptions = this.options.hover;
                var diff = function(a, b) {
                    return a.filter(function(x) {
                        return !b.some(function(y) {
                            return x.datasetIndex === y.datasetIndex && x.index === y.index;
                        });
                    });
                };
                var deactivated = diff(lastActive, active);
                var activated = replay ? active : diff(active, lastActive);
                if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
                if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
            }
        },
        {
            key: "_eventHandler",
            value: function _eventHandler(e, replay) {
                var _this = this;
                var args = {
                    event: e,
                    replay: replay,
                    cancelable: true,
                    inChartArea: this.isPointInArea(e)
                };
                var eventFilter = function(plugin) {
                    return (plugin.options.events || _this.options.events).includes(e.native.type);
                };
                if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
                var changed = this._handleEvent(e, replay, args.inChartArea);
                args.cancelable = false;
                this.notifyPlugins('afterEvent', args, eventFilter);
                if (changed || args.changed) this.render();
                return this;
            }
        },
        {
            key: "_handleEvent",
            value: function _handleEvent(e, replay, inChartArea) {
                var _this = this, tmp = _this._active, lastActive = tmp === void 0 ? [] : tmp, options = _this.options;
                var useFinalPosition = replay;
                var active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
                var isClick = (0, $8AEPV.aj)(e);
                var lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
                if (inChartArea) {
                    this._lastEvent = null;
                    (0, $8AEPV.Q)(options.onHover, [
                        e,
                        active,
                        this
                    ], this);
                    if (isClick) (0, $8AEPV.Q)(options.onClick, [
                        e,
                        active,
                        this
                    ], this);
                }
                var changed = !(0, $8AEPV.ai)(active, lastActive);
                if (changed || replay) {
                    this._active = active;
                    this._updateHoverStyles(active, lastActive, replay);
                }
                this._lastEvent = lastEvent;
                return changed;
            }
        },
        {
            key: "_getActiveElements",
            value: function _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
                if (e.type === 'mouseout') return [];
                if (!inChartArea) return lastActive;
                var hoverOptions = this.options.hover;
                return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
            }
        }
    ], [
        {
            key: "register",
            value: function register() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                var _registry;
                (_registry = registry).add.apply(_registry, (0, $2l5av._)(items));
                invalidatePlugins();
            }
        },
        {
            key: "unregister",
            value: function unregister() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                var _registry;
                (_registry = registry).remove.apply(_registry, (0, $2l5av._)(items));
                invalidatePlugins();
            }
        }
    ]);
    return Chart;
}();
(0, $k9HNQ._)(Chart, "defaults", (0, $8AEPV.d));
(0, $k9HNQ._)(Chart, "instances", instances);
(0, $k9HNQ._)(Chart, "overrides", (0, $8AEPV.a3));
(0, $k9HNQ._)(Chart, "registry", registry);
(0, $k9HNQ._)(Chart, "version", version);
(0, $k9HNQ._)(Chart, "getChart", getChart);
function invalidatePlugins() {
    return (0, $8AEPV.F)(Chart.instances, function(chart) {
        return chart._plugins.invalidate();
    });
}
function clipSelf(ctx, element, endAngle) {
    var startAngle = element.startAngle, x = element.x, y = element.y, outerRadius = element.outerRadius, innerRadius = element.innerRadius, options = element.options;
    var borderWidth = options.borderWidth, borderJoinStyle = options.borderJoinStyle;
    var outerAngleClip = Math.min(borderWidth / outerRadius, (0, $8AEPV.al)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        var innerAngleClip = Math.min(borderWidth / innerRadius, (0, $8AEPV.al)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        var clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $8AEPV.al)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $8AEPV.P) / 2, startAngle + (0, $8AEPV.P) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            var r = 2 * clipWidth * clipWidth;
            var endX = -r * Math.cos(endAngle + (0, $8AEPV.P) / 2) + x;
            var endY = -r * Math.sin(endAngle + (0, $8AEPV.P) / 2) + y;
            var startX = r * Math.cos(startAngle + (0, $8AEPV.P) / 2) + x;
            var startY = r * Math.sin(startAngle + (0, $8AEPV.P) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function clipArc(ctx, element, endAngle) {
    var startAngle = element.startAngle, pixelMargin = element.pixelMargin, x = element.x, y = element.y, outerRadius = element.outerRadius, innerRadius = element.innerRadius;
    var angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $8AEPV.H), startAngle - (0, $8AEPV.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, $8AEPV.am)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    var o = toRadiusCorners(arc.options.borderRadius);
    var halfThickness = (outerRadius - innerRadius) / 2;
    var innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    var computeOuterLimit = function(val) {
        var outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $8AEPV.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $8AEPV.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $8AEPV.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    var x = element.x, y = element.y, start = element.startAngle, pixelMargin = element.pixelMargin, innerR = element.innerRadius;
    var outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    var innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    var spacingOffset = 0;
    var alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        var noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        var noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        var avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        var adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    var beta = Math.max(0.001, alpha * outerRadius - offset / (0, $8AEPV.P)) / outerRadius;
    var angleOffset = (alpha - beta) / 2;
    var startAngle = start + angleOffset + spacingOffset;
    var endAngle = end - angleOffset - spacingOffset;
    var _parseBorderRadius$1 = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle), outerStart = _parseBorderRadius$1.outerStart, outerEnd = _parseBorderRadius$1.outerEnd, innerStart = _parseBorderRadius$1.innerStart, innerEnd = _parseBorderRadius$1.innerEnd;
    var outerStartAdjustedRadius = outerRadius - outerStart;
    var outerEndAdjustedRadius = outerRadius - outerEnd;
    var outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    var outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    var innerStartAdjustedRadius = innerRadius + innerStart;
    var innerEndAdjustedRadius = innerRadius + innerEnd;
    var innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    var innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        var outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            var pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $8AEPV.H));
        }
        // The line from point 3 to point 4
        var p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            var pCenter1 = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter1.x, pCenter1.y, innerEnd, endAngle + (0, $8AEPV.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        var innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            var pCenter2 = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter2.x, pCenter2.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $8AEPV.H));
        }
        // The line from point 7 to point 8
        var p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            var pCenter3 = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter3.x, pCenter3.y, outerStart, startAngle - (0, $8AEPV.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        var outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        var outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        var outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        var outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    var fullCircles = element.fullCircles, startAngle = element.startAngle, circumference = element.circumference;
    var endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(var i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $8AEPV.T) || (0, $8AEPV.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    var fullCircles = element.fullCircles, startAngle = element.startAngle, circumference = element.circumference, options = element.options;
    var borderWidth = options.borderWidth, borderJoinStyle = options.borderJoinStyle, borderDash = options.borderDash, borderDashOffset = options.borderDashOffset, borderRadius = options.borderRadius;
    var inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    var endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(var i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $8AEPV.T) || (0, $8AEPV.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $8AEPV.P) && borderRadius === 0 && borderJoinStyle !== 'miter') clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
var ArcElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(ArcElement, Element);
    function ArcElement(cfg) {
        (0, $bzgVo._)(this, ArcElement);
        var _this;
        _this = (0, $lXwto._)(this, ArcElement), (0, $k9HNQ._)(_this, "circumference", void 0), (0, $k9HNQ._)(_this, "endAngle", void 0), (0, $k9HNQ._)(_this, "fullCircles", void 0), (0, $k9HNQ._)(_this, "innerRadius", void 0), (0, $k9HNQ._)(_this, "outerRadius", void 0), (0, $k9HNQ._)(_this, "pixelMargin", void 0), (0, $k9HNQ._)(_this, "startAngle", void 0);
        _this.options = undefined;
        _this.circumference = undefined;
        _this.startAngle = undefined;
        _this.endAngle = undefined;
        _this.innerRadius = undefined;
        _this.outerRadius = undefined;
        _this.pixelMargin = 0;
        _this.fullCircles = 0;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $gHG1J._)(ArcElement, [
        {
            key: "inRange",
            value: function inRange(chartX, chartY, useFinalPosition) {
                var point = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition);
                var _getAngleFromPoint = (0, $8AEPV.D)(point, {
                    x: chartX,
                    y: chartY
                }), angle = _getAngleFromPoint.angle, distance = _getAngleFromPoint.distance;
                var _this_getProps = this.getProps([
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'circumference'
                ], useFinalPosition), startAngle = _this_getProps.startAngle, endAngle = _this_getProps.endAngle, innerRadius = _this_getProps.innerRadius, outerRadius = _this_getProps.outerRadius, circumference = _this_getProps.circumference;
                var rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
                var _circumference = (0, $8AEPV.v)(circumference, endAngle - startAngle);
                var nonZeroBetween = (0, $8AEPV.p)(angle, startAngle, endAngle) && startAngle !== endAngle;
                var betweenAngles = _circumference >= (0, $8AEPV.T) || nonZeroBetween;
                var withinRadius = (0, $8AEPV.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
                return betweenAngles && withinRadius;
            }
        },
        {
            key: "getCenterPoint",
            value: function getCenterPoint(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y, startAngle = _this_getProps.startAngle, endAngle = _this_getProps.endAngle, innerRadius = _this_getProps.innerRadius, outerRadius = _this_getProps.outerRadius;
                var _this_options = this.options, offset = _this_options.offset, spacing = _this_options.spacing;
                var halfAngle = (startAngle + endAngle) / 2;
                var halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
                return {
                    x: x + Math.cos(halfAngle) * halfRadius,
                    y: y + Math.sin(halfAngle) * halfRadius
                };
            }
        },
        {
            key: "tooltipPosition",
            value: function tooltipPosition(useFinalPosition) {
                return this.getCenterPoint(useFinalPosition);
            }
        },
        {
            key: "draw",
            value: function draw(ctx) {
                var _this = this, options = _this.options, circumference = _this.circumference;
                var offset = (options.offset || 0) / 4;
                var spacing = (options.spacing || 0) / 2;
                var circular = options.circular;
                this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
                this.fullCircles = circumference > (0, $8AEPV.T) ? Math.floor(circumference / (0, $8AEPV.T)) : 0;
                if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
                ctx.save();
                var halfAngle = (this.startAngle + this.endAngle) / 2;
                ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
                var fix = 1 - Math.sin(Math.min((0, $8AEPV.P), circumference || 0));
                var radiusOffset = offset * fix;
                ctx.fillStyle = options.backgroundColor;
                ctx.strokeStyle = options.borderColor;
                drawArc(ctx, this, radiusOffset, spacing, circular);
                drawBorder(ctx, this, radiusOffset, spacing, circular);
                ctx.restore();
            }
        }
    ]);
    return ArcElement;
}((0, $ggYC0._)(Element));
(0, $k9HNQ._)(ArcElement, "id", 'arc');
(0, $k9HNQ._)(ArcElement, "defaults", {
    borderAlign: 'center',
    borderColor: '#fff',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true,
    selfJoin: false
});
(0, $k9HNQ._)(ArcElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor'
});
(0, $k9HNQ._)(ArcElement, "descriptors", {
    _scriptable: true,
    _indexable: function(name) {
        return name !== 'borderDash';
    }
});
function setStyle(ctx, options) {
    var style = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : options;
    ctx.lineCap = (0, $8AEPV.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $8AEPV.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $8AEPV.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $8AEPV.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $8AEPV.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $8AEPV.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, $8AEPV.at;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $8AEPV.au;
    return lineTo;
}
function pathVars(points, segment) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var count = points.length;
    var tmp = params.start, paramsStart = tmp === void 0 ? 0 : tmp, tmp1 = params.end, paramsEnd = tmp1 === void 0 ? count - 1 : tmp1;
    var segmentStart = segment.start, segmentEnd = segment.end;
    var start = Math.max(paramsStart, segmentStart);
    var end = Math.min(paramsEnd, segmentEnd);
    var outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    var points = line.points, options = line.options;
    var _pathVars = pathVars(points, segment, params), count = _pathVars.count, start = _pathVars.start, loop = _pathVars.loop, ilen = _pathVars.ilen;
    var lineMethod = getLineMethod(options);
    var _ref = params || {}, _ref_move = _ref.move, move = _ref_move === void 0 ? true : _ref_move, reverse = _ref.reverse;
    var i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    var points = line.points;
    var _pathVars = pathVars(points, segment, params), count = _pathVars.count, start = _pathVars.start, ilen = _pathVars.ilen;
    var _ref = params || {}, _ref_move = _ref.move, move = _ref_move === void 0 ? true : _ref_move, reverse = _ref.reverse;
    var avgX = 0;
    var countX = 0;
    var i, point, prevX, minY, maxY, lastY;
    var pointIndex = function(index) {
        return (start + (reverse ? ilen - index : index)) % count;
    };
    var drawX = function() {
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        var x = point.x;
        var y = point.y;
        var truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    var opts = line.options;
    var borderDash = opts.borderDash && opts.borderDash.length;
    var useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, $8AEPV.aq;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $8AEPV.ar;
    return 0, $8AEPV.as;
}
function strokePathWithCache(ctx, line, start, count) {
    var path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    var segments = line.segments, options = line.options;
    var segmentMethod = _getSegmentMethod(line);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            setStyle(ctx, options, segment.style);
            ctx.beginPath();
            if (segmentMethod(ctx, line, segment, {
                start: start,
                end: start + count - 1
            })) ctx.closePath();
            ctx.stroke();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
var LineElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(LineElement, Element);
    function LineElement(cfg) {
        (0, $bzgVo._)(this, LineElement);
        var _this;
        _this = (0, $lXwto._)(this, LineElement);
        _this.animated = true;
        _this.options = undefined;
        _this._chart = undefined;
        _this._loop = undefined;
        _this._fullLoop = undefined;
        _this._path = undefined;
        _this._points = undefined;
        _this._segments = undefined;
        _this._decimated = false;
        _this._pointsUpdated = false;
        _this._datasetIndex = undefined;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $gHG1J._)(LineElement, [
        {
            key: "updateControlPoints",
            value: function updateControlPoints(chartArea, indexAxis) {
                var options = this.options;
                if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
                    var loop = options.spanGaps ? this._loop : this._fullLoop;
                    (0, $8AEPV.an)(this._points, options, chartArea, loop, indexAxis);
                    this._pointsUpdated = true;
                }
            }
        },
        {
            key: "points",
            get: function get() {
                return this._points;
            },
            set: function set(points) {
                this._points = points;
                delete this._segments;
                delete this._path;
                this._pointsUpdated = false;
            }
        },
        {
            key: "segments",
            get: function get() {
                return this._segments || (this._segments = (0, $8AEPV.ao)(this, this.options.segment));
            }
        },
        {
            key: "first",
            value: function first() {
                var segments = this.segments;
                var points = this.points;
                return segments.length && points[segments[0].start];
            }
        },
        {
            key: "last",
            value: function last() {
                var segments = this.segments;
                var points = this.points;
                var count = segments.length;
                return count && points[segments[count - 1].end];
            }
        },
        {
            key: "interpolate",
            value: function interpolate(point, property) {
                var options = this.options;
                var value = point[property];
                var points = this.points;
                var segments = (0, $8AEPV.ap)(this, {
                    property: property,
                    start: value,
                    end: value
                });
                if (!segments.length) return;
                var result = [];
                var _interpolate = _getInterpolationMethod(options);
                var i, ilen;
                for(i = 0, ilen = segments.length; i < ilen; ++i){
                    var _segments_i = segments[i], start = _segments_i.start, end = _segments_i.end;
                    var p1 = points[start];
                    var p2 = points[end];
                    if (p1 === p2) {
                        result.push(p1);
                        continue;
                    }
                    var t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
                    var interpolated = _interpolate(p1, p2, t, options.stepped);
                    interpolated[property] = point[property];
                    result.push(interpolated);
                }
                return result.length === 1 ? result[0] : result;
            }
        },
        {
            key: "pathSegment",
            value: function pathSegment(ctx, segment, params) {
                var segmentMethod = _getSegmentMethod(this);
                return segmentMethod(ctx, this, segment, params);
            }
        },
        {
            key: "path",
            value: function path(ctx, start, count) {
                var segments = this.segments;
                var segmentMethod = _getSegmentMethod(this);
                var loop = this._loop;
                start = start || 0;
                count = count || this.points.length - start;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var segment = _step.value;
                        loop &= segmentMethod(ctx, this, segment, {
                            start: start,
                            end: start + count - 1
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !!loop;
            }
        },
        {
            key: "draw",
            value: function draw1(ctx, chartArea, start, count) {
                var options = this.options || {};
                var points = this.points || [];
                if (points.length && options.borderWidth) {
                    ctx.save();
                    draw(ctx, this, start, count);
                    ctx.restore();
                }
                if (this.animated) {
                    this._pointsUpdated = false;
                    this._path = undefined;
                }
            }
        }
    ]);
    return LineElement;
}((0, $ggYC0._)(Element));
(0, $k9HNQ._)(LineElement, "id", 'line');
(0, $k9HNQ._)(LineElement, "defaults", {
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: 'default',
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
});
(0, $k9HNQ._)(LineElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
(0, $k9HNQ._)(LineElement, "descriptors", {
    _scriptable: true,
    _indexable: function(name) {
        return name !== 'borderDash' && name !== 'fill';
    }
});
function inRange$1(el, pos, axis, useFinalPosition) {
    var options = el.options;
    var _el_getProps = el.getProps([
        axis
    ], useFinalPosition), value = _el_getProps[axis];
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
var PointElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(PointElement, Element);
    function PointElement(cfg) {
        (0, $bzgVo._)(this, PointElement);
        var _this;
        _this = (0, $lXwto._)(this, PointElement), (0, $k9HNQ._)(_this, "parsed", void 0), (0, $k9HNQ._)(_this, "skip", void 0), (0, $k9HNQ._)(_this, "stop", void 0);
        _this.options = undefined;
        _this.parsed = undefined;
        _this.skip = undefined;
        _this.stop = undefined;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $gHG1J._)(PointElement, [
        {
            key: "inRange",
            value: function inRange(mouseX, mouseY, useFinalPosition) {
                var options = this.options;
                var _this_getProps = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
                return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
            }
        },
        {
            key: "inXRange",
            value: function inXRange(mouseX, useFinalPosition) {
                return inRange$1(this, mouseX, 'x', useFinalPosition);
            }
        },
        {
            key: "inYRange",
            value: function inYRange(mouseY, useFinalPosition) {
                return inRange$1(this, mouseY, 'y', useFinalPosition);
            }
        },
        {
            key: "getCenterPoint",
            value: function getCenterPoint(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y;
                return {
                    x: x,
                    y: y
                };
            }
        },
        {
            key: "size",
            value: function size(options) {
                options = options || this.options || {};
                var radius = options.radius || 0;
                radius = Math.max(radius, radius && options.hoverRadius || 0);
                var borderWidth = radius && options.borderWidth || 0;
                return (radius + borderWidth) * 2;
            }
        },
        {
            key: "draw",
            value: function draw(ctx, area) {
                var options = this.options;
                if (this.skip || options.radius < 0.1 || !(0, $8AEPV.C)(this, area, this.size(options) / 2)) return;
                ctx.strokeStyle = options.borderColor;
                ctx.lineWidth = options.borderWidth;
                ctx.fillStyle = options.backgroundColor;
                (0, $8AEPV.av)(ctx, options, this.x, this.y);
            }
        },
        {
            key: "getRange",
            value: function getRange() {
                var options = this.options || {};
                // @ts-expect-error Fallbacks should never be hit in practice
                return options.radius + options.hitRadius;
            }
        }
    ]);
    return PointElement;
}((0, $ggYC0._)(Element));
(0, $k9HNQ._)(PointElement, "id", 'point');
/**
   * @type {any}
   */ (0, $k9HNQ._)(PointElement, "defaults", {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: 'circle',
    radius: 3,
    rotation: 0
});
/**
   * @type {any}
   */ (0, $k9HNQ._)(PointElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
function getBarBounds(bar, useFinalPosition) {
    var _bar_getProps = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition), x = _bar_getProps.x, y = _bar_getProps.y, base = _bar_getProps.base, width = _bar_getProps.width, height = _bar_getProps.height;
    var left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $8AEPV.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    var value = bar.options.borderWidth;
    var skip = bar.borderSkipped;
    var o = (0, $8AEPV.ax)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    var enableBorderRadius = bar.getProps([
        'enableBorderRadius'
    ]).enableBorderRadius;
    var value = bar.options.borderRadius;
    var o = (0, $8AEPV.ay)(value);
    var maxR = Math.min(maxW, maxH);
    var skip = bar.borderSkipped;
    var enableBorder = enableBorderRadius || (0, $8AEPV.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    var bounds = getBarBounds(bar);
    var width = bounds.right - bounds.left;
    var height = bounds.bottom - bounds.top;
    var border = parseBorderWidth(bar, width / 2, height / 2);
    var radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    var skipX = x === null;
    var skipY = y === null;
    var skipBoth = skipX && skipY;
    var bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $8AEPV.ak)(x, bounds.left, bounds.right)) && (skipY || (0, $8AEPV.ak)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount) {
    var refRect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var x = rect.x !== refRect.x ? -amount : 0;
    var y = rect.y !== refRect.y ? -amount : 0;
    var w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    var h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
var BarElement = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(BarElement, Element);
    function BarElement(cfg) {
        (0, $bzgVo._)(this, BarElement);
        var _this;
        _this = (0, $lXwto._)(this, BarElement);
        _this.options = undefined;
        _this.horizontal = undefined;
        _this.base = undefined;
        _this.width = undefined;
        _this.height = undefined;
        _this.inflateAmount = undefined;
        if (cfg) Object.assign(_this, cfg);
        return _this;
    }
    (0, $gHG1J._)(BarElement, [
        {
            key: "draw",
            value: function draw(ctx) {
                var _this = this, inflateAmount = _this.inflateAmount, _this_options = _this.options, borderColor = _this_options.borderColor, backgroundColor = _this_options.backgroundColor;
                var _boundingRects = boundingRects(this), inner = _boundingRects.inner, outer = _boundingRects.outer;
                var addRectPath = hasRadius(outer.radius) ? (0, $8AEPV.aw) : addNormalRectPath;
                ctx.save();
                if (outer.w !== inner.w || outer.h !== inner.h) {
                    ctx.beginPath();
                    addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
                    ctx.clip();
                    addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
                    ctx.fillStyle = borderColor;
                    ctx.fill('evenodd');
                }
                ctx.beginPath();
                addRectPath(ctx, inflateRect(inner, inflateAmount));
                ctx.fillStyle = backgroundColor;
                ctx.fill();
                ctx.restore();
            }
        },
        {
            key: "inRange",
            value: function inRange1(mouseX, mouseY, useFinalPosition) {
                return inRange(this, mouseX, mouseY, useFinalPosition);
            }
        },
        {
            key: "inXRange",
            value: function inXRange(mouseX, useFinalPosition) {
                return inRange(this, mouseX, null, useFinalPosition);
            }
        },
        {
            key: "inYRange",
            value: function inYRange(mouseY, useFinalPosition) {
                return inRange(this, null, mouseY, useFinalPosition);
            }
        },
        {
            key: "getCenterPoint",
            value: function getCenterPoint(useFinalPosition) {
                var _this_getProps = this.getProps([
                    'x',
                    'y',
                    'base',
                    'horizontal'
                ], useFinalPosition), x = _this_getProps.x, y = _this_getProps.y, base = _this_getProps.base, horizontal = _this_getProps.horizontal;
                return {
                    x: horizontal ? (x + base) / 2 : x,
                    y: horizontal ? y : (y + base) / 2
                };
            }
        },
        {
            key: "getRange",
            value: function getRange(axis) {
                return axis === 'x' ? this.width / 2 : this.height / 2;
            }
        }
    ]);
    return BarElement;
}((0, $ggYC0._)(Element));
(0, $k9HNQ._)(BarElement, "id", 'bar');
(0, $k9HNQ._)(BarElement, "defaults", {
    borderSkipped: 'start',
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: 'auto',
    pointStyle: undefined
});
(0, $k9HNQ._)(BarElement, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
var BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
var BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map(function(color) {
    return color.replace('rgb(', 'rgba(').replace(')', ', 0.5)');
});
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(function() {
        return getBorderColor(i++);
    });
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(function() {
        return getBackgroundColor(i++);
    });
    return i;
}
function getColorizer(chart) {
    var i = 0;
    return function(dataset, datasetIndex) {
        var controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    var k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function containsDefaultColorsDefenitions() {
    return (0, $8AEPV.d).borderColor !== 'rgba(0,0,0,0.1)' || (0, $8AEPV.d).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var plugin_colors = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout: function(chart, _args, options) {
        if (!options.enabled) return;
        var _chart_config = chart.config, datasets = _chart_config.data.datasets, chartOptions = _chart_config.options;
        var elements = chartOptions.elements;
        var containsColorDefenition = containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements) || containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        var colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    var samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    var decimated = [];
    var bucketWidth = (count - 2) / (samples - 2);
    var sampledIndex = 0;
    var endIndex = start + count - 1;
    var a = start;
    var i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        var avgX = 0;
        var avgY = 0;
        var j = void 0;
        var avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        var avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        var avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        var rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        var rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        var _data_a = data[a], pointAx = _data_a.x, pointAy = _data_a.y;
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    var avgX = 0;
    var countX = 0;
    var i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    var decimated = [];
    var endIndex = start + count - 1;
    var xMin = data[start].x;
    var xMax = data[endIndex].x;
    var dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        var truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            var lastIndex = i - 1;
            if (!(0, $8AEPV.k)(minIndex) && !(0, $8AEPV.k)(maxIndex)) {
                var intermediateIndex1 = Math.min(minIndex, maxIndex);
                var intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push((0, $fth2V._)((0, $7idZr._)({}, data[intermediateIndex1]), {
                    x: avgX
                }));
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push((0, $fth2V._)((0, $7idZr._)({}, data[intermediateIndex2]), {
                    x: avgX
                }));
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        var data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach(function(dataset) {
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    var pointCount = points.length;
    var start = 0;
    var count;
    var iScale = meta.iScale;
    var _iScale_getUserBounds = iScale.getUserBounds(), min = _iScale_getUserBounds.min, max = _iScale_getUserBounds.max, minDefined = _iScale_getUserBounds.minDefined, maxDefined = _iScale_getUserBounds.maxDefined;
    if (minDefined) start = (0, $8AEPV.S)((0, $8AEPV.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $8AEPV.S)((0, $8AEPV.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var plugin_decimation = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: function(chart, args, options) {
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        var availableWidth = chart.width;
        chart.data.datasets.forEach(function(dataset, datasetIndex) {
            var _data = dataset._data, indexAxis = dataset.indexAxis;
            var meta = chart.getDatasetMeta(datasetIndex);
            var data = _data || dataset.data;
            if ((0, $8AEPV.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            var xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            var _getStartAndCountOfVisiblePointsSimplified = getStartAndCountOfVisiblePointsSimplified(meta, data), start = _getStartAndCountOfVisiblePointsSimplified.start, count = _getStartAndCountOfVisiblePointsSimplified.count;
            var threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $8AEPV.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function get() {
                        return this._decimated;
                    },
                    set: function set(d) {
                        this._data = d;
                    }
                });
            }
            var decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error("Unsupported decimation algorithm '".concat(options.algorithm, "'"));
            }
            dataset._decimated = decimated;
        });
    },
    destroy: function(chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    var segments = line.segments;
    var points = line.points;
    var tpoints = target.points;
    var parts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            end = _findSegmentEnd(start, end, points);
            var bounds = _getBounds(property, points[start], points[end], segment.loop);
            if (!target.segments) {
                parts.push({
                    source: segment,
                    target: bounds,
                    start: points[start],
                    end: points[end]
                });
                continue;
            }
            var targetSegments = (0, $8AEPV.ap)(target, bounds);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = targetSegments[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var tgt = _step1.value;
                    var subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
                    var fillSources = (0, $8AEPV.az)(segment, points, subBounds);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = fillSources[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var fillSource = _step2.value;
                            parts.push({
                                source: fillSource,
                                target: tgt,
                                start: (0, $k9HNQ._)({}, property, _getEdge(bounds, subBounds, 'start', Math.max)),
                                end: (0, $k9HNQ._)({}, property, _getEdge(bounds, subBounds, 'end', Math.min))
                            });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    var start = first[property];
    var end = last[property];
    if (property === 'angle') {
        start = (0, $8AEPV.al)(start);
        end = (0, $8AEPV.al)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function _pointsFromSegments(boundary, line) {
    var _ref = boundary || {}, _ref_x = _ref.x, x = _ref_x === void 0 ? null : _ref_x, _ref_y = _ref.y, y = _ref_y === void 0 ? null : _ref_y;
    var linePoints = line.points;
    var points = [];
    line.segments.forEach(function(param) {
        var start = param.start, end = param.end;
        end = _findSegmentEnd(start, end, linePoints);
        var first = linePoints[start];
        var last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        var point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    var points = [];
    var _loop = false;
    if ((0, $8AEPV.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    var source = sources[index];
    var fill = source.fill;
    var visited = [
        index
    ];
    var target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $8AEPV.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    var fill = parseFillOption(line);
    if ((0, $8AEPV.i)(fill)) return isNaN(fill.value) ? false : fill;
    var target = parseFloat(fill);
    if ((0, $8AEPV.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    var pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $8AEPV.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    var value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $8AEPV.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    var options = line.options;
    var fillOption = options.fill;
    var fill = (0, $8AEPV.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function _buildStackLine(source) {
    var scale = source.scale, index = source.index, line = source.line;
    var points = [];
    var segments = line.segments;
    var sourcePoints = line.points;
    var linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        for(var j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points: points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    var below = [];
    var metas = scale.getMatchingVisibleMetas('line');
    for(var i = 0; i < metas.length; i++){
        var meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    var _points;
    var postponed = [];
    for(var j = 0; j < linesBelow.length; j++){
        var line = linesBelow[j];
        var _findPoint = findPoint(line, sourcePoint, 'x'), first = _findPoint.first, last = _findPoint.last, point = _findPoint.point;
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    (_points = points).push.apply(_points, (0, $2l5av._)(postponed));
}
function findPoint(line, sourcePoint, property) {
    var point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    var pointValue = point[property];
    var segments = line.segments;
    var linePoints = line.points;
    var first = false;
    var last = false;
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        var firstValue = linePoints[segment.start][property];
        var lastValue = linePoints[segment.end][property];
        if ((0, $8AEPV.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
var simpleArc = /*#__PURE__*/ function() {
    "use strict";
    function simpleArc(opts) {
        (0, $bzgVo._)(this, simpleArc);
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    (0, $gHG1J._)(simpleArc, [
        {
            key: "pathSegment",
            value: function pathSegment(ctx, bounds, opts) {
                var _this = this, x = _this.x, y = _this.y, radius = _this.radius;
                bounds = bounds || {
                    start: 0,
                    end: (0, $8AEPV.T)
                };
                ctx.arc(x, y, radius, bounds.end, bounds.start, true);
                return !opts.bounds;
            }
        },
        {
            key: "interpolate",
            value: function interpolate(point) {
                var _this = this, x = _this.x, y = _this.y, radius = _this.radius;
                var angle = point.angle;
                return {
                    x: x + Math.cos(angle) * radius,
                    y: y + Math.sin(angle) * radius,
                    angle: angle
                };
            }
        }
    ]);
    return simpleArc;
}();
function _getTarget(source) {
    var chart = source.chart, fill = source.fill, line = source.line;
    if ((0, $8AEPV.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === 'stack') return _buildStackLine(source);
    if (fill === 'shape') return true;
    var boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    var meta = chart.getDatasetMeta(index);
    var visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    var scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    var _source_scale = source.scale, scale = _source_scale === void 0 ? {} : _source_scale, fill = source.fill;
    var pixel = _getTargetPixel(fill, scale);
    if ((0, $8AEPV.g)(pixel)) {
        var horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    var scale = source.scale, fill = source.fill;
    var options = scale.options;
    var length = scale.getLabels().length;
    var start = options.reverse ? scale.max : scale.min;
    var value = _getTargetValue(fill, scale, start);
    var target = [];
    if (options.grid.circular) {
        var center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(var i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    var target = _getTarget(source);
    var chart = source.chart, index = source.index, line = source.line, scale = source.scale, axis = source.axis;
    var lineOpts = line.options;
    var fillOption = lineOpts.fill;
    var color = lineOpts.backgroundColor;
    var _ref = fillOption || {}, _ref_above = _ref.above, above = _ref_above === void 0 ? color : _ref_above, _ref_below = _ref.below, below = _ref_below === void 0 ? color : _ref_below;
    var meta = chart.getDatasetMeta(index);
    var clip = (0, $8AEPV.ah)(chart, meta);
    if (target && line.points.length) {
        (0, $8AEPV.Y)(ctx, area);
        doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $8AEPV.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    var line = cfg.line, target = cfg.target, above = cfg.above, below = cfg.below, area = cfg.area, scale = cfg.scale, clip = cfg.clip;
    var property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    var fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            clipVertical(ctx, target, area.top);
            fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            clipHorizontal(ctx, target, area.left);
            fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    var segments = target.segments, points = target.points;
    var first = true;
    var lineLoop = false;
    ctx.beginPath();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            var firstPoint = points[start];
            var lastPoint = points[_findSegmentEnd(start, end, points)];
            if (first) {
                ctx.moveTo(firstPoint.x, firstPoint.y);
                first = false;
            } else {
                ctx.lineTo(firstPoint.x, clipY);
                ctx.lineTo(firstPoint.x, firstPoint.y);
            }
            lineLoop = !!target.pathSegment(ctx, segment, {
                move: lineLoop
            });
            if (lineLoop) ctx.closePath();
            else ctx.lineTo(lastPoint.x, clipY);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function clipHorizontal(ctx, target, clipX) {
    var segments = target.segments, points = target.points;
    var first = true;
    var lineLoop = false;
    ctx.beginPath();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var start = segment.start, end = segment.end;
            var firstPoint = points[start];
            var lastPoint = points[_findSegmentEnd(start, end, points)];
            if (first) {
                ctx.moveTo(firstPoint.x, firstPoint.y);
                first = false;
            } else {
                ctx.lineTo(clipX, firstPoint.y);
                ctx.lineTo(firstPoint.x, firstPoint.y);
            }
            lineLoop = !!target.pathSegment(ctx, segment, {
                move: lineLoop
            });
            if (lineLoop) ctx.closePath();
            else ctx.lineTo(clipX, lastPoint.y);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    var line = cfg.line, target = cfg.target, property = cfg.property, color = cfg.color, scale = cfg.scale, clip = cfg.clip;
    var segments = _segments(line, target, property);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, src = _step_value.source, tgt = _step_value.target, start = _step_value.start, end = _step_value.end;
            var tmp = src.style, _ref = tmp === void 0 ? {} : tmp, _ref_backgroundColor = _ref.backgroundColor, backgroundColor = _ref_backgroundColor === void 0 ? color : _ref_backgroundColor;
            var notShape = target !== true;
            ctx.save();
            ctx.fillStyle = backgroundColor;
            clipBounds(ctx, scale, clip, notShape && _getBounds(property, start, end));
            ctx.beginPath();
            var lineLoop = !!line.pathSegment(ctx, src);
            var loop = void 0;
            if (notShape) {
                if (lineLoop) ctx.closePath();
                else interpolatedLineTo(ctx, target, end, property);
                var targetLoop = !!target.pathSegment(ctx, tgt, {
                    move: lineLoop,
                    reverse: true
                });
                loop = lineLoop && targetLoop;
                if (!loop) interpolatedLineTo(ctx, target, start, property);
            }
            ctx.closePath();
            ctx.fill(loop ? 'evenodd' : 'nonzero');
            ctx.restore();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function clipBounds(ctx, scale, clip, bounds) {
    var chartArea = scale.chart.chartArea;
    var _ref = bounds || {}, property = _ref.property, start = _ref.start, end = _ref.end;
    if (property === 'x' || property === 'y') {
        var left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    var interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: 'filler',
    afterDatasetsUpdate: function(chart, _args, options) {
        var count = (chart.data.datasets || []).length;
        var sources = [];
        var meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw: function(chart, _args, options) {
        var draw = options.drawTime === 'beforeDraw';
        var metasets = chart.getSortedVisibleDatasetMetas();
        var area = chart.chartArea;
        for(var i = metasets.length - 1; i >= 0; --i){
            var source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw: function(chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        var metasets = chart.getSortedVisibleDatasetMetas();
        for(var i = metasets.length - 1; i >= 0; --i){
            var source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw: function(chart, args, options) {
        var source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
var getBoxSize = function(labelOpts, fontSize) {
    var _labelOpts_boxHeight = labelOpts.boxHeight, boxHeight = _labelOpts_boxHeight === void 0 ? fontSize : _labelOpts_boxHeight, _labelOpts_boxWidth = labelOpts.boxWidth, boxWidth = _labelOpts_boxWidth === void 0 ? fontSize : _labelOpts_boxWidth;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
var itemsEqual = function(a, b) {
    return a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
};
var Legend = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(Legend, Element);
    function Legend(config) {
        (0, $bzgVo._)(this, Legend);
        var _this;
        _this = (0, $lXwto._)(this, Legend);
        _this._added = false;
        _this.legendHitBoxes = [];
        _this._hoveredItem = null;
        _this.doughnutMode = false;
        _this.chart = config.chart;
        _this.options = config.options;
        _this.ctx = config.ctx;
        _this.legendItems = undefined;
        _this.columnSizes = undefined;
        _this.lineWidths = undefined;
        _this.maxHeight = undefined;
        _this.maxWidth = undefined;
        _this.top = undefined;
        _this.bottom = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.height = undefined;
        _this.width = undefined;
        _this._margins = undefined;
        _this.position = undefined;
        _this.weight = undefined;
        _this.fullSize = undefined;
        return _this;
    }
    (0, $gHG1J._)(Legend, [
        {
            key: "update",
            value: function update(maxWidth, maxHeight, margins) {
                this.maxWidth = maxWidth;
                this.maxHeight = maxHeight;
                this._margins = margins;
                this.setDimensions();
                this.buildLabels();
                this.fit();
            }
        },
        {
            key: "setDimensions",
            value: function setDimensions() {
                if (this.isHorizontal()) {
                    this.width = this.maxWidth;
                    this.left = this._margins.left;
                    this.right = this.width;
                } else {
                    this.height = this.maxHeight;
                    this.top = this._margins.top;
                    this.bottom = this.height;
                }
            }
        },
        {
            key: "buildLabels",
            value: function buildLabels() {
                var _this = this;
                var labelOpts = this.options.labels || {};
                var legendItems = (0, $8AEPV.Q)(labelOpts.generateLabels, [
                    this.chart
                ], this) || [];
                if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                    return labelOpts.filter(item, _this.chart.data);
                });
                if (labelOpts.sort) legendItems = legendItems.sort(function(a, b) {
                    return labelOpts.sort(a, b, _this.chart.data);
                });
                if (this.options.reverse) legendItems.reverse();
                this.legendItems = legendItems;
            }
        },
        {
            key: "fit",
            value: function fit() {
                var _this = this, options = _this.options, ctx = _this.ctx;
                if (!options.display) {
                    this.width = this.height = 0;
                    return;
                }
                var labelOpts = options.labels;
                var labelFont = (0, $8AEPV.a0)(labelOpts.font);
                var fontSize = labelFont.size;
                var titleHeight = this._computeTitleHeight();
                var _getBoxSize = getBoxSize(labelOpts, fontSize), boxWidth = _getBoxSize.boxWidth, itemHeight = _getBoxSize.itemHeight;
                var width, height;
                ctx.font = labelFont.string;
                if (this.isHorizontal()) {
                    width = this.maxWidth;
                    height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
                } else {
                    height = this.maxHeight;
                    width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
                }
                this.width = Math.min(width, options.maxWidth || this.maxWidth);
                this.height = Math.min(height, options.maxHeight || this.maxHeight);
            }
        },
        {
            key: "_fitRows",
            value: function _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
                var _this = this, ctx = _this.ctx, maxWidth = _this.maxWidth, _this_options = _this.options, padding = _this_options.labels.padding;
                var hitboxes = this.legendHitBoxes = [];
                var lineWidths = this.lineWidths = [
                    0
                ];
                var lineHeight = itemHeight + padding;
                var totalHeight = titleHeight;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                var row = -1;
                var top = -lineHeight;
                this.legendItems.forEach(function(legendItem, i) {
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                        totalHeight += lineHeight;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                        top += lineHeight;
                        row++;
                    }
                    hitboxes[i] = {
                        left: 0,
                        top: top,
                        row: row,
                        width: itemWidth,
                        height: itemHeight
                    };
                    lineWidths[lineWidths.length - 1] += itemWidth + padding;
                });
                return totalHeight;
            }
        },
        {
            key: "_fitCols",
            value: function _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
                var _this = this, ctx = _this.ctx, maxHeight = _this.maxHeight, _this_options = _this.options, padding = _this_options.labels.padding;
                var hitboxes = this.legendHitBoxes = [];
                var columnSizes = this.columnSizes = [];
                var heightLimit = maxHeight - titleHeight;
                var totalWidth = padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                var left = 0;
                var col = 0;
                this.legendItems.forEach(function(legendItem, i) {
                    var _calculateItemSize = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight), itemWidth = _calculateItemSize.itemWidth, itemHeight = _calculateItemSize.itemHeight;
                    if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                        totalWidth += currentColWidth + padding;
                        columnSizes.push({
                            width: currentColWidth,
                            height: currentColHeight
                        });
                        left += currentColWidth + padding;
                        col++;
                        currentColWidth = currentColHeight = 0;
                    }
                    hitboxes[i] = {
                        left: left,
                        top: currentColHeight,
                        col: col,
                        width: itemWidth,
                        height: itemHeight
                    };
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += itemHeight + padding;
                });
                totalWidth += currentColWidth;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                return totalWidth;
            }
        },
        {
            key: "adjustHitBoxes",
            value: function adjustHitBoxes() {
                if (!this.options.display) return;
                var titleHeight = this._computeTitleHeight();
                var _this = this, hitboxes = _this.legendHitBoxes, _this_options = _this.options, align = _this_options.align, padding = _this_options.labels.padding, rtl = _this_options.rtl;
                var rtlHelper = (0, $8AEPV.aA)(rtl, this.left, this.width);
                if (this.isHorizontal()) {
                    var row = 0;
                    var left = (0, $8AEPV.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = hitboxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var hitbox = _step.value;
                            if (row !== hitbox.row) {
                                row = hitbox.row;
                                left = (0, $8AEPV.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                            }
                            hitbox.top += this.top + titleHeight + padding;
                            hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                            left += hitbox.width + padding;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    var col = 0;
                    var top = (0, $8AEPV.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = hitboxes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var hitbox1 = _step1.value;
                            if (hitbox1.col !== col) {
                                col = hitbox1.col;
                                top = (0, $8AEPV.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                            }
                            hitbox1.top = top;
                            hitbox1.left += this.left + padding;
                            hitbox1.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox1.left), hitbox1.width);
                            top += hitbox1.height + padding;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "isHorizontal",
            value: function isHorizontal() {
                return this.options.position === 'top' || this.options.position === 'bottom';
            }
        },
        {
            key: "draw",
            value: function draw() {
                if (this.options.display) {
                    var ctx = this.ctx;
                    (0, $8AEPV.Y)(ctx, this);
                    this._draw();
                    (0, $8AEPV.$)(ctx);
                }
            }
        },
        {
            key: "_draw",
            value: function _draw() {
                var _this = this;
                var _this1 = this, opts = _this1.options, columnSizes = _this1.columnSizes, lineWidths = _this1.lineWidths, ctx = _this1.ctx;
                var align = opts.align, labelOpts = opts.labels;
                var defaultColor = (0, $8AEPV.d).color;
                var rtlHelper = (0, $8AEPV.aA)(opts.rtl, this.left, this.width);
                var labelFont = (0, $8AEPV.a0)(labelOpts.font);
                var padding = labelOpts.padding;
                var fontSize = labelFont.size;
                var halfFontSize = fontSize / 2;
                var cursor;
                this.drawTitle();
                ctx.textAlign = rtlHelper.textAlign('left');
                ctx.textBaseline = 'middle';
                ctx.lineWidth = 0.5;
                ctx.font = labelFont.string;
                var _getBoxSize = getBoxSize(labelOpts, fontSize), boxWidth = _getBoxSize.boxWidth, boxHeight = _getBoxSize.boxHeight, itemHeight = _getBoxSize.itemHeight;
                var drawLegendBox = function drawLegendBox(x, y, legendItem) {
                    if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
                    ctx.save();
                    var lineWidth = (0, $8AEPV.v)(legendItem.lineWidth, 1);
                    ctx.fillStyle = (0, $8AEPV.v)(legendItem.fillStyle, defaultColor);
                    ctx.lineCap = (0, $8AEPV.v)(legendItem.lineCap, 'butt');
                    ctx.lineDashOffset = (0, $8AEPV.v)(legendItem.lineDashOffset, 0);
                    ctx.lineJoin = (0, $8AEPV.v)(legendItem.lineJoin, 'miter');
                    ctx.lineWidth = lineWidth;
                    ctx.strokeStyle = (0, $8AEPV.v)(legendItem.strokeStyle, defaultColor);
                    ctx.setLineDash((0, $8AEPV.v)(legendItem.lineDash, []));
                    if (labelOpts.usePointStyle) {
                        var drawOptions = {
                            radius: boxHeight * Math.SQRT2 / 2,
                            pointStyle: legendItem.pointStyle,
                            rotation: legendItem.rotation,
                            borderWidth: lineWidth
                        };
                        var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                        var centerY = y + halfFontSize;
                        (0, $8AEPV.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
                    } else {
                        var yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                        var xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                        var borderRadius = (0, $8AEPV.ay)(legendItem.borderRadius);
                        ctx.beginPath();
                        if (Object.values(borderRadius).some(function(v) {
                            return v !== 0;
                        })) (0, $8AEPV.aw)(ctx, {
                            x: xBoxLeft,
                            y: yBoxTop,
                            w: boxWidth,
                            h: boxHeight,
                            radius: borderRadius
                        });
                        else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                        ctx.fill();
                        if (lineWidth !== 0) ctx.stroke();
                    }
                    ctx.restore();
                };
                var fillText = function fillText(x, y, legendItem) {
                    (0, $8AEPV.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                        strikethrough: legendItem.hidden,
                        textAlign: rtlHelper.textAlign(legendItem.textAlign)
                    });
                };
                var isHorizontal = this.isHorizontal();
                var titleHeight = this._computeTitleHeight();
                if (isHorizontal) cursor = {
                    x: (0, $8AEPV.a2)(align, this.left + padding, this.right - lineWidths[0]),
                    y: this.top + padding + titleHeight,
                    line: 0
                };
                else cursor = {
                    x: this.left + padding,
                    y: (0, $8AEPV.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
                    line: 0
                };
                (0, $8AEPV.aB)(this.ctx, opts.textDirection);
                var lineHeight = itemHeight + padding;
                this.legendItems.forEach(function(legendItem, i) {
                    ctx.strokeStyle = legendItem.fontColor;
                    ctx.fillStyle = legendItem.fontColor;
                    var textWidth = ctx.measureText(legendItem.text).width;
                    var textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
                    var width = boxWidth + halfFontSize + textWidth;
                    var x = cursor.x;
                    var y = cursor.y;
                    rtlHelper.setWidth(_this.width);
                    if (isHorizontal) {
                        if (i > 0 && x + width + padding > _this.right) {
                            y = cursor.y += lineHeight;
                            cursor.line++;
                            x = cursor.x = (0, $8AEPV.a2)(align, _this.left + padding, _this.right - lineWidths[cursor.line]);
                        }
                    } else if (i > 0 && y + lineHeight > _this.bottom) {
                        x = cursor.x = x + columnSizes[cursor.line].width + padding;
                        cursor.line++;
                        y = cursor.y = (0, $8AEPV.a2)(align, _this.top + titleHeight + padding, _this.bottom - columnSizes[cursor.line].height);
                    }
                    var realX = rtlHelper.x(x);
                    drawLegendBox(realX, y, legendItem);
                    x = (0, $8AEPV.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : _this.right, opts.rtl);
                    fillText(rtlHelper.x(x), y, legendItem);
                    if (isHorizontal) cursor.x += width + padding;
                    else if (typeof legendItem.text !== 'string') {
                        var fontLineHeight = labelFont.lineHeight;
                        cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
                    } else cursor.y += lineHeight;
                });
                (0, $8AEPV.aD)(this.ctx, opts.textDirection);
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle() {
                var opts = this.options;
                var titleOpts = opts.title;
                var titleFont = (0, $8AEPV.a0)(titleOpts.font);
                var titlePadding = (0, $8AEPV.E)(titleOpts.padding);
                if (!titleOpts.display) return;
                var rtlHelper = (0, $8AEPV.aA)(opts.rtl, this.left, this.width);
                var ctx = this.ctx;
                var position = titleOpts.position;
                var halfFontSize = titleFont.size / 2;
                var topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
                var y;
                var left = this.left;
                var maxWidth = this.width;
                if (this.isHorizontal()) {
                    var _Math;
                    maxWidth = (_Math = Math).max.apply(_Math, (0, $2l5av._)(this.lineWidths));
                    y = this.top + topPaddingPlusHalfFontSize;
                    left = (0, $8AEPV.a2)(opts.align, left, this.right - maxWidth);
                } else {
                    var maxHeight = this.columnSizes.reduce(function(acc, size) {
                        return Math.max(acc, size.height);
                    }, 0);
                    y = topPaddingPlusHalfFontSize + (0, $8AEPV.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
                }
                var x = (0, $8AEPV.a2)(position, left, left + maxWidth);
                ctx.textAlign = rtlHelper.textAlign((0, $8AEPV.a1)(position));
                ctx.textBaseline = 'middle';
                ctx.strokeStyle = titleOpts.color;
                ctx.fillStyle = titleOpts.color;
                ctx.font = titleFont.string;
                (0, $8AEPV.Z)(ctx, titleOpts.text, x, y, titleFont);
            }
        },
        {
            key: "_computeTitleHeight",
            value: function _computeTitleHeight() {
                var titleOpts = this.options.title;
                var titleFont = (0, $8AEPV.a0)(titleOpts.font);
                var titlePadding = (0, $8AEPV.E)(titleOpts.padding);
                return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
            }
        },
        {
            key: "_getLegendItemAt",
            value: function _getLegendItemAt(x, y) {
                var i, hitBox, lh;
                if ((0, $8AEPV.ak)(x, this.left, this.right) && (0, $8AEPV.ak)(y, this.top, this.bottom)) {
                    lh = this.legendHitBoxes;
                    for(i = 0; i < lh.length; ++i){
                        hitBox = lh[i];
                        if ((0, $8AEPV.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $8AEPV.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
                    }
                }
                return null;
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(e) {
                var opts = this.options;
                if (!isListened(e.type, opts)) return;
                var hoveredItem = this._getLegendItemAt(e.x, e.y);
                if (e.type === 'mousemove' || e.type === 'mouseout') {
                    var previous = this._hoveredItem;
                    var sameItem = itemsEqual(previous, hoveredItem);
                    if (previous && !sameItem) (0, $8AEPV.Q)(opts.onLeave, [
                        e,
                        previous,
                        this
                    ], this);
                    this._hoveredItem = hoveredItem;
                    if (hoveredItem && !sameItem) (0, $8AEPV.Q)(opts.onHover, [
                        e,
                        hoveredItem,
                        this
                    ], this);
                } else if (hoveredItem) (0, $8AEPV.Q)(opts.onClick, [
                    e,
                    hoveredItem,
                    this
                ], this);
            }
        }
    ]);
    return Legend;
}((0, $ggYC0._)(Element));
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    var itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    var itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    var legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce(function(a, b) {
        return a.length > b.length ? a : b;
    });
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    var itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    var labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var plugin_legend = {
    id: 'legend',
    _element: Legend,
    start: function(chart, _args, options) {
        var legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop: function(chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate: function(chart, _args, options) {
        var legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate: function(chart) {
        var legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent: function(chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick: function(e, legendItem, legend) {
            var index = legendItem.datasetIndex;
            var ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: function(ctx) {
                return ctx.chart.options.color;
            },
            boxWidth: 40,
            padding: 10,
            generateLabels: function(chart) {
                var datasets = chart.data.datasets;
                var _chart_legend_options = chart.legend.options, _chart_legend_options_labels = _chart_legend_options.labels, usePointStyle = _chart_legend_options_labels.usePointStyle, pointStyle = _chart_legend_options_labels.pointStyle, textAlign = _chart_legend_options_labels.textAlign, color = _chart_legend_options_labels.color, useBorderRadius = _chart_legend_options_labels.useBorderRadius, borderRadius = _chart_legend_options_labels.borderRadius;
                return chart._getSortedDatasetMetas().map(function(meta) {
                    var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    var borderWidth = (0, $8AEPV.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: function(ctx) {
                return ctx.chart.options.color;
            },
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: function(name) {
            return !name.startsWith('on');
        },
        labels: {
            _scriptable: function(name) {
                return ![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name);
            }
        }
    }
};
var Title = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(Title, Element);
    function Title(config) {
        (0, $bzgVo._)(this, Title);
        var _this;
        _this = (0, $lXwto._)(this, Title);
        _this.chart = config.chart;
        _this.options = config.options;
        _this.ctx = config.ctx;
        _this._padding = undefined;
        _this.top = undefined;
        _this.bottom = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.width = undefined;
        _this.height = undefined;
        _this.position = undefined;
        _this.weight = undefined;
        _this.fullSize = undefined;
        return _this;
    }
    (0, $gHG1J._)(Title, [
        {
            key: "update",
            value: function update(maxWidth, maxHeight) {
                var opts = this.options;
                this.left = 0;
                this.top = 0;
                if (!opts.display) {
                    this.width = this.height = this.right = this.bottom = 0;
                    return;
                }
                this.width = this.right = maxWidth;
                this.height = this.bottom = maxHeight;
                var lineCount = (0, $8AEPV.b)(opts.text) ? opts.text.length : 1;
                this._padding = (0, $8AEPV.E)(opts.padding);
                var textSize = lineCount * (0, $8AEPV.a0)(opts.font).lineHeight + this._padding.height;
                if (this.isHorizontal()) this.height = textSize;
                else this.width = textSize;
            }
        },
        {
            key: "isHorizontal",
            value: function isHorizontal() {
                var pos = this.options.position;
                return pos === 'top' || pos === 'bottom';
            }
        },
        {
            key: "_drawArgs",
            value: function _drawArgs(offset) {
                var _this = this, top = _this.top, left = _this.left, bottom = _this.bottom, right = _this.right, options = _this.options;
                var align = options.align;
                var rotation = 0;
                var maxWidth, titleX, titleY;
                if (this.isHorizontal()) {
                    titleX = (0, $8AEPV.a2)(align, left, right);
                    titleY = top + offset;
                    maxWidth = right - left;
                } else {
                    if (options.position === 'left') {
                        titleX = left + offset;
                        titleY = (0, $8AEPV.a2)(align, bottom, top);
                        rotation = (0, $8AEPV.P) * -0.5;
                    } else {
                        titleX = right - offset;
                        titleY = (0, $8AEPV.a2)(align, top, bottom);
                        rotation = (0, $8AEPV.P) * 0.5;
                    }
                    maxWidth = bottom - top;
                }
                return {
                    titleX: titleX,
                    titleY: titleY,
                    maxWidth: maxWidth,
                    rotation: rotation
                };
            }
        },
        {
            key: "draw",
            value: function draw() {
                var ctx = this.ctx;
                var opts = this.options;
                if (!opts.display) return;
                var fontOpts = (0, $8AEPV.a0)(opts.font);
                var lineHeight = fontOpts.lineHeight;
                var offset = lineHeight / 2 + this._padding.top;
                var _this__drawArgs = this._drawArgs(offset), titleX = _this__drawArgs.titleX, titleY = _this__drawArgs.titleY, maxWidth = _this__drawArgs.maxWidth, rotation = _this__drawArgs.rotation;
                (0, $8AEPV.Z)(ctx, opts.text, 0, 0, fontOpts, {
                    color: opts.color,
                    maxWidth: maxWidth,
                    rotation: rotation,
                    textAlign: (0, $8AEPV.a1)(opts.align),
                    textBaseline: 'middle',
                    translation: [
                        titleX,
                        titleY
                    ]
                });
            }
        }
    ]);
    return Title;
}((0, $ggYC0._)(Element));
function createTitle(chart, titleOpts) {
    var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: 'title',
    _element: Title,
    start: function(chart, _args, options) {
        createTitle(chart, options);
    },
    stop: function(chart) {
        var titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate: function(chart, _args, options) {
        var title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
var map = new WeakMap();
var plugin_subtitle = {
    id: 'subtitle',
    start: function(chart, _args, options) {
        var title = new Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop: function(chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate: function(chart, _args, options) {
        var title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
var positioners = {
    average: function(items) {
        if (!items.length) return false;
        var i, len;
        var xSet = new Set();
        var y = 0;
        var count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            var el = items[i].element;
            if (el && el.hasValue()) {
                var pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        var xAverage = (0, $2l5av._)(xSet).reduce(function(a, b) {
            return a + b;
        }) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest: function(items, eventPosition) {
        if (!items.length) return false;
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            var el = items[i].element;
            if (el && el.hasValue()) {
                var center = el.getCenterPoint();
                var d = (0, $8AEPV.aF)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            var tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $8AEPV.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function createTooltipItem(chart, item) {
    var element = item.element, datasetIndex = item.datasetIndex, index = item.index;
    var controller = chart.getDatasetMeta(datasetIndex).controller;
    var _controller_getLabelAndValue = controller.getLabelAndValue(index), label = _controller_getLabelAndValue.label, value = _controller_getLabelAndValue.value;
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function getTooltipSize(tooltip, options) {
    var ctx = tooltip.chart.ctx;
    var body = tooltip.body, footer = tooltip.footer, title = tooltip.title;
    var boxWidth = options.boxWidth, boxHeight = options.boxHeight;
    var bodyFont = (0, $8AEPV.a0)(options.bodyFont);
    var titleFont = (0, $8AEPV.a0)(options.titleFont);
    var footerFont = (0, $8AEPV.a0)(options.footerFont);
    var titleLineCount = title.length;
    var footerLineCount = footer.length;
    var bodyLineItemCount = body.length;
    var padding = (0, $8AEPV.E)(options.padding);
    var height = padding.height;
    var width = 0;
    var combinedBodyLength = body.reduce(function(count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
    }, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        var bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    var widthPadding = 0;
    var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $8AEPV.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $8AEPV.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $8AEPV.F)(body, function(bodyItem) {
        (0, $8AEPV.F)(bodyItem.before, maxLineWidth);
        (0, $8AEPV.F)(bodyItem.lines, maxLineWidth);
        (0, $8AEPV.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $8AEPV.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function determineYAlign(chart, size) {
    var y = size.y, height = size.height;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    var x = size.x, width = size.width;
    var caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    var x = size.x, width = size.width;
    var chartWidth = chart.width, _chart_chartArea = chart.chartArea, left = _chart_chartArea.left, right = _chart_chartArea.right;
    var xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function determineAlignment(chart, options, size) {
    var yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function alignX(size, xAlign) {
    var x = size.x, width = size.width;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    var y = size.y, height = size.height;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    var caretSize = options.caretSize, caretPadding = options.caretPadding, cornerRadius = options.cornerRadius;
    var xAlign = alignment.xAlign, yAlign = alignment.yAlign;
    var paddingAndSize = caretSize + caretPadding;
    var _toTRBLCorners = (0, $8AEPV.ay)(cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
    var x = alignX(size, xAlign);
    var y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $8AEPV.S)(x, 0, chart.width - size.width),
        y: (0, $8AEPV.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    var padding = (0, $8AEPV.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $8AEPV.j)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    var override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
var defaultCallbacks = {
    beforeTitle: (0, $8AEPV.aG),
    title: function(tooltipItems) {
        if (tooltipItems.length > 0) {
            var item = tooltipItems[0];
            var labels = item.chart.data.labels;
            var labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $8AEPV.aG),
    beforeBody: (0, $8AEPV.aG),
    beforeLabel: (0, $8AEPV.aG),
    label: function(tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        var label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        var value = tooltipItem.formattedValue;
        if (!(0, $8AEPV.k)(value)) label += value;
        return label;
    },
    labelColor: function(tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor: function() {
        return this.options.bodyColor;
    },
    labelPointStyle: function(tooltipItem) {
        var meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        var options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $8AEPV.aG),
    afterBody: (0, $8AEPV.aG),
    beforeFooter: (0, $8AEPV.aG),
    footer: (0, $8AEPV.aG),
    afterFooter: (0, $8AEPV.aG)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    var result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return defaultCallbacks[name].call(ctx, arg);
    return result;
}
var Tooltip = /*#__PURE__*/ function(Element) {
    "use strict";
    (0, $fwyhh._)(Tooltip, Element);
    function Tooltip(config) {
        (0, $bzgVo._)(this, Tooltip);
        var _this;
        _this = (0, $lXwto._)(this, Tooltip);
        _this.opacity = 0;
        _this._active = [];
        _this._eventPosition = undefined;
        _this._size = undefined;
        _this._cachedAnimations = undefined;
        _this._tooltipItems = [];
        _this.$animations = undefined;
        _this.$context = undefined;
        _this.chart = config.chart;
        _this.options = config.options;
        _this.dataPoints = undefined;
        _this.title = undefined;
        _this.beforeBody = undefined;
        _this.body = undefined;
        _this.afterBody = undefined;
        _this.footer = undefined;
        _this.xAlign = undefined;
        _this.yAlign = undefined;
        _this.x = undefined;
        _this.y = undefined;
        _this.height = undefined;
        _this.width = undefined;
        _this.caretX = undefined;
        _this.caretY = undefined;
        _this.labelColors = undefined;
        _this.labelPointStyles = undefined;
        _this.labelTextColors = undefined;
        return _this;
    }
    (0, $gHG1J._)(Tooltip, [
        {
            key: "initialize",
            value: function initialize(options) {
                this.options = options;
                this._cachedAnimations = undefined;
                this.$context = undefined;
            }
        },
        {
            key: "_resolveAnimations",
            value: function _resolveAnimations() {
                var cached = this._cachedAnimations;
                if (cached) return cached;
                var chart = this.chart;
                var options = this.options.setContext(this.getContext());
                var opts = options.enabled && chart.options.animation && options.animations;
                var animations = new Animations(this.chart, opts);
                if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
                return animations;
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
            }
        },
        {
            key: "getTitle",
            value: function getTitle(context, options) {
                var callbacks = options.callbacks;
                var beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
                var title = invokeCallbackWithFallback(callbacks, 'title', this, context);
                var afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
                var lines = [];
                lines = pushOrConcat(lines, splitNewlines(beforeTitle));
                lines = pushOrConcat(lines, splitNewlines(title));
                lines = pushOrConcat(lines, splitNewlines(afterTitle));
                return lines;
            }
        },
        {
            key: "getBeforeBody",
            value: function getBeforeBody(tooltipItems, options) {
                return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
            }
        },
        {
            key: "getBody",
            value: function getBody(tooltipItems, options) {
                var _this = this;
                var callbacks = options.callbacks;
                var bodyItems = [];
                (0, $8AEPV.F)(tooltipItems, function(context) {
                    var bodyItem = {
                        before: [],
                        lines: [],
                        after: []
                    };
                    var scoped = overrideCallbacks(callbacks, context);
                    pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', _this, context)));
                    pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', _this, context));
                    pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', _this, context)));
                    bodyItems.push(bodyItem);
                });
                return bodyItems;
            }
        },
        {
            key: "getAfterBody",
            value: function getAfterBody(tooltipItems, options) {
                return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
            }
        },
        {
            key: "getFooter",
            value: function getFooter(tooltipItems, options) {
                var callbacks = options.callbacks;
                var beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
                var footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
                var afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
                var lines = [];
                lines = pushOrConcat(lines, splitNewlines(beforeFooter));
                lines = pushOrConcat(lines, splitNewlines(footer));
                lines = pushOrConcat(lines, splitNewlines(afterFooter));
                return lines;
            }
        },
        {
            key: "_createItems",
            value: function _createItems(options) {
                var _this = this;
                var active = this._active;
                var data = this.chart.data;
                var labelColors = [];
                var labelPointStyles = [];
                var labelTextColors = [];
                var tooltipItems = [];
                var i, len;
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
                if (options.filter) tooltipItems = tooltipItems.filter(function(element, index, array) {
                    return options.filter(element, index, array, data);
                });
                if (options.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return options.itemSort(a, b, data);
                });
                (0, $8AEPV.F)(tooltipItems, function(context) {
                    var scoped = overrideCallbacks(options.callbacks, context);
                    labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', _this, context));
                    labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', _this, context));
                    labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', _this, context));
                });
                this.labelColors = labelColors;
                this.labelPointStyles = labelPointStyles;
                this.labelTextColors = labelTextColors;
                this.dataPoints = tooltipItems;
                return tooltipItems;
            }
        },
        {
            key: "update",
            value: function update(changed, replay) {
                var options = this.options.setContext(this.getContext());
                var active = this._active;
                var properties;
                var tooltipItems = [];
                if (!active.length) {
                    if (this.opacity !== 0) properties = {
                        opacity: 0
                    };
                } else {
                    var position = positioners[options.position].call(this, active, this._eventPosition);
                    tooltipItems = this._createItems(options);
                    this.title = this.getTitle(tooltipItems, options);
                    this.beforeBody = this.getBeforeBody(tooltipItems, options);
                    this.body = this.getBody(tooltipItems, options);
                    this.afterBody = this.getAfterBody(tooltipItems, options);
                    this.footer = this.getFooter(tooltipItems, options);
                    var size = this._size = getTooltipSize(this, options);
                    var positionAndSize = Object.assign({}, position, size);
                    var alignment = determineAlignment(this.chart, options, positionAndSize);
                    var backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
                    this.xAlign = alignment.xAlign;
                    this.yAlign = alignment.yAlign;
                    properties = {
                        opacity: 1,
                        x: backgroundPoint.x,
                        y: backgroundPoint.y,
                        width: size.width,
                        height: size.height,
                        caretX: position.x,
                        caretY: position.y
                    };
                }
                this._tooltipItems = tooltipItems;
                this.$context = undefined;
                if (properties) this._resolveAnimations().update(this, properties);
                if (changed && options.external) options.external.call(this, {
                    chart: this.chart,
                    tooltip: this,
                    replay: replay
                });
            }
        },
        {
            key: "drawCaret",
            value: function drawCaret(tooltipPoint, ctx, size, options) {
                var caretPosition = this.getCaretPosition(tooltipPoint, size, options);
                ctx.lineTo(caretPosition.x1, caretPosition.y1);
                ctx.lineTo(caretPosition.x2, caretPosition.y2);
                ctx.lineTo(caretPosition.x3, caretPosition.y3);
            }
        },
        {
            key: "getCaretPosition",
            value: function getCaretPosition(tooltipPoint, size, options) {
                var _this = this, xAlign = _this.xAlign, yAlign = _this.yAlign;
                var caretSize = options.caretSize, cornerRadius = options.cornerRadius;
                var _toTRBLCorners = (0, $8AEPV.ay)(cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
                var ptX = tooltipPoint.x, ptY = tooltipPoint.y;
                var width = size.width, height = size.height;
                var x1, x2, x3, y1, y2, y3;
                if (yAlign === 'center') {
                    y2 = ptY + height / 2;
                    if (xAlign === 'left') {
                        x1 = ptX;
                        x2 = x1 - caretSize;
                        y1 = y2 + caretSize;
                        y3 = y2 - caretSize;
                    } else {
                        x1 = ptX + width;
                        x2 = x1 + caretSize;
                        y1 = y2 - caretSize;
                        y3 = y2 + caretSize;
                    }
                    x3 = x1;
                } else {
                    if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
                    else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
                    else x2 = this.caretX;
                    if (yAlign === 'top') {
                        y1 = ptY;
                        y2 = y1 - caretSize;
                        x1 = x2 - caretSize;
                        x3 = x2 + caretSize;
                    } else {
                        y1 = ptY + height;
                        y2 = y1 + caretSize;
                        x1 = x2 + caretSize;
                        x3 = x2 - caretSize;
                    }
                    y3 = y1;
                }
                return {
                    x1: x1,
                    x2: x2,
                    x3: x3,
                    y1: y1,
                    y2: y2,
                    y3: y3
                };
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle(pt, ctx, options) {
                var title = this.title;
                var length = title.length;
                var titleFont, titleSpacing, i;
                if (length) {
                    var rtlHelper = (0, $8AEPV.aA)(options.rtl, this.x, this.width);
                    pt.x = getAlignedX(this, options.titleAlign, options);
                    ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
                    ctx.textBaseline = 'middle';
                    titleFont = (0, $8AEPV.a0)(options.titleFont);
                    titleSpacing = options.titleSpacing;
                    ctx.fillStyle = options.titleColor;
                    ctx.font = titleFont.string;
                    for(i = 0; i < length; ++i){
                        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                        pt.y += titleFont.lineHeight + titleSpacing;
                        if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
                    }
                }
            }
        },
        {
            key: "_drawColorBox",
            value: function _drawColorBox(ctx, pt, i, rtlHelper, options) {
                var labelColor = this.labelColors[i];
                var labelPointStyle = this.labelPointStyles[i];
                var boxHeight = options.boxHeight, boxWidth = options.boxWidth;
                var bodyFont = (0, $8AEPV.a0)(options.bodyFont);
                var colorX = getAlignedX(this, 'left', options);
                var rtlColorX = rtlHelper.x(colorX);
                var yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
                var colorY = pt.y + yOffSet;
                if (options.usePointStyle) {
                    var drawOptions = {
                        radius: Math.min(boxWidth, boxHeight) / 2,
                        pointStyle: labelPointStyle.pointStyle,
                        rotation: labelPointStyle.rotation,
                        borderWidth: 1
                    };
                    var centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
                    var centerY = colorY + boxHeight / 2;
                    ctx.strokeStyle = options.multiKeyBackground;
                    ctx.fillStyle = options.multiKeyBackground;
                    (0, $8AEPV.av)(ctx, drawOptions, centerX, centerY);
                    ctx.strokeStyle = labelColor.borderColor;
                    ctx.fillStyle = labelColor.backgroundColor;
                    (0, $8AEPV.av)(ctx, drawOptions, centerX, centerY);
                } else {
                    var _Math;
                    ctx.lineWidth = (0, $8AEPV.i)(labelColor.borderWidth) ? (_Math = Math).max.apply(_Math, (0, $2l5av._)(Object.values(labelColor.borderWidth))) : labelColor.borderWidth || 1;
                    ctx.strokeStyle = labelColor.borderColor;
                    ctx.setLineDash(labelColor.borderDash || []);
                    ctx.lineDashOffset = labelColor.borderDashOffset || 0;
                    var outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
                    var innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
                    var borderRadius = (0, $8AEPV.ay)(labelColor.borderRadius);
                    if (Object.values(borderRadius).some(function(v) {
                        return v !== 0;
                    })) {
                        ctx.beginPath();
                        ctx.fillStyle = options.multiKeyBackground;
                        (0, $8AEPV.aw)(ctx, {
                            x: outerX,
                            y: colorY,
                            w: boxWidth,
                            h: boxHeight,
                            radius: borderRadius
                        });
                        ctx.fill();
                        ctx.stroke();
                        ctx.fillStyle = labelColor.backgroundColor;
                        ctx.beginPath();
                        (0, $8AEPV.aw)(ctx, {
                            x: innerX,
                            y: colorY + 1,
                            w: boxWidth - 2,
                            h: boxHeight - 2,
                            radius: borderRadius
                        });
                        ctx.fill();
                    } else {
                        ctx.fillStyle = options.multiKeyBackground;
                        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                        ctx.fillStyle = labelColor.backgroundColor;
                        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
                    }
                }
                ctx.fillStyle = this.labelTextColors[i];
            }
        },
        {
            key: "drawBody",
            value: function drawBody(pt, ctx, options) {
                var body = this.body;
                var bodySpacing = options.bodySpacing, bodyAlign = options.bodyAlign, displayColors = options.displayColors, boxHeight = options.boxHeight, boxWidth = options.boxWidth, boxPadding = options.boxPadding;
                var bodyFont = (0, $8AEPV.a0)(options.bodyFont);
                var bodyLineHeight = bodyFont.lineHeight;
                var xLinePadding = 0;
                var rtlHelper = (0, $8AEPV.aA)(options.rtl, this.x, this.width);
                var fillLineOfText = function fillLineOfText(line) {
                    ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
                    pt.y += bodyLineHeight + bodySpacing;
                };
                var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
                var bodyItem, textColor, lines, i, j, ilen, jlen;
                ctx.textAlign = bodyAlign;
                ctx.textBaseline = 'middle';
                ctx.font = bodyFont.string;
                pt.x = getAlignedX(this, bodyAlignForCalculation, options);
                ctx.fillStyle = options.bodyColor;
                (0, $8AEPV.F)(this.beforeBody, fillLineOfText);
                xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
                for(i = 0, ilen = body.length; i < ilen; ++i){
                    bodyItem = body[i];
                    textColor = this.labelTextColors[i];
                    ctx.fillStyle = textColor;
                    (0, $8AEPV.F)(bodyItem.before, fillLineOfText);
                    lines = bodyItem.lines;
                    if (displayColors && lines.length) {
                        this._drawColorBox(ctx, pt, i, rtlHelper, options);
                        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
                    }
                    for(j = 0, jlen = lines.length; j < jlen; ++j){
                        fillLineOfText(lines[j]);
                        bodyLineHeight = bodyFont.lineHeight;
                    }
                    (0, $8AEPV.F)(bodyItem.after, fillLineOfText);
                }
                xLinePadding = 0;
                bodyLineHeight = bodyFont.lineHeight;
                (0, $8AEPV.F)(this.afterBody, fillLineOfText);
                pt.y -= bodySpacing;
            }
        },
        {
            key: "drawFooter",
            value: function drawFooter(pt, ctx, options) {
                var footer = this.footer;
                var length = footer.length;
                var footerFont, i;
                if (length) {
                    var rtlHelper = (0, $8AEPV.aA)(options.rtl, this.x, this.width);
                    pt.x = getAlignedX(this, options.footerAlign, options);
                    pt.y += options.footerMarginTop;
                    ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
                    ctx.textBaseline = 'middle';
                    footerFont = (0, $8AEPV.a0)(options.footerFont);
                    ctx.fillStyle = options.footerColor;
                    ctx.font = footerFont.string;
                    for(i = 0; i < length; ++i){
                        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                        pt.y += footerFont.lineHeight + options.footerSpacing;
                    }
                }
            }
        },
        {
            key: "drawBackground",
            value: function drawBackground(pt, ctx, tooltipSize, options) {
                var _this = this, xAlign = _this.xAlign, yAlign = _this.yAlign;
                var x = pt.x, y = pt.y;
                var width = tooltipSize.width, height = tooltipSize.height;
                var _toTRBLCorners = (0, $8AEPV.ay)(options.cornerRadius), topLeft = _toTRBLCorners.topLeft, topRight = _toTRBLCorners.topRight, bottomLeft = _toTRBLCorners.bottomLeft, bottomRight = _toTRBLCorners.bottomRight;
                ctx.fillStyle = options.backgroundColor;
                ctx.strokeStyle = options.borderColor;
                ctx.lineWidth = options.borderWidth;
                ctx.beginPath();
                ctx.moveTo(x + topLeft, y);
                if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x + width - topRight, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
                if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x + width, y + height - bottomRight);
                ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
                if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x + bottomLeft, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
                if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
                ctx.lineTo(x, y + topLeft);
                ctx.quadraticCurveTo(x, y, x + topLeft, y);
                ctx.closePath();
                ctx.fill();
                if (options.borderWidth > 0) ctx.stroke();
            }
        },
        {
            key: "_updateAnimationTarget",
            value: function _updateAnimationTarget(options) {
                var chart = this.chart;
                var anims = this.$animations;
                var animX = anims && anims.x;
                var animY = anims && anims.y;
                if (animX || animY) {
                    var position = positioners[options.position].call(this, this._active, this._eventPosition);
                    if (!position) return;
                    var size = this._size = getTooltipSize(this, options);
                    var positionAndSize = Object.assign({}, position, this._size);
                    var alignment = determineAlignment(chart, options, positionAndSize);
                    var point = getBackgroundPoint(options, positionAndSize, alignment, chart);
                    if (animX._to !== point.x || animY._to !== point.y) {
                        this.xAlign = alignment.xAlign;
                        this.yAlign = alignment.yAlign;
                        this.width = size.width;
                        this.height = size.height;
                        this.caretX = position.x;
                        this.caretY = position.y;
                        this._resolveAnimations().update(this, point);
                    }
                }
            }
        },
        {
            key: "_willRender",
            value: function _willRender() {
                return !!this.opacity;
            }
        },
        {
            key: "draw",
            value: function draw(ctx) {
                var options = this.options.setContext(this.getContext());
                var opacity = this.opacity;
                if (!opacity) return;
                this._updateAnimationTarget(options);
                var tooltipSize = {
                    width: this.width,
                    height: this.height
                };
                var pt = {
                    x: this.x,
                    y: this.y
                };
                opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
                var padding = (0, $8AEPV.E)(options.padding);
                var hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
                if (options.enabled && hasTooltipContent) {
                    ctx.save();
                    ctx.globalAlpha = opacity;
                    this.drawBackground(pt, ctx, tooltipSize, options);
                    (0, $8AEPV.aB)(ctx, options.textDirection);
                    pt.y += padding.top;
                    this.drawTitle(pt, ctx, options);
                    this.drawBody(pt, ctx, options);
                    this.drawFooter(pt, ctx, options);
                    (0, $8AEPV.aD)(ctx, options.textDirection);
                    ctx.restore();
                }
            }
        },
        {
            key: "getActiveElements",
            value: function getActiveElements() {
                return this._active || [];
            }
        },
        {
            key: "setActiveElements",
            value: function setActiveElements(activeElements, eventPosition) {
                var _this = this;
                var lastActive = this._active;
                var active = activeElements.map(function(param) {
                    var datasetIndex = param.datasetIndex, index = param.index;
                    var meta = _this.chart.getDatasetMeta(datasetIndex);
                    if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
                    return {
                        datasetIndex: datasetIndex,
                        element: meta.data[index],
                        index: index
                    };
                });
                var changed = !(0, $8AEPV.ai)(lastActive, active);
                var positionChanged = this._positionChanged(active, eventPosition);
                if (changed || positionChanged) {
                    this._active = active;
                    this._eventPosition = eventPosition;
                    this._ignoreReplayEvents = true;
                    this.update(true);
                }
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(e, replay) {
                var inChartArea = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                if (replay && this._ignoreReplayEvents) return false;
                this._ignoreReplayEvents = false;
                var options = this.options;
                var lastActive = this._active || [];
                var active = this._getActiveElements(e, lastActive, replay, inChartArea);
                var positionChanged = this._positionChanged(active, e);
                var changed = replay || !(0, $8AEPV.ai)(active, lastActive) || positionChanged;
                if (changed) {
                    this._active = active;
                    if (options.enabled || options.external) {
                        this._eventPosition = {
                            x: e.x,
                            y: e.y
                        };
                        this.update(true, replay);
                    }
                }
                return changed;
            }
        },
        {
            key: "_getActiveElements",
            value: function _getActiveElements(e, lastActive, replay, inChartArea) {
                var _this = this;
                var options = this.options;
                if (e.type === 'mouseout') return [];
                if (!inChartArea) return lastActive.filter(function(i) {
                    return _this.chart.data.datasets[i.datasetIndex] && _this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined;
                });
                var active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
                if (options.reverse) active.reverse();
                return active;
            }
        },
        {
            key: "_positionChanged",
            value: function _positionChanged(active, e) {
                var _this = this, caretX = _this.caretX, caretY = _this.caretY, options = _this.options;
                var position = positioners[options.position].call(this, active, e);
                return position !== false && (caretX !== position.x || caretY !== position.y);
            }
        }
    ]);
    return Tooltip;
}((0, $ggYC0._)(Element));
(0, $k9HNQ._)(Tooltip, "positioners", positioners);
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners: positioners,
    afterInit: function(chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate: function(chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset: function(chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw: function(chart) {
        var tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            var args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', (0, $fth2V._)((0, $7idZr._)({}, args), {
                cancelable: true
            })) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent: function(chart, args) {
        if (chart.tooltip) {
            var useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: function(ctx, opts) {
            return opts.bodyFont.size;
        },
        boxWidth: function(ctx, opts) {
            return opts.bodyFont.size;
        },
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: function(name) {
            return name !== 'filter' && name !== 'itemSort' && name !== 'external';
        },
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
var addIfString = function(labels, raw, index, addedLabels) {
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    var first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    var last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
var validIndex = function(index, max) {
    return index === null ? null : (0, $8AEPV.S)(Math.round(index), 0, max);
};
function _getLabelForValue(value) {
    var labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
var CategoryScale = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $fwyhh._)(CategoryScale, Scale);
    function CategoryScale(cfg) {
        (0, $bzgVo._)(this, CategoryScale);
        var _this;
        _this = (0, $lXwto._)(this, CategoryScale, [
            cfg
        ]);
        _this._startValue = undefined;
        _this._valueRange = 0;
        _this._addedLabels = [];
        return _this;
    }
    (0, $gHG1J._)(CategoryScale, [
        {
            key: "init",
            value: function init(scaleOptions) {
                var added = this._addedLabels;
                if (added.length) {
                    var labels = this.getLabels();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = added[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _step.value, index = _step_value.index, label = _step_value.label;
                            if (labels[index] === label) labels.splice(index, 1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._addedLabels = [];
                }
                (0, $8wpvj._)((0, $grPlv._)(CategoryScale.prototype), "init", this).call(this, scaleOptions);
            }
        },
        {
            key: "parse",
            value: function parse(raw, index) {
                if ((0, $8AEPV.k)(raw)) return null;
                var labels = this.getLabels();
                index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, $8AEPV.v)(index, raw), this._addedLabels);
                return validIndex(index, labels.length - 1);
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
                if (this.options.bounds === 'ticks') {
                    if (!minDefined) min = 0;
                    if (!maxDefined) max = this.getLabels().length - 1;
                }
                this.min = min;
                this.max = max;
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var min = this.min;
                var max = this.max;
                var offset = this.options.offset;
                var ticks = [];
                var labels = this.getLabels();
                labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
                this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
                this._startValue = this.min - (offset ? 0.5 : 0);
                for(var value = min; value <= max; value++)ticks.push({
                    value: value
                });
                return ticks;
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return _getLabelForValue.call(this, value);
            }
        },
        {
            key: "configure",
            value: function configure() {
                (0, $8wpvj._)((0, $grPlv._)(CategoryScale.prototype), "configure", this).call(this);
                if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                if (typeof value !== 'number') value = this.parse(value);
                return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
            }
        },
        {
            key: "getPixelForTick",
            value: function getPixelForTick(index) {
                var ticks = this.ticks;
                if (index < 0 || index > ticks.length - 1) return null;
                return this.getPixelForValue(ticks[index].value);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
            }
        },
        {
            key: "getBasePixel",
            value: function getBasePixel() {
                return this.bottom;
            }
        }
    ]);
    return CategoryScale;
}(Scale);
(0, $k9HNQ._)(CategoryScale, "id", 'category');
(0, $k9HNQ._)(CategoryScale, "defaults", {
    ticks: {
        callback: _getLabelForValue
    }
});
function generateTicks$1(generationOptions, dataRange) {
    var ticks = [];
    var MIN_SPACING = 1e-14;
    var bounds = generationOptions.bounds, step = generationOptions.step, min = generationOptions.min, max = generationOptions.max, precision = generationOptions.precision, count = generationOptions.count, maxTicks = generationOptions.maxTicks, maxDigits = generationOptions.maxDigits, includeBounds = generationOptions.includeBounds;
    var unit = step || 1;
    var maxSpaces = maxTicks - 1;
    var rmin = dataRange.min, rmax = dataRange.max;
    var minDefined = !(0, $8AEPV.k)(min);
    var maxDefined = !(0, $8AEPV.k)(max);
    var countDefined = !(0, $8AEPV.k)(count);
    var minSpacing = (rmax - rmin) / (maxDigits + 1);
    var spacing = (0, $8AEPV.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    var factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $8AEPV.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $8AEPV.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $8AEPV.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $8AEPV.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    var decimalPlaces = Math.max((0, $8AEPV.aL)(spacing), (0, $8AEPV.aL)(niceMin));
    factor = Math.pow(10, (0, $8AEPV.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    var j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $8AEPV.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        var tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $8AEPV.aK)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, param) {
    var horizontal = param.horizontal, minRotation = param.minRotation;
    var rad = (0, $8AEPV.t)(minRotation);
    var ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    var length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
var LinearScaleBase = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $fwyhh._)(LinearScaleBase, Scale);
    function LinearScaleBase(cfg) {
        (0, $bzgVo._)(this, LinearScaleBase);
        var _this;
        _this = (0, $lXwto._)(this, LinearScaleBase, [
            cfg
        ]);
        _this.start = undefined;
        _this.end = undefined;
        _this._startValue = undefined;
        _this._endValue = undefined;
        _this._valueRange = 0;
        return _this;
    }
    (0, $gHG1J._)(LinearScaleBase, [
        {
            key: "parse",
            value: function parse(raw, index) {
                if ((0, $8AEPV.k)(raw)) return null;
                if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
                return +raw;
            }
        },
        {
            key: "handleTickRangeOptions",
            value: function handleTickRangeOptions() {
                var beginAtZero = this.options.beginAtZero;
                var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var _this = this, min = _this.min, max = _this.max;
                var setMin = function(v) {
                    return min = minDefined ? min : v;
                };
                var setMax = function(v) {
                    return max = maxDefined ? max : v;
                };
                if (beginAtZero) {
                    var minSign = (0, $8AEPV.s)(min);
                    var maxSign = (0, $8AEPV.s)(max);
                    if (minSign < 0 && maxSign < 0) setMax(0);
                    else if (minSign > 0 && maxSign > 0) setMin(0);
                }
                if (min === max) {
                    var offset = max === 0 ? 1 : Math.abs(max * 0.05);
                    setMax(max + offset);
                    if (!beginAtZero) setMin(min - offset);
                }
                this.min = min;
                this.max = max;
            }
        },
        {
            key: "getTickLimit",
            value: function getTickLimit() {
                var tickOpts = this.options.ticks;
                var maxTicksLimit = tickOpts.maxTicksLimit, stepSize = tickOpts.stepSize;
                var maxTicks;
                if (stepSize) {
                    maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
                    if (maxTicks > 1000) {
                        console.warn("scales.".concat(this.id, ".ticks.stepSize: ").concat(stepSize, " would result generating up to ").concat(maxTicks, " ticks. Limiting to 1000."));
                        maxTicks = 1000;
                    }
                } else {
                    maxTicks = this.computeTickLimit();
                    maxTicksLimit = maxTicksLimit || 11;
                }
                if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
                return maxTicks;
            }
        },
        {
            key: "computeTickLimit",
            value: function computeTickLimit() {
                return Number.POSITIVE_INFINITY;
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var opts = this.options;
                var tickOpts = opts.ticks;
                var maxTicks = this.getTickLimit();
                maxTicks = Math.max(2, maxTicks);
                var numericGeneratorOptions = {
                    maxTicks: maxTicks,
                    bounds: opts.bounds,
                    min: opts.min,
                    max: opts.max,
                    precision: tickOpts.precision,
                    step: tickOpts.stepSize,
                    count: tickOpts.count,
                    maxDigits: this._maxDigits(),
                    horizontal: this.isHorizontal(),
                    minRotation: tickOpts.minRotation || 0,
                    includeBounds: tickOpts.includeBounds !== false
                };
                var dataRange = this._range || this;
                var ticks = generateTicks$1(numericGeneratorOptions, dataRange);
                if (opts.bounds === 'ticks') (0, $8AEPV.aH)(ticks, this, 'value');
                if (opts.reverse) {
                    ticks.reverse();
                    this.start = this.max;
                    this.end = this.min;
                } else {
                    this.start = this.min;
                    this.end = this.max;
                }
                return ticks;
            }
        },
        {
            key: "configure",
            value: function configure() {
                var ticks = this.ticks;
                var start = this.min;
                var end = this.max;
                (0, $8wpvj._)((0, $grPlv._)(LinearScaleBase.prototype), "configure", this).call(this);
                if (this.options.offset && ticks.length) {
                    var offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                    start -= offset;
                    end += offset;
                }
                this._startValue = start;
                this._endValue = end;
                this._valueRange = end - start;
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return (0, $8AEPV.o)(value, this.chart.options.locale, this.options.ticks.format);
            }
        }
    ]);
    return LinearScaleBase;
}(Scale);
var LinearScale = /*#__PURE__*/ function(LinearScaleBase) {
    "use strict";
    (0, $fwyhh._)(LinearScale, LinearScaleBase);
    function LinearScale() {
        (0, $bzgVo._)(this, LinearScale);
        return (0, $lXwto._)(this, LinearScale, arguments);
    }
    (0, $gHG1J._)(LinearScale, [
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
                this.min = (0, $8AEPV.g)(min) ? min : 0;
                this.max = (0, $8AEPV.g)(max) ? max : 1;
                this.handleTickRangeOptions();
            }
        },
        {
            key: "computeTickLimit",
            value: function computeTickLimit() {
                var horizontal = this.isHorizontal();
                var length = horizontal ? this.width : this.height;
                var minRotation = (0, $8AEPV.t)(this.options.ticks.minRotation);
                var ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
                var tickFont = this._resolveTickFontOptions(0);
                return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
            }
        }
    ]);
    return LinearScale;
}(LinearScaleBase);
(0, $k9HNQ._)(LinearScale, "id", 'linear');
(0, $k9HNQ._)(LinearScale, "defaults", {
    ticks: {
        callback: (0, $8AEPV.aM).formatters.numeric
    }
});
var log10Floor = function(v) {
    return Math.floor((0, $8AEPV.aN)(v));
};
var changeExponent = function(v, m) {
    return Math.pow(10, log10Floor(v) + m);
};
function isMajor(tickVal) {
    var remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    var rangeStep = Math.pow(10, rangeExp);
    var start = Math.floor(min / rangeStep);
    var end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    var range = max - min;
    var rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, param) {
    var min = param.min, max = param.max;
    min = (0, $8AEPV.O)(generationOptions.min, min);
    var ticks = [];
    var minExp = log10Floor(min);
    var exp = startExp(min, max);
    var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    var stepSize = Math.pow(10, exp);
    var base = minExp > exp ? Math.pow(10, minExp) : 0;
    var start = Math.round((min - base) * precision) / precision;
    var offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    var significand = Math.floor((start - offset) / Math.pow(10, exp));
    var value = (0, $8AEPV.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    var lastTick = (0, $8AEPV.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
var LogarithmicScale = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $fwyhh._)(LogarithmicScale, Scale);
    function LogarithmicScale(cfg) {
        (0, $bzgVo._)(this, LogarithmicScale);
        var _this;
        _this = (0, $lXwto._)(this, LogarithmicScale, [
            cfg
        ]);
        _this.start = undefined;
        _this.end = undefined;
        _this._startValue = undefined;
        _this._valueRange = 0;
        return _this;
    }
    (0, $gHG1J._)(LogarithmicScale, [
        {
            key: "parse",
            value: function parse(raw, index) {
                var value = LinearScaleBase.prototype.parse.apply(this, [
                    raw,
                    index
                ]);
                if (value === 0) {
                    this._zero = true;
                    return undefined;
                }
                return (0, $8AEPV.g)(value) && value > 0 ? value : null;
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getMinMax = this.getMinMax(true), min = _this_getMinMax.min, max = _this_getMinMax.max;
                this.min = (0, $8AEPV.g)(min) ? Math.max(0, min) : null;
                this.max = (0, $8AEPV.g)(max) ? Math.max(0, max) : null;
                if (this.options.beginAtZero) this._zero = true;
                if (this._zero && this.min !== this._suggestedMin && !(0, $8AEPV.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
                this.handleTickRangeOptions();
            }
        },
        {
            key: "handleTickRangeOptions",
            value: function handleTickRangeOptions() {
                var _this_getUserBounds = this.getUserBounds(), minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                var min = this.min;
                var max = this.max;
                var setMin = function(v) {
                    return min = minDefined ? min : v;
                };
                var setMax = function(v) {
                    return max = maxDefined ? max : v;
                };
                if (min === max) {
                    if (min <= 0) {
                        setMin(1);
                        setMax(10);
                    } else {
                        setMin(changeExponent(min, -1));
                        setMax(changeExponent(max, 1));
                    }
                }
                if (min <= 0) setMin(changeExponent(max, -1));
                if (max <= 0) setMax(changeExponent(min, 1));
                this.min = min;
                this.max = max;
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var opts = this.options;
                var generationOptions = {
                    min: this._userMin,
                    max: this._userMax
                };
                var ticks = generateTicks(generationOptions, this);
                if (opts.bounds === 'ticks') (0, $8AEPV.aH)(ticks, this, 'value');
                if (opts.reverse) {
                    ticks.reverse();
                    this.start = this.max;
                    this.end = this.min;
                } else {
                    this.start = this.min;
                    this.end = this.max;
                }
                return ticks;
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                return value === undefined ? '0' : (0, $8AEPV.o)(value, this.chart.options.locale, this.options.ticks.format);
            }
        },
        {
            key: "configure",
            value: function configure() {
                var start = this.min;
                (0, $8wpvj._)((0, $grPlv._)(LogarithmicScale.prototype), "configure", this).call(this);
                this._startValue = (0, $8AEPV.aN)(start);
                this._valueRange = (0, $8AEPV.aN)(this.max) - (0, $8AEPV.aN)(start);
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                if (value === undefined || value === 0) value = this.min;
                if (value === null || isNaN(value)) return NaN;
                return this.getPixelForDecimal(value === this.min ? 0 : ((0, $8AEPV.aN)(value) - this._startValue) / this._valueRange);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                var decimal = this.getDecimalForPixel(pixel);
                return Math.pow(10, this._startValue + decimal * this._valueRange);
            }
        }
    ]);
    return LogarithmicScale;
}(Scale);
(0, $k9HNQ._)(LogarithmicScale, "id", 'logarithmic');
(0, $k9HNQ._)(LogarithmicScale, "defaults", {
    ticks: {
        callback: (0, $8AEPV.aM).formatters.logarithmic,
        major: {
            enabled: true
        }
    }
});
function getTickBackdropHeight(opts) {
    var tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        var padding = (0, $8AEPV.E)(tickOpts.backdropPadding);
        return (0, $8AEPV.v)(tickOpts.font && tickOpts.font.size, (0, $8AEPV.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, $8AEPV.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $8AEPV.aO)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    var orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    var limits = Object.assign({}, orig);
    var labelSizes = [];
    var padding = [];
    var valueCount = scale._pointLabels.length;
    var pointLabelOpts = scale.options.pointLabels;
    var additionalAngle = pointLabelOpts.centerPointLabels ? (0, $8AEPV.P) / valueCount : 0;
    for(var i = 0; i < valueCount; i++){
        var opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        var pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        var plFont = (0, $8AEPV.a0)(opts.font);
        var textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        var angleRadians = (0, $8AEPV.al)(scale.getIndexAngle(i) + additionalAngle);
        var angle = Math.round((0, $8AEPV.U)(angleRadians));
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    var sin = Math.abs(Math.sin(angle));
    var cos = Math.abs(Math.cos(angle));
    var x = 0;
    var y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    var outerDistance = scale.drawingArea;
    var extra = itemOpts.extra, additionalAngle = itemOpts.additionalAngle, padding = itemOpts.padding, size = itemOpts.size;
    var pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    var angle = Math.round((0, $8AEPV.U)((0, $8AEPV.al)(pointLabelPosition.angle + (0, $8AEPV.H))));
    var y = yForAngle(pointLabelPosition.y, size.h, angle);
    var textAlign = getTextAlignForAngle(angle);
    var left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    var left = item.left, top = item.top, right = item.right, bottom = item.bottom;
    var apexesInArea = (0, $8AEPV.C)({
        x: left,
        y: top
    }, area) || (0, $8AEPV.C)({
        x: left,
        y: bottom
    }, area) || (0, $8AEPV.C)({
        x: right,
        y: top
    }, area) || (0, $8AEPV.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    var items = [];
    var valueCount = scale._pointLabels.length;
    var opts = scale.options;
    var _opts_pointLabels = opts.pointLabels, centerPointLabels = _opts_pointLabels.centerPointLabels, display = _opts_pointLabels.display;
    var itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $8AEPV.P) / valueCount : 0
    };
    var area;
    for(var i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        var item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    var left = item.left, top = item.top, right = item.right, bottom = item.bottom;
    var backdropColor = opts.backdropColor;
    if (!(0, $8AEPV.k)(backdropColor)) {
        var borderRadius = (0, $8AEPV.ay)(opts.borderRadius);
        var padding = (0, $8AEPV.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        var backdropLeft = left - padding.left;
        var backdropTop = top - padding.top;
        var backdropWidth = right - left + padding.width;
        var backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some(function(v) {
            return v !== 0;
        })) {
            ctx.beginPath();
            (0, $8AEPV.aw)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    var ctx = scale.ctx, pointLabels = scale.options.pointLabels;
    for(var i = labelCount - 1; i >= 0; i--){
        var item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        var optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        var plFont = (0, $8AEPV.a0)(optsAtIndex.font);
        var x = item.x, y = item.y, textAlign = item.textAlign;
        (0, $8AEPV.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    var ctx = scale.ctx;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $8AEPV.T));
    else {
        var pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(var i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    var ctx = scale.ctx;
    var circular = gridLineOpts.circular;
    var color = gridLineOpts.color, lineWidth = gridLineOpts.lineWidth;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, $8AEPV.j)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
var RadialLinearScale = /*#__PURE__*/ function(LinearScaleBase1) {
    "use strict";
    (0, $fwyhh._)(RadialLinearScale, LinearScaleBase1);
    function RadialLinearScale(cfg) {
        (0, $bzgVo._)(this, RadialLinearScale);
        var _this;
        _this = (0, $lXwto._)(this, RadialLinearScale, [
            cfg
        ]);
        _this.xCenter = undefined;
        _this.yCenter = undefined;
        _this.drawingArea = undefined;
        _this._pointLabels = [];
        _this._pointLabelItems = [];
        return _this;
    }
    (0, $gHG1J._)(RadialLinearScale, [
        {
            key: "setDimensions",
            value: function setDimensions() {
                var padding = this._padding = (0, $8AEPV.E)(getTickBackdropHeight(this.options) / 2);
                var w = this.width = this.maxWidth - padding.width;
                var h = this.height = this.maxHeight - padding.height;
                this.xCenter = Math.floor(this.left + w / 2 + padding.left);
                this.yCenter = Math.floor(this.top + h / 2 + padding.top);
                this.drawingArea = Math.floor(Math.min(w, h) / 2);
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var _this_getMinMax = this.getMinMax(false), min = _this_getMinMax.min, max = _this_getMinMax.max;
                this.min = (0, $8AEPV.g)(min) && !isNaN(min) ? min : 0;
                this.max = (0, $8AEPV.g)(max) && !isNaN(max) ? max : 0;
                this.handleTickRangeOptions();
            }
        },
        {
            key: "computeTickLimit",
            value: function computeTickLimit() {
                return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
            }
        },
        {
            key: "generateTickLabels",
            value: function generateTickLabels(ticks) {
                var _this = this;
                LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
                this._pointLabels = this.getLabels().map(function(value, index) {
                    var label = (0, $8AEPV.Q)(_this.options.pointLabels.callback, [
                        value,
                        index
                    ], _this);
                    return label || label === 0 ? label : '';
                }).filter(function(v, i) {
                    return _this.chart.getDataVisibility(i);
                });
            }
        },
        {
            key: "fit",
            value: function fit() {
                var opts = this.options;
                if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
                else this.setCenterPoint(0, 0, 0, 0);
            }
        },
        {
            key: "setCenterPoint",
            value: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
                this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
                this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
                this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
            }
        },
        {
            key: "getIndexAngle",
            value: function getIndexAngle(index) {
                var angleMultiplier = (0, $8AEPV.T) / (this._pointLabels.length || 1);
                var startAngle = this.options.startAngle || 0;
                return (0, $8AEPV.al)(index * angleMultiplier + (0, $8AEPV.t)(startAngle));
            }
        },
        {
            key: "getDistanceFromCenterForValue",
            value: function getDistanceFromCenterForValue(value) {
                if ((0, $8AEPV.k)(value)) return NaN;
                var scalingFactor = this.drawingArea / (this.max - this.min);
                if (this.options.reverse) return (this.max - value) * scalingFactor;
                return (value - this.min) * scalingFactor;
            }
        },
        {
            key: "getValueForDistanceFromCenter",
            value: function getValueForDistanceFromCenter(distance) {
                if ((0, $8AEPV.k)(distance)) return NaN;
                var scaledDistance = distance / (this.drawingArea / (this.max - this.min));
                return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
            }
        },
        {
            key: "getPointLabelContext",
            value: function getPointLabelContext(index) {
                var pointLabels = this._pointLabels || [];
                if (index >= 0 && index < pointLabels.length) {
                    var pointLabel = pointLabels[index];
                    return createPointLabelContext(this.getContext(), index, pointLabel);
                }
            }
        },
        {
            key: "getPointPosition",
            value: function getPointPosition(index, distanceFromCenter) {
                var additionalAngle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var angle = this.getIndexAngle(index) - (0, $8AEPV.H) + additionalAngle;
                return {
                    x: Math.cos(angle) * distanceFromCenter + this.xCenter,
                    y: Math.sin(angle) * distanceFromCenter + this.yCenter,
                    angle: angle
                };
            }
        },
        {
            key: "getPointPositionForValue",
            value: function getPointPositionForValue(index, value) {
                return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
            }
        },
        {
            key: "getBasePosition",
            value: function getBasePosition(index) {
                return this.getPointPositionForValue(index || 0, this.getBaseValue());
            }
        },
        {
            key: "getPointLabelPosition",
            value: function getPointLabelPosition(index) {
                var _this__pointLabelItems_index = this._pointLabelItems[index], left = _this__pointLabelItems_index.left, top = _this__pointLabelItems_index.top, right = _this__pointLabelItems_index.right, bottom = _this__pointLabelItems_index.bottom;
                return {
                    left: left,
                    top: top,
                    right: right,
                    bottom: bottom
                };
            }
        },
        {
            key: "drawBackground",
            value: function drawBackground() {
                var _this_options = this.options, backgroundColor = _this_options.backgroundColor, circular = _this_options.grid.circular;
                if (backgroundColor) {
                    var ctx = this.ctx;
                    ctx.save();
                    ctx.beginPath();
                    pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
                    ctx.closePath();
                    ctx.fillStyle = backgroundColor;
                    ctx.fill();
                    ctx.restore();
                }
            }
        },
        {
            key: "drawGrid",
            value: function drawGrid() {
                var _this = this;
                var ctx = this.ctx;
                var opts = this.options;
                var angleLines = opts.angleLines, grid = opts.grid, border = opts.border;
                var labelCount = this._pointLabels.length;
                var i, offset, position;
                if (opts.pointLabels.display) drawPointLabels(this, labelCount);
                if (grid.display) this.ticks.forEach(function(tick, index) {
                    if (index !== 0 || index === 0 && _this.min < 0) {
                        offset = _this.getDistanceFromCenterForValue(tick.value);
                        var context = _this.getContext(index);
                        var optsAtIndex = grid.setContext(context);
                        var optsAtIndexBorder = border.setContext(context);
                        drawRadiusLine(_this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
                    }
                });
                if (angleLines.display) {
                    ctx.save();
                    for(i = labelCount - 1; i >= 0; i--){
                        var optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                        var color = optsAtIndex.color, lineWidth = optsAtIndex.lineWidth;
                        if (!lineWidth || !color) continue;
                        ctx.lineWidth = lineWidth;
                        ctx.strokeStyle = color;
                        ctx.setLineDash(optsAtIndex.borderDash);
                        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                        offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                        position = this.getPointPosition(i, offset);
                        ctx.beginPath();
                        ctx.moveTo(this.xCenter, this.yCenter);
                        ctx.lineTo(position.x, position.y);
                        ctx.stroke();
                    }
                    ctx.restore();
                }
            }
        },
        {
            key: "drawBorder",
            value: function drawBorder() {}
        },
        {
            key: "drawLabels",
            value: function drawLabels() {
                var _this = this;
                var ctx = this.ctx;
                var opts = this.options;
                var tickOpts = opts.ticks;
                if (!tickOpts.display) return;
                var startAngle = this.getIndexAngle(0);
                var offset, width;
                ctx.save();
                ctx.translate(this.xCenter, this.yCenter);
                ctx.rotate(startAngle);
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                this.ticks.forEach(function(tick, index) {
                    if (index === 0 && _this.min >= 0 && !opts.reverse) return;
                    var optsAtIndex = tickOpts.setContext(_this.getContext(index));
                    var tickFont = (0, $8AEPV.a0)(optsAtIndex.font);
                    offset = _this.getDistanceFromCenterForValue(_this.ticks[index].value);
                    if (optsAtIndex.showLabelBackdrop) {
                        ctx.font = tickFont.string;
                        width = ctx.measureText(tick.label).width;
                        ctx.fillStyle = optsAtIndex.backdropColor;
                        var padding = (0, $8AEPV.E)(optsAtIndex.backdropPadding);
                        ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
                    }
                    (0, $8AEPV.Z)(ctx, tick.label, 0, -offset, tickFont, {
                        color: optsAtIndex.color,
                        strokeColor: optsAtIndex.textStrokeColor,
                        strokeWidth: optsAtIndex.textStrokeWidth
                    });
                });
                ctx.restore();
            }
        },
        {
            key: "drawTitle",
            value: function drawTitle() {}
        }
    ]);
    return RadialLinearScale;
}(LinearScaleBase);
(0, $k9HNQ._)(RadialLinearScale, "id", 'radialLinear');
(0, $k9HNQ._)(RadialLinearScale, "defaults", {
    display: true,
    animate: true,
    position: 'chartArea',
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: (0, $8AEPV.aM).formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback: function(label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
});
(0, $k9HNQ._)(RadialLinearScale, "defaultRoutes", {
    'angleLines.color': 'borderColor',
    'pointLabels.color': 'color',
    'ticks.color': 'color'
});
(0, $k9HNQ._)(RadialLinearScale, "descriptors", {
    angleLines: {
        _fallback: 'grid'
    }
});
var INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
var UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, $8AEPV.k)(input)) return null;
    var adapter = scale._adapter;
    var _scale__parseOpts = scale._parseOpts, parser = _scale__parseOpts.parser, round = _scale__parseOpts.round, isoWeekday = _scale__parseOpts.isoWeekday;
    var value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $8AEPV.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $8AEPV.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    var ilen = UNITS.length;
    for(var i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        var interval = INTERVALS[UNITS[i]];
        var factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(var i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        var unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        var _$_lookup = (0, $8AEPV.aQ)(timestamps, time), lo = _$_lookup.lo, hi = _$_lookup.hi;
        var timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    var adapter = scale._adapter;
    var first = +adapter.startOf(ticks[0].value, majorUnit);
    var last = ticks[ticks.length - 1].value;
    var major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    var ticks = [];
    var map = {};
    var ilen = values.length;
    var i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
var TimeScale = /*#__PURE__*/ function(Scale) {
    "use strict";
    (0, $fwyhh._)(TimeScale, Scale);
    function TimeScale(props) {
        (0, $bzgVo._)(this, TimeScale);
        var _this;
        _this = (0, $lXwto._)(this, TimeScale, [
            props
        ]);
        _this._cache = {
            data: [],
            labels: [],
            all: []
        };
        _this._unit = 'day';
        _this._majorUnit = undefined;
        _this._offsets = {};
        _this._normalized = false;
        _this._parseOpts = undefined;
        return _this;
    }
    (0, $gHG1J._)(TimeScale, [
        {
            key: "init",
            value: function init(scaleOpts) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var time = scaleOpts.time || (scaleOpts.time = {});
                var adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
                adapter.init(opts);
                (0, $8AEPV.ab)(time.displayFormats, adapter.formats());
                this._parseOpts = {
                    parser: time.parser,
                    round: time.round,
                    isoWeekday: time.isoWeekday
                };
                (0, $8wpvj._)((0, $grPlv._)(TimeScale.prototype), "init", this).call(this, scaleOpts);
                this._normalized = opts.normalized;
            }
        },
        {
            key: "parse",
            value: function parse1(raw, index) {
                if (raw === undefined) return null;
                return parse(this, raw);
            }
        },
        {
            key: "beforeLayout",
            value: function beforeLayout() {
                (0, $8wpvj._)((0, $grPlv._)(TimeScale.prototype), "beforeLayout", this).call(this);
                this._cache = {
                    data: [],
                    labels: [],
                    all: []
                };
            }
        },
        {
            key: "determineDataLimits",
            value: function determineDataLimits() {
                var options = this.options;
                var adapter = this._adapter;
                var unit = options.time.unit || 'day';
                var _this_getUserBounds = this.getUserBounds(), min = _this_getUserBounds.min, max = _this_getUserBounds.max, minDefined = _this_getUserBounds.minDefined, maxDefined = _this_getUserBounds.maxDefined;
                function _applyBounds(bounds) {
                    if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
                    if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
                }
                if (!minDefined || !maxDefined) {
                    _applyBounds(this._getLabelBounds());
                    if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
                }
                min = (0, $8AEPV.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
                max = (0, $8AEPV.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
                this.min = Math.min(min, max - 1);
                this.max = Math.max(min + 1, max);
            }
        },
        {
            key: "_getLabelBounds",
            value: function _getLabelBounds() {
                var arr = this.getLabelTimestamps();
                var min = Number.POSITIVE_INFINITY;
                var max = Number.NEGATIVE_INFINITY;
                if (arr.length) {
                    min = arr[0];
                    max = arr[arr.length - 1];
                }
                return {
                    min: min,
                    max: max
                };
            }
        },
        {
            key: "buildTicks",
            value: function buildTicks() {
                var options = this.options;
                var timeOpts = options.time;
                var tickOpts = options.ticks;
                var timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
                if (options.bounds === 'ticks' && timestamps.length) {
                    this.min = this._userMin || timestamps[0];
                    this.max = this._userMax || timestamps[timestamps.length - 1];
                }
                var min = this.min;
                var max = this.max;
                var ticks = (0, $8AEPV.aP)(timestamps, min, max);
                this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
                this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
                this.initOffsets(timestamps);
                if (options.reverse) ticks.reverse();
                return ticksFromTimestamps(this, ticks, this._majorUnit);
            }
        },
        {
            key: "afterAutoSkip",
            value: function afterAutoSkip() {
                if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map(function(tick) {
                    return +tick.value;
                }));
            }
        },
        {
            key: "initOffsets",
            value: function initOffsets() {
                var timestamps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var start = 0;
                var end = 0;
                var first, last;
                if (this.options.offset && timestamps.length) {
                    first = this.getDecimalForValue(timestamps[0]);
                    if (timestamps.length === 1) start = 1 - first;
                    else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
                    last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
                    if (timestamps.length === 1) end = last;
                    else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
                }
                var limit = timestamps.length < 3 ? 0.5 : 0.25;
                start = (0, $8AEPV.S)(start, 0, limit);
                end = (0, $8AEPV.S)(end, 0, limit);
                this._offsets = {
                    start: start,
                    end: end,
                    factor: 1 / (start + 1 + end)
                };
            }
        },
        {
            key: "_generate",
            value: function _generate() {
                var adapter = this._adapter;
                var min = this.min;
                var max = this.max;
                var options = this.options;
                var timeOpts = options.time;
                var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
                var stepSize = (0, $8AEPV.v)(options.ticks.stepSize, 1);
                var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
                var hasWeekday = (0, $8AEPV.x)(weekday) || weekday === true;
                var ticks = {};
                var first = min;
                var time, count;
                if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
                first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
                if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
                var timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
                for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
                if (time === max || options.bounds === 'ticks' || count === 1) addTick(ticks, time, timestamps);
                return Object.keys(ticks).sort(sorter).map(function(x) {
                    return +x;
                });
            }
        },
        {
            key: "getLabelForValue",
            value: function getLabelForValue(value) {
                var adapter = this._adapter;
                var timeOpts = this.options.time;
                if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
                return adapter.format(value, timeOpts.displayFormats.datetime);
            }
        },
        {
            key: "format",
            value: function format(value, _format) {
                var options = this.options;
                var formats = options.time.displayFormats;
                var unit = this._unit;
                var fmt = _format || formats[unit];
                return this._adapter.format(value, fmt);
            }
        },
        {
            key: "_tickFormatFunction",
            value: function _tickFormatFunction(time, index, ticks, format) {
                var options = this.options;
                var formatter = options.ticks.callback;
                if (formatter) return (0, $8AEPV.Q)(formatter, [
                    time,
                    index,
                    ticks
                ], this);
                var formats = options.time.displayFormats;
                var unit = this._unit;
                var majorUnit = this._majorUnit;
                var minorFormat = unit && formats[unit];
                var majorFormat = majorUnit && formats[majorUnit];
                var tick = ticks[index];
                var major = majorUnit && majorFormat && tick && tick.major;
                return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
            }
        },
        {
            key: "generateTickLabels",
            value: function generateTickLabels(ticks) {
                var i, ilen, tick;
                for(i = 0, ilen = ticks.length; i < ilen; ++i){
                    tick = ticks[i];
                    tick.label = this._tickFormatFunction(tick.value, i, ticks);
                }
            }
        },
        {
            key: "getDecimalForValue",
            value: function getDecimalForValue(value) {
                return value === null ? NaN : (value - this.min) / (this.max - this.min);
            }
        },
        {
            key: "getPixelForValue",
            value: function getPixelForValue(value) {
                var offsets = this._offsets;
                var pos = this.getDecimalForValue(value);
                return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                var offsets = this._offsets;
                var pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
                return this.min + pos * (this.max - this.min);
            }
        },
        {
            key: "_getLabelSize",
            value: function _getLabelSize(label) {
                var ticksOpts = this.options.ticks;
                var tickLabelWidth = this.ctx.measureText(label).width;
                var angle = (0, $8AEPV.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
                var cosRotation = Math.cos(angle);
                var sinRotation = Math.sin(angle);
                var tickFontSize = this._resolveTickFontOptions(0).size;
                return {
                    w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                    h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
                };
            }
        },
        {
            key: "_getLabelCapacity",
            value: function _getLabelCapacity(exampleTime) {
                var timeOpts = this.options.time;
                var displayFormats = timeOpts.displayFormats;
                var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
                var exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
                    exampleTime
                ], this._majorUnit), format);
                var size = this._getLabelSize(exampleLabel);
                var capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
                return capacity > 0 ? capacity : 1;
            }
        },
        {
            key: "getDataTimestamps",
            value: function getDataTimestamps() {
                var timestamps = this._cache.data || [];
                var i, ilen;
                if (timestamps.length) return timestamps;
                var metas = this.getMatchingVisibleMetas();
                if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
                for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
                return this._cache.data = this.normalize(timestamps);
            }
        },
        {
            key: "getLabelTimestamps",
            value: function getLabelTimestamps() {
                var timestamps = this._cache.labels || [];
                var i, ilen;
                if (timestamps.length) return timestamps;
                var labels = this.getLabels();
                for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
                return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
            }
        },
        {
            key: "normalize",
            value: function normalize(values) {
                return (0, $8AEPV._)(values.sort(sorter));
            }
        }
    ]);
    return TimeScale;
}(Scale);
(0, $k9HNQ._)(TimeScale, "id", 'time');
(0, $k9HNQ._)(TimeScale, "defaults", {
    bounds: 'data',
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
    },
    ticks: {
        source: 'auto',
        callback: false,
        major: {
            enabled: false
        }
    }
});
function interpolate(table, val, reverse) {
    var lo = 0;
    var hi = table.length - 1;
    var prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        var ref;
        if (val >= table[lo].pos && val <= table[hi].pos) ref = (0, $8AEPV.B)(table, 'pos', val), lo = ref.lo, hi = ref.hi, ref;
        var ref1;
        ref1 = table[lo], prevSource = ref1.pos, prevTarget = ref1.time, ref1;
        var ref2;
        ref2 = table[hi], nextSource = ref2.pos, nextTarget = ref2.time, ref2;
    } else {
        var ref3;
        if (val >= table[lo].time && val <= table[hi].time) ref3 = (0, $8AEPV.B)(table, 'time', val), lo = ref3.lo, hi = ref3.hi, ref3;
        var ref4;
        ref4 = table[lo], prevSource = ref4.time, prevTarget = ref4.pos, ref4;
        var ref5;
        ref5 = table[hi], nextSource = ref5.time, nextTarget = ref5.pos, ref5;
    }
    var span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
var TimeSeriesScale = /*#__PURE__*/ function(TimeScale) {
    "use strict";
    (0, $fwyhh._)(TimeSeriesScale, TimeScale);
    function TimeSeriesScale(props) {
        (0, $bzgVo._)(this, TimeSeriesScale);
        var _this;
        _this = (0, $lXwto._)(this, TimeSeriesScale, [
            props
        ]);
        _this._table = [];
        _this._minPos = undefined;
        _this._tableRange = undefined;
        return _this;
    }
    (0, $gHG1J._)(TimeSeriesScale, [
        {
            key: "initOffsets",
            value: function initOffsets() {
                var timestamps = this._getTimestampsForTable();
                var table = this._table = this.buildLookupTable(timestamps);
                this._minPos = interpolate(table, this.min);
                this._tableRange = interpolate(table, this.max) - this._minPos;
                (0, $8wpvj._)((0, $grPlv._)(TimeSeriesScale.prototype), "initOffsets", this).call(this, timestamps);
            }
        },
        {
            key: "buildLookupTable",
            value: function buildLookupTable(timestamps) {
                var _this = this, min = _this.min, max = _this.max;
                var items = [];
                var table = [];
                var i, ilen, prev, curr, next;
                for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                    curr = timestamps[i];
                    if (curr >= min && curr <= max) items.push(curr);
                }
                if (items.length < 2) return [
                    {
                        time: min,
                        pos: 0
                    },
                    {
                        time: max,
                        pos: 1
                    }
                ];
                for(i = 0, ilen = items.length; i < ilen; ++i){
                    next = items[i + 1];
                    prev = items[i - 1];
                    curr = items[i];
                    if (Math.round((next + prev) / 2) !== curr) table.push({
                        time: curr,
                        pos: i / (ilen - 1)
                    });
                }
                return table;
            }
        },
        {
            key: "_generate",
            value: function _generate() {
                var min = this.min;
                var max = this.max;
                var timestamps = (0, $8wpvj._)((0, $grPlv._)(TimeSeriesScale.prototype), "getDataTimestamps", this).call(this);
                if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
                if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
                return timestamps.sort(function(a, b) {
                    return a - b;
                });
            }
        },
        {
            key: "_getTimestampsForTable",
            value: function _getTimestampsForTable() {
                var timestamps = this._cache.all || [];
                if (timestamps.length) return timestamps;
                var data = this.getDataTimestamps();
                var label = this.getLabelTimestamps();
                if (data.length && label.length) timestamps = this.normalize(data.concat(label));
                else timestamps = data.length ? data : label;
                timestamps = this._cache.all = timestamps;
                return timestamps;
            }
        },
        {
            key: "getDecimalForValue",
            value: function getDecimalForValue(value) {
                return (interpolate(this._table, value) - this._minPos) / this._tableRange;
            }
        },
        {
            key: "getValueForPixel",
            value: function getValueForPixel(pixel) {
                var offsets = this._offsets;
                var decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
                return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
            }
        }
    ]);
    return TimeSeriesScale;
}(TimeScale);
(0, $k9HNQ._)(TimeSeriesScale, "id", 'timeseries');
(0, $k9HNQ._)(TimeSeriesScale, "defaults", TimeScale.defaults);
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
var registerables = [
    controllers,
    elements,
    plugins,
    scales
];

});
parcelRegister("ggYC0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd8d2838928419ad$export$71511d61b312f219; });

var $5DDeP = parcelRequire("5DDeP");

var $grPlv = parcelRequire("grPlv");

var $36XuW = parcelRequire("36XuW");

var $abyzP = parcelRequire("abyzP");
function $bd8d2838928419ad$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bd8d2838928419ad$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $36XuW._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $5DDeP._)(Class, arguments, (0, $grPlv._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $abyzP._)(Wrapper, Class);
    };
    return $bd8d2838928419ad$export$71511d61b312f219(Class);
}

});
parcelRegister("5DDeP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $41af082b8e822da5$export$71511d61b312f219; });

var $lBa4g = parcelRequire("lBa4g");

var $abyzP = parcelRequire("abyzP");
function $41af082b8e822da5$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $lBa4g._)()) $41af082b8e822da5$export$71511d61b312f219 = Reflect.construct;
    else $41af082b8e822da5$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $abyzP._)(instance, Class.prototype);
        return instance;
    };
    return $41af082b8e822da5$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("36XuW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $244015b1c01a2222$export$71511d61b312f219; });
function $244015b1c01a2222$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("8AEPV", function(module, exports) {

$parcel$export(module.exports, "aG", function () { return $64115cd316658422$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "ac", function () { return $64115cd316658422$export$2219238a014317b0; });
$parcel$export(module.exports, "k", function () { return $64115cd316658422$export$342063e11d6c3cad; });
$parcel$export(module.exports, "b", function () { return $64115cd316658422$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "i", function () { return $64115cd316658422$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "g", function () { return $64115cd316658422$export$39b482c5e57630a8; });
$parcel$export(module.exports, "O", function () { return $64115cd316658422$export$c4ce752e73470fba; });
$parcel$export(module.exports, "v", function () { return $64115cd316658422$export$90a7f3efeed30595; });
$parcel$export(module.exports, "m", function () { return $64115cd316658422$export$953cecd6e717a553; });
$parcel$export(module.exports, "n", function () { return $64115cd316658422$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "Q", function () { return $64115cd316658422$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "F", function () { return $64115cd316658422$export$d66501df72047452; });
$parcel$export(module.exports, "ai", function () { return $64115cd316658422$export$f38c853ae54ed474; });
$parcel$export(module.exports, "aT", function () { return $64115cd316658422$export$667d3bf0c5f83305; });
$parcel$export(module.exports, "aU", function () { return $64115cd316658422$export$317a3d46287192d8; });
$parcel$export(module.exports, "a4", function () { return $64115cd316658422$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "ab", function () { return $64115cd316658422$export$555508cbc6add439; });
$parcel$export(module.exports, "aV", function () { return $64115cd316658422$export$1ee57be6f6687d2c; });
$parcel$export(module.exports, "aW", function () { return $64115cd316658422$export$9d0e2d13d04f7070; });
$parcel$export(module.exports, "aX", function () { return $64115cd316658422$export$1a8f5705751d8277; });
$parcel$export(module.exports, "f", function () { return $64115cd316658422$export$2d1720544b23b823; });
$parcel$export(module.exports, "a5", function () { return $64115cd316658422$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "h", function () { return $64115cd316658422$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a7", function () { return $64115cd316658422$export$a93c5207d687da10; });
$parcel$export(module.exports, "ag", function () { return $64115cd316658422$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "aj", function () { return $64115cd316658422$export$3b513254972cfc9c; });
$parcel$export(module.exports, "P", function () { return $64115cd316658422$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "T", function () { return $64115cd316658422$export$971d5caa766a69d7; });
$parcel$export(module.exports, "b2", function () { return $64115cd316658422$export$2ec5befb9e6c97d4; });
$parcel$export(module.exports, "b3", function () { return $64115cd316658422$export$53c86fa97d611818; });
$parcel$export(module.exports, "b4", function () { return $64115cd316658422$export$39c1cc7c062529d4; });
$parcel$export(module.exports, "H", function () { return $64115cd316658422$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "b5", function () { return $64115cd316658422$export$7a0bdf7d4a91ea88; });
$parcel$export(module.exports, "b6", function () { return $64115cd316658422$export$c18d01048907ea92; });
$parcel$export(module.exports, "aN", function () { return $64115cd316658422$export$faec65b429be379; });
$parcel$export(module.exports, "s", function () { return $64115cd316658422$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "aK", function () { return $64115cd316658422$export$23ebac1979863676; });
$parcel$export(module.exports, "aI", function () { return $64115cd316658422$export$b9a6b53f9be3734; });
$parcel$export(module.exports, "N", function () { return $64115cd316658422$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "x", function () { return $64115cd316658422$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "aJ", function () { return $64115cd316658422$export$a05254e7c3aeba6e; });
$parcel$export(module.exports, "aH", function () { return $64115cd316658422$export$a33b77bbdbb8366c; });
$parcel$export(module.exports, "t", function () { return $64115cd316658422$export$625550452a3fa3ec; });
$parcel$export(module.exports, "U", function () { return $64115cd316658422$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "aL", function () { return $64115cd316658422$export$91477dc880baac21; });
$parcel$export(module.exports, "D", function () { return $64115cd316658422$export$96f57966bedc81b4; });
$parcel$export(module.exports, "aF", function () { return $64115cd316658422$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "b7", function () { return $64115cd316658422$export$f074adc9fbd50943; });
$parcel$export(module.exports, "al", function () { return $64115cd316658422$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "p", function () { return $64115cd316658422$export$ffb5f4729a158638; });
$parcel$export(module.exports, "S", function () { return $64115cd316658422$export$25ce5a424b770e84; });
$parcel$export(module.exports, "W", function () { return $64115cd316658422$export$71cec2538cb2c617; });
$parcel$export(module.exports, "ak", function () { return $64115cd316658422$export$21579262ef46735b; });
$parcel$export(module.exports, "aQ", function () { return $64115cd316658422$export$f96d196f7728bb5; });
$parcel$export(module.exports, "B", function () { return $64115cd316658422$export$ef35774e6d314e91; });
$parcel$export(module.exports, "A", function () { return $64115cd316658422$export$ebd11618f299a286; });
$parcel$export(module.exports, "aP", function () { return $64115cd316658422$export$2ed0fc6709e59212; });
$parcel$export(module.exports, "l", function () { return $64115cd316658422$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $64115cd316658422$export$3b14a55fb2447963; });
$parcel$export(module.exports, "_", function () { return $64115cd316658422$export$71511d61b312f219; });
$parcel$export(module.exports, "b0", function () { return $64115cd316658422$export$8c78c7c36408ea29; });
$parcel$export(module.exports, "r", function () { return $64115cd316658422$export$43caf9889c228507; });
$parcel$export(module.exports, "L", function () { return $64115cd316658422$export$61196ced6d74a310; });
$parcel$export(module.exports, "ad", function () { return $64115cd316658422$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "a1", function () { return $64115cd316658422$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "a2", function () { return $64115cd316658422$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "aC", function () { return $64115cd316658422$export$890c4ad488842ce7; });
$parcel$export(module.exports, "q", function () { return $64115cd316658422$export$9e5f44173e64f162; });
$parcel$export(module.exports, "w", function () { return $64115cd316658422$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "e", function () { return $64115cd316658422$export$f1e1789686576879; });
$parcel$export(module.exports, "aR", function () { return $64115cd316658422$export$738ab4df8bf92ae9; });
$parcel$export(module.exports, "c", function () { return $64115cd316658422$export$db3b6bfb95261072; });
$parcel$export(module.exports, "aS", function () { return $64115cd316658422$export$d377dcb2b61d6c4e; });
$parcel$export(module.exports, "o", function () { return $64115cd316658422$export$ae1af26003f05816; });
$parcel$export(module.exports, "aM", function () { return $64115cd316658422$export$9f4f30ee63539e24; });
$parcel$export(module.exports, "a3", function () { return $64115cd316658422$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a6", function () { return $64115cd316658422$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "d", function () { return $64115cd316658422$export$4368d992c4eafac0; });
$parcel$export(module.exports, "aY", function () { return $64115cd316658422$export$e171bab687b50e0; });
$parcel$export(module.exports, "V", function () { return $64115cd316658422$export$e7c866399fa523f5; });
$parcel$export(module.exports, "aO", function () { return $64115cd316658422$export$c03999cb2f36933f; });
$parcel$export(module.exports, "X", function () { return $64115cd316658422$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "af", function () { return $64115cd316658422$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "av", function () { return $64115cd316658422$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "aE", function () { return $64115cd316658422$export$158acd800e1ef08b; });
$parcel$export(module.exports, "C", function () { return $64115cd316658422$export$e7094788287c5e9b; });
$parcel$export(module.exports, "Y", function () { return $64115cd316658422$export$8743009a87fcb00f; });
$parcel$export(module.exports, "$", function () { return $64115cd316658422$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "at", function () { return $64115cd316658422$export$493d36ec626b6698; });
$parcel$export(module.exports, "au", function () { return $64115cd316658422$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "Z", function () { return $64115cd316658422$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "aw", function () { return $64115cd316658422$export$92108d983e8ee699; });
$parcel$export(module.exports, "b1", function () { return $64115cd316658422$export$d29e374196577086; });
$parcel$export(module.exports, "am", function () { return $64115cd316658422$export$1a82df3d29112e01; });
$parcel$export(module.exports, "ax", function () { return $64115cd316658422$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "ay", function () { return $64115cd316658422$export$28f7fcd39efa255; });
$parcel$export(module.exports, "E", function () { return $64115cd316658422$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "a0", function () { return $64115cd316658422$export$34aec0b863436764; });
$parcel$export(module.exports, "a", function () { return $64115cd316658422$export$407448d2b89b1813; });
$parcel$export(module.exports, "R", function () { return $64115cd316658422$export$db202ddc8be9136; });
$parcel$export(module.exports, "j", function () { return $64115cd316658422$export$35e795649ee09318; });
$parcel$export(module.exports, "a9", function () { return $64115cd316658422$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "a8", function () { return $64115cd316658422$export$c3950d9923825c02; });
$parcel$export(module.exports, "aa", function () { return $64115cd316658422$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "y", function () { return $64115cd316658422$export$4a5767248b18ef41; });
$parcel$export(module.exports, "aZ", function () { return $64115cd316658422$export$527e9aa3390079e9; });
$parcel$export(module.exports, "a_", function () { return $64115cd316658422$export$a17c37559e1db147; });
$parcel$export(module.exports, "an", function () { return $64115cd316658422$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "M", function () { return $64115cd316658422$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "I", function () { return $64115cd316658422$export$9bb611d729802a56; });
$parcel$export(module.exports, "a$", function () { return $64115cd316658422$export$fef3dfd9bad05307; });
$parcel$export(module.exports, "z", function () { return $64115cd316658422$export$df995fae86a55f06; });
$parcel$export(module.exports, "G", function () { return $64115cd316658422$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "ae", function () { return $64115cd316658422$export$f787f51d84a910ad; });
$parcel$export(module.exports, "K", function () { return $64115cd316658422$export$3466f893ebf79586; });
$parcel$export(module.exports, "J", function () { return $64115cd316658422$export$b4171a6734a65d42; });
$parcel$export(module.exports, "as", function () { return $64115cd316658422$export$6554612db691658e; });
$parcel$export(module.exports, "aq", function () { return $64115cd316658422$export$8a5498727ef6be21; });
$parcel$export(module.exports, "ar", function () { return $64115cd316658422$export$d24c54395ce0c509; });
$parcel$export(module.exports, "aA", function () { return $64115cd316658422$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "aB", function () { return $64115cd316658422$export$9d398bebfec1c039; });
$parcel$export(module.exports, "aD", function () { return $64115cd316658422$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "az", function () { return $64115cd316658422$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "ap", function () { return $64115cd316658422$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "ao", function () { return $64115cd316658422$export$7a38258bbe170828; });
$parcel$export(module.exports, "ah", function () { return $64115cd316658422$export$995eb9fca571757; });
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $bzgVo = parcelRequire("bzgVo");

var $gHG1J = parcelRequire("gHG1J");

var $k9HNQ = parcelRequire("k9HNQ");

var $2l5av = parcelRequire("2l5av");

var $aqUTs = parcelRequire("aqUTs");

var $6IWPt = parcelRequire("6IWPt");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $64115cd316658422$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ var $64115cd316658422$export$2219238a014317b0 = function() {
    var id = 0;
    return function() {
        return id++;
    };
}();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $64115cd316658422$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $64115cd316658422$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    var type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $64115cd316658422$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $64115cd316658422$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $64115cd316658422$export$c4ce752e73470fba(value, defaultValue) {
    return $64115cd316658422$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $64115cd316658422$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
var $64115cd316658422$export$953cecd6e717a553 = function(value, dimension) {
    return typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
};
var $64115cd316658422$export$7ccc53e8f1e7dfc5 = function(value, dimension) {
    return typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
};
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $64115cd316658422$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $64115cd316658422$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    var i, len, keys;
    if ($64115cd316658422$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($64115cd316658422$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $64115cd316658422$export$f38c853ae54ed474(a0, a1) {
    var i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $64115cd316658422$export$667d3bf0c5f83305(source) {
    if ($64115cd316658422$export$8b22cf2602fb60ce(source)) return source.map($64115cd316658422$export$667d3bf0c5f83305);
    if ($64115cd316658422$export$23f2a1d2818174ef(source)) {
        var target = Object.create(null);
        var keys = Object.keys(source);
        var klen = keys.length;
        var k = 0;
        for(; k < klen; ++k)target[keys[k]] = $64115cd316658422$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $64115cd316658422$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $64115cd316658422$export$317a3d46287192d8(key, target, source, options) {
    if (!$64115cd316658422$var$isValidKey(key)) return;
    var tval = target[key];
    var sval = source[key];
    if ($64115cd316658422$export$23f2a1d2818174ef(tval) && $64115cd316658422$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $64115cd316658422$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $64115cd316658422$export$667d3bf0c5f83305(sval);
}
function $64115cd316658422$export$efca4cbe5dd06740(target, source, options) {
    var sources = $64115cd316658422$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    var ilen = sources.length;
    if (!$64115cd316658422$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    var merger = options.merger || $64115cd316658422$export$317a3d46287192d8;
    var current;
    for(var i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$64115cd316658422$export$23f2a1d2818174ef(current)) continue;
        var keys = Object.keys(current);
        for(var k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $64115cd316658422$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $64115cd316658422$export$efca4cbe5dd06740(target, source, {
        merger: $64115cd316658422$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $64115cd316658422$export$1ee57be6f6687d2c(key, target, source) {
    if (!$64115cd316658422$var$isValidKey(key)) return;
    var tval = target[key];
    var sval = source[key];
    if ($64115cd316658422$export$23f2a1d2818174ef(tval) && $64115cd316658422$export$23f2a1d2818174ef(sval)) $64115cd316658422$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $64115cd316658422$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $64115cd316658422$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
var $64115cd316658422$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': function(v) {
        return v;
    },
    // default resolvers
    x: function(o) {
        return o.x;
    },
    y: function(o) {
        return o.y;
    }
};
/**
 * @private
 */ function $64115cd316658422$export$1a8f5705751d8277(key) {
    var parts = key.split('.');
    var keys = [];
    var tmp = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            tmp += part;
            if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
            else {
                keys.push(tmp);
                tmp = '';
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return keys;
}
function $64115cd316658422$var$_getKeyResolver(key) {
    var keys = $64115cd316658422$export$1a8f5705751d8277(key);
    return function(obj) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var k = _step.value;
                if (k === '') break;
                obj = obj && obj[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
}
function $64115cd316658422$export$2d1720544b23b823(obj, key) {
    var resolver = $64115cd316658422$var$keyResolvers[key] || ($64115cd316658422$var$keyResolvers[key] = $64115cd316658422$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $64115cd316658422$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $64115cd316658422$export$dda1d9f60106f0e9 = function(value) {
    return typeof value !== 'undefined';
};
var $64115cd316658422$export$a93c5207d687da10 = function(value) {
    return typeof value === 'function';
};
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
var $64115cd316658422$export$ee7c8ad385a60b7b = function(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (!b.has(item)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $64115cd316658422$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ var $64115cd316658422$export$56c0d5a1e737357d = Math.PI;
var $64115cd316658422$export$971d5caa766a69d7 = 2 * $64115cd316658422$export$56c0d5a1e737357d;
var $64115cd316658422$export$2ec5befb9e6c97d4 = $64115cd316658422$export$971d5caa766a69d7 + $64115cd316658422$export$56c0d5a1e737357d;
var $64115cd316658422$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
var $64115cd316658422$export$39c1cc7c062529d4 = $64115cd316658422$export$56c0d5a1e737357d / 180;
var $64115cd316658422$export$7f8ddf7c7c20b3cd = $64115cd316658422$export$56c0d5a1e737357d / 2;
var $64115cd316658422$export$7a0bdf7d4a91ea88 = $64115cd316658422$export$56c0d5a1e737357d / 4;
var $64115cd316658422$export$c18d01048907ea92 = $64115cd316658422$export$56c0d5a1e737357d * 2 / 3;
var $64115cd316658422$export$faec65b429be379 = Math.log10;
var $64115cd316658422$export$2408f22a0fab9ae5 = Math.sign;
function $64115cd316658422$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $64115cd316658422$export$b9a6b53f9be3734(range) {
    var roundedRange = Math.round(range);
    range = $64115cd316658422$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    var niceRange = Math.pow(10, Math.floor($64115cd316658422$export$faec65b429be379(range)));
    var fraction = range / niceRange;
    var niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $64115cd316658422$export$a07804094c3ecf2d(value) {
    var result = [];
    var sqrt = Math.sqrt(value);
    var i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort(function(a, b) {
        return a - b;
    }).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $64115cd316658422$var$isNonPrimitive(n) {
    return (typeof n === "undefined" ? "undefined" : (0, $aqUTs._)(n)) === 'symbol' || (typeof n === "undefined" ? "undefined" : (0, $aqUTs._)(n)) === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $64115cd316658422$export$d141bba7fdc215a3(n) {
    return !$64115cd316658422$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $64115cd316658422$export$a05254e7c3aeba6e(x, epsilon) {
    var rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $64115cd316658422$export$a33b77bbdbb8366c(array, target, property) {
    var i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $64115cd316658422$export$625550452a3fa3ec(degrees) {
    return degrees * ($64115cd316658422$export$56c0d5a1e737357d / 180);
}
function $64115cd316658422$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $64115cd316658422$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $64115cd316658422$export$91477dc880baac21(x) {
    if (!$64115cd316658422$export$39b482c5e57630a8(x)) return;
    var e = 1;
    var p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $64115cd316658422$export$96f57966bedc81b4(centrePoint, anglePoint) {
    var distanceFromXCenter = anglePoint.x - centrePoint.x;
    var distanceFromYCenter = anglePoint.y - centrePoint.y;
    var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $64115cd316658422$export$56c0d5a1e737357d) angle += $64115cd316658422$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $64115cd316658422$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $64115cd316658422$export$f074adc9fbd50943(a, b) {
    return (a - b + $64115cd316658422$export$2ec5befb9e6c97d4) % $64115cd316658422$export$971d5caa766a69d7 - $64115cd316658422$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $64115cd316658422$export$ab83b03e4111b1d0(a) {
    return (a % $64115cd316658422$export$971d5caa766a69d7 + $64115cd316658422$export$971d5caa766a69d7) % $64115cd316658422$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $64115cd316658422$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    var a = $64115cd316658422$export$ab83b03e4111b1d0(angle);
    var s = $64115cd316658422$export$ab83b03e4111b1d0(start);
    var e = $64115cd316658422$export$ab83b03e4111b1d0(end);
    var angleToStart = $64115cd316658422$export$ab83b03e4111b1d0(s - a);
    var angleToEnd = $64115cd316658422$export$ab83b03e4111b1d0(e - a);
    var startToAngle = $64115cd316658422$export$ab83b03e4111b1d0(a - s);
    var endToAngle = $64115cd316658422$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $64115cd316658422$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $64115cd316658422$export$71cec2538cb2c617(value) {
    return $64115cd316658422$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $64115cd316658422$export$21579262ef46735b(value, start, end) {
    var epsilon = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1e-6;
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $64115cd316658422$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || function(index) {
        return table[index] < value;
    };
    var hi = table.length - 1;
    var lo = 0;
    var mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ var $64115cd316658422$export$ef35774e6d314e91 = function(table, key, value, last) {
    return $64115cd316658422$export$f96d196f7728bb5(table, value, last ? function(index) {
        var ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : function(index) {
        return table[index][key] < value;
    });
};
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ var $64115cd316658422$export$ebd11618f299a286 = function(table, key, value) {
    return $64115cd316658422$export$f96d196f7728bb5(table, value, function(index) {
        return table[index][key] >= value;
    });
};
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $64115cd316658422$export$2ed0fc6709e59212(values, min, max) {
    var start = 0;
    var end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
var $64115cd316658422$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $64115cd316658422$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $64115cd316658422$var$arrayEvents.forEach(function(key) {
        var method = '_onData' + $64115cd316658422$export$a8550f7dbe79f93a(key);
        var base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var res = base.apply(this, args);
                array._chartjs.listeners.forEach(function(object) {
                    var _object;
                    if (typeof object[method] === 'function') (_object = object)[method].apply(_object, (0, $2l5av._)(args));
                });
                return res;
            }
        });
    });
}
function $64115cd316658422$export$3b14a55fb2447963(array, listener) {
    var stub = array._chartjs;
    if (!stub) return;
    var listeners = stub.listeners;
    var index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $64115cd316658422$var$arrayEvents.forEach(function(key) {
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $64115cd316658422$export$71511d61b312f219(items) {
    var set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $64115cd316658422$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ var $64115cd316658422$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $64115cd316658422$export$61196ced6d74a310(fn, thisArg) {
    var argsToUse = [];
    var ticking = false;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $64115cd316658422$export$43caf9889c228507.call(window, function() {
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $64115cd316658422$export$4c3d22f3d993c33f(fn, delay) {
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ var $64115cd316658422$export$3c2fa207a37baaea = function(align) {
    return align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
};
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ var $64115cd316658422$export$ce26c07117d59d6a = function(align, start, end) {
    return align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
};
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ var $64115cd316658422$export$890c4ad488842ce7 = function(align, left, right, rtl) {
    var check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $64115cd316658422$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    var pointCount = points.length;
    var start = 0;
    var count = pointCount;
    if (meta._sorted) {
        var iScale = meta.iScale, vScale = meta.vScale, _parsed = meta._parsed;
        var spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        var axis = iScale.axis;
        var _iScale_getUserBounds = iScale.getUserBounds(), min = _iScale_getUserBounds.min, max = _iScale_getUserBounds.max, minDefined = _iScale_getUserBounds.minDefined, maxDefined = _iScale_getUserBounds.maxDefined;
        if (minDefined) {
            start = Math.min($64115cd316658422$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $64115cd316658422$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                var distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex(function(point) {
                    return !$64115cd316658422$export$342063e11d6c3cad(point[vScale.axis]);
                });
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $64115cd316658422$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            var end = Math.max($64115cd316658422$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $64115cd316658422$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                var distanceToDefinedHi = _parsed.slice(end - 1).findIndex(function(point) {
                    return !$64115cd316658422$export$342063e11d6c3cad(point[vScale.axis]);
                });
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $64115cd316658422$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $64115cd316658422$export$efccba1c4a2ef57b(meta) {
    var xScale = meta.xScale, yScale = meta.yScale, _scaleRanges = meta._scaleRanges;
    var newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    var changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
var $64115cd316658422$var$atEdge = function(t) {
    return t === 0 || t === 1;
};
var $64115cd316658422$var$elasticIn = function(t, s, p) {
    return -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $64115cd316658422$export$971d5caa766a69d7 / p));
};
var $64115cd316658422$var$elasticOut = function(t, s, p) {
    return Math.pow(2, -10 * t) * Math.sin((t - s) * $64115cd316658422$export$971d5caa766a69d7 / p) + 1;
};
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ var $64115cd316658422$export$f1e1789686576879 = {
    linear: function(t) {
        return t;
    },
    easeInQuad: function(t) {
        return t * t;
    },
    easeOutQuad: function(t) {
        return -t * (t - 2);
    },
    easeInOutQuad: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1);
    },
    easeInCubic: function(t) {
        return t * t * t;
    },
    easeOutCubic: function(t) {
        return (t -= 1) * t * t + 1;
    },
    easeInOutCubic: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2);
    },
    easeInQuart: function(t) {
        return t * t * t * t;
    },
    easeOutQuart: function(t) {
        return -((t -= 1) * t * t * t - 1);
    },
    easeInOutQuart: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2);
    },
    easeInQuint: function(t) {
        return t * t * t * t * t;
    },
    easeOutQuint: function(t) {
        return (t -= 1) * t * t * t * t + 1;
    },
    easeInOutQuint: function(t) {
        return (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2);
    },
    easeInSine: function(t) {
        return -Math.cos(t * $64115cd316658422$export$7f8ddf7c7c20b3cd) + 1;
    },
    easeOutSine: function(t) {
        return Math.sin(t * $64115cd316658422$export$7f8ddf7c7c20b3cd);
    },
    easeInOutSine: function(t) {
        return -0.5 * (Math.cos($64115cd316658422$export$56c0d5a1e737357d * t) - 1);
    },
    easeInExpo: function(t) {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
    },
    easeOutExpo: function(t) {
        return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
    },
    easeInOutExpo: function(t) {
        return $64115cd316658422$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2);
    },
    easeInCirc: function(t) {
        return t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1);
    },
    easeOutCirc: function(t) {
        return Math.sqrt(1 - (t -= 1) * t);
    },
    easeInOutCirc: function(t) {
        return (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
    },
    easeInElastic: function(t) {
        return $64115cd316658422$var$atEdge(t) ? t : $64115cd316658422$var$elasticIn(t, 0.075, 0.3);
    },
    easeOutElastic: function(t) {
        return $64115cd316658422$var$atEdge(t) ? t : $64115cd316658422$var$elasticOut(t, 0.075, 0.3);
    },
    easeInOutElastic: function(t) {
        var s = 0.1125;
        var p = 0.45;
        return $64115cd316658422$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $64115cd316658422$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $64115cd316658422$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack: function(t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack: function(t) {
        var s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack: function(t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: function(t) {
        return 1 - $64115cd316658422$export$f1e1789686576879.easeOutBounce(1 - t);
    },
    easeOutBounce: function(t) {
        var m = 7.5625;
        var d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: function(t) {
        return t < 0.5 ? $64115cd316658422$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $64115cd316658422$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
    }
};
function $64115cd316658422$export$738ab4df8bf92ae9(value) {
    if (value && (typeof value === "undefined" ? "undefined" : (0, $aqUTs._)(value)) === 'object') {
        var type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $64115cd316658422$export$db3b6bfb95261072(value) {
    return $64115cd316658422$export$738ab4df8bf92ae9(value) ? value : new (0, $6IWPt.Color)(value);
}
function $64115cd316658422$export$d377dcb2b61d6c4e(value) {
    return $64115cd316658422$export$738ab4df8bf92ae9(value) ? value : new (0, $6IWPt.Color)(value).saturate(0.5).darken(0.1).hexString();
}
var $64115cd316658422$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
var $64115cd316658422$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $64115cd316658422$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: function(name) {
            return name !== 'onProgress' && name !== 'onComplete' && name !== 'fn';
        }
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $64115cd316658422$var$colors
        },
        numbers: {
            type: 'number',
            properties: $64115cd316658422$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: function(v) {
                        return v | 0;
                    }
                }
            }
        }
    });
}
function $64115cd316658422$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
var $64115cd316658422$var$intlCache = new Map();
function $64115cd316658422$var$getNumberFormat(locale, options) {
    options = options || {};
    var cacheKey = locale + JSON.stringify(options);
    var formatter = $64115cd316658422$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $64115cd316658422$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $64115cd316658422$export$ae1af26003f05816(num, locale, options) {
    return $64115cd316658422$var$getNumberFormat(locale, options).format(num);
}
var $64115cd316658422$var$formatters = {
    values: function(value) {
        return $64115cd316658422$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric: function(tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        var locale = this.chart.options.locale;
        var notation;
        var delta = tickValue;
        if (ticks.length > 1) {
            var maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $64115cd316658422$var$calculateDelta(tickValue, ticks);
        }
        var logDelta = $64115cd316658422$export$faec65b429be379(Math.abs(delta));
        var numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        var options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $64115cd316658422$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic: function(tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        var remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($64115cd316658422$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $64115cd316658422$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $64115cd316658422$var$calculateDelta(tickValue, ticks) {
    var delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $64115cd316658422$export$9f4f30ee63539e24 = {
    formatters: $64115cd316658422$var$formatters
};
function $64115cd316658422$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: function(_ctx, options) {
                return options.lineWidth;
            },
            tickColor: function(_ctx, options) {
                return options.color;
            },
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $64115cd316658422$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: function(name) {
            return !name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser';
        },
        _indexable: function(name) {
            return name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash';
        }
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: function(name) {
            return name !== 'backdropPadding' && name !== 'callback';
        },
        _indexable: function(name) {
            return name !== 'backdropPadding';
        }
    });
}
var $64115cd316658422$export$6559d589eb85fbb6 = Object.create(null);
var $64115cd316658422$export$2e2af4578d910ddf = Object.create(null);
function $64115cd316658422$var$getScope$1(node, key) {
    if (!key) return node;
    var keys = key.split('.');
    for(var i = 0, n = keys.length; i < n; ++i){
        var k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $64115cd316658422$var$set(root, scope, values) {
    if (typeof scope === 'string') return $64115cd316658422$export$efca4cbe5dd06740($64115cd316658422$var$getScope$1(root, scope), values);
    return $64115cd316658422$export$efca4cbe5dd06740($64115cd316658422$var$getScope$1(root, ''), scope);
}
var $64115cd316658422$var$Defaults = /*#__PURE__*/ function() {
    "use strict";
    function Defaults(_descriptors, _appliers) {
        (0, $bzgVo._)(this, Defaults);
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = function(context) {
            return context.chart.platform.getDevicePixelRatio();
        };
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = function(ctx, options) {
            return $64115cd316658422$export$d377dcb2b61d6c4e(options.backgroundColor);
        };
        this.hoverBorderColor = function(ctx, options) {
            return $64115cd316658422$export$d377dcb2b61d6c4e(options.borderColor);
        };
        this.hoverColor = function(ctx, options) {
            return $64115cd316658422$export$d377dcb2b61d6c4e(options.color);
        };
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    (0, $gHG1J._)(Defaults, [
        {
            key: "set",
            value: function set1(scope, values) {
                return $64115cd316658422$var$set(this, scope, values);
            }
        },
        {
            key: "get",
            value: function get(scope) {
                return $64115cd316658422$var$getScope$1(this, scope);
            }
        },
        {
            key: "describe",
            value: function describe(scope, values) {
                return $64115cd316658422$var$set($64115cd316658422$export$2e2af4578d910ddf, scope, values);
            }
        },
        {
            key: "override",
            value: function override(scope, values) {
                return $64115cd316658422$var$set($64115cd316658422$export$6559d589eb85fbb6, scope, values);
            }
        },
        {
            key: "route",
            value: function route(scope, name, targetScope, targetName) {
                var scopeObject = $64115cd316658422$var$getScope$1(this, scope);
                var targetScopeObject = $64115cd316658422$var$getScope$1(this, targetScope);
                var privateName = '_' + name;
                var _obj;
                Object.defineProperties(scopeObject, (_obj = {}, (0, $k9HNQ._)(_obj, privateName, {
                    value: scopeObject[name],
                    writable: true
                }), (0, $k9HNQ._)(_obj, name, {
                    enumerable: true,
                    get: function() {
                        var local = this[privateName];
                        var target = targetScopeObject[targetName];
                        if ($64115cd316658422$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                        return $64115cd316658422$export$90a7f3efeed30595(local, target);
                    },
                    set: function(value) {
                        this[privateName] = value;
                    }
                }), _obj));
            }
        },
        {
            key: "apply",
            value: function apply(appliers) {
                var _this = this;
                appliers.forEach(function(apply) {
                    return apply(_this);
                });
            }
        }
    ]);
    return Defaults;
}();
var $64115cd316658422$export$4368d992c4eafac0 = /* #__PURE__ */ new $64115cd316658422$var$Defaults({
    _scriptable: function(name) {
        return !name.startsWith('on');
    },
    _indexable: function(name) {
        return name !== 'events';
    },
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $64115cd316658422$var$applyAnimationsDefaults,
    $64115cd316658422$var$applyLayoutsDefaults,
    $64115cd316658422$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $64115cd316658422$export$e171bab687b50e0(font) {
    if (!font || $64115cd316658422$export$342063e11d6c3cad(font.size) || $64115cd316658422$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $64115cd316658422$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    var textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $64115cd316658422$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    var data = cache.data = cache.data || {};
    var gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    var longest = 0;
    var ilen = arrayOfThings.length;
    var i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$64115cd316658422$export$8b22cf2602fb60ce(thing)) longest = $64115cd316658422$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($64115cd316658422$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$64115cd316658422$export$8b22cf2602fb60ce(nestedThing)) longest = $64115cd316658422$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    var gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $64115cd316658422$export$78acf4525d8a74c4(chart, pixel, width) {
    var devicePixelRatio = chart.currentDevicePixelRatio;
    var halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $64115cd316658422$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $64115cd316658422$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $64115cd316658422$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $64115cd316658422$export$158acd800e1ef08b(ctx, options, x, y, w) {
    var type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    var style = options.pointStyle;
    var rotation = options.rotation;
    var radius = options.radius;
    var rad = (rotation || 0) * $64115cd316658422$export$39c1cc7c062529d4;
    if (style && (typeof style === "undefined" ? "undefined" : (0, $aqUTs._)(style)) === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $64115cd316658422$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $64115cd316658422$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $64115cd316658422$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $64115cd316658422$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $64115cd316658422$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $64115cd316658422$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $64115cd316658422$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $64115cd316658422$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $64115cd316658422$export$56c0d5a1e737357d, rad - $64115cd316658422$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $64115cd316658422$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $64115cd316658422$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $64115cd316658422$export$7f8ddf7c7c20b3cd, rad + $64115cd316658422$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $64115cd316658422$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $64115cd316658422$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $64115cd316658422$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $64115cd316658422$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $64115cd316658422$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $64115cd316658422$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $64115cd316658422$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        var midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $64115cd316658422$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $64115cd316658422$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$64115cd316658422$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $64115cd316658422$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ var metrics = ctx.measureText(line);
        var left = x - metrics.actualBoundingBoxLeft;
        var right = x + metrics.actualBoundingBoxRight;
        var top = y - metrics.actualBoundingBoxAscent;
        var bottom = y + metrics.actualBoundingBoxDescent;
        var yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $64115cd316658422$var$drawBackdrop(ctx, opts) {
    var oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $64115cd316658422$export$dc98b0b04f4c7758(ctx, text, x, y, font) {
    var opts = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var lines = $64115cd316658422$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    var stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    var i, line;
    ctx.save();
    ctx.font = font.string;
    $64115cd316658422$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $64115cd316658422$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$64115cd316658422$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $64115cd316658422$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $64115cd316658422$export$92108d983e8ee699(ctx, rect) {
    var x = rect.x, y = rect.y, w = rect.w, h = rect.h, radius = rect.radius;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $64115cd316658422$export$56c0d5a1e737357d, $64115cd316658422$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $64115cd316658422$export$56c0d5a1e737357d, $64115cd316658422$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $64115cd316658422$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$64115cd316658422$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
var $64115cd316658422$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
var $64115cd316658422$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $64115cd316658422$export$d29e374196577086(value, size) {
    var matches = ('' + value).match($64115cd316658422$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
var $64115cd316658422$var$numberOrZero = function(v) {
    return +v || 0;
};
function $64115cd316658422$export$1a82df3d29112e01(value, props) {
    var ret = {};
    var objProps = $64115cd316658422$export$23f2a1d2818174ef(props);
    var keys = objProps ? Object.keys(props) : props;
    var read = $64115cd316658422$export$23f2a1d2818174ef(value) ? objProps ? function(prop) {
        return $64115cd316658422$export$90a7f3efeed30595(value[prop], value[props[prop]]);
    } : function(prop) {
        return value[prop];
    } : function() {
        return value;
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            ret[prop] = $64115cd316658422$var$numberOrZero(read(prop));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $64115cd316658422$export$9fa96a7d116ea3ce(value) {
    return $64115cd316658422$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $64115cd316658422$export$28f7fcd39efa255(value) {
    return $64115cd316658422$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $64115cd316658422$export$a9c23c6ac3fc3eca(value) {
    var obj = $64115cd316658422$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $64115cd316658422$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $64115cd316658422$export$4368d992c4eafac0.font;
    var size = $64115cd316658422$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    var style = $64115cd316658422$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($64115cd316658422$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    var font = {
        family: $64115cd316658422$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $64115cd316658422$export$d29e374196577086($64115cd316658422$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $64115cd316658422$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $64115cd316658422$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $64115cd316658422$export$407448d2b89b1813(inputs, context, index, info) {
    var cacheable = true;
    var i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $64115cd316658422$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $64115cd316658422$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    var min = minmax.min, max = minmax.max;
    var change = $64115cd316658422$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    var keepZero = function(value, add) {
        return beginAtZero && value === 0 ? 0 : value + add;
    };
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $64115cd316658422$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $64115cd316658422$export$a9c996f45e5784d0(scopes) {
    var prefixes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        ''
    ], rootScopes = arguments.length > 2 ? arguments[2] : void 0, fallback = arguments.length > 3 ? arguments[3] : void 0, getTarget = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
        return scopes[0];
    };
    var finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $64115cd316658422$var$_resolve('_fallback', scopes);
    var _obj;
    var cache = (_obj = {}, (0, $k9HNQ._)(_obj, Symbol.toStringTag, 'Object'), (0, $k9HNQ._)(_obj, "_cacheable", true), (0, $k9HNQ._)(_obj, "_scopes", scopes), (0, $k9HNQ._)(_obj, "_rootScopes", finalRootScopes), (0, $k9HNQ._)(_obj, "_fallback", fallback), (0, $k9HNQ._)(_obj, "_getTarget", getTarget), (0, $k9HNQ._)(_obj, "override", function(scope) {
        return $64115cd316658422$export$a9c996f45e5784d0([
            scope
        ].concat((0, $2l5av._)(scopes)), prefixes, finalRootScopes, fallback);
    }), _obj);
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty: function(target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get: function(target, prop) {
            return $64115cd316658422$var$_cached(target, prop, function() {
                return $64115cd316658422$var$_resolveWithPrefixes(prop, prefixes, scopes, target);
            });
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor: function(target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf: function() {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has: function(target, prop) {
            return $64115cd316658422$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys: function(target) {
            return $64115cd316658422$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set: function(target, prop, value) {
            var storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $64115cd316658422$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    var cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $64115cd316658422$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: function(ctx) {
            return $64115cd316658422$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults);
        },
        override: function(scope) {
            return $64115cd316658422$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults);
        }
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty: function(target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get: function(target, prop, receiver) {
            return $64115cd316658422$var$_cached(target, prop, function() {
                return $64115cd316658422$var$_resolveWithContext(target, prop, receiver);
            });
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor: function(target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf: function() {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has: function(target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys: function() {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set: function(target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $64115cd316658422$export$7910e0436ed8d1de(proxy) {
    var defaults = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        scriptable: true,
        indexable: true
    };
    var _proxy__scriptable = proxy._scriptable, _scriptable = _proxy__scriptable === void 0 ? defaults.scriptable : _proxy__scriptable, _proxy__indexable = proxy._indexable, _indexable = _proxy__indexable === void 0 ? defaults.indexable : _proxy__indexable, _proxy__allKeys = proxy._allKeys, _allKeys = _proxy__allKeys === void 0 ? defaults.allKeys : _proxy__allKeys;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $64115cd316658422$export$a93c5207d687da10(_scriptable) ? _scriptable : function() {
            return _scriptable;
        },
        isIndexable: $64115cd316658422$export$a93c5207d687da10(_indexable) ? _indexable : function() {
            return _indexable;
        }
    };
}
var $64115cd316658422$var$readKey = function(prefix, name) {
    return prefix ? prefix + $64115cd316658422$export$a8550f7dbe79f93a(name) : name;
};
var $64115cd316658422$var$needsSubResolver = function(prop, value) {
    return $64115cd316658422$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
};
function $64115cd316658422$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    var value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $64115cd316658422$var$_resolveWithContext(target, prop, receiver) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, descriptors = target._descriptors;
    var value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($64115cd316658422$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $64115cd316658422$var$_resolveScriptable(prop, value, target, receiver);
    if ($64115cd316658422$export$8b22cf2602fb60ce(value) && value.length) value = $64115cd316658422$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($64115cd316658422$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $64115cd316658422$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $64115cd316658422$var$_resolveScriptable(prop, getValue, target, receiver) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, _stack = target._stack;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    var value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($64115cd316658422$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $64115cd316658422$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $64115cd316658422$var$_resolveArray(prop, value, target, isIndexable) {
    var _proxy = target._proxy, _context = target._context, _subProxy = target._subProxy, descriptors = target._descriptors;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($64115cd316658422$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        var arr = value;
        var scopes = _proxy._scopes.filter(function(s) {
            return s !== arr;
        });
        value = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var resolver = $64115cd316658422$var$createSubResolver(scopes, _proxy, prop, item);
                value.push($64115cd316658422$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return value;
}
function $64115cd316658422$var$resolveFallback(fallback, prop, value) {
    return $64115cd316658422$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
var $64115cd316658422$var$getScope = function(key, parent) {
    return key === true ? parent : typeof key === 'string' ? $64115cd316658422$export$2d1720544b23b823(parent, key) : undefined;
};
function $64115cd316658422$var$addScopes(set, parentScopes, key, parentFallback, value) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parentScopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var parent = _step.value;
            var scope = $64115cd316658422$var$getScope(key, parent);
            if (scope) {
                set.add(scope);
                var fallback = $64115cd316658422$var$resolveFallback(scope._fallback, key, value);
                if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
                // The fallback will resume to that new scope.
                return fallback;
            } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
            // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
            return null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $64115cd316658422$var$createSubResolver(parentScopes, resolver, prop, value) {
    var rootScopes = resolver._rootScopes;
    var fallback = $64115cd316658422$var$resolveFallback(resolver._fallback, prop, value);
    var allScopes = (0, $2l5av._)(parentScopes).concat((0, $2l5av._)(rootScopes));
    var set = new Set();
    set.add(value);
    var key = $64115cd316658422$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $64115cd316658422$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $64115cd316658422$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, function() {
        return $64115cd316658422$var$subGetTarget(resolver, prop, value);
    });
}
function $64115cd316658422$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $64115cd316658422$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $64115cd316658422$var$subGetTarget(resolver, prop, value) {
    var parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    var target = parent[prop];
    if ($64115cd316658422$export$8b22cf2602fb60ce(target) && $64115cd316658422$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $64115cd316658422$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    var value;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = prefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prefix = _step.value;
            value = $64115cd316658422$var$_resolve($64115cd316658422$var$readKey(prefix, prop), scopes);
            if (typeof value !== 'undefined') return $64115cd316658422$var$needsSubResolver(prop, value) ? $64115cd316658422$var$createSubResolver(scopes, proxy, prop, value) : value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $64115cd316658422$var$_resolve(key, scopes) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var scope = _step.value;
            if (!scope) continue;
            var value = scope[key];
            if (typeof value !== 'undefined') return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $64115cd316658422$var$getKeysFromAllScopes(target) {
    var keys = target._keys;
    if (!keys) keys = target._keys = $64115cd316658422$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $64115cd316658422$var$resolveKeysFromAllScopes(scopes) {
    var set = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = scopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var scope = _step.value;
            try {
                for(var _iterator1 = Object.keys(scope).filter(function(k) {
                    return !k.startsWith('_');
                })[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var key = _step1.value;
                    set.add(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return Array.from(set);
}
function $64115cd316658422$export$4a5767248b18ef41(meta, data, start, count) {
    var iScale = meta.iScale;
    var _this__parsing = this._parsing, _this__parsing_key = _this__parsing.key, key = _this__parsing_key === void 0 ? 'r' : _this__parsing_key;
    var parsed = new Array(count);
    var i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($64115cd316658422$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
var $64115cd316658422$var$EPSILON = Number.EPSILON || 1e-14;
var $64115cd316658422$var$getPoint = function(points, i) {
    return i < points.length && !points[i].skip && points[i];
};
var $64115cd316658422$var$getValueAxis = function(indexAxis) {
    return indexAxis === 'x' ? 'y' : 'x';
};
function $64115cd316658422$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    var previous = firstPoint.skip ? middlePoint : firstPoint;
    var current = middlePoint;
    var next = afterPoint.skip ? middlePoint : afterPoint;
    var d01 = $64115cd316658422$export$cf2f7c5792f80b46(current, previous);
    var d12 = $64115cd316658422$export$cf2f7c5792f80b46(next, current);
    var s01 = d01 / (d01 + d12);
    var s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    var fa = t * s01; // scaling factor for triangle Ta
    var fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $64115cd316658422$var$monotoneAdjust(points, deltaK, mK) {
    var pointsLen = points.length;
    var alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    var pointAfter = $64115cd316658422$var$getPoint(points, 0);
    for(var i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $64115cd316658422$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($64115cd316658422$export$23ebac1979863676(deltaK[i], 0, $64115cd316658422$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $64115cd316658422$var$monotoneCompute(points, mK) {
    var indexAxis = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'x';
    var valueAxis = $64115cd316658422$var$getValueAxis(indexAxis);
    var pointsLen = points.length;
    var delta, pointBefore, pointCurrent;
    var pointAfter = $64115cd316658422$var$getPoint(points, 0);
    for(var i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $64115cd316658422$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        var iPixel = pointCurrent[indexAxis];
        var vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent["cp1".concat(indexAxis)] = iPixel - delta;
            pointCurrent["cp1".concat(valueAxis)] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent["cp2".concat(indexAxis)] = iPixel + delta;
            pointCurrent["cp2".concat(valueAxis)] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $64115cd316658422$export$a17c37559e1db147(points) {
    var indexAxis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'x';
    var valueAxis = $64115cd316658422$var$getValueAxis(indexAxis);
    var pointsLen = points.length;
    var deltaK = Array(pointsLen).fill(0);
    var mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    var i, pointBefore, pointCurrent;
    var pointAfter = $64115cd316658422$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $64115cd316658422$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            var slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $64115cd316658422$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $64115cd316658422$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $64115cd316658422$var$monotoneAdjust(points, deltaK, mK);
    $64115cd316658422$var$monotoneCompute(points, mK, indexAxis);
}
function $64115cd316658422$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $64115cd316658422$var$capBezierPoints(points, area) {
    var i, ilen, point, inArea, inAreaPrev;
    var inAreaNext = $64115cd316658422$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $64115cd316658422$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $64115cd316658422$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $64115cd316658422$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $64115cd316658422$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $64115cd316658422$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $64115cd316658422$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    var i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter(function(pt) {
        return !pt.skip;
    });
    if (options.cubicInterpolationMode === 'monotone') $64115cd316658422$export$a17c37559e1db147(points, indexAxis);
    else {
        var prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $64115cd316658422$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $64115cd316658422$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $64115cd316658422$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $64115cd316658422$export$9bb611d729802a56(domNode) {
    var parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $64115cd316658422$var$parseMaxStyle(styleValue, node, parentProperty) {
    var valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
var $64115cd316658422$var$getComputedStyle = function(element) {
    return element.ownerDocument.defaultView.getComputedStyle(element, null);
};
function $64115cd316658422$export$fef3dfd9bad05307(el, property) {
    return $64115cd316658422$var$getComputedStyle(el).getPropertyValue(property);
}
var $64115cd316658422$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $64115cd316658422$var$getPositionedStyle(styles, style, suffix) {
    var result = {};
    suffix = suffix ? '-' + suffix : '';
    for(var i = 0; i < 4; i++){
        var pos = $64115cd316658422$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
var $64115cd316658422$var$useOffsetPos = function(x, y, target) {
    return (x > 0 || y > 0) && (!target || !target.shadowRoot);
};
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $64115cd316658422$var$getCanvasPosition(e, canvas) {
    var touches = e.touches;
    var source = touches && touches.length ? touches[0] : e;
    var offsetX = source.offsetX, offsetY = source.offsetY;
    var box = false;
    var x, y;
    if ($64115cd316658422$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        var rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $64115cd316658422$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    var canvas = chart.canvas, currentDevicePixelRatio = chart.currentDevicePixelRatio;
    var style = $64115cd316658422$var$getComputedStyle(canvas);
    var borderBox = style.boxSizing === 'border-box';
    var paddings = $64115cd316658422$var$getPositionedStyle(style, 'padding');
    var borders = $64115cd316658422$var$getPositionedStyle(style, 'border', 'width');
    var _getCanvasPosition = $64115cd316658422$var$getCanvasPosition(event, canvas), x = _getCanvasPosition.x, y = _getCanvasPosition.y, box = _getCanvasPosition.box;
    var xOffset = paddings.left + (box && borders.left);
    var yOffset = paddings.top + (box && borders.top);
    var width = chart.width, height = chart.height;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $64115cd316658422$var$getContainerSize(canvas, width, height) {
    var maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        var container = canvas && $64115cd316658422$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            var rect = container.getBoundingClientRect(); // this is the border box of the container
            var containerStyle = $64115cd316658422$var$getComputedStyle(container);
            var containerBorder = $64115cd316658422$var$getPositionedStyle(containerStyle, 'border', 'width');
            var containerPadding = $64115cd316658422$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $64115cd316658422$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $64115cd316658422$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $64115cd316658422$export$53c86fa97d611818,
        maxHeight: maxHeight || $64115cd316658422$export$53c86fa97d611818
    };
}
var $64115cd316658422$var$round1 = function(v) {
    return Math.round(v * 10) / 10;
};
// eslint-disable-next-line complexity
function $64115cd316658422$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    var style = $64115cd316658422$var$getComputedStyle(canvas);
    var margins = $64115cd316658422$var$getPositionedStyle(style, 'margin');
    var maxWidth = $64115cd316658422$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $64115cd316658422$export$53c86fa97d611818;
    var maxHeight = $64115cd316658422$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $64115cd316658422$export$53c86fa97d611818;
    var containerSize = $64115cd316658422$var$getContainerSize(canvas, bbWidth, bbHeight);
    var width = containerSize.width, height = containerSize.height;
    if (style.boxSizing === 'content-box') {
        var borders = $64115cd316658422$var$getPositionedStyle(style, 'border', 'width');
        var paddings = $64115cd316658422$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $64115cd316658422$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $64115cd316658422$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $64115cd316658422$var$round1(width / 2);
    var maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $64115cd316658422$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $64115cd316658422$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    var pixelRatio = forceRatio || 1;
    var deviceHeight = $64115cd316658422$var$round1(chart.height * pixelRatio);
    var deviceWidth = $64115cd316658422$var$round1(chart.width * pixelRatio);
    chart.height = $64115cd316658422$var$round1(chart.height);
    chart.width = $64115cd316658422$var$round1(chart.width);
    var canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = "".concat(chart.height, "px");
        canvas.style.width = "".concat(chart.width, "px");
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var $64115cd316658422$export$3466f893ebf79586 = function() {
    var passiveSupported = false;
    try {
        var options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($64115cd316658422$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $64115cd316658422$export$b4171a6734a65d42(element, property) {
    var value = $64115cd316658422$export$fef3dfd9bad05307(element, property);
    var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $64115cd316658422$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $64115cd316658422$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $64115cd316658422$export$d24c54395ce0c509(p1, p2, t, mode) {
    var cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    var cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    var a = $64115cd316658422$export$6554612db691658e(p1, cp1, t);
    var b = $64115cd316658422$export$6554612db691658e(cp1, cp2, t);
    var c = $64115cd316658422$export$6554612db691658e(cp2, p2, t);
    var d = $64115cd316658422$export$6554612db691658e(a, b, t);
    var e = $64115cd316658422$export$6554612db691658e(b, c, t);
    return $64115cd316658422$export$6554612db691658e(d, e, t);
}
var $64115cd316658422$var$getRightToLeftAdapter = function getRightToLeftAdapter(rectX, width) {
    return {
        x: function(x) {
            return rectX + rectX + width - x;
        },
        setWidth: function(w) {
            width = w;
        },
        textAlign: function(align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus: function(x, value) {
            return x - value;
        },
        leftForLtr: function(x, itemWidth) {
            return x - itemWidth;
        }
    };
};
var $64115cd316658422$var$getLeftToRightAdapter = function getLeftToRightAdapter() {
    return {
        x: function(x) {
            return x;
        },
        setWidth: function(w) {},
        textAlign: function(align) {
            return align;
        },
        xPlus: function(x, value) {
            return x + value;
        },
        leftForLtr: function(x, _itemWidth) {
            return x;
        }
    };
};
function $64115cd316658422$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $64115cd316658422$var$getRightToLeftAdapter(rectX, width) : $64115cd316658422$var$getLeftToRightAdapter();
}
function $64115cd316658422$export$9d398bebfec1c039(ctx, direction) {
    var style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $64115cd316658422$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $64115cd316658422$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $64115cd316658422$export$ffb5f4729a158638,
        compare: $64115cd316658422$export$f074adc9fbd50943,
        normalize: $64115cd316658422$export$ab83b03e4111b1d0
    };
    return {
        between: $64115cd316658422$export$21579262ef46735b,
        compare: function(a, b) {
            return a - b;
        },
        normalize: function(x) {
            return x;
        }
    };
}
function $64115cd316658422$var$normalizeSegment(param) {
    var start = param.start, end = param.end, count = param.count, loop = param.loop, style = param.style;
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $64115cd316658422$var$getSegment(segment, points, bounds) {
    var property = bounds.property, startBound = bounds.start, endBound = bounds.end;
    var _propertyFn = $64115cd316658422$var$propertyFn(property), between = _propertyFn.between, normalize = _propertyFn.normalize;
    var count = points.length;
    var start = segment.start, end = segment.end, loop = segment.loop;
    var i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $64115cd316658422$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    var property = bounds.property, startBound = bounds.start, endBound = bounds.end;
    var count = points.length;
    var _propertyFn = $64115cd316658422$var$propertyFn(property), compare = _propertyFn.compare, between = _propertyFn.between, normalize = _propertyFn.normalize;
    var _getSegment = $64115cd316658422$var$getSegment(segment, points, bounds), start = _getSegment.start, end = _getSegment.end, loop = _getSegment.loop, style = _getSegment.style;
    var result = [];
    var inside = false;
    var subStart = null;
    var value, point, prevValue;
    var startIsBefore = function() {
        return between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    };
    var endIsBefore = function() {
        return compare(endBound, value) === 0 || between(endBound, prevValue, value);
    };
    var shouldStart = function() {
        return inside || startIsBefore();
    };
    var shouldStop = function() {
        return !inside || endIsBefore();
    };
    for(var i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($64115cd316658422$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($64115cd316658422$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $64115cd316658422$export$2f6ca3d3b1f80bf5(line, bounds) {
    var result = [];
    var segments = line.segments;
    for(var i = 0; i < segments.length; i++){
        var _result;
        var sub = $64115cd316658422$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) (_result = result).push.apply(_result, (0, $2l5av._)(sub));
    }
    return result;
}
function $64115cd316658422$var$findStartAndEnd(points, count, loop, spanGaps) {
    var start = 0;
    var end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $64115cd316658422$var$solidSegments(points, start, max, loop) {
    var count = points.length;
    var result = [];
    var last = start;
    var prev = points[start];
    var end;
    for(end = start + 1; end <= max; ++end){
        var cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $64115cd316658422$export$7a38258bbe170828(line, segmentOptions) {
    var points = line.points;
    var spanGaps = line.options.spanGaps;
    var count = points.length;
    if (!count) return [];
    var loop = !!line._loop;
    var _findStartAndEnd = $64115cd316658422$var$findStartAndEnd(points, count, loop, spanGaps), start = _findStartAndEnd.start, end = _findStartAndEnd.end;
    if (spanGaps === true) return $64115cd316658422$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    var max = end < start ? end + count : end;
    var completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $64115cd316658422$var$splitByStyles(line, $64115cd316658422$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $64115cd316658422$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $64115cd316658422$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $64115cd316658422$var$doSplitByStyles(line, segments, points, segmentOptions) {
    var chartContext = line._chart.getContext();
    var baseStyle = $64115cd316658422$var$readStyle(line.options);
    var datasetIndex = line._datasetIndex, spanGaps = line.options.spanGaps;
    var count = points.length;
    var result = [];
    var prevStyle = baseStyle;
    var start = segments[0].start;
    var i = start;
    function addStyle(s, e, l, st) {
        var dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            start = spanGaps ? start : segment.start;
            var prev = points[start % count];
            var style = void 0;
            for(i = start + 1; i <= segment.end; i++){
                var pt = points[i % count];
                style = $64115cd316658422$var$readStyle(segmentOptions.setContext($64115cd316658422$export$35e795649ee09318(chartContext, {
                    type: 'segment',
                    p0: prev,
                    p1: pt,
                    p0DataIndex: (i - 1) % count,
                    p1DataIndex: i % count,
                    datasetIndex: datasetIndex
                })));
                if ($64115cd316658422$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
                prev = pt;
                prevStyle = style;
            }
            if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $64115cd316658422$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $64115cd316658422$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    var cache = [];
    var replacer = function replacer(key, value) {
        if (!$64115cd316658422$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $64115cd316658422$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $64115cd316658422$var$getDatasetArea(meta, chartArea) {
    var xScale = meta.xScale, yScale = meta.yScale;
    if (xScale && yScale) return {
        left: $64115cd316658422$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $64115cd316658422$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $64115cd316658422$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $64115cd316658422$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $64115cd316658422$export$995eb9fca571757(chart, meta) {
    var clip = meta._clip;
    if (clip.disabled) return false;
    var area = $64115cd316658422$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

});
parcelRegister("6IWPt", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $4e547c6877ea91f6$export$892596cec99bc70e; });
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ 
var $bzgVo = parcelRequire("bzgVo");

var $gHG1J = parcelRequire("gHG1J");

var $aqUTs = parcelRequire("aqUTs");
function $4e547c6877ea91f6$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
var $4e547c6877ea91f6$export$837ba5c449269406 = function(v, l, h) {
    return Math.max(Math.min(v, h), l);
};
function $4e547c6877ea91f6$export$bcc6e673dfa14d36(v) {
    return $4e547c6877ea91f6$export$837ba5c449269406($4e547c6877ea91f6$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $4e547c6877ea91f6$export$869b26d4e1bbdb63(v) {
    return $4e547c6877ea91f6$export$837ba5c449269406($4e547c6877ea91f6$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $4e547c6877ea91f6$export$ed9bd8dcaeba14f6(v) {
    return $4e547c6877ea91f6$export$837ba5c449269406($4e547c6877ea91f6$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $4e547c6877ea91f6$export$dbf961a8d278dbef(v) {
    return $4e547c6877ea91f6$export$837ba5c449269406($4e547c6877ea91f6$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $4e547c6877ea91f6$export$aa35ef1f24408ab9(v) {
    return $4e547c6877ea91f6$export$837ba5c449269406($4e547c6877ea91f6$export$2077e0241d6afd3c(v * 100), 0, 100);
}
var $4e547c6877ea91f6$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
var $4e547c6877ea91f6$var$hex = Array.from('0123456789ABCDEF');
var $4e547c6877ea91f6$var$h1 = function(b) {
    return $4e547c6877ea91f6$var$hex[b & 0xF];
};
var $4e547c6877ea91f6$var$h2 = function(b) {
    return $4e547c6877ea91f6$var$hex[(b & 0xF0) >> 4] + $4e547c6877ea91f6$var$hex[b & 0xF];
};
var $4e547c6877ea91f6$var$eq = function(b) {
    return (b & 0xF0) >> 4 === (b & 0xF);
};
var $4e547c6877ea91f6$var$isShort = function(v) {
    return $4e547c6877ea91f6$var$eq(v.r) && $4e547c6877ea91f6$var$eq(v.g) && $4e547c6877ea91f6$var$eq(v.b) && $4e547c6877ea91f6$var$eq(v.a);
};
function $4e547c6877ea91f6$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $4e547c6877ea91f6$var$map$1[str[1]] * 17,
            g: 255 & $4e547c6877ea91f6$var$map$1[str[2]] * 17,
            b: 255 & $4e547c6877ea91f6$var$map$1[str[3]] * 17,
            a: len === 5 ? $4e547c6877ea91f6$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $4e547c6877ea91f6$var$map$1[str[1]] << 4 | $4e547c6877ea91f6$var$map$1[str[2]],
            g: $4e547c6877ea91f6$var$map$1[str[3]] << 4 | $4e547c6877ea91f6$var$map$1[str[4]],
            b: $4e547c6877ea91f6$var$map$1[str[5]] << 4 | $4e547c6877ea91f6$var$map$1[str[6]],
            a: len === 9 ? $4e547c6877ea91f6$var$map$1[str[7]] << 4 | $4e547c6877ea91f6$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
var $4e547c6877ea91f6$var$alpha = function(a, f) {
    return a < 255 ? f(a) : '';
};
function $4e547c6877ea91f6$export$1b06654353ef9f67(v) {
    var f = $4e547c6877ea91f6$var$isShort(v) ? $4e547c6877ea91f6$var$h1 : $4e547c6877ea91f6$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $4e547c6877ea91f6$var$alpha(v.a, f) : undefined;
}
var $4e547c6877ea91f6$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $4e547c6877ea91f6$var$hsl2rgbn(h, s, l) {
    var a = s * Math.min(l, 1 - l);
    var f = function(n) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $4e547c6877ea91f6$var$hsv2rgbn(h, s, v) {
    var f = function(n) {
        var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 60) % 6;
        return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    };
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $4e547c6877ea91f6$var$hwb2rgbn(h, w, b) {
    var rgb = $4e547c6877ea91f6$var$hsl2rgbn(h, 1, 0.5);
    var i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $4e547c6877ea91f6$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $4e547c6877ea91f6$export$b5ba70b240f8f7f(v) {
    var range = 255;
    var r = v.r / range;
    var g = v.g / range;
    var b = v.b / range;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var l = (max + min) / 2;
    var h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $4e547c6877ea91f6$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $4e547c6877ea91f6$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($4e547c6877ea91f6$export$ed9bd8dcaeba14f6);
}
function $4e547c6877ea91f6$export$4c15bd42559b811d(h, s, l) {
    return $4e547c6877ea91f6$var$calln($4e547c6877ea91f6$var$hsl2rgbn, h, s, l);
}
function $4e547c6877ea91f6$export$e2710022c70fc9ee(h, w, b) {
    return $4e547c6877ea91f6$var$calln($4e547c6877ea91f6$var$hwb2rgbn, h, w, b);
}
function $4e547c6877ea91f6$export$b785a357c84e4a04(h, s, v) {
    return $4e547c6877ea91f6$var$calln($4e547c6877ea91f6$var$hsv2rgbn, h, s, v);
}
function $4e547c6877ea91f6$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $4e547c6877ea91f6$export$5e91288c399be4f9(str) {
    var m = $4e547c6877ea91f6$var$HUE_RE.exec(str);
    var a = 255;
    var v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $4e547c6877ea91f6$export$bcc6e673dfa14d36(+m[5]) : $4e547c6877ea91f6$export$ed9bd8dcaeba14f6(+m[5]);
    var h = $4e547c6877ea91f6$var$hue(+m[2]);
    var p1 = +m[3] / 100;
    var p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $4e547c6877ea91f6$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $4e547c6877ea91f6$export$b785a357c84e4a04(h, p1, p2);
    else v = $4e547c6877ea91f6$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $4e547c6877ea91f6$export$bb628a54ab399bc9(v, deg) {
    var h = $4e547c6877ea91f6$export$b5ba70b240f8f7f(v);
    h[0] = $4e547c6877ea91f6$var$hue(h[0] + deg);
    h = $4e547c6877ea91f6$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $4e547c6877ea91f6$export$a197af1c58e6260c(v) {
    if (!v) return;
    var a = $4e547c6877ea91f6$export$b5ba70b240f8f7f(v);
    var h = a[0];
    var s = $4e547c6877ea91f6$export$aa35ef1f24408ab9(a[1]);
    var l = $4e547c6877ea91f6$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat($4e547c6877ea91f6$export$dbf961a8d278dbef(v.a), ")") : "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
}
var $4e547c6877ea91f6$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
var $4e547c6877ea91f6$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $4e547c6877ea91f6$var$unpack() {
    var unpacked = {};
    var keys = Object.keys($4e547c6877ea91f6$var$names$1);
    var tkeys = Object.keys($4e547c6877ea91f6$var$map);
    var i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $4e547c6877ea91f6$var$map[k]);
        }
        k = parseInt($4e547c6877ea91f6$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
var $4e547c6877ea91f6$var$names;
function $4e547c6877ea91f6$export$b2f06b640faad956(str) {
    if (!$4e547c6877ea91f6$var$names) {
        $4e547c6877ea91f6$var$names = $4e547c6877ea91f6$var$unpack();
        $4e547c6877ea91f6$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    var a = $4e547c6877ea91f6$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
var $4e547c6877ea91f6$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $4e547c6877ea91f6$export$91aedb20f296e541(str) {
    var m = $4e547c6877ea91f6$var$RGB_RE.exec(str);
    var a = 255;
    var r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        var v = +m[7];
        a = m[8] ? $4e547c6877ea91f6$export$bcc6e673dfa14d36(v) : $4e547c6877ea91f6$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $4e547c6877ea91f6$export$bcc6e673dfa14d36(r) : $4e547c6877ea91f6$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $4e547c6877ea91f6$export$bcc6e673dfa14d36(g) : $4e547c6877ea91f6$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $4e547c6877ea91f6$export$bcc6e673dfa14d36(b) : $4e547c6877ea91f6$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $4e547c6877ea91f6$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? "rgba(".concat(v.r, ", ").concat(v.g, ", ").concat(v.b, ", ").concat($4e547c6877ea91f6$export$dbf961a8d278dbef(v.a), ")") : "rgb(".concat(v.r, ", ").concat(v.g, ", ").concat(v.b, ")"));
}
var $4e547c6877ea91f6$var$to = function(v) {
    return v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
};
var $4e547c6877ea91f6$var$from = function(v) {
    return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
};
function $4e547c6877ea91f6$var$interpolate(rgb1, rgb2, t) {
    var r = $4e547c6877ea91f6$var$from($4e547c6877ea91f6$export$dbf961a8d278dbef(rgb1.r));
    var g = $4e547c6877ea91f6$var$from($4e547c6877ea91f6$export$dbf961a8d278dbef(rgb1.g));
    var b = $4e547c6877ea91f6$var$from($4e547c6877ea91f6$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $4e547c6877ea91f6$export$ed9bd8dcaeba14f6($4e547c6877ea91f6$var$to(r + t * ($4e547c6877ea91f6$var$from($4e547c6877ea91f6$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $4e547c6877ea91f6$export$ed9bd8dcaeba14f6($4e547c6877ea91f6$var$to(g + t * ($4e547c6877ea91f6$var$from($4e547c6877ea91f6$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $4e547c6877ea91f6$export$ed9bd8dcaeba14f6($4e547c6877ea91f6$var$to(b + t * ($4e547c6877ea91f6$var$from($4e547c6877ea91f6$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $4e547c6877ea91f6$var$modHSL(v, i, ratio) {
    if (v) {
        var tmp = $4e547c6877ea91f6$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $4e547c6877ea91f6$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $4e547c6877ea91f6$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $4e547c6877ea91f6$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $4e547c6877ea91f6$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $4e547c6877ea91f6$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $4e547c6877ea91f6$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $4e547c6877ea91f6$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $4e547c6877ea91f6$export$91aedb20f296e541(str);
    return $4e547c6877ea91f6$export$5e91288c399be4f9(str);
}
var $4e547c6877ea91f6$export$892596cec99bc70e = /*#__PURE__*/ function() {
    "use strict";
    function Color(input) {
        (0, $bzgVo._)(this, Color);
        if (input instanceof Color) return input;
        var type = typeof input === "undefined" ? "undefined" : (0, $aqUTs._)(input);
        var v;
        if (type === 'object') v = $4e547c6877ea91f6$var$fromObject(input);
        else if (type === 'string') v = $4e547c6877ea91f6$export$625a38b961e8b5e9(input) || $4e547c6877ea91f6$export$b2f06b640faad956(input) || $4e547c6877ea91f6$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    (0, $gHG1J._)(Color, [
        {
            key: "valid",
            get: function get() {
                return this._valid;
            }
        },
        {
            key: "rgb",
            get: function get() {
                var v = $4e547c6877ea91f6$var$clone(this._rgb);
                if (v) v.a = $4e547c6877ea91f6$export$dbf961a8d278dbef(v.a);
                return v;
            },
            set: function set(obj) {
                this._rgb = $4e547c6877ea91f6$var$fromObject(obj);
            }
        },
        {
            key: "rgbString",
            value: function rgbString1() {
                return this._valid ? $4e547c6877ea91f6$export$9595423f22cf925a(this._rgb) : undefined;
            }
        },
        {
            key: "hexString",
            value: function hexString1() {
                return this._valid ? $4e547c6877ea91f6$export$1b06654353ef9f67(this._rgb) : undefined;
            }
        },
        {
            key: "hslString",
            value: function hslString1() {
                return this._valid ? $4e547c6877ea91f6$export$a197af1c58e6260c(this._rgb) : undefined;
            }
        },
        {
            key: "mix",
            value: function mix(color, weight) {
                if (color) {
                    var c1 = this.rgb;
                    var c2 = color.rgb;
                    var w2;
                    var p = weight === w2 ? 0.5 : weight;
                    var w = 2 * p - 1;
                    var a = c1.a - c2.a;
                    var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
                    w2 = 1 - w1;
                    c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
                    c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
                    c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
                    c1.a = p * c1.a + (1 - p) * c2.a;
                    this.rgb = c1;
                }
                return this;
            }
        },
        {
            key: "interpolate",
            value: function interpolate1(color, t) {
                if (color) this._rgb = $4e547c6877ea91f6$var$interpolate(this._rgb, color._rgb, t);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new Color(this.rgb);
            }
        },
        {
            key: "alpha",
            value: function alpha(a) {
                this._rgb.a = $4e547c6877ea91f6$export$ed9bd8dcaeba14f6(a);
                return this;
            }
        },
        {
            key: "clearer",
            value: function clearer(ratio) {
                var rgb = this._rgb;
                rgb.a *= 1 - ratio;
                return this;
            }
        },
        {
            key: "greyscale",
            value: function greyscale() {
                var rgb = this._rgb;
                var val = $4e547c6877ea91f6$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
                rgb.r = rgb.g = rgb.b = val;
                return this;
            }
        },
        {
            key: "opaquer",
            value: function opaquer(ratio) {
                var rgb = this._rgb;
                rgb.a *= 1 + ratio;
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                var v = this._rgb;
                v.r = 255 - v.r;
                v.g = 255 - v.g;
                v.b = 255 - v.b;
                return this;
            }
        },
        {
            key: "lighten",
            value: function lighten(ratio) {
                $4e547c6877ea91f6$var$modHSL(this._rgb, 2, ratio);
                return this;
            }
        },
        {
            key: "darken",
            value: function darken(ratio) {
                $4e547c6877ea91f6$var$modHSL(this._rgb, 2, -ratio);
                return this;
            }
        },
        {
            key: "saturate",
            value: function saturate(ratio) {
                $4e547c6877ea91f6$var$modHSL(this._rgb, 1, ratio);
                return this;
            }
        },
        {
            key: "desaturate",
            value: function desaturate(ratio) {
                $4e547c6877ea91f6$var$modHSL(this._rgb, 1, -ratio);
                return this;
            }
        },
        {
            key: "rotate",
            value: function rotate1(deg) {
                $4e547c6877ea91f6$export$bb628a54ab399bc9(this._rgb, deg);
                return this;
            }
        }
    ]);
    return Color;
}();
function $4e547c6877ea91f6$export$2e2bcd8739ae039(input) {
    return new $4e547c6877ea91f6$export$892596cec99bc70e(input);
}

});



parcelRegister("ev39C", function(module, exports) {

var $5Oz3R = parcelRequire("5Oz3R");
$parcel$exportWildcard(module.exports, $5Oz3R);

});
parcelRegister("5Oz3R", function(module, exports) {

$parcel$export(module.exports, "HALF_PI", function () { return (parcelRequire("8AEPV")).H; });
$parcel$export(module.exports, "INFINITY", function () { return (parcelRequire("8AEPV")).b3; });
$parcel$export(module.exports, "PI", function () { return (parcelRequire("8AEPV")).P; });
$parcel$export(module.exports, "PITAU", function () { return (parcelRequire("8AEPV")).b2; });
$parcel$export(module.exports, "QUARTER_PI", function () { return (parcelRequire("8AEPV")).b5; });
$parcel$export(module.exports, "RAD_PER_DEG", function () { return (parcelRequire("8AEPV")).b4; });
$parcel$export(module.exports, "TAU", function () { return (parcelRequire("8AEPV")).T; });
$parcel$export(module.exports, "TWO_THIRDS_PI", function () { return (parcelRequire("8AEPV")).b6; });
$parcel$export(module.exports, "_addGrace", function () { return (parcelRequire("8AEPV")).R; });
$parcel$export(module.exports, "_alignPixel", function () { return (parcelRequire("8AEPV")).X; });
$parcel$export(module.exports, "_alignStartEnd", function () { return (parcelRequire("8AEPV")).a2; });
$parcel$export(module.exports, "_angleBetween", function () { return (parcelRequire("8AEPV")).p; });
$parcel$export(module.exports, "_angleDiff", function () { return (parcelRequire("8AEPV")).b7; });
$parcel$export(module.exports, "_arrayUnique", function () { return (parcelRequire("8AEPV"))._; });
$parcel$export(module.exports, "_attachContext", function () { return (parcelRequire("8AEPV")).a8; });
$parcel$export(module.exports, "_bezierCurveTo", function () { return (parcelRequire("8AEPV")).au; });
$parcel$export(module.exports, "_bezierInterpolation", function () { return (parcelRequire("8AEPV")).ar; });
$parcel$export(module.exports, "_boundSegment", function () { return (parcelRequire("8AEPV")).az; });
$parcel$export(module.exports, "_boundSegments", function () { return (parcelRequire("8AEPV")).ap; });
$parcel$export(module.exports, "_capitalize", function () { return (parcelRequire("8AEPV")).a5; });
$parcel$export(module.exports, "_computeSegments", function () { return (parcelRequire("8AEPV")).ao; });
$parcel$export(module.exports, "_createResolver", function () { return (parcelRequire("8AEPV")).a9; });
$parcel$export(module.exports, "_decimalPlaces", function () { return (parcelRequire("8AEPV")).aL; });
$parcel$export(module.exports, "_deprecated", function () { return (parcelRequire("8AEPV")).aW; });
$parcel$export(module.exports, "_descriptors", function () { return (parcelRequire("8AEPV")).aa; });
$parcel$export(module.exports, "_elementsEqual", function () { return (parcelRequire("8AEPV")).ai; });
$parcel$export(module.exports, "_factorize", function () { return (parcelRequire("8AEPV")).N; });
$parcel$export(module.exports, "_filterBetween", function () { return (parcelRequire("8AEPV")).aP; });
$parcel$export(module.exports, "_getParentNode", function () { return (parcelRequire("8AEPV")).I; });
$parcel$export(module.exports, "_getStartAndCountOfVisiblePoints", function () { return (parcelRequire("8AEPV")).q; });
$parcel$export(module.exports, "_int16Range", function () { return (parcelRequire("8AEPV")).W; });
$parcel$export(module.exports, "_isBetween", function () { return (parcelRequire("8AEPV")).ak; });
$parcel$export(module.exports, "_isClickEvent", function () { return (parcelRequire("8AEPV")).aj; });
$parcel$export(module.exports, "_isDomSupported", function () { return (parcelRequire("8AEPV")).M; });
$parcel$export(module.exports, "_isPointInArea", function () { return (parcelRequire("8AEPV")).C; });
$parcel$export(module.exports, "_limitValue", function () { return (parcelRequire("8AEPV")).S; });
$parcel$export(module.exports, "_longestText", function () { return (parcelRequire("8AEPV")).aO; });
$parcel$export(module.exports, "_lookup", function () { return (parcelRequire("8AEPV")).aQ; });
$parcel$export(module.exports, "_lookupByKey", function () { return (parcelRequire("8AEPV")).B; });
$parcel$export(module.exports, "_measureText", function () { return (parcelRequire("8AEPV")).V; });
$parcel$export(module.exports, "_merger", function () { return (parcelRequire("8AEPV")).aU; });
$parcel$export(module.exports, "_mergerIf", function () { return (parcelRequire("8AEPV")).aV; });
$parcel$export(module.exports, "_normalizeAngle", function () { return (parcelRequire("8AEPV")).al; });
$parcel$export(module.exports, "_parseObjectDataRadialScale", function () { return (parcelRequire("8AEPV")).y; });
$parcel$export(module.exports, "_pointInLine", function () { return (parcelRequire("8AEPV")).as; });
$parcel$export(module.exports, "_readValueToProps", function () { return (parcelRequire("8AEPV")).am; });
$parcel$export(module.exports, "_rlookupByKey", function () { return (parcelRequire("8AEPV")).A; });
$parcel$export(module.exports, "_scaleRangesChanged", function () { return (parcelRequire("8AEPV")).w; });
$parcel$export(module.exports, "_setMinAndMaxByKey", function () { return (parcelRequire("8AEPV")).aH; });
$parcel$export(module.exports, "_splitKey", function () { return (parcelRequire("8AEPV")).aX; });
$parcel$export(module.exports, "_steppedInterpolation", function () { return (parcelRequire("8AEPV")).aq; });
$parcel$export(module.exports, "_steppedLineTo", function () { return (parcelRequire("8AEPV")).at; });
$parcel$export(module.exports, "_textX", function () { return (parcelRequire("8AEPV")).aC; });
$parcel$export(module.exports, "_toLeftRightCenter", function () { return (parcelRequire("8AEPV")).a1; });
$parcel$export(module.exports, "_updateBezierControlPoints", function () { return (parcelRequire("8AEPV")).an; });
$parcel$export(module.exports, "addRoundedRectPath", function () { return (parcelRequire("8AEPV")).aw; });
$parcel$export(module.exports, "almostEquals", function () { return (parcelRequire("8AEPV")).aK; });
$parcel$export(module.exports, "almostWhole", function () { return (parcelRequire("8AEPV")).aJ; });
$parcel$export(module.exports, "callback", function () { return (parcelRequire("8AEPV")).Q; });
$parcel$export(module.exports, "clearCanvas", function () { return (parcelRequire("8AEPV")).af; });
$parcel$export(module.exports, "clipArea", function () { return (parcelRequire("8AEPV")).Y; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("8AEPV")).aT; });
$parcel$export(module.exports, "color", function () { return (parcelRequire("8AEPV")).c; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("8AEPV")).j; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("8AEPV")).ad; });
$parcel$export(module.exports, "defined", function () { return (parcelRequire("8AEPV")).h; });
$parcel$export(module.exports, "distanceBetweenPoints", function () { return (parcelRequire("8AEPV")).aF; });
$parcel$export(module.exports, "drawPoint", function () { return (parcelRequire("8AEPV")).av; });
$parcel$export(module.exports, "drawPointLegend", function () { return (parcelRequire("8AEPV")).aE; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("8AEPV")).F; });
$parcel$export(module.exports, "easingEffects", function () { return (parcelRequire("8AEPV")).e; });
$parcel$export(module.exports, "finiteOrDefault", function () { return (parcelRequire("8AEPV")).O; });
$parcel$export(module.exports, "fontString", function () { return (parcelRequire("8AEPV")).b0; });
$parcel$export(module.exports, "formatNumber", function () { return (parcelRequire("8AEPV")).o; });
$parcel$export(module.exports, "getAngleFromPoint", function () { return (parcelRequire("8AEPV")).D; });
$parcel$export(module.exports, "getDatasetClipArea", function () { return (parcelRequire("8AEPV")).ah; });
$parcel$export(module.exports, "getHoverColor", function () { return (parcelRequire("8AEPV")).aS; });
$parcel$export(module.exports, "getMaximumSize", function () { return (parcelRequire("8AEPV")).G; });
$parcel$export(module.exports, "getRelativePosition", function () { return (parcelRequire("8AEPV")).z; });
$parcel$export(module.exports, "getRtlAdapter", function () { return (parcelRequire("8AEPV")).aA; });
$parcel$export(module.exports, "getStyle", function () { return (parcelRequire("8AEPV")).a$; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("8AEPV")).b; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("8AEPV")).g; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("8AEPV")).a7; });
$parcel$export(module.exports, "isNullOrUndef", function () { return (parcelRequire("8AEPV")).k; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("8AEPV")).x; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("8AEPV")).i; });
$parcel$export(module.exports, "isPatternOrGradient", function () { return (parcelRequire("8AEPV")).aR; });
$parcel$export(module.exports, "listenArrayEvents", function () { return (parcelRequire("8AEPV")).l; });
$parcel$export(module.exports, "log10", function () { return (parcelRequire("8AEPV")).aN; });
$parcel$export(module.exports, "merge", function () { return (parcelRequire("8AEPV")).a4; });
$parcel$export(module.exports, "mergeIf", function () { return (parcelRequire("8AEPV")).ab; });
$parcel$export(module.exports, "niceNum", function () { return (parcelRequire("8AEPV")).aI; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("8AEPV")).aG; });
$parcel$export(module.exports, "overrideTextDirection", function () { return (parcelRequire("8AEPV")).aB; });
$parcel$export(module.exports, "readUsedSize", function () { return (parcelRequire("8AEPV")).J; });
$parcel$export(module.exports, "renderText", function () { return (parcelRequire("8AEPV")).Z; });
$parcel$export(module.exports, "requestAnimFrame", function () { return (parcelRequire("8AEPV")).r; });
$parcel$export(module.exports, "resolve", function () { return (parcelRequire("8AEPV")).a; });
$parcel$export(module.exports, "resolveObjectKey", function () { return (parcelRequire("8AEPV")).f; });
$parcel$export(module.exports, "restoreTextDirection", function () { return (parcelRequire("8AEPV")).aD; });
$parcel$export(module.exports, "retinaScale", function () { return (parcelRequire("8AEPV")).ae; });
$parcel$export(module.exports, "setsEqual", function () { return (parcelRequire("8AEPV")).ag; });
$parcel$export(module.exports, "sign", function () { return (parcelRequire("8AEPV")).s; });
$parcel$export(module.exports, "splineCurve", function () { return (parcelRequire("8AEPV")).aZ; });
$parcel$export(module.exports, "splineCurveMonotone", function () { return (parcelRequire("8AEPV")).a_; });
$parcel$export(module.exports, "supportsEventListenerOptions", function () { return (parcelRequire("8AEPV")).K; });
$parcel$export(module.exports, "throttled", function () { return (parcelRequire("8AEPV")).L; });
$parcel$export(module.exports, "toDegrees", function () { return (parcelRequire("8AEPV")).U; });
$parcel$export(module.exports, "toDimension", function () { return (parcelRequire("8AEPV")).n; });
$parcel$export(module.exports, "toFont", function () { return (parcelRequire("8AEPV")).a0; });
$parcel$export(module.exports, "toFontString", function () { return (parcelRequire("8AEPV")).aY; });
$parcel$export(module.exports, "toLineHeight", function () { return (parcelRequire("8AEPV")).b1; });
$parcel$export(module.exports, "toPadding", function () { return (parcelRequire("8AEPV")).E; });
$parcel$export(module.exports, "toPercentage", function () { return (parcelRequire("8AEPV")).m; });
$parcel$export(module.exports, "toRadians", function () { return (parcelRequire("8AEPV")).t; });
$parcel$export(module.exports, "toTRBL", function () { return (parcelRequire("8AEPV")).ax; });
$parcel$export(module.exports, "toTRBLCorners", function () { return (parcelRequire("8AEPV")).ay; });
$parcel$export(module.exports, "uid", function () { return (parcelRequire("8AEPV")).ac; });
$parcel$export(module.exports, "unclipArea", function () { return (parcelRequire("8AEPV")).$; });
$parcel$export(module.exports, "unlistenArrayEvents", function () { return (parcelRequire("8AEPV")).u; });
$parcel$export(module.exports, "valueOrDefault", function () { return (parcelRequire("8AEPV")).v; });
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $8AEPV = parcelRequire("8AEPV");


});


// ============================================
// Solve Page Entry Point
// ============================================
// Import Bootstrap CSS AND JS

parcelRequire("lylu0");



var $8Y07q = parcelRequire("8Y07q");
// ============================================
// Chart.js Setup with Drag-and-Drop
// ============================================

var $2l5av = parcelRequire("2l5av");

var $lKySX = parcelRequire("lKySX");
var $974792b9b4a4c67f$exports = {};
/*!
 * chartjs-plugin-dragdata v2.3.1
 * https://github.com/artus9033/chartjs-plugin-dragdata.git
 * (c) 2018-2024 chartjs-plugin-dragdata contributors
 * Released under the MIT license
 */ 
var $k9HNQ = parcelRequire("k9HNQ");

var $aqUTs = parcelRequire("aqUTs");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $aqUTs = parcelRequire("aqUTs");
var $360d51dadf3ec78e$var$extendStatics = function extendStatics1(d, b) {
    $360d51dadf3ec78e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $360d51dadf3ec78e$var$extendStatics(d, b);
};
function $360d51dadf3ec78e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $360d51dadf3ec78e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $360d51dadf3ec78e$export$18ce0697a983be9b = function __assign1() {
    $360d51dadf3ec78e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $360d51dadf3ec78e$export$18ce0697a983be9b.apply(this, arguments);
};
function $360d51dadf3ec78e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $360d51dadf3ec78e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $aqUTs._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $360d51dadf3ec78e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $360d51dadf3ec78e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $aqUTs._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $360d51dadf3ec78e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $360d51dadf3ec78e$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $aqUTs._)(x)) === "symbol" ? x : "".concat(x);
}
function $360d51dadf3ec78e$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $aqUTs._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $360d51dadf3ec78e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $aqUTs._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $360d51dadf3ec78e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $360d51dadf3ec78e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $360d51dadf3ec78e$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $360d51dadf3ec78e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $360d51dadf3ec78e$export$45d3717a4c69092e(o, m, p);
}
function $360d51dadf3ec78e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $360d51dadf3ec78e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $360d51dadf3ec78e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($360d51dadf3ec78e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $360d51dadf3ec78e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $360d51dadf3ec78e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $360d51dadf3ec78e$export$10c90e4f7922046c(v) {
    return this instanceof $360d51dadf3ec78e$export$10c90e4f7922046c ? (this.v = v, this) : new $360d51dadf3ec78e$export$10c90e4f7922046c(v);
}
function $360d51dadf3ec78e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $360d51dadf3ec78e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $360d51dadf3ec78e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $360d51dadf3ec78e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $360d51dadf3ec78e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $360d51dadf3ec78e$export$19a8beecd37a4c45 === "function" ? $360d51dadf3ec78e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $360d51dadf3ec78e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $360d51dadf3ec78e$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $360d51dadf3ec78e$var$ownKeys = function ownKeys1(o) {
    $360d51dadf3ec78e$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $360d51dadf3ec78e$var$ownKeys(o);
};
function $360d51dadf3ec78e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $360d51dadf3ec78e$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $360d51dadf3ec78e$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $360d51dadf3ec78e$var$__setModuleDefault(result, mod);
    return result;
}
function $360d51dadf3ec78e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $360d51dadf3ec78e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $360d51dadf3ec78e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $360d51dadf3ec78e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $aqUTs._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $360d51dadf3ec78e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $aqUTs._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $360d51dadf3ec78e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $360d51dadf3ec78e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $360d51dadf3ec78e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $360d51dadf3ec78e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $360d51dadf3ec78e$export$2e2bcd8739ae039 = {
    __extends: $360d51dadf3ec78e$export$a8ba968b8961cb8a,
    __assign: $360d51dadf3ec78e$export$18ce0697a983be9b,
    __rest: $360d51dadf3ec78e$export$3c9a16f847548506,
    __decorate: $360d51dadf3ec78e$export$29e00dfd3077644b,
    __param: $360d51dadf3ec78e$export$d5ad3fd78186038f,
    __esDecorate: $360d51dadf3ec78e$export$3a84e1ae4e97e9b0,
    __runInitializers: $360d51dadf3ec78e$export$d831c04e792af3d,
    __propKey: $360d51dadf3ec78e$export$6a2a36740a146cb8,
    __setFunctionName: $360d51dadf3ec78e$export$d1a06452d3489bc7,
    __metadata: $360d51dadf3ec78e$export$f1db080c865becb9,
    __awaiter: $360d51dadf3ec78e$export$1050f835b63b671e,
    __generator: $360d51dadf3ec78e$export$67ebef60e6f28a6,
    __createBinding: $360d51dadf3ec78e$export$45d3717a4c69092e,
    __exportStar: $360d51dadf3ec78e$export$f33643c0debef087,
    __values: $360d51dadf3ec78e$export$19a8beecd37a4c45,
    __read: $360d51dadf3ec78e$export$8d051b38c9118094,
    __spread: $360d51dadf3ec78e$export$afc72e2116322959,
    __spreadArrays: $360d51dadf3ec78e$export$6388937ca91ccae8,
    __spreadArray: $360d51dadf3ec78e$export$1216008129fb82ed,
    __await: $360d51dadf3ec78e$export$10c90e4f7922046c,
    __asyncGenerator: $360d51dadf3ec78e$export$e427f37a30a4de9b,
    __asyncDelegator: $360d51dadf3ec78e$export$bbd80228419bb833,
    __asyncValues: $360d51dadf3ec78e$export$e3b29a3d6162315f,
    __makeTemplateObject: $360d51dadf3ec78e$export$4fb47efe1390b86f,
    __importStar: $360d51dadf3ec78e$export$c21735bcef00d192,
    __importDefault: $360d51dadf3ec78e$export$da59b14a69baef04,
    __classPrivateFieldGet: $360d51dadf3ec78e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $360d51dadf3ec78e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $360d51dadf3ec78e$export$81fdc39f203e4e04,
    __addDisposableResource: $360d51dadf3ec78e$export$88ac25d8e944e405,
    __disposeResources: $360d51dadf3ec78e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $360d51dadf3ec78e$export$889dfb5d17574b0b
};




!function(t, n) {
    n($974792b9b4a4c67f$exports, (parcelRequire("ev39C")), (parcelRequire("lKySX")));
}(undefined, function(t, n, e) {
    "use strict";
    var i = {
        value: function() {}
    };
    function r() {
        for(var _$t, n = 0, _$e = arguments.length, i = {}; n < _$e; ++n){
            if (!(_$t = arguments[n] + "") || _$t in i || /[\s.]/.test(_$t)) throw new Error("illegal type: " + _$t);
            i[_$t] = [];
        }
        return new o(i);
    }
    function o(t) {
        this._ = t;
    }
    function a(t, n) {
        for(var _$e, i = 0, _$r = t.length; i < _$r; ++i)if ((_$e = t[i]).name === n) return _$e.value;
    }
    function u(t, n, e) {
        for(var _$r = 0, _$o = t.length; _$r < _$o; ++_$r)if (t[_$r].name === n) {
            t[_$r] = i, t = t.slice(0, _$r).concat(t.slice(_$r + 1));
            break;
        }
        return null != e && t.push({
            name: n,
            value: e
        }), t;
    }
    o.prototype = r.prototype = {
        constructor: o,
        on: function on(t, n) {
            var _$e, i, _$r = this._, _$o = (i = _$r, (t + "").trim().split(/^|\s+/).map(function(t) {
                var _$n = "", _$e = t.indexOf(".");
                if (_$e >= 0 && (_$n = t.slice(_$e + 1), t = t.slice(0, _$e)), t && !i.hasOwnProperty(t)) throw new Error("unknown type: " + t);
                return {
                    type: t,
                    name: _$n
                };
            })), l = -1, s = _$o.length;
            if (!(arguments.length < 2)) {
                if (null != n && "function" != typeof n) throw new Error("invalid callback: " + n);
                for(; ++l < s;)if (_$e = (t = _$o[l]).type) _$r[_$e] = u(_$r[_$e], t.name, n);
                else if (null == n) for(_$e in _$r)_$r[_$e] = u(_$r[_$e], t.name, null);
                return this;
            }
            for(; ++l < s;)if ((_$e = (t = _$o[l]).type) && (_$e = a(_$r[_$e], t.name))) return _$e;
        },
        copy: function copy() {
            var _$t = {}, n = this._;
            for(var _$e in n)_$t[_$e] = n[_$e].slice();
            return new o(_$t);
        },
        call: function call(t, n) {
            if ((_$e = arguments.length - 2) > 0) for(var _$e, i, _$r = new Array(_$e), _$o = 0; _$o < _$e; ++_$o)_$r[_$o] = arguments[_$o + 2];
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            for(_$o = 0, _$e = (i = this._[t]).length; _$o < _$e; ++_$o)i[_$o].value.apply(n, _$r);
        },
        apply: function apply(t, n, e) {
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            for(var i = this._[t], _$r = 0, _$o = i.length; _$r < _$o; ++_$r)i[_$r].value.apply(n, e);
        }
    };
    var l = "http://www.w3.org/1999/xhtml", s = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: l,
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
    };
    function c(t) {
        var n = t += "", _$e = n.indexOf(":");
        return _$e >= 0 && "xmlns" !== (n = t.slice(0, _$e)) && (t = t.slice(_$e + 1)), s.hasOwnProperty(n) ? {
            space: s[n],
            local: t
        } : t;
    }
    function f(t) {
        return function() {
            var n = this.ownerDocument, _$e = this.namespaceURI;
            return _$e === l && n.documentElement.namespaceURI === l ? n.createElement(t) : n.createElementNS(_$e, t);
        };
    }
    function d(t) {
        return function() {
            return this.ownerDocument.createElementNS(t.space, t.local);
        };
    }
    function h(t) {
        var n = c(t);
        return (n.local ? d : f)(n);
    }
    function v() {}
    function p(t) {
        return null == t ? v : function() {
            return this.querySelector(t);
        };
    }
    function g() {
        return [];
    }
    function y(t) {
        return function() {
            var n;
            return null == (n = t.apply(this, arguments)) ? [] : Array.isArray(n) ? n : Array.from(n);
        };
    }
    function m(t) {
        return function(n) {
            return n.matches(t);
        };
    }
    var _ = Array.prototype.find;
    function x() {
        return this.firstElementChild;
    }
    var w = Array.prototype.filter;
    function D() {
        return Array.from(this.children);
    }
    function b(t) {
        return new Array(t.length);
    }
    function A(t, n) {
        this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = n;
    }
    function I(t, n, e, i, r, o) {
        for(var a, u = 0, l = n.length, s = o.length; u < s; ++u)(a = n[u]) ? (a.__data__ = o[u], i[u] = a) : e[u] = new A(t, o[u]);
        for(; u < l; ++u)(a = n[u]) && (r[u] = a);
    }
    function S(t, n, e, i, r, o, a) {
        var u, l, s, c = new Map, f = n.length, d = o.length, h = new Array(f);
        for(u = 0; u < f; ++u)(l = n[u]) && (h[u] = s = a.call(l, l.__data__, u, n) + "", c.has(s) ? r[u] = l : c.set(s, l));
        for(u = 0; u < d; ++u)s = a.call(t, o[u], u, o) + "", (l = c.get(s)) ? (i[u] = l, l.__data__ = o[u], c.delete(s)) : e[u] = new A(t, o[u]);
        for(u = 0; u < f; ++u)(l = n[u]) && c.get(h[u]) === l && (r[u] = l);
    }
    function E(t) {
        return t.__data__;
    }
    function P(t) {
        return "object" == (typeof t === "undefined" ? "undefined" : (0, $aqUTs._)(t)) && "length" in t ? t : Array.from(t);
    }
    function M(t, n) {
        return t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
    }
    function C(t) {
        return function() {
            this.removeAttribute(t);
        };
    }
    function N(t) {
        return function() {
            this.removeAttributeNS(t.space, t.local);
        };
    }
    function j(t, n) {
        return function() {
            this.setAttribute(t, n);
        };
    }
    function k(t, n) {
        return function() {
            this.setAttributeNS(t.space, t.local, n);
        };
    }
    function T(t, n) {
        return function() {
            var _$e = n.apply(this, arguments);
            null == _$e ? this.removeAttribute(t) : this.setAttribute(t, _$e);
        };
    }
    function V(t, n) {
        return function() {
            var _$e = n.apply(this, arguments);
            null == _$e ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, _$e);
        };
    }
    function O(t) {
        return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
    }
    function B(t) {
        return function() {
            this.style.removeProperty(t);
        };
    }
    function L(t, n, e) {
        return function() {
            this.style.setProperty(t, n, e);
        };
    }
    function q(t, n, e) {
        return function() {
            var i = n.apply(this, arguments);
            null == i ? this.style.removeProperty(t) : this.style.setProperty(t, i, e);
        };
    }
    function R(t) {
        return function() {
            delete this[t];
        };
    }
    function U(t, n) {
        return function() {
            this[t] = n;
        };
    }
    function X(t, n) {
        return function() {
            var _$e = n.apply(this, arguments);
            null == _$e ? delete this[t] : this[t] = _$e;
        };
    }
    function F(t) {
        return t.trim().split(/^|\s+/);
    }
    function Y(t) {
        return t.classList || new z(t);
    }
    function z(t) {
        this._node = t, this._names = F(t.getAttribute("class") || "");
    }
    function H(t, n) {
        for(var _$e = Y(t), i = -1, _$r = n.length; ++i < _$r;)_$e.add(n[i]);
    }
    function G(t, n) {
        for(var _$e = Y(t), i = -1, _$r = n.length; ++i < _$r;)_$e.remove(n[i]);
    }
    function J(t) {
        return function() {
            H(this, t);
        };
    }
    function K(t) {
        return function() {
            G(this, t);
        };
    }
    function Q(t, n) {
        return function() {
            (n.apply(this, arguments) ? H : G)(this, t);
        };
    }
    function W() {
        this.textContent = "";
    }
    function Z(t) {
        return function() {
            this.textContent = t;
        };
    }
    function $(t) {
        return function() {
            var n = t.apply(this, arguments);
            this.textContent = null == n ? "" : n;
        };
    }
    function tt() {
        this.innerHTML = "";
    }
    function nt(t) {
        return function() {
            this.innerHTML = t;
        };
    }
    function et(t) {
        return function() {
            var n = t.apply(this, arguments);
            this.innerHTML = null == n ? "" : n;
        };
    }
    function it() {
        this.nextSibling && this.parentNode.appendChild(this);
    }
    function rt() {
        this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }
    function ot() {
        return null;
    }
    function at() {
        var _$t = this.parentNode;
        _$t && _$t.removeChild(this);
    }
    function ut() {
        var _$t = this.cloneNode(!1), n = this.parentNode;
        return n ? n.insertBefore(_$t, this.nextSibling) : _$t;
    }
    function lt() {
        var _$t = this.cloneNode(!0), n = this.parentNode;
        return n ? n.insertBefore(_$t, this.nextSibling) : _$t;
    }
    function st(t) {
        return function() {
            var n = this.__on;
            if (n) {
                for(var _$e, i = 0, _$r = -1, _$o = n.length; i < _$o; ++i)_$e = n[i], t.type && _$e.type !== t.type || _$e.name !== t.name ? n[++_$r] = _$e : this.removeEventListener(_$e.type, _$e.listener, _$e.options);
                ++_$r ? n.length = _$r : delete this.__on;
            }
        };
    }
    function ct(t, n, e) {
        return function() {
            var i, _$r = this.__on, _$o = function(t) {
                return function(n) {
                    t.call(this, n, this.__data__);
                };
            }(n);
            if (_$r) {
                for(var a = 0, u = _$r.length; a < u; ++a)if ((i = _$r[a]).type === t.type && i.name === t.name) return this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = _$o, i.options = e), void (i.value = n);
            }
            this.addEventListener(t.type, _$o, e), i = {
                type: t.type,
                name: t.name,
                value: n,
                listener: _$o,
                options: e
            }, _$r ? _$r.push(i) : this.__on = [
                i
            ];
        };
    }
    function ft(t, n, e) {
        var i = O(t), _$r = i.CustomEvent;
        "function" == typeof _$r ? _$r = new _$r(n, e) : (_$r = i.document.createEvent("Event"), e ? (_$r.initEvent(n, e.bubbles, e.cancelable), _$r.detail = e.detail) : _$r.initEvent(n, !1, !1)), t.dispatchEvent(_$r);
    }
    function dt(t, n) {
        return function() {
            return ft(this, t, n);
        };
    }
    function ht(t, n) {
        return function() {
            return ft(this, t, n.apply(this, arguments));
        };
    }
    A.prototype = {
        constructor: A,
        appendChild: function appendChild(t) {
            return this._parent.insertBefore(t, this._next);
        },
        insertBefore: function insertBefore(t, n) {
            return this._parent.insertBefore(t, n);
        },
        querySelector: function querySelector(t) {
            return this._parent.querySelector(t);
        },
        querySelectorAll: function querySelectorAll(t) {
            return this._parent.querySelectorAll(t);
        }
    }, z.prototype = {
        add: function add(t) {
            this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
        },
        remove: function remove(t) {
            var n = this._names.indexOf(t);
            n >= 0 && (this._names.splice(n, 1), this._node.setAttribute("class", this._names.join(" ")));
        },
        contains: function contains(t) {
            return this._names.indexOf(t) >= 0;
        }
    };
    var vt = [
        null
    ];
    function pt(t, n) {
        this._groups = t, this._parents = n;
    }
    function gt(t) {
        return "string" == typeof t ? new pt([
            [
                document.querySelector(t)
            ]
        ], [
            document.documentElement
        ]) : new pt([
            [
                t
            ]
        ], vt);
    }
    function yt(t, n) {
        if (t = function(t) {
            var _$n;
            for(; _$n = t.sourceEvent;)t = _$n;
            return t;
        }(t), void 0 === n && (n = t.currentTarget), n) {
            var _$e = n.ownerSVGElement || n;
            if (_$e.createSVGPoint) {
                var i = _$e.createSVGPoint();
                return i.x = t.clientX, i.y = t.clientY, [
                    (i = i.matrixTransform(n.getScreenCTM().inverse())).x,
                    i.y
                ];
            }
            if (n.getBoundingClientRect) {
                var _$r = n.getBoundingClientRect();
                return [
                    t.clientX - _$r.left - n.clientLeft,
                    t.clientY - _$r.top - n.clientTop
                ];
            }
        }
        return [
            t.pageX,
            t.pageY
        ];
    }
    pt.prototype = (0, $k9HNQ._)({
        constructor: pt,
        select: function select(t) {
            "function" != typeof t && (t = p(t));
            for(var n = this._groups, _$e = n.length, i = new Array(_$e), _$r = 0; _$r < _$e; ++_$r)for(var _$o, a, u = n[_$r], l = u.length, s = i[_$r] = new Array(l), c = 0; c < l; ++c)(_$o = u[c]) && (a = t.call(_$o, _$o.__data__, c, u)) && ("__data__" in _$o && (a.__data__ = _$o.__data__), s[c] = a);
            return new pt(i, this._parents);
        },
        selectAll: function selectAll(t) {
            t = "function" == typeof t ? y(t) : function(t) {
                return null == t ? g : function() {
                    return this.querySelectorAll(t);
                };
            }(t);
            for(var n = this._groups, _$e = n.length, i = [], _$r = [], _$o = 0; _$o < _$e; ++_$o)for(var a, u = n[_$o], l = u.length, s = 0; s < l; ++s)(a = u[s]) && (i.push(t.call(a, a.__data__, s, u)), _$r.push(a));
            return new pt(i, _$r);
        },
        selectChild: function selectChild(t) {
            return this.select(null == t ? x : function(t) {
                return function() {
                    return _.call(this.children, t);
                };
            }("function" == typeof t ? t : m(t)));
        },
        selectChildren: function selectChildren(t) {
            return this.selectAll(null == t ? D : function(t) {
                return function() {
                    return w.call(this.children, t);
                };
            }("function" == typeof t ? t : m(t)));
        },
        filter: function filter(t) {
            "function" != typeof t && (t = function(t) {
                return function() {
                    return this.matches(t);
                };
            }(t));
            for(var n = this._groups, _$e = n.length, i = new Array(_$e), _$r = 0; _$r < _$e; ++_$r)for(var _$o, a = n[_$r], u = a.length, l = i[_$r] = [], s = 0; s < u; ++s)(_$o = a[s]) && t.call(_$o, _$o.__data__, s, a) && l.push(_$o);
            return new pt(i, this._parents);
        },
        data: function data(t, n) {
            if (!arguments.length) return Array.from(this, E);
            var _$e, i = n ? S : I, _$r = this._parents, _$o = this._groups;
            "function" != typeof t && (_$e = t, t = function t() {
                return _$e;
            });
            for(var a = _$o.length, u = new Array(a), l = new Array(a), s = new Array(a), c = 0; c < a; ++c){
                var f = _$r[c], d = _$o[c], h = d.length, v = P(t.call(f, f && f.__data__, c, _$r)), p = v.length, g = l[c] = new Array(p), y = u[c] = new Array(p);
                i(f, d, g, y, s[c] = new Array(h), v, n);
                for(var m, _, x = 0, w = 0; x < p; ++x)if (m = g[x]) {
                    for(x >= w && (w = x + 1); !(_ = y[w]) && ++w < p;);
                    m._next = _ || null;
                }
            }
            return (u = new pt(u, _$r))._enter = l, u._exit = s, u;
        },
        enter: function enter() {
            return new pt(this._enter || this._groups.map(b), this._parents);
        },
        exit: function exit() {
            return new pt(this._exit || this._groups.map(b), this._parents);
        },
        join: function join(t, n, e) {
            var i = this.enter(), _$r = this, _$o = this.exit();
            return "function" == typeof t ? (i = t(i)) && (i = i.selection()) : i = i.append(t + ""), null != n && (_$r = n(_$r)) && (_$r = _$r.selection()), null == e ? _$o.remove() : e(_$o), i && _$r ? i.merge(_$r).order() : _$r;
        },
        merge: function merge(t) {
            for(var n = t.selection ? t.selection() : t, _$e = this._groups, i = n._groups, _$r = _$e.length, _$o = i.length, a = Math.min(_$r, _$o), u = new Array(_$r), l = 0; l < a; ++l)for(var s, c = _$e[l], f = i[l], d = c.length, h = u[l] = new Array(d), v = 0; v < d; ++v)(s = c[v] || f[v]) && (h[v] = s);
            for(; l < _$r; ++l)u[l] = _$e[l];
            return new pt(u, this._parents);
        },
        selection: function selection() {
            return this;
        },
        order: function order() {
            for(var _$t = this._groups, n = -1, _$e = _$t.length; ++n < _$e;)for(var i, _$r = _$t[n], _$o = _$r.length - 1, a = _$r[_$o]; --_$o >= 0;)(i = _$r[_$o]) && (a && 4 ^ i.compareDocumentPosition(a) && a.parentNode.insertBefore(i, a), a = i);
            return this;
        },
        sort: function sort(t) {
            function n(n, e) {
                return n && e ? t(n.__data__, e.__data__) : !n - !e;
            }
            t || (t = M);
            for(var _$e = this._groups, i = _$e.length, _$r = new Array(i), _$o = 0; _$o < i; ++_$o){
                for(var a, u = _$e[_$o], l = u.length, s = _$r[_$o] = new Array(l), c = 0; c < l; ++c)(a = u[c]) && (s[c] = a);
                s.sort(n);
            }
            return new pt(_$r, this._parents).order();
        },
        call: function call() {
            var _$t = arguments[0];
            return arguments[0] = this, _$t.apply(null, arguments), this;
        },
        nodes: function nodes() {
            return Array.from(this);
        },
        node: function node() {
            for(var _$t = this._groups, n = 0, _$e = _$t.length; n < _$e; ++n)for(var i = _$t[n], _$r = 0, _$o = i.length; _$r < _$o; ++_$r){
                var a = i[_$r];
                if (a) return a;
            }
            return null;
        },
        size: function size() {
            var _$t = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    ++_$t;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _$t;
        },
        empty: function empty() {
            return !this.node();
        },
        each: function each(t) {
            for(var n = this._groups, _$e = 0, i = n.length; _$e < i; ++_$e)for(var _$r, _$o = n[_$e], a = 0, u = _$o.length; a < u; ++a)(_$r = _$o[a]) && t.call(_$r, _$r.__data__, a, _$o);
            return this;
        },
        attr: function attr(t, n) {
            var _$e = c(t);
            if (arguments.length < 2) {
                var i = this.node();
                return _$e.local ? i.getAttributeNS(_$e.space, _$e.local) : i.getAttribute(_$e);
            }
            return this.each((null == n ? _$e.local ? N : C : "function" == typeof n ? _$e.local ? V : T : _$e.local ? k : j)(_$e, n));
        },
        style: function style(t, n, e) {
            return arguments.length > 1 ? this.each((null == n ? B : "function" == typeof n ? q : L)(t, n, null == e ? "" : e)) : function(t, n) {
                return t.style.getPropertyValue(n) || O(t).getComputedStyle(t, null).getPropertyValue(n);
            }(this.node(), t);
        },
        property: function property(t, n) {
            return arguments.length > 1 ? this.each((null == n ? R : "function" == typeof n ? X : U)(t, n)) : this.node()[t];
        },
        classed: function classed(t, n) {
            var _$e = F(t + "");
            if (arguments.length < 2) {
                for(var i = Y(this.node()), _$r = -1, _$o = _$e.length; ++_$r < _$o;)if (!i.contains(_$e[_$r])) return !1;
                return !0;
            }
            return this.each(("function" == typeof n ? Q : n ? J : K)(_$e, n));
        },
        text: function text(t) {
            return arguments.length ? this.each(null == t ? W : ("function" == typeof t ? $ : Z)(t)) : this.node().textContent;
        },
        html: function html(t) {
            return arguments.length ? this.each(null == t ? tt : ("function" == typeof t ? et : nt)(t)) : this.node().innerHTML;
        },
        raise: function raise() {
            return this.each(it);
        },
        lower: function lower() {
            return this.each(rt);
        },
        append: function append(t) {
            var n = "function" == typeof t ? t : h(t);
            return this.select(function() {
                return this.appendChild(n.apply(this, arguments));
            });
        },
        insert: function insert(t, n) {
            var _$e = "function" == typeof t ? t : h(t), i = null == n ? ot : "function" == typeof n ? n : p(n);
            return this.select(function() {
                return this.insertBefore(_$e.apply(this, arguments), i.apply(this, arguments) || null);
            });
        },
        remove: function remove() {
            return this.each(at);
        },
        clone: function clone(t) {
            return this.select(t ? lt : ut);
        },
        datum: function datum(t) {
            return arguments.length ? this.property("__data__", t) : this.node().__data__;
        },
        on: function on(t, n, e) {
            var i, _$r, _$o = function(t) {
                return t.trim().split(/^|\s+/).map(function(t) {
                    var _$n = "", _$e = t.indexOf(".");
                    return _$e >= 0 && (_$n = t.slice(_$e + 1), t = t.slice(0, _$e)), {
                        type: t,
                        name: _$n
                    };
                });
            }(t + ""), a = _$o.length;
            if (!(arguments.length < 2)) {
                for(u = n ? ct : st, i = 0; i < a; ++i)this.each(u(_$o[i], n, e));
                return this;
            }
            var u = this.node().__on;
            if (u) {
                for(var l, s = 0, c = u.length; s < c; ++s)for(i = 0, l = u[s]; i < a; ++i)if ((_$r = _$o[i]).type === l.type && _$r.name === l.name) return l.value;
            }
        },
        dispatch: function dispatch(t, n) {
            return this.each(("function" == typeof n ? ht : dt)(t, n));
        }
    }, Symbol.iterator, function() {
        var _$t, n, _$e, i, _$r, _$o, a, _tmp;
        return (0, $360d51dadf3ec78e$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _$t = this._groups, n = 0, _$e = _$t.length;
                    _state.label = 1;
                case 1:
                    if (!(n < _$e)) return [
                        3,
                        7
                    ];
                    _$r = _$t[n], _$o = 0, a = _$r.length;
                    _state.label = 2;
                case 2:
                    if (!(_$o < a)) return [
                        3,
                        6
                    ];
                    _tmp = i = _$r[_$o];
                    if (!_tmp) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        i
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp;
                    _state.label = 5;
                case 5:
                    ++_$o;
                    return [
                        3,
                        2
                    ];
                case 6:
                    ++n;
                    return [
                        3,
                        1
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    var mt = {
        passive: !1
    }, _t = {
        capture: !0,
        passive: !1
    };
    function xt(t) {
        t.stopImmediatePropagation();
    }
    function wt(t) {
        t.preventDefault(), t.stopImmediatePropagation();
    }
    var Dt = function(t) {
        return function() {
            return t;
        };
    };
    function bt(t, param) {
        var n = param.sourceEvent, _$e = param.subject, i = param.target, _$r = param.identifier, _$o = param.active, a = param.x, u = param.y, l = param.dx, s = param.dy, c = param.dispatch;
        Object.defineProperties(this, {
            type: {
                value: t,
                enumerable: !0,
                configurable: !0
            },
            sourceEvent: {
                value: n,
                enumerable: !0,
                configurable: !0
            },
            subject: {
                value: _$e,
                enumerable: !0,
                configurable: !0
            },
            target: {
                value: i,
                enumerable: !0,
                configurable: !0
            },
            identifier: {
                value: _$r,
                enumerable: !0,
                configurable: !0
            },
            active: {
                value: _$o,
                enumerable: !0,
                configurable: !0
            },
            x: {
                value: a,
                enumerable: !0,
                configurable: !0
            },
            y: {
                value: u,
                enumerable: !0,
                configurable: !0
            },
            dx: {
                value: l,
                enumerable: !0,
                configurable: !0
            },
            dy: {
                value: s,
                enumerable: !0,
                configurable: !0
            },
            _: {
                value: c
            }
        });
    }
    function At(t) {
        return !t.ctrlKey && !t.button;
    }
    function It() {
        return this.parentNode;
    }
    function St(t, n) {
        return null == n ? {
            x: t.x,
            y: t.y
        } : n;
    }
    function Et() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    function Pt() {
        var _$t, n, _$e, i, _$o = At, a = It, u = St, l = Et, s = {}, c = r("start", "drag", "end"), f = 0, d = 0;
        function h(t) {
            t.on("mousedown.drag", v).filter(l).on("touchstart.drag", y).on("touchmove.drag", m, mt).on("touchend.drag touchcancel.drag", _).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function v(r, u) {
            if (!i && _$o.call(this, r, u)) {
                var l = x(this, a.call(this, r, u), r, u, "mouse");
                l && (gt(r.view).on("mousemove.drag", p, _t).on("mouseup.drag", g, _t), function(t) {
                    var n = t.document.documentElement, _$e = gt(t).on("dragstart.drag", wt, _t);
                    "onselectstart" in n ? _$e.on("selectstart.drag", wt, _t) : (n.__noselect = n.style.MozUserSelect, n.style.MozUserSelect = "none");
                }(r.view), xt(r), _$e = !1, _$t = r.clientX, n = r.clientY, l("start", r));
            }
        }
        function p(i) {
            if (wt(i), !_$e) {
                var _$r = i.clientX - _$t, _$o = i.clientY - n;
                _$e = _$r * _$r + _$o * _$o > d;
            }
            s.mouse("drag", i);
        }
        function g(t) {
            gt(t.view).on("mousemove.drag mouseup.drag", null), function(t, n) {
                var _$e = t.document.documentElement, i = gt(t).on("dragstart.drag", null);
                n && (i.on("click.drag", wt, _t), setTimeout(function() {
                    i.on("click.drag", null);
                }, 0)), "onselectstart" in _$e ? i.on("selectstart.drag", null) : (_$e.style.MozUserSelect = _$e.__noselect, delete _$e.__noselect);
            }(t.view, _$e), wt(t), s.mouse("end", t);
        }
        function y(t, n) {
            if (_$o.call(this, t, n)) {
                var _$e, i, _$r = t.changedTouches, u = a.call(this, t, n), l = _$r.length;
                for(_$e = 0; _$e < l; ++_$e)(i = x(this, u, t, n, _$r[_$e].identifier, _$r[_$e])) && (xt(t), i("start", t, _$r[_$e]));
            }
        }
        function m(t) {
            var n, _$e, i = t.changedTouches, _$r = i.length;
            for(n = 0; n < _$r; ++n)(_$e = s[i[n].identifier]) && (wt(t), _$e("drag", t, i[n]));
        }
        function _(t) {
            var n, _$e, _$r = t.changedTouches, _$o = _$r.length;
            for(i && clearTimeout(i), i = setTimeout(function() {
                i = null;
            }, 500), n = 0; n < _$o; ++n)(_$e = s[_$r[n].identifier]) && (xt(t), _$e("end", t, _$r[n]));
        }
        function x(t, n, e, i, r, o) {
            var a, l, d, v = c.copy(), p = yt(o || e, n);
            if (null != (d = u.call(t, new bt("beforestart", {
                sourceEvent: e,
                target: h,
                identifier: r,
                active: f,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch: v
            }), i))) return a = d.x - p[0] || 0, l = d.y - p[1] || 0, function e(o, u, c) {
                var g, y = p;
                switch(o){
                    case "start":
                        s[r] = e, g = f++;
                        break;
                    case "end":
                        delete s[r], --f;
                    case "drag":
                        p = yt(c || u, n), g = f;
                }
                v.call(o, t, new bt(o, {
                    sourceEvent: u,
                    subject: d,
                    target: h,
                    identifier: r,
                    active: g,
                    x: p[0] + a,
                    y: p[1] + l,
                    dx: p[0] - y[0],
                    dy: p[1] - y[1],
                    dispatch: v
                }), i);
            };
        }
        return h.filter = function(t) {
            return arguments.length ? (_$o = "function" == typeof t ? t : Dt(!!t), h) : _$o;
        }, h.container = function(t) {
            return arguments.length ? (a = "function" == typeof t ? t : Dt(t), h) : a;
        }, h.subject = function(t) {
            return arguments.length ? (u = "function" == typeof t ? t : Dt(t), h) : u;
        }, h.touchable = function(t) {
            return arguments.length ? (l = "function" == typeof t ? t : Dt(!!t), h) : l;
        }, h.on = function() {
            var _$t = c.on.apply(c, arguments);
            return _$t === c ? h : _$t;
        }, h.clickDistance = function(t) {
            return arguments.length ? (d = (t = +t) * t, h) : Math.sqrt(d);
        }, h;
    }
    bt.prototype.on = function() {
        var _$t = this._.on.apply(this._, arguments);
        return _$t === this._ ? this : _$t;
    };
    var Mt = {
        id: "dragdata",
        statesStore: new Map,
        afterInit: function afterInit(t) {
            var n = {
                curIndex: void 0,
                curDatasetIndex: void 0,
                element: null,
                eventSettings: !1,
                floatingBar: !1,
                initValue: 0,
                xAxisID: "",
                yAxisID: "",
                rAxisID: "",
                stacked: !1,
                type: void 0,
                isDragging: !1
            };
            Mt.statesStore.set(t.id, n), gt(t.canvas).call(Pt().container(t.canvas).on("start", function(e) {
                return qt(e.sourceEvent, t, n);
            }).on("drag", function(e) {
                return Rt(e.sourceEvent, t, n);
            }).on("end", function(e) {
                return Lt(e.sourceEvent, t, n);
            }));
        },
        beforeEvent: function beforeEvent(t) {
            var n, _$e = Mt.statesStore.get(t.id);
            if (null == _$e ? void 0 : _$e.isDragging) return null === (n = t.tooltip) || void 0 === n || n.update(), !1;
        }
    };
    function Ct(t, n) {
        return void 0 === n || isNaN(n) || n < 0 ? t : Math.round(t * Math.pow(10, n)) / Math.pow(10, n);
    }
    function Nt(t, n, e) {
        return Math.min(Math.max(t, n), e);
    }
    function jt(t, e, i, r, o) {
        var a, u, l;
        void 0 === o && (o = Mt.statesStore.get(e.id));
        var s = n.getRelativePosition(t, e), c = s.x, f = s.y, d = e.scales[r], h = d.getPointPositionForValue(i + ("polarArea" === (null == o ? void 0 : o.type) ? .5 : 0), e.scales[r].max).angle, v = d.xCenter, p = d.yCenter, g = f - p, y = (c - v) * Math.cos(h) + g * Math.sin(h) > 0 ? Math.sqrt(Math.pow(c - v, 2) + Math.pow(f - p, 2)) : 0, m = d.getValueForDistanceFromCenter(y);
        return m = Nt(m = Ct(m, null === (l = null === (u = null === (a = e.config.options) || void 0 === a ? void 0 : a.plugins) || void 0 === u ? void 0 : u.dragData) || void 0 === l ? void 0 : l.round), e.scales[r].min, e.scales[r].max);
    }
    e.Chart.register(Mt);
    var kt = function kt1() {
        return kt = Object.assign || function(t) {
            for(var n, _$e = 1, i = arguments.length; _$e < i; _$e++)for(var _$r in n = arguments[_$e])Object.prototype.hasOwnProperty.call(n, _$r) && (t[_$r] = n[_$r]);
            return t;
        }, kt.apply(this, arguments);
    };
    function Tt(t) {
        return Array.isArray(t) ? function(t, n, e) {
            if (e || 2 === arguments.length) for(var i, _$r = 0, _$o = n.length; _$r < _$o; _$r++)!i && _$r in n || (i || (i = Array.prototype.slice.call(n, 0, _$r)), i[_$r] = n[_$r]);
            return t.concat(i || Array.prototype.slice.call(n));
        }([], t, !0) : "object" == (typeof t === "undefined" ? "undefined" : (0, $aqUTs._)(t)) ? kt({}, t) : t;
    }
    function Vt(t, e, i, r, o) {
        var a, u, l, s, c, f = r.xAxisDraggingDisabled, d = r.yAxisDraggingDisabled;
        if (void 0 === o && (o = Mt.statesStore.get(e.id)), !o) return i;
        var h = Tt(i), v = n.getRelativePosition(t, e), p = v.x, g = v.y, y = e.scales[o.xAxisID].getValueForPixel(p), m = e.scales[o.yAxisID].getValueForPixel(g), _ = null === (l = null === (u = null === (a = e.config.options) || void 0 === a ? void 0 : a.plugins) || void 0 === u ? void 0 : u.dragData) || void 0 === l ? void 0 : l.round;
        if (y = Ct(y, _), m = Ct(m, _), y = Nt(y, e.scales[o.xAxisID].min, e.scales[o.xAxisID].max), m = Nt(m, e.scales[o.yAxisID].min, e.scales[o.yAxisID].max), o.floatingBar) {
            var x = void 0;
            return x = "y" === (null === (s = e.config.options) || void 0 === s ? void 0 : s.indexAxis) ? y : m, Math.abs(x - h[0]) <= Math.abs(x - h[1]) ? h[0] = x : h[1] = x, h;
        }
        return void 0 === h.x || f || (h.x = y), void 0 !== h.y ? (d || (h.y = m), h) : "y" === (null === (c = e.config.options) || void 0 === c ? void 0 : c.indexAxis) ? f ? h : y : d ? h : m;
    }
    function Ot(t, n, e) {
        var i, _$r, _$o = null === (_$r = null === (i = t.config.options) || void 0 === i ? void 0 : i.plugins) || void 0 === _$r ? void 0 : _$r.dragData;
        if (null == _$o ? void 0 : _$o.magnet) {
            var a = null == _$o ? void 0 : _$o.magnet;
            if ("function" == typeof a.to) {
                var u = t.data.datasets[n].data[e];
                return u = a.to(u), t.data.datasets[n].data[e] = u, t.update("none"), u;
            }
            return null;
        }
        return t.data.datasets[n].data[e];
    }
    function Bt(t, n, e, i) {
        var _$r, _$o, a, u, l, s, c, f, d, h, v, p, g, y, m;
        if (void 0 === i && (i = Mt.statesStore.get(t.id)), !i) return {
            chartDraggingDisabled: !0,
            datasetDraggingDisabled: !0,
            xAxisDraggingDisabled: !0,
            yAxisDraggingDisabled: !0,
            dataPointDraggingDisabled: !0
        };
        var _ = t.data.datasets[n], x = !1 === (null === (_$o = null === (_$r = t.config.options) || void 0 === _$r ? void 0 : _$r.plugins) || void 0 === _$o ? void 0 : _$o.dragData), w = x || !1 === _.dragData, D = null === (l = null === (u = null === (a = t.config.options) || void 0 === a ? void 0 : a.scales) || void 0 === u ? void 0 : u[i.xAxisID]) || void 0 === l ? void 0 : l.dragData, b = !0;
        return w || !0 !== D && (!0 !== (null === (f = null === (c = null === (s = t.config.options) || void 0 === s ? void 0 : s.plugins) || void 0 === c ? void 0 : c.dragData) || void 0 === f ? void 0 : f.dragX) || !1 === D) || (b = !1), {
            chartDraggingDisabled: x,
            datasetDraggingDisabled: w,
            xAxisDraggingDisabled: b,
            yAxisDraggingDisabled: w || !1 === (null === (v = null === (h = null === (d = t.config.options) || void 0 === d ? void 0 : d.plugins) || void 0 === h ? void 0 : h.dragData) || void 0 === v ? void 0 : v.dragY) || !1 === (null === (y = null === (g = null === (p = t.config.options) || void 0 === p ? void 0 : p.scales) || void 0 === g ? void 0 : g[i.yAxisID]) || void 0 === y ? void 0 : y.dragData),
            dataPointDraggingDisabled: w || !1 === (null === (m = _.data[e]) || void 0 === m ? void 0 : m.dragData)
        };
    }
    function Lt(t, n, e) {
        var i, _$r, _$o, a, u;
        if (void 0 === e && (e = Mt.statesStore.get(n.id)), e) {
            var l = null === (_$o = null === (_$r = null === (i = n.options) || void 0 === i ? void 0 : i.plugins) || void 0 === _$r ? void 0 : _$r.dragData) || void 0 === _$o ? void 0 : _$o.onDragEnd;
            if (e.curIndex = void 0, e.isDragging = !1, (null === (u = null === (a = n.config.options) || void 0 === a ? void 0 : a.plugins) || void 0 === u ? void 0 : u.tooltip) && (n.config.options.plugins.tooltip.animation = e.eventSettings, n.update("none")), "function" == typeof l && e.element) {
                var s = e.element.datasetIndex, c = e.element.index;
                return l(t, s, c, Ot(n, s, c));
            }
        }
    }
    function qt(t, n, e) {
        var i, _$r, _$o, a, u, l, s, c, f, d, h, v, p, g, y, m, _, x, w, D, b, _$A, I, S, E, P;
        void 0 === e && (e = Mt.statesStore.get(n.id));
        var M = null === (_$o = null === (_$r = null === (i = n.options) || void 0 === i ? void 0 : i.plugins) || void 0 === _$r ? void 0 : _$r.dragData) || void 0 === _$o ? void 0 : _$o.onDragStart;
        if (e) {
            var C = null !== (l = null === (u = null === (a = n.config.options) || void 0 === a ? void 0 : a.interaction) || void 0 === u ? void 0 : u.mode) && void 0 !== l ? l : "nearest", N = null !== (c = null === (s = n.config.options) || void 0 === s ? void 0 : s.interaction) && void 0 !== c ? c : {
                intersect: !0
            };
            if (e.element = n.getElementsAtEventForMode(t, C, N, !1)[0], e.element) {
                var j = e.element.datasetIndex, k = e.element.index;
                e.type = null !== (d = null !== (f = n.config.type) && void 0 !== f ? f : n.data.datasets[j].type) && void 0 !== d ? d : void 0, e.eventSettings = null === (p = null === (v = null === (h = n.config.options) || void 0 === h ? void 0 : h.plugins) || void 0 === v ? void 0 : v.tooltip) || void 0 === p ? void 0 : p.animation;
                var T = n.data.datasets[j], V = n.getDatasetMeta(j), O = T.data[k];
                e.xAxisID = V.xAxisID, e.yAxisID = V.yAxisID, e.rAxisID = V.rAxisID;
                var B = Bt(n, j, k), L = B.datasetDraggingDisabled, q = B.xAxisDraggingDisabled, R = B.yAxisDraggingDisabled, U = B.dataPointDraggingDisabled;
                if (L || q && R || U) return void (e.element = null);
                if ("bar" === e.type) {
                    e.stacked = null !== (_ = null === (m = null === (y = null === (g = n.config.options) || void 0 === g ? void 0 : g.scales) || void 0 === y ? void 0 : y[e.xAxisID]) || void 0 === m ? void 0 : m.stacked) && void 0 !== _ ? _ : void 0;
                    var X = n.data.datasets[0].data[0];
                    e.floatingBar = null !== X && Array.isArray(X) && X.length >= 2;
                    var F = Vt(t, n, n.data.datasets[j].data[k], B, e);
                    e.initValue = F - O;
                }
                var Y = null === (D = null === (w = null === (x = n.config.options) || void 0 === x ? void 0 : x.plugins) || void 0 === w ? void 0 : w.dragData) || void 0 === D ? void 0 : D.showTooltip;
                void 0 !== Y && !0 !== Y || (null !== (b = (S = n.config).options) && void 0 !== b || (S.options = {}), null !== (_$A = (E = n.config.options).plugins) && void 0 !== _$A || (E.plugins = {}), null !== (I = (P = n.config.options.plugins).tooltip) && void 0 !== I || (P.tooltip = {}), n.config.options.plugins.tooltip.animation = !1), "function" == typeof M && e.element && !1 === M(t, j, k, O) && (e.element = null);
            }
        }
    }
    function Rt(t, n, e) {
        var i, _$r;
        if (void 0 === e && (e = Mt.statesStore.get(n.id)), e) {
            var _$o = null === (_$r = null === (i = n.options) || void 0 === i ? void 0 : i.plugins) || void 0 === _$r ? void 0 : _$r.dragData, a = null == _$o ? void 0 : _$o.onDrag;
            if (e.element) {
                e.curDatasetIndex = e.element.datasetIndex, e.curIndex = e.element.index, e.isDragging = !0;
                var u = n.data.datasets[e.curDatasetIndex].data[e.curIndex], l = Bt(n, e.curDatasetIndex, e.curIndex);
                if ("radar" === e.type || "polarArea" === e.type) u = jt(t, n, e.curIndex, e.rAxisID, e);
                else if (e.stacked) u = Ct(Vt(t, n, u, l, e) - e.initValue, null == _$o ? void 0 : _$o.round);
                else u = Vt(t, n, u, l, e);
                "function" == typeof a && !1 === a(t, e.curDatasetIndex, e.curIndex, u) || (n.data.datasets[e.curDatasetIndex].data[e.curIndex] = u, n.update("none"));
            }
        }
    }
    "function" == typeof SuppressedError && SuppressedError, t.applyMagnet = Ot, t.calcCartesian = Vt, t.calcRadialLinear = jt, t.checkDraggingConfiguration = Bt, t.clipValue = Nt, t.cloneDataPoint = Tt, t.default = Mt, t.dragEndCallback = Lt, t.getElement = qt, t.roundValue = Ct, t.updateData = Rt, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});


// ============================================
// Sunset Hills Algorithm
// ============================================
/**
 * Determines which buildings can see the sunset.
 * A building can see the sunset (which is to the WEST/LEFT) if all buildings 
 * to its left are strictly shorter.
 * 
 * Algorithm: Left-to-right scan with running maximum
 * Time Complexity: O(n)
 * Space Complexity: O(1) excluding result array
 * 
 * @param {number[]} heights - Array of building heights
 * @returns {number[]} - Indices of buildings that can see the sunset
 */ function $e6cd2f7804c62338$export$21f4a553ee067914(heights) {
    if (!heights || heights.length === 0) return [];
    var result = [];
    var maxHeight = 0;
    // Scan from left to right (buildings face west/left where sunset is)
    for(var i = 0; i < heights.length; i++)if (heights[i] > maxHeight) {
        result.push(i);
        maxHeight = heights[i];
    }
    return result;
}
function $e6cd2f7804c62338$export$36acff8d0cb9c1b4(indices) {
    return indices.map(function(index) {
        return "Building ".concat(index + 1);
    });
}
function $e6cd2f7804c62338$export$1ed963a35c063552(heights, solutionIndices) {
    if (solutionIndices.length === 0) return 'No buildings can see the sunset.';
    var buildingInfo = solutionIndices.map(function(index) {
        return "Building ".concat(index + 1, " (height: ").concat(heights[index], ")");
    });
    return "".concat(solutionIndices.length, " building(s) can see the sunset:\n").concat(buildingInfo.join(', '));
}


// ============================================
// Results Display Module
// ============================================

function $705482df8f59d364$export$2496d45061dc3e72(heights, solutionIndices) {
    var resultsOutput = document.getElementById('resultsOutput');
    if (!resultsOutput) {
        console.error('Results output element not found');
        return;
    }
    if (solutionIndices.length === 0) {
        resultsOutput.innerHTML = '\n      <div class="alert alert-warning mb-0" role="alert">\n        <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>\n        <strong>No buildings can see the sunset.</strong>\n        <p class="mb-0 mt-2 small">Try adjusting the building heights!</p>\n      </div>\n    ';
        return;
    }
    // Create building info cards
    var buildingCards = solutionIndices.map(function(index) {
        var buildingNum = index + 1;
        var height = heights[index];
        return '\n        <div class="building-card d-inline-block m-2 p-3 border rounded" style="min-width: 150px;">\n          <div class="d-flex align-items-center justify-content-between">\n            <div>\n              <i class="fa-solid fa-building text-warning fa-2x" aria-hidden="true"></i>\n            </div>\n            <div class="text-end">\n              <div class="fw-bold">Building '.concat(buildingNum, '</div>\n              <div class="text-muted small">Height: ').concat(height, "</div>\n            </div>\n          </div>\n        </div>\n      ");
    }).join('');
    resultsOutput.innerHTML = '\n    <div class="alert alert-success mb-3" role="alert">\n      <i class="fa-solid fa-circle-check" aria-hidden="true"></i>\n      <strong>'.concat(solutionIndices.length, ' building(s) can see the sunset!</strong>\n    </div>\n    <div class="buildings-grid">\n      ').concat(buildingCards, '\n    </div>\n    <div class="mt-3 small text-muted">\n      <i class="fa-solid fa-info-circle" aria-hidden="true"></i>\n      These buildings are taller than all buildings to their left (west).\n    </div>\n  ');
}


// ============================================
// Statistics Module
// ============================================
/**
 * Calculates statistics for the current building configuration
 * @param {number[]} heights - Array of building heights
 * @param {number[]} solutionIndices - Indices of buildings with sunset view
 * @returns {Object} - Statistics object
 */ 
var $2l5av = parcelRequire("2l5av");
function $8e37451603bc0f57$export$ea6a118828bbd5a9(heights, solutionIndices) {
    var _Math, _Math1;
    var total = heights.length;
    var withView = solutionIndices.length;
    var withoutView = total - withView;
    var percentageWithView = total > 0 ? Math.round(withView / total * 100) : 0;
    var sum = heights.reduce(function(acc, h) {
        return acc + h;
    }, 0);
    var average = total > 0 ? Math.round(sum / total) : 0;
    var tallest = (_Math = Math).max.apply(_Math, (0, $2l5av._)(heights));
    var shortest = (_Math1 = Math).min.apply(_Math1, (0, $2l5av._)(heights));
    return {
        total: total,
        withView: withView,
        withoutView: withoutView,
        percentageWithView: percentageWithView,
        average: average,
        tallest: tallest,
        shortest: shortest
    };
}
function $8e37451603bc0f57$export$8b761c299c0a78f0(stats) {
    var statsContainer = document.getElementById('statisticsDisplay');
    if (!statsContainer) {
        console.error('Statistics display element not found');
        return;
    }
    statsContainer.innerHTML = '\n    <div class="row g-3">\n      <div class="col-md-4">\n        <div class="stat-card">\n          <div class="stat-icon">\n            <i class="fa-solid fa-building-circle-check text-success"></i>\n          </div>\n          <div class="stat-value">'.concat(stats.withView, '</div>\n          <div class="stat-label">With Sunset View</div>\n        </div>\n      </div>\n      <div class="col-md-4">\n        <div class="stat-card">\n          <div class="stat-icon">\n            <i class="fa-solid fa-building-circle-xmark text-muted"></i>\n          </div>\n          <div class="stat-value">').concat(stats.withoutView, '</div>\n          <div class="stat-label">Without View</div>\n        </div>\n      </div>\n      <div class="col-md-4">\n        <div class="stat-card">\n          <div class="stat-icon">\n            <i class="fa-solid fa-percent text-primary"></i>\n          </div>\n          <div class="stat-value">').concat(stats.percentageWithView, '%</div>\n          <div class="stat-label">Success Rate</div>\n        </div>\n      </div>\n    </div>\n    <div class="row g-3 mt-2">\n      <div class="col-md-3">\n        <div class="stat-mini">\n          <i class="fa-solid fa-chart-simple text-info"></i>\n          <span class="ms-2"><strong>Avg:</strong> ').concat(stats.average, '</span>\n        </div>\n      </div>\n      <div class="col-md-3">\n        <div class="stat-mini">\n          <i class="fa-solid fa-arrow-up text-success"></i>\n          <span class="ms-2"><strong>Max:</strong> ').concat(stats.tallest, '</span>\n        </div>\n      </div>\n      <div class="col-md-3">\n        <div class="stat-mini">\n          <i class="fa-solid fa-arrow-down text-danger"></i>\n          <span class="ms-2"><strong>Min:</strong> ').concat(stats.shortest, '</span>\n        </div>\n      </div>\n      <div class="col-md-3">\n        <div class="stat-mini">\n          <i class="fa-solid fa-hashtag text-secondary"></i>\n          <span class="ms-2"><strong>Total:</strong> ').concat(stats.total, "</span>\n        </div>\n      </div>\n    </div>\n  ");
}


var // Register Chart.js components (dragData plugin auto-registers itself)
$633c291c2e4683d6$var$_Chart;
($633c291c2e4683d6$var$_Chart = (0, $lKySX.Chart)).register.apply($633c291c2e4683d6$var$_Chart, (0, $2l5av._)((0, $lKySX.registerables)));
// Default building heights
var $633c291c2e4683d6$var$DEFAULT_HEIGHTS = [
    71,
    55,
    50,
    65,
    95,
    68,
    28,
    34,
    14
];
// Store current heights
var $633c291c2e4683d6$var$currentHeights = (0, $2l5av._)($633c291c2e4683d6$var$DEFAULT_HEIGHTS);
// Chart instance
var $633c291c2e4683d6$var$chart = null;
/**
 * Gets theme-aware colors for the chart
 * @returns {object} Color configuration based on current theme
 */ function $633c291c2e4683d6$var$getChartColors() {
    var isDark = document.documentElement.getAttribute('data-bs-theme') === 'dark';
    return {
        gridColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
        textColor: isDark ? '#f8f9fa' : '#212529',
        labelColor: isDark ? '#f8f9fa' : '#000000',
        borderNoView: isDark ? 'rgba(139, 149, 161, 1)' : 'rgba(90, 98, 104, 1)'
    };
}
function $633c291c2e4683d6$export$88eaec01eecac0a4() {
    var canvas = document.getElementById('buildingsChart');
    if (!canvas) {
        console.error('Chart canvas not found');
        return;
    }
    var ctx = canvas.getContext('2d');
    // Calculate initial solution
    var solutionIndices = (0, $e6cd2f7804c62338$export$21f4a553ee067914)($633c291c2e4683d6$var$currentHeights);
    // Get theme-aware colors
    var colors = $633c291c2e4683d6$var$getChartColors();
    $633c291c2e4683d6$var$chart = new (0, $lKySX.Chart)(ctx, {
        type: 'bar',
        data: {
            labels: $633c291c2e4683d6$var$currentHeights.map(function(_, i) {
                return "Building ".concat(i + 1);
            }),
            datasets: [
                {
                    label: 'Building Height',
                    data: $633c291c2e4683d6$var$currentHeights,
                    backgroundColor: $633c291c2e4683d6$var$currentHeights.map(function(_, index) {
                        return solutionIndices.includes(index) ? 'rgba(255, 165, 0, 0.85)' : 'rgba(108, 117, 125, 0.75)';
                    }),
                    borderColor: $633c291c2e4683d6$var$currentHeights.map(function(_, index) {
                        return solutionIndices.includes(index) ? 'rgba(255, 140, 0, 1)' : colors.borderNoView;
                    }),
                    borderWidth: 2,
                    borderRadius: 4,
                    hoverBackgroundColor: $633c291c2e4683d6$var$currentHeights.map(function(_, index) {
                        return solutionIndices.includes(index) ? 'rgba(255, 165, 0, 1)' : 'rgba(108, 117, 125, 0.9)';
                    })
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                dragData: {
                    round: 0,
                    showTooltip: true,
                    onDragStart: function onDragStart(e, datasetIndex, index, value) {
                        // Allow dragging
                        return true;
                    },
                    onDrag: function onDrag(e, datasetIndex, index, value) {
                        // Constrain values between 10 and 100
                        if (value < 10) return false;
                        if (value > 100) return false;
                        return true;
                    },
                    onDragEnd: function onDragEnd(e, datasetIndex, index, value) {
                        // Update the height and refresh everything
                        $633c291c2e4683d6$var$currentHeights[index] = Math.round(value);
                        $633c291c2e4683d6$var$updateChart();
                    }
                },
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        generateLabels: function generateLabels() {
                            // Always get fresh colors based on current theme
                            var currentColors = $633c291c2e4683d6$var$getChartColors();
                            return [
                                {
                                    text: 'Can See Sunset',
                                    fillStyle: 'rgba(255, 165, 0, 0.85)',
                                    strokeStyle: 'rgba(255, 140, 0, 1)',
                                    lineWidth: 2
                                },
                                {
                                    text: 'Cannot See Sunset',
                                    fillStyle: 'rgba(108, 117, 125, 0.75)',
                                    strokeStyle: currentColors.borderNoView,
                                    lineWidth: 2
                                }
                            ];
                        },
                        font: {
                            size: 12,
                            weight: 'bold'
                        },
                        padding: 15,
                        color: colors.textColor
                    }
                },
                title: {
                    display: true,
                    text: 'Sunset Hills - Building Heights',
                    font: {
                        size: 18,
                        weight: 'bold'
                    },
                    padding: {
                        top: 10,
                        bottom: 20
                    },
                    color: colors.textColor
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    titleFont: {
                        size: 14,
                        weight: 'bold'
                    },
                    bodyFont: {
                        size: 13
                    },
                    padding: 12,
                    cornerRadius: 6,
                    callbacks: {
                        title: function title(context) {
                            return context[0].label;
                        },
                        label: function label(context) {
                            var canSeeSunset = solutionIndices.includes(context.dataIndex);
                            return [
                                "Height: ".concat(context.parsed.y, " units"),
                                canSeeSunset ? 'Can see sunset!' : 'Cannot see sunset'
                            ];
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    min: 0,
                    max: 100,
                    grid: {
                        color: colors.gridColor,
                        lineWidth: 1
                    },
                    title: {
                        display: true,
                        text: 'Height (units)',
                        font: {
                            size: 14,
                            weight: 'bold'
                        },
                        color: colors.textColor
                    },
                    ticks: {
                        stepSize: 10,
                        font: {
                            size: 11
                        },
                        color: colors.textColor
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: 'Buildings (Sunset to WEST/Left)',
                        font: {
                            size: 14,
                            weight: 'bold'
                        },
                        color: '#ff6b35'
                    },
                    ticks: {
                        font: {
                            size: 11,
                            weight: '500'
                        },
                        color: colors.textColor
                    }
                }
            },
            animation: {
                duration: 400,
                easing: 'easeInOutQuart'
            }
        },
        plugins: [
            {
                id: 'heightLabels',
                afterDatasetsDraw: function(chart) {
                    var ctx = chart.ctx;
                    var colors = $633c291c2e4683d6$var$getChartColors();
                    chart.data.datasets.forEach(function(dataset, i) {
                        var meta = chart.getDatasetMeta(i);
                        meta.data.forEach(function(bar, index) {
                            var data = dataset.data[index];
                            ctx.fillStyle = colors.labelColor;
                            ctx.font = 'bold 12px sans-serif';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';
                            ctx.fillText(data, bar.x, bar.y - 5);
                        });
                    });
                }
            }
        ]
    });
    // Listen for theme changes
    window.addEventListener('themeChanged', $633c291c2e4683d6$var$handleThemeChange);
    // Initial updates
    (0, $705482df8f59d364$export$2496d45061dc3e72)($633c291c2e4683d6$var$currentHeights, solutionIndices);
    (0, $8e37451603bc0f57$export$8b761c299c0a78f0)((0, $8e37451603bc0f57$export$ea6a118828bbd5a9)($633c291c2e4683d6$var$currentHeights, solutionIndices));
    console.log('Chart created successfully with drag functionality enabled');
}
/**
 * Handles theme change events
 * @param {CustomEvent} event - Theme change event
 */ function $633c291c2e4683d6$var$handleThemeChange(event) {
    if (!$633c291c2e4683d6$var$chart) return;
    console.log("Theme changed to ".concat(event.detail.theme, " mode - updating chart"));
    $633c291c2e4683d6$var$updateChartTheme();
}
/**
 * Updates chart colors based on current theme
 */ function $633c291c2e4683d6$var$updateChartTheme() {
    if (!$633c291c2e4683d6$var$chart) return;
    var colors = $633c291c2e4683d6$var$getChartColors();
    var solutionIndices = (0, $e6cd2f7804c62338$export$21f4a553ee067914)($633c291c2e4683d6$var$currentHeights);
    // Update border colors for non-sunset buildings
    $633c291c2e4683d6$var$chart.data.datasets[0].borderColor = $633c291c2e4683d6$var$currentHeights.map(function(_, index) {
        return solutionIndices.includes(index) ? 'rgba(255, 140, 0, 1)' : colors.borderNoView;
    });
    // Force legend to regenerate by replacing the generateLabels function
    // This ensures strokeStyle uses current theme colors
    if ($633c291c2e4683d6$var$chart.options.plugins.legend && $633c291c2e4683d6$var$chart.options.plugins.legend.labels) {
        $633c291c2e4683d6$var$chart.options.plugins.legend.labels.generateLabels = function() {
            // Get FRESH colors every time this is called
            var currentColors = $633c291c2e4683d6$var$getChartColors();
            return [
                {
                    text: 'Can See Sunset',
                    fillStyle: 'rgba(255, 165, 0, 0.85)',
                    strokeStyle: 'rgba(255, 140, 0, 1)',
                    lineWidth: 2
                },
                {
                    text: 'Cannot See Sunset',
                    fillStyle: 'rgba(108, 117, 125, 0.75)',
                    strokeStyle: currentColors.borderNoView,
                    lineWidth: 2
                }
            ];
        };
        // Update text color
        $633c291c2e4683d6$var$chart.options.plugins.legend.labels.color = colors.textColor;
    }
    // Title color
    if ($633c291c2e4683d6$var$chart.options.plugins.title) $633c291c2e4683d6$var$chart.options.plugins.title.color = colors.textColor;
    // Y-axis colors
    if ($633c291c2e4683d6$var$chart.options.scales.y) {
        $633c291c2e4683d6$var$chart.options.scales.y.grid.color = colors.gridColor;
        $633c291c2e4683d6$var$chart.options.scales.y.title.color = colors.textColor;
        $633c291c2e4683d6$var$chart.options.scales.y.ticks.color = colors.textColor;
    }
    // X-axis tick colors (keep title orange)
    if ($633c291c2e4683d6$var$chart.options.scales.x && $633c291c2e4683d6$var$chart.options.scales.x.ticks) $633c291c2e4683d6$var$chart.options.scales.x.ticks.color = colors.textColor;
    // Force chart to update with new colors
    // Use 'active' mode to force legend regeneration
    $633c291c2e4683d6$var$chart.update('active');
    console.log("Chart colors updated to ".concat(colors.textColor));
}
/**
 * Updates the chart colors and results based on current heights
 */ function $633c291c2e4683d6$var$updateChart() {
    if (!$633c291c2e4683d6$var$chart) return;
    var solutionIndices = (0, $e6cd2f7804c62338$export$21f4a553ee067914)($633c291c2e4683d6$var$currentHeights);
    var colors = $633c291c2e4683d6$var$getChartColors();
    // Update colors with smooth transition
    $633c291c2e4683d6$var$chart.data.datasets[0].backgroundColor = $633c291c2e4683d6$var$currentHeights.map(function(_, index) {
        return solutionIndices.includes(index) ? 'rgba(255, 165, 0, 0.85)' : 'rgba(108, 117, 125, 0.75)';
    });
    $633c291c2e4683d6$var$chart.data.datasets[0].borderColor = $633c291c2e4683d6$var$currentHeights.map(function(_, index) {
        return solutionIndices.includes(index) ? 'rgba(255, 140, 0, 1)' : colors.borderNoView;
    });
    $633c291c2e4683d6$var$chart.data.datasets[0].hoverBackgroundColor = $633c291c2e4683d6$var$currentHeights.map(function(_, index) {
        return solutionIndices.includes(index) ? 'rgba(255, 165, 0, 1)' : 'rgba(108, 117, 125, 0.9)';
    });
    $633c291c2e4683d6$var$chart.update();
    // Update displays
    (0, $705482df8f59d364$export$2496d45061dc3e72)($633c291c2e4683d6$var$currentHeights, solutionIndices);
    (0, $8e37451603bc0f57$export$8b761c299c0a78f0)((0, $8e37451603bc0f57$export$ea6a118828bbd5a9)($633c291c2e4683d6$var$currentHeights, solutionIndices));
}
function $633c291c2e4683d6$export$6c992664f64d6873() {
    $633c291c2e4683d6$var$currentHeights = (0, $2l5av._)($633c291c2e4683d6$var$DEFAULT_HEIGHTS);
    if ($633c291c2e4683d6$var$chart) {
        $633c291c2e4683d6$var$chart.data.datasets[0].data = $633c291c2e4683d6$var$currentHeights;
        $633c291c2e4683d6$var$chart.data.labels = $633c291c2e4683d6$var$currentHeights.map(function(_, i) {
            return "Building ".concat(i + 1);
        });
        $633c291c2e4683d6$var$updateChart();
    }
}
function $633c291c2e4683d6$export$bce910424373a8a1() {
    $633c291c2e4683d6$var$currentHeights = $633c291c2e4683d6$var$currentHeights.map(function() {
        return Math.floor(Math.random() * 91) + 10;
    }); // 10-100
    if ($633c291c2e4683d6$var$chart) {
        $633c291c2e4683d6$var$chart.data.datasets[0].data = $633c291c2e4683d6$var$currentHeights;
        $633c291c2e4683d6$var$updateChart();
    }
}
function $633c291c2e4683d6$export$683f79a044fbd3db(heights) {
    $633c291c2e4683d6$var$currentHeights = (0, $2l5av._)(heights);
    if ($633c291c2e4683d6$var$chart) {
        // Update data
        $633c291c2e4683d6$var$chart.data.datasets[0].data = $633c291c2e4683d6$var$currentHeights;
        $633c291c2e4683d6$var$chart.data.labels = $633c291c2e4683d6$var$currentHeights.map(function(_, i) {
            return "Building ".concat(i + 1);
        });
        $633c291c2e4683d6$var$updateChart();
    }
}
function $633c291c2e4683d6$export$85b491144b3e557(input) {
    try {
        var heights = input.split(',').map(function(h) {
            return parseInt(h.trim(), 10);
        }).filter(function(h) {
            return !isNaN(h) && h >= 10 && h <= 100;
        });
        if (heights.length === 0) throw new Error('No valid heights found');
        $633c291c2e4683d6$var$currentHeights = heights;
        if ($633c291c2e4683d6$var$chart) {
            $633c291c2e4683d6$var$chart.data.datasets[0].data = $633c291c2e4683d6$var$currentHeights;
            $633c291c2e4683d6$var$chart.data.labels = $633c291c2e4683d6$var$currentHeights.map(function(_, i) {
                return "Building ".concat(i + 1);
            });
            $633c291c2e4683d6$var$updateChart();
        }
        return true;
    } catch (error) {
        console.error('Error setting manual heights:', error);
        return false;
    }
}
function $633c291c2e4683d6$export$56dd7cc4e559b496() {
    if ($633c291c2e4683d6$var$currentHeights.length >= 20) return false; // Max 20 buildings
    var newHeight = Math.floor(Math.random() * 91) + 10; // 10-100
    $633c291c2e4683d6$var$currentHeights.push(newHeight);
    if ($633c291c2e4683d6$var$chart) {
        $633c291c2e4683d6$var$chart.data.datasets[0].data = $633c291c2e4683d6$var$currentHeights;
        $633c291c2e4683d6$var$chart.data.labels = $633c291c2e4683d6$var$currentHeights.map(function(_, i) {
            return "Building ".concat(i + 1);
        });
        $633c291c2e4683d6$var$updateChart();
    }
    return true;
}
function $633c291c2e4683d6$export$50be0aa3ff308335() {
    if ($633c291c2e4683d6$var$currentHeights.length <= 1) return false; // Must have at least 1 building
    $633c291c2e4683d6$var$currentHeights.pop();
    if ($633c291c2e4683d6$var$chart) {
        $633c291c2e4683d6$var$chart.data.datasets[0].data = $633c291c2e4683d6$var$currentHeights;
        $633c291c2e4683d6$var$chart.data.labels = $633c291c2e4683d6$var$currentHeights.map(function(_, i) {
            return "Building ".concat(i + 1);
        });
        $633c291c2e4683d6$var$updateChart();
    }
    return true;
}
function $633c291c2e4683d6$export$53b19b5a6459480b() {
    return (0, $2l5av._)($633c291c2e4683d6$var$currentHeights);
}


// ============================================
// Preset Scenarios Module
// ============================================
/**
 * Predefined building height scenarios for testing
 */ 
var $8Hr86 = parcelRequire("8Hr86");
var $ec724b2d93023790$export$9265403940be6b4 = {
    default: {
        name: 'Default',
        description: 'Original building configuration',
        heights: [
            71,
            55,
            50,
            65,
            95,
            68,
            28,
            34,
            14
        ]
    },
    allSame: {
        name: 'All Same Height',
        description: 'All buildings same height - only the last one sees sunset',
        heights: [
            50,
            50,
            50,
            50,
            50,
            50,
            50,
            50,
            50
        ]
    },
    ascending: {
        name: 'Ascending Order',
        description: 'Heights increase left to right - only last building sees sunset',
        heights: [
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            90
        ]
    },
    descending: {
        name: 'Descending Order',
        description: 'Heights decrease left to right - all buildings see sunset!',
        heights: [
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10
        ]
    },
    pyramid: {
        name: 'Pyramid',
        description: 'Heights form a pyramid shape',
        heights: [
            30,
            50,
            70,
            85,
            95,
            85,
            70,
            50,
            30
        ]
    },
    valley: {
        name: 'Valley',
        description: 'Heights form a valley shape',
        heights: [
            80,
            60,
            40,
            25,
            15,
            25,
            40,
            60,
            80
        ]
    },
    zigzag: {
        name: 'Zigzag',
        description: 'Alternating high and low buildings',
        heights: [
            80,
            20,
            70,
            30,
            60,
            40,
            50,
            45,
            90
        ]
    },
    stairs: {
        name: 'Staircase',
        description: 'Buildings form ascending stairs',
        heights: [
            10,
            10,
            25,
            25,
            40,
            40,
            60,
            60,
            85
        ]
    },
    challenge: {
        name: 'Challenge',
        description: 'A challenging configuration to analyze',
        heights: [
            45,
            88,
            32,
            67,
            91,
            54,
            29,
            76,
            13
        ]
    },
    minimal: {
        name: 'Minimal Case',
        description: 'Just 3 buildings for simplicity',
        heights: [
            50,
            75,
            25
        ]
    },
    skyscraper: {
        name: 'Skyscraper City',
        description: 'All very tall buildings',
        heights: [
            85,
            92,
            78,
            95,
            88,
            90,
            82,
            87,
            91
        ]
    },
    smallTown: {
        name: 'Small Town',
        description: 'All relatively short buildings',
        heights: [
            15,
            22,
            18,
            25,
            20,
            16,
            19,
            23,
            21
        ]
    }
};
function $ec724b2d93023790$export$1fca50893cda5ca5(key) {
    return $ec724b2d93023790$export$9265403940be6b4[key] || null;
}
function $ec724b2d93023790$export$e4b9bdbdd0eb6150() {
    return Object.keys($ec724b2d93023790$export$9265403940be6b4);
}
function $ec724b2d93023790$export$77ae3f3f3c0ebf7e() {
    return Object.entries($ec724b2d93023790$export$9265403940be6b4).map(function(param) {
        var _param = (0, $8Hr86._)(param, 2), key = _param[0], preset = _param[1];
        return '<option value="'.concat(key, '">').concat(preset.name, "</option>");
    }).join('');
}


// ============================================
// Toast Notifications Module
// ============================================
/**
 * Shows a toast notification
 * @param {string} message - Message to display
 * @param {string} type - Toast type: 'success', 'error', 'info', 'warning'
 * @param {number} duration - Duration in milliseconds (default: 3000)
 */ function $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3000;
    // Create toast container if it doesn't exist
    var container = document.getElementById('toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'toast-container';
        container.className = 'toast-container';
        document.body.appendChild(container);
    }
    // Create toast element
    var toast = document.createElement('div');
    toast.className = "toast toast-".concat(type);
    // Set icon based on type
    var icons = {
        success: 'fa-circle-check',
        error: 'fa-circle-exclamation',
        info: 'fa-circle-info',
        warning: 'fa-triangle-exclamation'
    };
    var icon = icons[type] || icons.info;
    toast.innerHTML = '\n    <i class="fa-solid '.concat(icon, '" aria-hidden="true"></i>\n    <span>').concat(message, "</span>\n  ");
    // Add to container
    container.appendChild(toast);
    // Trigger animation
    setTimeout(function() {
        toast.classList.add('show');
    }, 10);
    // Remove after duration
    setTimeout(function() {
        toast.classList.remove('show');
        setTimeout(function() {
            container.removeChild(toast);
            // Remove container if empty
            if (container.children.length === 0) document.body.removeChild(container);
        }, 300);
    }, duration);
}
function $80f856a7a06aa14e$export$d841eba85c078f0b(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'success');
}
function $80f856a7a06aa14e$export$3879b24e8245693d(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'error');
}
function $80f856a7a06aa14e$export$3ddc711ac21275cd(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'info');
}
function $80f856a7a06aa14e$export$da2f4e8190fdb5e1(message) {
    $80f856a7a06aa14e$export$f6cef6fcf9ca4e17(message, 'warning');
}


// Initialize theme toggle
(0, $8Y07q.initThemeToggle)();
console.log('Solve page initializing...');
// Initialize the chart
console.log('Initializing chart...');
try {
    (0, $633c291c2e4683d6$export$88eaec01eecac0a4)();
    console.log('Chart initialized successfully');
} catch (error) {
    console.error('Error initializing chart:', error);
}
// Populate preset dropdown
var $8ad0536b9450bda3$var$presetSelect = document.getElementById('presetSelect');
if ($8ad0536b9450bda3$var$presetSelect) {
    console.log('Populating preset dropdown...');
    $8ad0536b9450bda3$var$presetSelect.innerHTML = '\n    <option value="">-- Choose a Preset --</option>\n    '.concat((0, $ec724b2d93023790$export$77ae3f3f3c0ebf7e)(), "\n  ");
    console.log('Preset dropdown populated');
    $8ad0536b9450bda3$var$presetSelect.addEventListener('change', function(e) {
        var presetKey = e.target.value;
        if (presetKey) {
            var preset = (0, $ec724b2d93023790$export$1fca50893cda5ca5)(presetKey);
            if (preset) {
                (0, $633c291c2e4683d6$export$683f79a044fbd3db)(preset.heights);
                (0, $80f856a7a06aa14e$export$d841eba85c078f0b)("Loaded preset: ".concat(preset.name));
                console.log("Loaded preset: ".concat(preset.name), preset.description);
            }
        }
    });
} else console.error('Preset select element not found!');
// Reset button
var $8ad0536b9450bda3$var$resetBtn = document.getElementById('resetBtn');
if ($8ad0536b9450bda3$var$resetBtn) {
    $8ad0536b9450bda3$var$resetBtn.addEventListener('click', function() {
        (0, $633c291c2e4683d6$export$6c992664f64d6873)();
        (0, $80f856a7a06aa14e$export$3ddc711ac21275cd)('Buildings reset to default heights');
        console.log('Buildings reset to default heights');
        // Reset preset dropdown
        if ($8ad0536b9450bda3$var$presetSelect) $8ad0536b9450bda3$var$presetSelect.value = '';
    });
    console.log('Reset button wired up');
} else console.error('Reset button not found!');
// Randomize button
var $8ad0536b9450bda3$var$randomizeBtn = document.getElementById('randomizeBtn');
if ($8ad0536b9450bda3$var$randomizeBtn) {
    $8ad0536b9450bda3$var$randomizeBtn.addEventListener('click', function() {
        (0, $633c291c2e4683d6$export$bce910424373a8a1)();
        (0, $80f856a7a06aa14e$export$d841eba85c078f0b)('Buildings randomized!');
        console.log('Buildings randomized');
    });
    console.log('Randomize button wired up');
} else console.error('Randomize button not found!');
// Manual input
var $8ad0536b9450bda3$var$manualInput = document.getElementById('manualHeights');
var $8ad0536b9450bda3$var$applyManualBtn = document.getElementById('applyManualBtn');
if ($8ad0536b9450bda3$var$applyManualBtn && $8ad0536b9450bda3$var$manualInput) {
    $8ad0536b9450bda3$var$applyManualBtn.addEventListener('click', function() {
        var input = $8ad0536b9450bda3$var$manualInput.value.trim();
        if (input) {
            var success = (0, $633c291c2e4683d6$export$85b491144b3e557)(input);
            if (success) {
                (0, $80f856a7a06aa14e$export$d841eba85c078f0b)('Custom heights applied!');
                $8ad0536b9450bda3$var$manualInput.value = '';
            } else (0, $80f856a7a06aa14e$export$3879b24e8245693d)('Invalid input. Use comma-separated numbers (10-100).');
        } else (0, $80f856a7a06aa14e$export$3879b24e8245693d)('Please enter building heights.');
    });
    // Allow Enter key to apply
    $8ad0536b9450bda3$var$manualInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') $8ad0536b9450bda3$var$applyManualBtn.click();
    });
    console.log('Manual input wired up');
}
// Add building button
var $8ad0536b9450bda3$var$addBuildingBtn = document.getElementById('addBuildingBtn');
if ($8ad0536b9450bda3$var$addBuildingBtn) {
    $8ad0536b9450bda3$var$addBuildingBtn.addEventListener('click', function() {
        var success = (0, $633c291c2e4683d6$export$56dd7cc4e559b496)();
        if (success) (0, $80f856a7a06aa14e$export$d841eba85c078f0b)('Building added!');
        else (0, $80f856a7a06aa14e$export$3879b24e8245693d)('Maximum 20 buildings reached.');
    });
    console.log('Add building button wired up');
}
// Remove building button
var $8ad0536b9450bda3$var$removeBuildingBtn = document.getElementById('removeBuildingBtn');
if ($8ad0536b9450bda3$var$removeBuildingBtn) {
    $8ad0536b9450bda3$var$removeBuildingBtn.addEventListener('click', function() {
        var success = (0, $633c291c2e4683d6$export$50be0aa3ff308335)();
        if (success) (0, $80f856a7a06aa14e$export$3ddc711ac21275cd)('Building removed.');
        else (0, $80f856a7a06aa14e$export$3879b24e8245693d)('Must have at least 1 building.');
    });
    console.log('Remove building button wired up');
}
console.log('? Solve page initialized successfully');

})();
//# sourceMappingURL=solve.9ac228aa.js.map
